package xyz.qwewqa.relive.simulator.core.gen

/*
1000101:
  _id_: 1000101
  description:
    en: '(Passive) [Seisho Center Position] Act Power Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [세이쇼 중간 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的ACT力量 +%opt1_value%'
  name:
    en: Seisho Center Position Act Power Up
    ja: 聖翔立ち位置中のACTパワーアップ
    ko: 세이쇼 중간 포지션의 ACT 파워 증가
    zh_hant: 提升聖翔站位為中的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3002
1000102:
  _id_: 1000102
  description:
    en: '(Passive) [Seisho Center Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為中】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Flower Dmg Received Down
    ja: 聖翔立ち位置中の花属性被ダメージダウン
    ko: 세이쇼 중간 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕聖翔站位為中受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3002
1000103:
  _id_: 1000103
  description:
    en: '(Passive) [Seisho Center Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為中】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Wind Dmg Received Down
    ja: 聖翔立ち位置中の風属性被ダメージダウン
    ko: 세이쇼 중간 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕聖翔站位為中受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3002
1000104:
  _id_: 1000104
  description:
    en: '(Passive) [Seisho Center Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為中】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Snow Dmg Received Down
    ja: 聖翔立ち位置中の雪属性被ダメージダウン
    ko: 세이쇼 중간 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕聖翔站位為中受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3002
1000105:
  _id_: 1000105
  description:
    en: '(Passive) [Seisho Center Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為中】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Moon Dmg Received Down
    ja: 聖翔立ち位置中の月属性被ダメージダウン
    ko: 세이쇼 중간 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕聖翔站位為中受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3002
1000106:
  _id_: 1000106
  description:
    en: '(Passive) [Seisho Center Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為中】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Space Dmg Received Down
    ja: 聖翔立ち位置中の宙属性被ダメージダウン
    ko: 세이쇼 중간 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕聖翔站位為中受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3002
1000107:
  _id_: 1000107
  description:
    en: '(Passive) [Seisho Center Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為中】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Cloud Dmg Received Down
    ja: 聖翔立ち位置中の雲属性被ダメージダウン
    ko: 세이쇼 중간 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕聖翔站位為中受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3002
1000108:
  _id_: 1000108
  description:
    en: '(Passive) [Seisho Center Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為中】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dream Dmg Received Down
    ja: 聖翔立ち位置中の夢属性被ダメージダウン
    ko: 세이쇼 중간 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕聖翔站位為中受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3002
1000109:
  _id_: 1000109
  description:
    en: '(Passive) [Seisho Center Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dmg to Flower Up
    ja: 聖翔立ち位置中の花属性特効与ダメージアップ
    ko: 세이쇼 중간 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為中的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3002
1000110:
  _id_: 1000110
  description:
    en: '(Passive) [Seisho Center Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dmg to Wind Up
    ja: 聖翔立ち位置中の風属性特効与ダメージアップ
    ko: 세이쇼 중간 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為中的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3002
1000111:
  _id_: 1000111
  description:
    en: '(Passive) [Seisho Center Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dmg to Snow Up
    ja: 聖翔立ち位置中の雪属性特効与ダメージアップ
    ko: 세이쇼 중간 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為中的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3002
1000112:
  _id_: 1000112
  description:
    en: '(Passive) [Seisho Center Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dmg to Moon Up
    ja: 聖翔立ち位置中の月属性特効与ダメージアップ
    ko: 세이쇼 중간 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為中的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3002
1000113:
  _id_: 1000113
  description:
    en: '(Passive) [Seisho Center Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dmg to Space Up
    ja: 聖翔立ち位置中の宙属性特効与ダメージアップ
    ko: 세이쇼 중간 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為中的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3002
1000114:
  _id_: 1000114
  description:
    en: '(Passive) [Seisho Center Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dmg to Cloud Up
    ja: 聖翔立ち位置中の雲属性特効与ダメージアップ
    ko: 세이쇼 중간 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為中的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3002
1000115:
  _id_: 1000115
  description:
    en: '(Passive) [Seisho Center Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Center Position Dmg to Dream Up
    ja: 聖翔立ち位置中の夢属性特効与ダメージアップ
    ko: 세이쇼 중간 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為中的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3002
1000116:
  _id_: 1000116
  description:
    en: '(Passive) [Seisho Center Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [세이쇼 중간 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的普通防禦力 +%opt1_value%'
  name:
    en: Seisho Center Position Normal Defense Up
    ja: 聖翔立ち位置中の通常防御力アップ
    ko: 세이쇼 중간 포지션의 일반 방어력 증가
    zh_hant: 提升聖翔站位為中的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3002
1000117:
  _id_: 1000117
  description:
    en: '(Passive) [Seisho Center Position] Special Defense Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [세이쇼 중간 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的特殊防禦力 +%opt1_value%'
  name:
    en: Seisho Center Position Special Defense Up
    ja: 聖翔立ち位置中の特殊防御力アップ
    ko: 세이쇼 중간 포지션의 특수 방어력 증가
    zh_hant: 提升聖翔站位為中的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3002
1000118:
  _id_: 1000118
  description:
    en: '(Passive) [Seisho Center Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的普通防禦力 +%opt1_value%%'
  name:
    en: Seisho Center Position Normal Defense Up
    ja: 聖翔立ち位置中の通常防御力アップ
    ko: 세이쇼 중간 포지션의 일반 방어력 증가
    zh_hant: 提升聖翔站位為中的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3002
1000119:
  _id_: 1000119
  description:
    en: '(Passive) [Seisho Center Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的特殊防禦力 +%opt1_value%%'
  name:
    en: Seisho Center Position Special Defense Up
    ja: 聖翔立ち位置中の特殊防御力アップ
    ko: 세이쇼 중간 포지션의 특수 방어력 증가
    zh_hant: 提升聖翔站位為中的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3002
1000120:
  _id_: 1000120
  description:
    en: '(Passive) [Seisho Center Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的會心率 +%opt1_value%%'
  name:
    en: Seisho Center Position Dexterity Up
    ja: 聖翔立ち位置中のクリティカル率アップ
    ko: 세이쇼 중간 포지션의 크리티컬 확률 증가
    zh_hant: 提升聖翔站位為中的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3002
1000121:
  _id_: 1000121
  description:
    en: '(Passive) [Seisho Center Position] Critical Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為中】的會心威力 +%opt1_value%%'
  name:
    en: Seisho Center Position Critical Up
    ja: 聖翔立ち位置中のクリティカル威力アップ
    ko: 세이쇼 중간 포지션의 크리티컬 위력 증가
    zh_hant: 提升聖翔站位為中的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3002
1000201:
  _id_: 1000201
  description:
    en: '(Passive) [Space Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [우주 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Space Rear Position Act Power Up
    ja: 宙属性立ち位置後のACTパワーアップ
    ko: 우주 속성 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升宙屬性站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3083
1000202:
  _id_: 1000202
  description:
    en: '(Passive) [Space Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Flower Dmg Received Down
    ja: 宙属性立ち位置後の花属性被ダメージダウン
    ko: 우주 속성 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3083
1000203:
  _id_: 1000203
  description:
    en: '(Passive) [Space Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Wind Dmg Received Down
    ja: 宙属性立ち位置後の風属性被ダメージダウン
    ko: 우주 속성 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3083
1000204:
  _id_: 1000204
  description:
    en: '(Passive) [Space Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Snow Dmg Received Down
    ja: 宙属性立ち位置後の雪属性被ダメージダウン
    ko: 우주 속성 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3083
1000205:
  _id_: 1000205
  description:
    en: '(Passive) [Space Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Moon Dmg Received Down
    ja: 宙属性立ち位置後の月属性被ダメージダウン
    ko: 우주 속성 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3083
1000206:
  _id_: 1000206
  description:
    en: '(Passive) [Space Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Space Dmg Received Down
    ja: 宙属性立ち位置後の宙属性被ダメージダウン
    ko: 우주 속성 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3083
1000207:
  _id_: 1000207
  description:
    en: '(Passive) [Space Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Cloud Dmg Received Down
    ja: 宙属性立ち位置後の雲属性被ダメージダウン
    ko: 우주 속성 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3083
1000208:
  _id_: 1000208
  description:
    en: '(Passive) [Space Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dream Dmg Received Down
    ja: 宙属性立ち位置後の夢属性被ダメージダウン
    ko: 우주 속성 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3083
1000209:
  _id_: 1000209
  description:
    en: '(Passive) [Space Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dmg to Flower Up
    ja: 宙属性立ち位置後の花属性特効与ダメージアップ
    ko: 우주 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3083
1000210:
  _id_: 1000210
  description:
    en: '(Passive) [Space Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dmg to Wind Up
    ja: 宙属性立ち位置後の風属性特効与ダメージアップ
    ko: 우주 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3083
1000211:
  _id_: 1000211
  description:
    en: '(Passive) [Space Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dmg to Snow Up
    ja: 宙属性立ち位置後の雪属性特効与ダメージアップ
    ko: 우주 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3083
1000212:
  _id_: 1000212
  description:
    en: '(Passive) [Space Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dmg to Moon Up
    ja: 宙属性立ち位置後の月属性特効与ダメージアップ
    ko: 우주 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3083
1000213:
  _id_: 1000213
  description:
    en: '(Passive) [Space Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dmg to Space Up
    ja: 宙属性立ち位置後の宙属性特効与ダメージアップ
    ko: 우주 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3083
1000214:
  _id_: 1000214
  description:
    en: '(Passive) [Space Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dmg to Cloud Up
    ja: 宙属性立ち位置後の雲属性特効与ダメージアップ
    ko: 우주 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3083
1000215:
  _id_: 1000215
  description:
    en: '(Passive) [Space Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Rear Position Dmg to Dream Up
    ja: 宙属性立ち位置後の夢属性特効与ダメージアップ
    ko: 우주 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3083
1000216:
  _id_: 1000216
  description:
    en: '(Passive) [Space Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [우주 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Space Rear Position Normal Defense Up
    ja: 宙属性立ち位置後の通常防御力アップ
    ko: 우주 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升宙屬性站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3083
1000217:
  _id_: 1000217
  description:
    en: '(Passive) [Space Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [우주 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Space Rear Position Special Defense Up
    ja: 宙属性立ち位置後の特殊防御力アップ
    ko: 우주 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升宙屬性站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3083
1000218:
  _id_: 1000218
  description:
    en: '(Passive) [Space Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Space Rear Position Normal Defense Up
    ja: 宙属性立ち位置後の通常防御力アップ
    ko: 우주 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升宙屬性站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3083
1000219:
  _id_: 1000219
  description:
    en: '(Passive) [Space Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Space Rear Position Special Defense Up
    ja: 宙属性立ち位置後の特殊防御力アップ
    ko: 우주 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升宙屬性站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3083
1000220:
  _id_: 1000220
  description:
    en: '(Passive) [Space Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Space Rear Position Dexterity Up
    ja: 宙属性立ち位置後のクリティカル率アップ
    ko: 우주 속성 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升宙屬性站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3083
1000221:
  _id_: 1000221
  description:
    en: '(Passive) [Space Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Space Rear Position Critical Up
    ja: 宙属性立ち位置後のクリティカル威力アップ
    ko: 우주 속성 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升宙屬性站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3083
1000301:
  _id_: 1000301
  description:
    en: '(Passive) [Flower Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [꽃 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Flower Rear Position Act Power Up
    ja: 花属性立ち位置後のACTパワーアップ
    ko: 꽃 속성 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升花屬性站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3053
1000302:
  _id_: 1000302
  description:
    en: '(Passive) [Flower Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Flower Dmg Received Down
    ja: 花属性立ち位置後の花属性被ダメージダウン
    ko: 꽃 속성 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕花屬性站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3053
1000303:
  _id_: 1000303
  description:
    en: '(Passive) [Flower Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Wind Dmg Received Down
    ja: 花属性立ち位置後の風属性被ダメージダウン
    ko: 꽃 속성 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕花屬性站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3053
1000304:
  _id_: 1000304
  description:
    en: '(Passive) [Flower Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Snow Dmg Received Down
    ja: 花属性立ち位置後の雪属性被ダメージダウン
    ko: 꽃 속성 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕花屬性站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3053
1000305:
  _id_: 1000305
  description:
    en: '(Passive) [Flower Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Moon Dmg Received Down
    ja: 花属性立ち位置後の月属性被ダメージダウン
    ko: 꽃 속성 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕花屬性站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3053
1000306:
  _id_: 1000306
  description:
    en: '(Passive) [Flower Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Space Dmg Received Down
    ja: 花属性立ち位置後の宙属性被ダメージダウン
    ko: 꽃 속성 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕花屬性站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3053
1000307:
  _id_: 1000307
  description:
    en: '(Passive) [Flower Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Cloud Dmg Received Down
    ja: 花属性立ち位置後の雲属性被ダメージダウン
    ko: 꽃 속성 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕花屬性站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3053
1000308:
  _id_: 1000308
  description:
    en: '(Passive) [Flower Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dream Dmg Received Down
    ja: 花属性立ち位置後の夢属性被ダメージダウン
    ko: 꽃 속성 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕花屬性站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3053
1000309:
  _id_: 1000309
  description:
    en: '(Passive) [Flower Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dmg to Flower Up
    ja: 花属性立ち位置後の花属性特効与ダメージアップ
    ko: 꽃 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3053
1000310:
  _id_: 1000310
  description:
    en: '(Passive) [Flower Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dmg to Wind Up
    ja: 花属性立ち位置後の風属性特効与ダメージアップ
    ko: 꽃 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3053
1000311:
  _id_: 1000311
  description:
    en: '(Passive) [Flower Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dmg to Snow Up
    ja: 花属性立ち位置後の雪属性特効与ダメージアップ
    ko: 꽃 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3053
1000312:
  _id_: 1000312
  description:
    en: '(Passive) [Flower Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dmg to Moon Up
    ja: 花属性立ち位置後の月属性特効与ダメージアップ
    ko: 꽃 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3053
1000313:
  _id_: 1000313
  description:
    en: '(Passive) [Flower Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dmg to Space Up
    ja: 花属性立ち位置後の宙属性特効与ダメージアップ
    ko: 꽃 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3053
1000314:
  _id_: 1000314
  description:
    en: '(Passive) [Flower Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dmg to Cloud Up
    ja: 花属性立ち位置後の雲属性特効与ダメージアップ
    ko: 꽃 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3053
1000315:
  _id_: 1000315
  description:
    en: '(Passive) [Flower Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Rear Position Dmg to Dream Up
    ja: 花属性立ち位置後の夢属性特効与ダメージアップ
    ko: 꽃 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3053
1000316:
  _id_: 1000316
  description:
    en: '(Passive) [Flower Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [꽃 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Flower Rear Position Normal Defense Up
    ja: 花属性立ち位置後の通常防御力アップ
    ko: 꽃 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升花屬性站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3053
1000317:
  _id_: 1000317
  description:
    en: '(Passive) [Flower Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [꽃 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Flower Rear Position Special Defense Up
    ja: 花属性立ち位置後の特殊防御力アップ
    ko: 꽃 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升花屬性站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3053
1000318:
  _id_: 1000318
  description:
    en: '(Passive) [Flower Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Flower Rear Position Normal Defense Up
    ja: 花属性立ち位置後の通常防御力アップ
    ko: 꽃 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升花屬性站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3053
1000319:
  _id_: 1000319
  description:
    en: '(Passive) [Flower Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Flower Rear Position Special Defense Up
    ja: 花属性立ち位置後の特殊防御力アップ
    ko: 꽃 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升花屬性站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3053
1000320:
  _id_: 1000320
  description:
    en: '(Passive) [Flower Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Flower Rear Position Dexterity Up
    ja: 花属性立ち位置後のクリティカル率アップ
    ko: 꽃 속성 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升花屬性站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3053
1000321:
  _id_: 1000321
  description:
    en: '(Passive) [Flower Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Flower Rear Position Critical Up
    ja: 花属性立ち位置後のクリティカル威力アップ
    ko: 꽃 속성 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升花屬性站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3053
1000401:
  _id_: 1000401
  description:
    en: '(Passive) [Moon Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【月属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [달 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Moon Rear Position Act Power Up
    ja: 月属性立ち位置後のACTパワーアップ
    ko: 달 속성 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升月屬性站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3043
1000402:
  _id_: 1000402
  description:
    en: '(Passive) [Moon Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Flower Dmg Received Down
    ja: 月属性立ち位置後の花属性被ダメージダウン
    ko: 달 속성 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕月屬性站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3043
1000403:
  _id_: 1000403
  description:
    en: '(Passive) [Moon Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Wind Dmg Received Down
    ja: 月属性立ち位置後の風属性被ダメージダウン
    ko: 달 속성 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕月屬性站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3043
1000404:
  _id_: 1000404
  description:
    en: '(Passive) [Moon Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Snow Dmg Received Down
    ja: 月属性立ち位置後の雪属性被ダメージダウン
    ko: 달 속성 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕月屬性站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3043
1000405:
  _id_: 1000405
  description:
    en: '(Passive) [Moon Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Moon Dmg Received Down
    ja: 月属性立ち位置後の月属性被ダメージダウン
    ko: 달 속성 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕月屬性站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3043
1000406:
  _id_: 1000406
  description:
    en: '(Passive) [Moon Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Space Dmg Received Down
    ja: 月属性立ち位置後の宙属性被ダメージダウン
    ko: 달 속성 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕月屬性站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3043
1000407:
  _id_: 1000407
  description:
    en: '(Passive) [Moon Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Cloud Dmg Received Down
    ja: 月属性立ち位置後の雲属性被ダメージダウン
    ko: 달 속성 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕月屬性站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3043
1000408:
  _id_: 1000408
  description:
    en: '(Passive) [Moon Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dream Dmg Received Down
    ja: 月属性立ち位置後の夢属性被ダメージダウン
    ko: 달 속성 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕月屬性站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3043
1000409:
  _id_: 1000409
  description:
    en: '(Passive) [Moon Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dmg to Flower Up
    ja: 月属性立ち位置後の花属性特効与ダメージアップ
    ko: 달 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3043
1000410:
  _id_: 1000410
  description:
    en: '(Passive) [Moon Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dmg to Wind Up
    ja: 月属性立ち位置後の風属性特効与ダメージアップ
    ko: 달 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3043
1000411:
  _id_: 1000411
  description:
    en: '(Passive) [Moon Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dmg to Snow Up
    ja: 月属性立ち位置後の雪属性特効与ダメージアップ
    ko: 달 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3043
1000412:
  _id_: 1000412
  description:
    en: '(Passive) [Moon Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dmg to Moon Up
    ja: 月属性立ち位置後の月属性特効与ダメージアップ
    ko: 달 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3043
1000413:
  _id_: 1000413
  description:
    en: '(Passive) [Moon Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dmg to Space Up
    ja: 月属性立ち位置後の宙属性特効与ダメージアップ
    ko: 달 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3043
1000414:
  _id_: 1000414
  description:
    en: '(Passive) [Moon Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dmg to Cloud Up
    ja: 月属性立ち位置後の雲属性特効与ダメージアップ
    ko: 달 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3043
1000415:
  _id_: 1000415
  description:
    en: '(Passive) [Moon Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Rear Position Dmg to Dream Up
    ja: 月属性立ち位置後の夢属性特効与ダメージアップ
    ko: 달 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3043
1000416:
  _id_: 1000416
  description:
    en: '(Passive) [Moon Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [달 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Moon Rear Position Normal Defense Up
    ja: 月属性立ち位置後の通常防御力アップ
    ko: 달 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升月屬性站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3043
1000417:
  _id_: 1000417
  description:
    en: '(Passive) [Moon Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [달 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Moon Rear Position Special Defense Up
    ja: 月属性立ち位置後の特殊防御力アップ
    ko: 달 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升月屬性站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3043
1000418:
  _id_: 1000418
  description:
    en: '(Passive) [Moon Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Moon Rear Position Normal Defense Up
    ja: 月属性立ち位置後の通常防御力アップ
    ko: 달 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升月屬性站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3043
1000419:
  _id_: 1000419
  description:
    en: '(Passive) [Moon Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Moon Rear Position Special Defense Up
    ja: 月属性立ち位置後の特殊防御力アップ
    ko: 달 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升月屬性站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3043
1000420:
  _id_: 1000420
  description:
    en: '(Passive) [Moon Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Moon Rear Position Dexterity Up
    ja: 月属性立ち位置後のクリティカル率アップ
    ko: 달 속성 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升月屬性站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3043
1000421:
  _id_: 1000421
  description:
    en: '(Passive) [Moon Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [달 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Moon Rear Position Critical Up
    ja: 月属性立ち位置後のクリティカル威力アップ
    ko: 달 속성 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升月屬性站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3043
1000501:
  _id_: 1000501
  description:
    en: '(Passive) [Wind Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【風属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [바람 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Wind Rear Position Act Power Up
    ja: 風属性立ち位置後のACTパワーアップ
    ko: 바람 속성 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升風屬性站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3073
1000502:
  _id_: 1000502
  description:
    en: '(Passive) [Wind Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Flower Dmg Received Down
    ja: 風属性立ち位置後の花属性被ダメージダウン
    ko: 바람 속성 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕風屬性站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3073
1000503:
  _id_: 1000503
  description:
    en: '(Passive) [Wind Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Wind Dmg Received Down
    ja: 風属性立ち位置後の風属性被ダメージダウン
    ko: 바람 속성 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕風屬性站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3073
1000504:
  _id_: 1000504
  description:
    en: '(Passive) [Wind Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Snow Dmg Received Down
    ja: 風属性立ち位置後の雪属性被ダメージダウン
    ko: 바람 속성 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕風屬性站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3073
1000505:
  _id_: 1000505
  description:
    en: '(Passive) [Wind Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Moon Dmg Received Down
    ja: 風属性立ち位置後の月属性被ダメージダウン
    ko: 바람 속성 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕風屬性站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3073
1000506:
  _id_: 1000506
  description:
    en: '(Passive) [Wind Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Space Dmg Received Down
    ja: 風属性立ち位置後の宙属性被ダメージダウン
    ko: 바람 속성 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕風屬性站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3073
1000507:
  _id_: 1000507
  description:
    en: '(Passive) [Wind Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Cloud Dmg Received Down
    ja: 風属性立ち位置後の雲属性被ダメージダウン
    ko: 바람 속성 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕風屬性站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3073
1000508:
  _id_: 1000508
  description:
    en: '(Passive) [Wind Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dream Dmg Received Down
    ja: 風属性立ち位置後の夢属性被ダメージダウン
    ko: 바람 속성 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕風屬性站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3073
1000509:
  _id_: 1000509
  description:
    en: '(Passive) [Wind Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dmg to Flower Up
    ja: 風属性立ち位置後の花属性特効与ダメージアップ
    ko: 바람 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3073
1000510:
  _id_: 1000510
  description:
    en: '(Passive) [Wind Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dmg to Wind Up
    ja: 風属性立ち位置後の風属性特効与ダメージアップ
    ko: 바람 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3073
1000511:
  _id_: 1000511
  description:
    en: '(Passive) [Wind Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dmg to Snow Up
    ja: 風属性立ち位置後の雪属性特効与ダメージアップ
    ko: 바람 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3073
1000512:
  _id_: 1000512
  description:
    en: '(Passive) [Wind Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dmg to Moon Up
    ja: 風属性立ち位置後の月属性特効与ダメージアップ
    ko: 바람 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3073
1000513:
  _id_: 1000513
  description:
    en: '(Passive) [Wind Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dmg to Space Up
    ja: 風属性立ち位置後の宙属性特効与ダメージアップ
    ko: 바람 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3073
1000514:
  _id_: 1000514
  description:
    en: '(Passive) [Wind Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dmg to Cloud Up
    ja: 風属性立ち位置後の雲属性特効与ダメージアップ
    ko: 바람 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3073
1000515:
  _id_: 1000515
  description:
    en: '(Passive) [Wind Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Rear Position Dmg to Dream Up
    ja: 風属性立ち位置後の夢属性特効与ダメージアップ
    ko: 바람 속성 뒤 포지션의 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3073
1000516:
  _id_: 1000516
  description:
    en: '(Passive) [Wind Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [바람 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Wind Rear Position Normal Defense Up
    ja: 風属性立ち位置後の通常防御力アップ
    ko: 바람 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升風屬性站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3073
1000517:
  _id_: 1000517
  description:
    en: '(Passive) [Wind Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [바람 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Wind Rear Position Special Defense Up
    ja: 風属性立ち位置後の特殊防御力アップ
    ko: 바람 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升風屬性站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3073
1000518:
  _id_: 1000518
  description:
    en: '(Passive) [Wind Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Wind Rear Position Normal Defense Up
    ja: 風属性立ち位置後の通常防御力アップ
    ko: 바람 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升風屬性站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3073
1000519:
  _id_: 1000519
  description:
    en: '(Passive) [Wind Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Wind Rear Position Special Defense Up
    ja: 風属性立ち位置後の特殊防御力アップ
    ko: 바람 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升風屬性站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3073
1000520:
  _id_: 1000520
  description:
    en: '(Passive) [Wind Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Wind Rear Position Dexterity Up
    ja: 風属性立ち位置後のクリティカル率アップ
    ko: 바람 속성 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升風屬性站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3073
1000521:
  _id_: 1000521
  description:
    en: '(Passive) [Wind Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Wind Rear Position Critical Up
    ja: 風属性立ち位置後のクリティカル威力アップ
    ko: 바람 속성 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升風屬性站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3073
1000601:
  _id_: 1000601
  description:
    en: '(Passive) [Seisho Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [세이쇼 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Seisho Rear Position Act Power Up
    ja: 聖翔立ち位置後のACTパワーアップ
    ko: 세이쇼 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升聖翔站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3003
1000602:
  _id_: 1000602
  description:
    en: '(Passive) [Seisho Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Flower Dmg Received Down
    ja: 聖翔立ち位置後の花属性被ダメージダウン
    ko: 세이쇼 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕聖翔站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3003
1000603:
  _id_: 1000603
  description:
    en: '(Passive) [Seisho Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Wind Dmg Received Down
    ja: 聖翔立ち位置後の風属性被ダメージダウン
    ko: 세이쇼 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕聖翔站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3003
1000604:
  _id_: 1000604
  description:
    en: '(Passive) [Seisho Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Snow Dmg Received Down
    ja: 聖翔立ち位置後の雪属性被ダメージダウン
    ko: 세이쇼 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕聖翔站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3003
1000605:
  _id_: 1000605
  description:
    en: '(Passive) [Seisho Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Moon Dmg Received Down
    ja: 聖翔立ち位置後の月属性被ダメージダウン
    ko: 세이쇼 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕聖翔站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3003
1000606:
  _id_: 1000606
  description:
    en: '(Passive) [Seisho Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Space Dmg Received Down
    ja: 聖翔立ち位置後の宙属性被ダメージダウン
    ko: 세이쇼 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕聖翔站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3003
1000607:
  _id_: 1000607
  description:
    en: '(Passive) [Seisho Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Cloud Dmg Received Down
    ja: 聖翔立ち位置後の雲属性被ダメージダウン
    ko: 세이쇼 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕聖翔站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3003
1000608:
  _id_: 1000608
  description:
    en: '(Passive) [Seisho Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dream Dmg Received Down
    ja: 聖翔立ち位置後の夢属性被ダメージダウン
    ko: 세이쇼 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕聖翔站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3003
1000609:
  _id_: 1000609
  description:
    en: '(Passive) [Seisho Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dmg to Flower Up
    ja: 聖翔立ち位置後の花属性特効与ダメージアップ
    ko: 세이쇼 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3003
1000610:
  _id_: 1000610
  description:
    en: '(Passive) [Seisho Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dmg to Wind Up
    ja: 聖翔立ち位置後の風属性特効与ダメージアップ
    ko: 세이쇼 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3003
1000611:
  _id_: 1000611
  description:
    en: '(Passive) [Seisho Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dmg to Snow Up
    ja: 聖翔立ち位置後の雪属性特効与ダメージアップ
    ko: 세이쇼 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3003
1000612:
  _id_: 1000612
  description:
    en: '(Passive) [Seisho Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dmg to Moon Up
    ja: 聖翔立ち位置後の月属性特効与ダメージアップ
    ko: 세이쇼 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3003
1000613:
  _id_: 1000613
  description:
    en: '(Passive) [Seisho Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dmg to Space Up
    ja: 聖翔立ち位置後の宙属性特効与ダメージアップ
    ko: 세이쇼 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3003
1000614:
  _id_: 1000614
  description:
    en: '(Passive) [Seisho Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dmg to Cloud Up
    ja: 聖翔立ち位置後の雲属性特効与ダメージアップ
    ko: 세이쇼 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3003
1000615:
  _id_: 1000615
  description:
    en: '(Passive) [Seisho Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dmg to Dream Up
    ja: 聖翔立ち位置後の夢属性特効与ダメージアップ
    ko: 세이쇼 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3003
1000616:
  _id_: 1000616
  description:
    en: '(Passive) [Seisho Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [세이쇼 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Seisho Rear Position Normal Defense Up
    ja: 聖翔立ち位置後の通常防御力アップ
    ko: 세이쇼 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升聖翔站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3003
1000617:
  _id_: 1000617
  description:
    en: '(Passive) [Seisho Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [세이쇼 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Seisho Rear Position Special Defense Up
    ja: 聖翔立ち位置後の特殊防御力アップ
    ko: 세이쇼 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升聖翔站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3003
1000618:
  _id_: 1000618
  description:
    en: '(Passive) [Seisho Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Seisho Rear Position Normal Defense Up
    ja: 聖翔立ち位置後の通常防御力アップ
    ko: 세이쇼 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升聖翔站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3003
1000619:
  _id_: 1000619
  description:
    en: '(Passive) [Seisho Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Seisho Rear Position Special Defense Up
    ja: 聖翔立ち位置後の特殊防御力アップ
    ko: 세이쇼 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升聖翔站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3003
1000620:
  _id_: 1000620
  description:
    en: '(Passive) [Seisho Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Seisho Rear Position Dexterity Up
    ja: 聖翔立ち位置後のクリティカル率アップ
    ko: 세이쇼 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升聖翔站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3003
1000621:
  _id_: 1000621
  description:
    en: '(Passive) [Seisho Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Seisho Rear Position Critical Up
    ja: 聖翔立ち位置後のクリティカル威力アップ
    ko: 세이쇼 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升聖翔站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3003
1000701:
  _id_: 1000701
  description:
    en: '(Passive) [Cloud Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [구름 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Cloud Rear Position Act Power Up
    ja: 雲属性立ち位置後のACTパワーアップ
    ko: 구름 속성 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升雲屬性站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3093
1000702:
  _id_: 1000702
  description:
    en: '(Passive) [Cloud Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Flower Dmg Received Down
    ja: 雲属性立ち位置後の花属性被ダメージダウン
    ko: 구름 속성 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3093
1000703:
  _id_: 1000703
  description:
    en: '(Passive) [Cloud Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Wind Dmg Received Down
    ja: 雲属性立ち位置後の風属性被ダメージダウン
    ko: 구름 속성 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3093
1000704:
  _id_: 1000704
  description:
    en: '(Passive) [Cloud Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Snow Dmg Received Down
    ja: 雲属性立ち位置後の雪属性被ダメージダウン
    ko: 구름 속성 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3093
1000705:
  _id_: 1000705
  description:
    en: '(Passive) [Cloud Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Moon Dmg Received Down
    ja: 雲属性立ち位置後の月属性被ダメージダウン
    ko: 구름 속성 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3093
1000706:
  _id_: 1000706
  description:
    en: '(Passive) [Cloud Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Space Dmg Received Down
    ja: 雲属性立ち位置後の宙属性被ダメージダウン
    ko: 구름 속성 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3093
1000707:
  _id_: 1000707
  description:
    en: '(Passive) [Cloud Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Cloud Dmg Received Down
    ja: 雲属性立ち位置後の雲属性被ダメージダウン
    ko: 구름 속성 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3093
1000708:
  _id_: 1000708
  description:
    en: '(Passive) [Cloud Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dream Dmg Received Down
    ja: 雲属性立ち位置後の夢属性被ダメージダウン
    ko: 구름 속성 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3093
1000709:
  _id_: 1000709
  description:
    en: '(Passive) [Cloud Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dmg to Flower Up
    ja: 雲属性立ち位置後の花属性特効与ダメージアップ
    ko: 구름 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3093
1000710:
  _id_: 1000710
  description:
    en: '(Passive) [Cloud Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dmg to Wind Up
    ja: 雲属性立ち位置後の風属性特効与ダメージアップ
    ko: 구름 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3093
1000711:
  _id_: 1000711
  description:
    en: '(Passive) [Cloud Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dmg to Snow Up
    ja: 雲属性立ち位置後の雪属性特効与ダメージアップ
    ko: 구름 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3093
1000712:
  _id_: 1000712
  description:
    en: '(Passive) [Cloud Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dmg to Moon Up
    ja: 雲属性立ち位置後の月属性特効与ダメージアップ
    ko: 구름 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3093
1000713:
  _id_: 1000713
  description:
    en: '(Passive) [Cloud Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dmg to Space Up
    ja: 雲属性立ち位置後の宙属性特効与ダメージアップ
    ko: 구름 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3093
1000714:
  _id_: 1000714
  description:
    en: '(Passive) [Cloud Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dmg to Cloud Up
    ja: 雲属性立ち位置後の雲属性特効与ダメージアップ
    ko: 구름 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3093
1000715:
  _id_: 1000715
  description:
    en: '(Passive) [Cloud Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dmg to Dream Up
    ja: 雲属性立ち位置後の夢属性特効与ダメージアップ
    ko: 구름 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3093
1000716:
  _id_: 1000716
  description:
    en: '(Passive) [Cloud Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [구름 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Cloud Rear Position Normal Defense Up
    ja: 雲属性立ち位置後の通常防御力アップ
    ko: 구름 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升雲屬性站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3093
1000717:
  _id_: 1000717
  description:
    en: '(Passive) [Cloud Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [구름 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Cloud Rear Position Special Defense Up
    ja: 雲属性立ち位置後の特殊防御力アップ
    ko: 구름 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升雲屬性站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3093
1000718:
  _id_: 1000718
  description:
    en: '(Passive) [Cloud Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Cloud Rear Position Normal Defense Up
    ja: 雲属性立ち位置後の通常防御力アップ
    ko: 구름 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升雲屬性站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3093
1000719:
  _id_: 1000719
  description:
    en: '(Passive) [Cloud Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Cloud Rear Position Special Defense Up
    ja: 雲属性立ち位置後の特殊防御力アップ
    ko: 구름 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升雲屬性站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3093
1000720:
  _id_: 1000720
  description:
    en: '(Passive) [Cloud Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Cloud Rear Position Dexterity Up
    ja: 雲属性立ち位置後のクリティカル率アップ
    ko: 구름 속성 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升雲屬性站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3093
1000721:
  _id_: 1000721
  description:
    en: '(Passive) [Cloud Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Cloud Rear Position Critical Up
    ja: 雲属性立ち位置後のクリティカル威力アップ
    ko: 구름 속성 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升雲屬性站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3093
1000801:
  _id_: 1000801
  description:
    en: '(Passive) [Seisho Front Position] Act Power Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [세이쇼 앞 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的ACT力量 +%opt1_value%'
  name:
    en: Seisho Front Position Act Power Up
    ja: 聖翔立ち位置前のACTパワーアップ
    ko: 세이쇼 앞 포지션의 ACT 파워 증가
    zh_hant: 提升聖翔站位為前的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3001
1000802:
  _id_: 1000802
  description:
    en: '(Passive) [Seisho Front Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為前】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Flower Dmg Received Down
    ja: 聖翔立ち位置前の花属性被ダメージダウン
    ko: 세이쇼 앞 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕聖翔站位為前受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3001
1000803:
  _id_: 1000803
  description:
    en: '(Passive) [Seisho Front Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為前】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Wind Dmg Received Down
    ja: 聖翔立ち位置前の風属性被ダメージダウン
    ko: 세이쇼 앞 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕聖翔站位為前受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3001
1000804:
  _id_: 1000804
  description:
    en: '(Passive) [Seisho Front Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為前】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Snow Dmg Received Down
    ja: 聖翔立ち位置前の雪属性被ダメージダウン
    ko: 세이쇼 앞 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕聖翔站位為前受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3001
1000805:
  _id_: 1000805
  description:
    en: '(Passive) [Seisho Front Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為前】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Moon Dmg Received Down
    ja: 聖翔立ち位置前の月属性被ダメージダウン
    ko: 세이쇼 앞 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕聖翔站位為前受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3001
1000806:
  _id_: 1000806
  description:
    en: '(Passive) [Seisho Front Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為前】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Space Dmg Received Down
    ja: 聖翔立ち位置前の宙属性被ダメージダウン
    ko: 세이쇼 앞 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕聖翔站位為前受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3001
1000807:
  _id_: 1000807
  description:
    en: '(Passive) [Seisho Front Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為前】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Cloud Dmg Received Down
    ja: 聖翔立ち位置前の雲属性被ダメージダウン
    ko: 세이쇼 앞 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕聖翔站位為前受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3001
1000808:
  _id_: 1000808
  description:
    en: '(Passive) [Seisho Front Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【聖翔且站位為前】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dream Dmg Received Down
    ja: 聖翔立ち位置前の夢属性被ダメージダウン
    ko: 세이쇼 앞 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕聖翔站位為前受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3001
1000809:
  _id_: 1000809
  description:
    en: '(Passive) [Seisho Front Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dmg to Flower Up
    ja: 聖翔立ち位置前の花属性特効与ダメージアップ
    ko: 세이쇼 앞 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為前的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3001
1000810:
  _id_: 1000810
  description:
    en: '(Passive) [Seisho Front Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dmg to Wind Up
    ja: 聖翔立ち位置前の風属性特効与ダメージアップ
    ko: 세이쇼 앞 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為前的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3001
1000811:
  _id_: 1000811
  description:
    en: '(Passive) [Seisho Front Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dmg to Snow Up
    ja: 聖翔立ち位置前の雪属性特効与ダメージアップ
    ko: 세이쇼 앞 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為前的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3001
1000812:
  _id_: 1000812
  description:
    en: '(Passive) [Seisho Front Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dmg to Moon Up
    ja: 聖翔立ち位置前の月属性特効与ダメージアップ
    ko: 세이쇼 앞 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為前的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3001
1000813:
  _id_: 1000813
  description:
    en: '(Passive) [Seisho Front Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dmg to Space Up
    ja: 聖翔立ち位置前の宙属性特効与ダメージアップ
    ko: 세이쇼 앞 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為前的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3001
1000814:
  _id_: 1000814
  description:
    en: '(Passive) [Seisho Front Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dmg to Cloud Up
    ja: 聖翔立ち位置前の雲属性特効与ダメージアップ
    ko: 세이쇼 앞 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為前的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3001
1000815:
  _id_: 1000815
  description:
    en: '(Passive) [Seisho Front Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seisho Front Position Dmg to Dream Up
    ja: 聖翔立ち位置前の夢属性特効与ダメージアップ
    ko: 세이쇼 앞 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升聖翔站位為前的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3001
1000816:
  _id_: 1000816
  description:
    en: '(Passive) [Seisho Front Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [세이쇼 앞 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的普通防禦力 +%opt1_value%'
  name:
    en: Seisho Front Position Normal Defense Up
    ja: 聖翔立ち位置前の通常防御力アップ
    ko: 세이쇼 앞 포지션의 일반 방어력 증가
    zh_hant: 提升聖翔站位為前的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3001
1000817:
  _id_: 1000817
  description:
    en: '(Passive) [Seisho Front Position] Special Defense Up %opt1_value% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [세이쇼 앞 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的特殊防禦力 +%opt1_value%'
  name:
    en: Seisho Front Position Special Defense Up
    ja: 聖翔立ち位置前の特殊防御力アップ
    ko: 세이쇼 앞 포지션의 특수 방어력 증가
    zh_hant: 提升聖翔站位為前的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3001
1000818:
  _id_: 1000818
  description:
    en: '(Passive) [Seisho Front Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的普通防禦力 +%opt1_value%%'
  name:
    en: Seisho Front Position Normal Defense Up
    ja: 聖翔立ち位置前の通常防御力アップ
    ko: 세이쇼 앞 포지션의 일반 방어력 증가
    zh_hant: 提升聖翔站位為前的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3001
1000819:
  _id_: 1000819
  description:
    en: '(Passive) [Seisho Front Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的特殊防禦力 +%opt1_value%%'
  name:
    en: Seisho Front Position Special Defense Up
    ja: 聖翔立ち位置前の特殊防御力アップ
    ko: 세이쇼 앞 포지션의 특수 방어력 증가
    zh_hant: 提升聖翔站位為前的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3001
1000820:
  _id_: 1000820
  description:
    en: '(Passive) [Seisho Front Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的會心率 +%opt1_value%%'
  name:
    en: Seisho Front Position Dexterity Up
    ja: 聖翔立ち位置前のクリティカル率アップ
    ko: 세이쇼 앞 포지션의 크리티컬 확률 증가
    zh_hant: 提升聖翔站位為前的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3001
1000821:
  _id_: 1000821
  description:
    en: '(Passive) [Seisho Front Position] Critical Up %opt1_value%% '
    ja: '[永続]【聖翔かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [세이쇼 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【聖翔且站位為前】的會心威力 +%opt1_value%%'
  name:
    en: Seisho Front Position Critical Up
    ja: 聖翔立ち位置前のクリティカル威力アップ
    ko: 세이쇼 앞 포지션의 크리티컬 위력 증가
    zh_hant: 提升聖翔站位為前的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3001
1000901:
  _id_: 1000901
  description:
    en: '(Passive) [Flower Center Position] Act Power Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [꽃 속성 중간 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的ACT力量 +%opt1_value%'
  name:
    en: Flower Center Position Act Power Up
    ja: 花属性立ち位置中のACTパワーアップ
    ko: 꽃 속성 중간 포지션의 ACT 파워 증가
    zh_hant: 提升花屬性站位為中的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3052
1000902:
  _id_: 1000902
  description:
    en: '(Passive) [Flower Center Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為中】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Flower Dmg Received Down
    ja: 花属性立ち位置中の花属性被ダメージダウン
    ko: 꽃 속성 중간 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕花屬性站位為中受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3052
1000903:
  _id_: 1000903
  description:
    en: '(Passive) [Flower Center Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為中】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Wind Dmg Received Down
    ja: 花属性立ち位置中の風属性被ダメージダウン
    ko: 꽃 속성 중간 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕花屬性站位為中受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3052
1000904:
  _id_: 1000904
  description:
    en: '(Passive) [Flower Center Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為中】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Snow Dmg Received Down
    ja: 花属性立ち位置中の雪属性被ダメージダウン
    ko: 꽃 속성 중간 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕花屬性站位為中受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3052
1000905:
  _id_: 1000905
  description:
    en: '(Passive) [Flower Center Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為中】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Moon Dmg Received Down
    ja: 花属性立ち位置中の月属性被ダメージダウン
    ko: 꽃 속성 중간 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕花屬性站位為中受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3052
1000906:
  _id_: 1000906
  description:
    en: '(Passive) [Flower Center Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為中】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Space Dmg Received Down
    ja: 花属性立ち位置中の宙属性被ダメージダウン
    ko: 꽃 속성 중간 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕花屬性站位為中受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3052
1000907:
  _id_: 1000907
  description:
    en: '(Passive) [Flower Center Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為中】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Cloud Dmg Received Down
    ja: 花属性立ち位置中の雲属性被ダメージダウン
    ko: 꽃 속성 중간 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕花屬性站位為中受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3052
1000908:
  _id_: 1000908
  description:
    en: '(Passive) [Flower Center Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為中】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dream Dmg Received Down
    ja: 花属性立ち位置中の夢属性被ダメージダウン
    ko: 꽃 속성 중간 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕花屬性站位為中受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3052
1000909:
  _id_: 1000909
  description:
    en: '(Passive) [Flower Center Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dmg to Flower Up
    ja: 花属性立ち位置中の花属性特効与ダメージアップ
    ko: 꽃 속성 중간 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為中的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3052
1000910:
  _id_: 1000910
  description:
    en: '(Passive) [Flower Center Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dmg to Wind Up
    ja: 花属性立ち位置中の風属性特効与ダメージアップ
    ko: 꽃 속성 중간 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為中的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3052
1000911:
  _id_: 1000911
  description:
    en: '(Passive) [Flower Center Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dmg to Snow Up
    ja: 花属性立ち位置中の雪属性特効与ダメージアップ
    ko: 꽃 속성 중간 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為中的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3052
1000912:
  _id_: 1000912
  description:
    en: '(Passive) [Flower Center Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dmg to Moon Up
    ja: 花属性立ち位置中の月属性特効与ダメージアップ
    ko: 꽃 속성 중간 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為中的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3052
1000913:
  _id_: 1000913
  description:
    en: '(Passive) [Flower Center Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dmg to Space Up
    ja: 花属性立ち位置中の宙属性特効与ダメージアップ
    ko: 꽃 속성 중간 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為中的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3052
1000914:
  _id_: 1000914
  description:
    en: '(Passive) [Flower Center Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dmg to Cloud Up
    ja: 花属性立ち位置中の雲属性特効与ダメージアップ
    ko: 꽃 속성 중간 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為中的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3052
1000915:
  _id_: 1000915
  description:
    en: '(Passive) [Flower Center Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Center Position Dmg to Dream Up
    ja: 花属性立ち位置中の夢属性特効与ダメージアップ
    ko: 꽃 속성 중간 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為中的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3052
1000916:
  _id_: 1000916
  description:
    en: '(Passive) [Flower Center Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [꽃 속성 중간 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的普通防禦力 +%opt1_value%'
  name:
    en: Flower Center Position Normal Defense Up
    ja: 花属性立ち位置中の通常防御力アップ
    ko: 꽃 속성 중간 포지션의 일반 방어력 증가
    zh_hant: 提升花屬性站位為中的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3052
1000917:
  _id_: 1000917
  description:
    en: '(Passive) [Flower Center Position] Special Defense Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [꽃 속성 중간 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的特殊防禦力 +%opt1_value%'
  name:
    en: Flower Center Position Special Defense Up
    ja: 花属性立ち位置中の特殊防御力アップ
    ko: 꽃 속성 중간 포지션의 특수 방어력 증가
    zh_hant: 提升花屬性站位為中的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3052
1000918:
  _id_: 1000918
  description:
    en: '(Passive) [Flower Center Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的普通防禦力 +%opt1_value%%'
  name:
    en: Flower Center Position Normal Defense Up
    ja: 花属性立ち位置中の通常防御力アップ
    ko: 꽃 속성 중간 포지션의 일반 방어력 증가
    zh_hant: 提升花屬性站位為中的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3052
1000919:
  _id_: 1000919
  description:
    en: '(Passive) [Flower Center Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的特殊防禦力 +%opt1_value%%'
  name:
    en: Flower Center Position Special Defense Up
    ja: 花属性立ち位置中の特殊防御力アップ
    ko: 꽃 속성 중간 포지션의 특수 방어력 증가
    zh_hant: 提升花屬性站位為中的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3052
1000920:
  _id_: 1000920
  description:
    en: '(Passive) [Flower Center Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的會心率 +%opt1_value%%'
  name:
    en: Flower Center Position Dexterity Up
    ja: 花属性立ち位置中のクリティカル率アップ
    ko: 꽃 속성 중간 포지션의 크리티컬 확률 증가
    zh_hant: 提升花屬性站位為中的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3052
1000921:
  _id_: 1000921
  description:
    en: '(Passive) [Flower Center Position] Critical Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為中】的會心威力 +%opt1_value%%'
  name:
    en: Flower Center Position Critical Up
    ja: 花属性立ち位置中のクリティカル威力アップ
    ko: 꽃 속성 중간 포지션의 크리티컬 위력 증가
    zh_hant: 提升花屬性站位為中的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3052
1100101:
  _id_: 1100101
  description:
    en: '(Passive) [Snow Front Position] Act Power Up %opt1_value% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [눈 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的ACT力量 +%opt1_value%'
  name:
    en: Snow Front Position Act Power Up
    ja: 雪属性立ち位置前のACTパワーアップ
    ko: 눈 속성 앞 포지션의 ACT 파워 증가
    zh_hant: 提升雪屬性站位為前的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3061
1100102:
  _id_: 1100102
  description:
    en: '(Passive) [Snow Front Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為前】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Flower Dmg Received Down
    ja: 雪属性立ち位置前の花属性被ダメージダウン
    ko: 눈 속성 앞 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為前受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3061
1100103:
  _id_: 1100103
  description:
    en: '(Passive) [Snow Front Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為前】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Wind Dmg Received Down
    ja: 雪属性立ち位置前の風属性被ダメージダウン
    ko: 눈 속성 앞 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為前受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3061
1100104:
  _id_: 1100104
  description:
    en: '(Passive) [Snow Front Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Snow Dmg Received Down
    ja: 雪属性立ち位置前の雪属性被ダメージダウン
    ko: 눈 속성 앞 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為前受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3061
1100105:
  _id_: 1100105
  description:
    en: '(Passive) [Snow Front Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為前】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Moon Dmg Received Down
    ja: 雪属性立ち位置前の月属性被ダメージダウン
    ko: 눈 속성 앞 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為前受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3061
1100106:
  _id_: 1100106
  description:
    en: '(Passive) [Snow Front Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Space Dmg Received Down
    ja: 雪属性立ち位置前の宙属性被ダメージダウン
    ko: 눈 속성 앞 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為前受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3061
1100107:
  _id_: 1100107
  description:
    en: '(Passive) [Snow Front Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Cloud Dmg Received Down
    ja: 雪属性立ち位置前の雲属性被ダメージダウン
    ko: 눈 속성 앞 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為前受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3061
1100108:
  _id_: 1100108
  description:
    en: '(Passive) [Snow Front Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dream Dmg Received Down
    ja: 雪属性立ち位置前の夢属性被ダメージダウン
    ko: 눈 속성 앞 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為前受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3061
1100109:
  _id_: 1100109
  description:
    en: '(Passive) [Snow Front Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dmg to Flower Up
    ja: 雪属性立ち位置前の花属性特効与ダメージアップ
    ko: 눈 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為前的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3061
1100110:
  _id_: 1100110
  description:
    en: '(Passive) [Snow Front Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dmg to Wind Up
    ja: 雪属性立ち位置前の風属性特効与ダメージアップ
    ko: 눈 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為前的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3061
1100111:
  _id_: 1100111
  description:
    en: '(Passive) [Snow Front Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dmg to Snow Up
    ja: 雪属性立ち位置前の雪属性特効与ダメージアップ
    ko: 눈 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為前的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3061
1100112:
  _id_: 1100112
  description:
    en: '(Passive) [Snow Front Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dmg to Moon Up
    ja: 雪属性立ち位置前の月属性特効与ダメージアップ
    ko: 눈 속성 앞 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為前的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3061
1100113:
  _id_: 1100113
  description:
    en: '(Passive) [Snow Front Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dmg to Space Up
    ja: 雪属性立ち位置前の宙属性特効与ダメージアップ
    ko: 눈 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為前的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3061
1100114:
  _id_: 1100114
  description:
    en: '(Passive) [Snow Front Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dmg to Cloud Up
    ja: 雪属性立ち位置前の雲属性特効与ダメージアップ
    ko: 눈 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為前的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3061
1100115:
  _id_: 1100115
  description:
    en: '(Passive) [Snow Front Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Front Position Dmg to Dream Up
    ja: 雪属性立ち位置前の夢属性特効与ダメージアップ
    ko: 눈 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為前的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3061
1100116:
  _id_: 1100116
  description:
    en: '(Passive) [Snow Front Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [눈 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的普通防禦力 +%opt1_value%'
  name:
    en: Snow Front Position Normal Defense Up
    ja: 雪属性立ち位置前の通常防御力アップ
    ko: 눈 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升雪屬性站位為前的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3061
1100117:
  _id_: 1100117
  description:
    en: '(Passive) [Snow Front Position] Special Defense Up %opt1_value% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [눈 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的特殊防禦力 +%opt1_value%'
  name:
    en: Snow Front Position Special Defense Up
    ja: 雪属性立ち位置前の特殊防御力アップ
    ko: 눈 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升雪屬性站位為前的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3061
1100118:
  _id_: 1100118
  description:
    en: '(Passive) [Snow Front Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的普通防禦力 +%opt1_value%%'
  name:
    en: Snow Front Position Normal Defense Up
    ja: 雪属性立ち位置前の通常防御力アップ
    ko: 눈 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升雪屬性站位為前的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3061
1100119:
  _id_: 1100119
  description:
    en: '(Passive) [Snow Front Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的特殊防禦力 +%opt1_value%%'
  name:
    en: Snow Front Position Special Defense Up
    ja: 雪属性立ち位置前の特殊防御力アップ
    ko: 눈 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升雪屬性站位為前的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3061
1100120:
  _id_: 1100120
  description:
    en: '(Passive) [Snow Front Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的會心率 +%opt1_value%%'
  name:
    en: Cloud Front Position Dexterity Up
    ja: 雪属性立ち位置前のクリティカル率アップ
    ko: 눈 속성 앞 포지션의 크리티컬 확률 증가
    zh_hant: 提升雪屬性站位為前的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3061
1100121:
  _id_: 1100121
  description:
    en: '(Passive) [Snow Front Position] Critical Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為前】的會心威力 +%opt1_value%%'
  name:
    en: Cloud Front Position Critical Up
    ja: 雪属性立ち位置前のクリティカル威力アップ
    ko: 눈 속성 앞 포지션의 크리티컬 위력 증가
    zh_hant: 提升雪屬性站位為前的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3061
1100122:
  _id_: 1100122
  description:
    en: '(Passive) [Hikari & Junna] Act Power Up %opt1_value% '
    ja: '[永続]【ひかりと純那】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [히카리와 준나]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【光和純那】的ACT力量 +%opt1_value%'
  name:
    en: Hikari & Junna Act Power Up
    ja: ひかりと純那のACTパワーアップ
    ko: 히카리와 준나의 ACT 파워 증가
    zh_hant: 提升光和純那的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3111
1100123:
  _id_: 1100123
  description:
    en: '(Passive) [Hikari & Junna] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和純那】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Flower Dmg Received Down
    ja: ひかりと純那の花属性被ダメージダウン
    ko: 히카리와 준나가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕光和純那受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3111
1100124:
  _id_: 1100124
  description:
    en: '(Passive) [Hikari & Junna] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和純那】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Wind Dmg Received Down
    ja: ひかりと純那の風属性被ダメージダウン
    ko: 히카리와 준나가 받는 바람 속성 대미지 감소
    zh_hant: 減輕光和純那受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3111
1100125:
  _id_: 1100125
  description:
    en: '(Passive) [Hikari & Junna] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和純那】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Snow Dmg Received Down
    ja: ひかりと純那の雪属性被ダメージダウン
    ko: 히카리와 준나가 받는 눈 속성 대미지 감소
    zh_hant: 減輕光和純那受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3111
1100126:
  _id_: 1100126
  description:
    en: '(Passive) [Hikari & Junna] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和純那】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Moon Dmg Received Down
    ja: ひかりと純那の月属性被ダメージダウン
    ko: 히카리와 준나가 받는 달 속성 대미지 감소
    zh_hant: 減輕光和純那受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3111
1100127:
  _id_: 1100127
  description:
    en: '(Passive) [Hikari & Junna] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和純那】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Space Dmg Received Down
    ja: ひかりと純那の宙属性被ダメージダウン
    ko: 히카리와 준나가 받는 우주 속성 대미지 감소
    zh_hant: 減輕光和純那受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3111
1100128:
  _id_: 1100128
  description:
    en: '(Passive) [Hikari & Junna] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和純那】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Cloud Dmg Received Down
    ja: ひかりと純那の雲属性被ダメージダウン
    ko: 히카리와 준나가 받는 구름 속성 대미지 감소
    zh_hant: 減輕光和純那受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3111
1100129:
  _id_: 1100129
  description:
    en: '(Passive) [Hikari & Junna] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和純那】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dream Dmg Received Down
    ja: ひかりと純那の夢属性被ダメージダウン
    ko: 히카리와 준나가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕光和純那受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3111
1100130:
  _id_: 1100130
  description:
    en: '(Passive) [Hikari & Junna] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dmg to Flower Up
    ja: ひかりと純那の花属性特効与ダメージアップ
    ko: 히카리와 준나가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升光和純那的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3111
1100131:
  _id_: 1100131
  description:
    en: '(Passive) [Hikari & Junna] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dmg to Wind Up
    ja: ひかりと純那の風属性特効与ダメージアップ
    ko: 히카리와 준나가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升光和純那的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3111
1100132:
  _id_: 1100132
  description:
    en: '(Passive) [Hikari & Junna] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dmg to Snow Up
    ja: ひかりと純那の雪属性特効与ダメージアップ
    ko: 히카리와 준나가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升光和純那的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3111
1100133:
  _id_: 1100133
  description:
    en: '(Passive) [Hikari & Junna] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dmg to Moon Up
    ja: ひかりと純那の月属性特効与ダメージアップ
    ko: 히카리와 준나가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升光和純那的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3111
1100134:
  _id_: 1100134
  description:
    en: '(Passive) [Hikari & Junna] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dmg to Space Up
    ja: ひかりと純那の宙属性特効与ダメージアップ
    ko: 히카리와 준나가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升光和純那的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3111
1100135:
  _id_: 1100135
  description:
    en: '(Passive) [Hikari & Junna] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dmg to Cloud Up
    ja: ひかりと純那の雲属性特効与ダメージアップ
    ko: 히카리와 준나가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升光和純那的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3111
1100136:
  _id_: 1100136
  description:
    en: '(Passive) [Hikari & Junna] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Junna Dmg to Dream Up
    ja: ひかりと純那の夢属性特効与ダメージアップ
    ko: 히카리와 준나가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升光和純那的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3111
1100137:
  _id_: 1100137
  description:
    en: '(Passive) [Hikari & Junna] Normal Defense Up %opt1_value% '
    ja: '[永続]【ひかりと純那】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [히카리와 준나]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【光和純那】的普通防禦力 +%opt1_value%'
  name:
    en: Hikari & Junna Normal Defense Up
    ja: ひかりと純那の通常防御力アップ
    ko: 히카리와 준나의 일반 방어력 증가
    zh_hant: 提升光和純那的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3111
1100138:
  _id_: 1100138
  description:
    en: '(Passive) [Hikari & Junna] Special Defense Up %opt1_value% '
    ja: '[永続]【ひかりと純那】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [히카리와 준나]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【光和純那】的特殊防禦力 +%opt1_value%'
  name:
    en: Hikari & Junna Special Defense Up
    ja: ひかりと純那の特殊防御力アップ
    ko: 히카리와 준나의 특수 방어력 증가
    zh_hant: 提升光和純那的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3111
1100139:
  _id_: 1100139
  description:
    en: '(Passive) [Hikari & Junna] Normal Defense Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的普通防禦力 +%opt1_value%%'
  name:
    en: Hikari & Junna Normal Defense Up
    ja: ひかりと純那の通常防御力アップ
    ko: 히카리와 준나의 일반 방어력 증가
    zh_hant: 提升光和純那的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3111
1100140:
  _id_: 1100140
  description:
    en: '(Passive) [Hikari & Junna] Special Defense Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的特殊防禦力 +%opt1_value%%'
  name:
    en: Hikari & Junna Special Defense Up
    ja: ひかりと純那の特殊防御力アップ
    ko: 히카리와 준나의 특수 방어력 증가
    zh_hant: 提升光和純那的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3111
1100141:
  _id_: 1100141
  description:
    en: '(Passive) [Hikari & Junna] Dexterity Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的會心率 +%opt1_value%%'
  name:
    en: Hikari & Junna Dexterity Up
    ja: ひかりと純那のクリティカル率アップ
    ko: 히카리와 준나의 크리티컬 확률 증가
    zh_hant: 提升光和純那的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3111
1100142:
  _id_: 1100142
  description:
    en: '(Passive) [Hikari & Junna] Critical Up %opt1_value%% '
    ja: '[永続]【ひかりと純那】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [히카리와 준나]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和純那】的會心威力 +%opt1_value%%'
  name:
    en: Hikari & Junna Critical Up
    ja: ひかりと純那のクリティカル威力アップ
    ko: 히카리와 준나의 크리티컬 위력 증가
    zh_hant: 提升光和純那的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3111
1100201:
  _id_: 1100201
  description:
    en: '(Passive) [Wind Front Position] Act Power Up %opt1_value% '
    ja: '[永続]【風属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [바람 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的ACT力量 +%opt1_value%'
  name:
    en: Wind Front Position Act Power Up
    ja: 風属性立ち位置前のACTパワーアップ
    ko: 바람 속성 앞 포지션의 ACT 파워 증가
    zh_hant: 提升風屬性站位為前的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3071
1100202:
  _id_: 1100202
  description:
    en: '(Passive) [Wind Front Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為前】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Flower Dmg Received Down
    ja: 風属性立ち位置前の花属性被ダメージダウン
    ko: 바람 속성 앞 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕風屬性站位為前受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3071
1100203:
  _id_: 1100203
  description:
    en: '(Passive) [Wind Front Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為前】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Wind Dmg Received Down
    ja: 風属性立ち位置前の風属性被ダメージダウン
    ko: 바람 속성 앞 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕風屬性站位為前受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3071
1100204:
  _id_: 1100204
  description:
    en: '(Passive) [Wind Front Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Snow Dmg Received Down
    ja: 風属性立ち位置前の雪属性被ダメージダウン
    ko: 바람 속성 앞 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕風屬性站位為前受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3071
1100205:
  _id_: 1100205
  description:
    en: '(Passive) [Wind Front Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為前】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Moon Dmg Received Down
    ja: 風属性立ち位置前の月属性被ダメージダウン
    ko: 바람 속성 앞 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕風屬性站位為前受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3071
1100206:
  _id_: 1100206
  description:
    en: '(Passive) [Wind Front Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Space Dmg Received Down
    ja: 風属性立ち位置前の宙属性被ダメージダウン
    ko: 바람 속성 앞 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕風屬性站位為前受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3071
1100207:
  _id_: 1100207
  description:
    en: '(Passive) [Wind Front Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Cloud Dmg Received Down
    ja: 風属性立ち位置前の雲属性被ダメージダウン
    ko: 바람 속성 앞 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕風屬性站位為前受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3071
1100208:
  _id_: 1100208
  description:
    en: '(Passive) [Wind Front Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【風屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dream Dmg Received Down
    ja: 風属性立ち位置前の夢属性被ダメージダウン
    ko: 바람 속성 앞 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕風屬性站位為前受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3071
1100209:
  _id_: 1100209
  description:
    en: '(Passive) [Wind Front Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dmg to Flower Up
    ja: 風属性立ち位置前の花属性特効与ダメージアップ
    ko: 바람 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為前的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3071
1100210:
  _id_: 1100210
  description:
    en: '(Passive) [Wind Front Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dmg to Wind Up
    ja: 風属性立ち位置前の風属性特効与ダメージアップ
    ko: 바람 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為前的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3071
1100211:
  _id_: 1100211
  description:
    en: '(Passive) [Wind Front Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dmg to Snow Up
    ja: 風属性立ち位置前の雪属性特効与ダメージアップ
    ko: 바람 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為前的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3071
1100212:
  _id_: 1100212
  description:
    en: '(Passive) [Wind Front Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dmg to Moon Up
    ja: 風属性立ち位置前の月属性特効与ダメージアップ
    ko: 바람 속성 앞 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為前的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3071
1100213:
  _id_: 1100213
  description:
    en: '(Passive) [Wind Front Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dmg to Space Up
    ja: 風属性立ち位置前の宙属性特効与ダメージアップ
    ko: 바람 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為前的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3071
1100214:
  _id_: 1100214
  description:
    en: '(Passive) [Wind Front Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dmg to Cloud Up
    ja: 風属性立ち位置前の雲属性特効与ダメージアップ
    ko: 바람 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為前的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3071
1100215:
  _id_: 1100215
  description:
    en: '(Passive) [Wind Front Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Wind Front Position Dmg to Dream Up
    ja: 風属性立ち位置前の夢属性特効与ダメージアップ
    ko: 바람 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升風屬性站位為前的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3071
1100216:
  _id_: 1100216
  description:
    en: '(Passive) [Wind Front Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [바람 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的普通防禦力 +%opt1_value%'
  name:
    en: Wind Front Position Normal Defense Up
    ja: 風属性立ち位置前の通常防御力アップ
    ko: 바람 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升風屬性站位為前的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3071
1100217:
  _id_: 1100217
  description:
    en: '(Passive) [Wind Front Position] Special Defense Up %opt1_value% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [바람 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的特殊防禦力 +%opt1_value%'
  name:
    en: Wind Front Position Special Defense Up
    ja: 風属性立ち位置前の特殊防御力アップ
    ko: 바람 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升風屬性站位為前的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3071
1100218:
  _id_: 1100218
  description:
    en: '(Passive) [Wind Front Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的普通防禦力 +%opt1_value%%'
  name:
    en: Wind Front Position Normal Defense Up
    ja: 風属性立ち位置前の通常防御力アップ
    ko: 바람 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升風屬性站位為前的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3071
1100219:
  _id_: 1100219
  description:
    en: '(Passive) [Wind Front Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的特殊防禦力 +%opt1_value%%'
  name:
    en: Wind Front Position Special Defense Up
    ja: 風属性立ち位置前の特殊防御力アップ
    ko: 바람 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升風屬性站位為前的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3071
1100220:
  _id_: 1100220
  description:
    en: '(Passive) [Wind Front Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的會心率 +%opt1_value%%'
  name:
    en: Wind Front Position Dexterity Up
    ja: 風属性立ち位置前のクリティカル率アップ
    ko: 바람 속성 앞 포지션의 크리티컬 확률 증가
    zh_hant: 提升風屬性站位為前的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3071
1100221:
  _id_: 1100221
  description:
    en: '(Passive) [Wind Front Position] Critical Up %opt1_value%% '
    ja: '[永続]【風属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [바람 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【風屬性且站位為前】的會心威力 +%opt1_value%%'
  name:
    en: Wind Rear Position Critical Up
    ja: 風属性立ち位置前のクリティカル威力アップ
    ko: 바람 속성 앞 포지션의 크리티컬 위력 증가
    zh_hant: 提升風屬性站位為前的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3071
1100222:
  _id_: 1100222
  description:
    en: '(Passive) [Karen & Junna] Act Power Up %opt1_value% '
    ja: '[永続]【華恋と純那】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌과 준나]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和純那】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Junna Act Power Up
    ja: 華恋と純那のACTパワーアップ
    ko: 카렌과 준나의 ACT 파워 증가
    zh_hant: 提升華戀和純那的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3112
1100223:
  _id_: 1100223
  description:
    en: '(Passive) [Karen & Junna] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和純那】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Flower Dmg Received Down
    ja: 華恋と純那の花属性被ダメージダウン
    ko: 카렌과 준나가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀和純那受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3112
1100224:
  _id_: 1100224
  description:
    en: '(Passive) [Karen & Junna] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和純那】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Wind Dmg Received Down
    ja: 華恋と純那の風属性被ダメージダウン
    ko: 카렌과 준나가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀和純那受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3112
1100225:
  _id_: 1100225
  description:
    en: '(Passive) [Karen & Junna] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和純那】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Snow Dmg Received Down
    ja: 華恋と純那の雪属性被ダメージダウン
    ko: 카렌과 준나가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀和純那受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3112
1100226:
  _id_: 1100226
  description:
    en: '(Passive) [Karen & Junna] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和純那】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Moon Dmg Received Down
    ja: 華恋と純那の月属性被ダメージダウン
    ko: 카렌과 준나가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀和純那受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3112
1100227:
  _id_: 1100227
  description:
    en: '(Passive) [Karen & Junna] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和純那】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Space Dmg Received Down
    ja: 華恋と純那の宙属性被ダメージダウン
    ko: 카렌과 준나가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀和純那受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3112
1100228:
  _id_: 1100228
  description:
    en: '(Passive) [Karen & Junna] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和純那】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Cloud Dmg Received Down
    ja: 華恋と純那の雲属性被ダメージダウン
    ko: 카렌과 준나가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀和純那受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3112
1100229:
  _id_: 1100229
  description:
    en: '(Passive) [Karen & Junna] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和純那】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dream Dmg Received Down
    ja: 華恋と純那の夢属性被ダメージダウン
    ko: 카렌과 준나가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀和純那受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3112
1100230:
  _id_: 1100230
  description:
    en: '(Passive) [Karen & Junna] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dmg to Flower Up
    ja: 華恋と純那の花属性特効与ダメージアップ
    ko: 카렌과 준나가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和純那的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3112
1100231:
  _id_: 1100231
  description:
    en: '(Passive) [Karen & Junna] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dmg to Wind Up
    ja: 華恋と純那の風属性特効与ダメージアップ
    ko: 카렌과 준나가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和純那的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3112
1100232:
  _id_: 1100232
  description:
    en: '(Passive) [Karen & Junna] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dmg to Snow Up
    ja: 華恋と純那の雪属性特効与ダメージアップ
    ko: 카렌과 준나가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和純那的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3112
1100233:
  _id_: 1100233
  description:
    en: '(Passive) [Karen & Junna] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dmg to Moon Up
    ja: 華恋と純那の月属性特効与ダメージアップ
    ko: 카렌과 준나가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和純那的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3112
1100234:
  _id_: 1100234
  description:
    en: '(Passive) [Karen & Junna] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dmg to Space Up
    ja: 華恋と純那の宙属性特効与ダメージアップ
    ko: 카렌과 준나가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和純那的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3112
1100235:
  _id_: 1100235
  description:
    en: '(Passive) [Karen & Junna] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dmg to Cloud Up
    ja: 華恋と純那の雲属性特効与ダメージアップ
    ko: 카렌과 준나가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和純那的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3112
1100236:
  _id_: 1100236
  description:
    en: '(Passive) [Karen & Junna] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Junna Dmg to Dream Up
    ja: 華恋と純那の夢属性特効与ダメージアップ
    ko: 카렌과 준나가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和純那的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3112
1100237:
  _id_: 1100237
  description:
    en: '(Passive) [Karen & Junna] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋と純那】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 준나]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和純那】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Junna Normal Defense Up
    ja: 華恋と純那の通常防御力アップ
    ko: 카렌과 준나의 일반 방어력 증가
    zh_hant: 提升華戀和純那的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3112
1100238:
  _id_: 1100238
  description:
    en: '(Passive) [Karen & Junna] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋と純那】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 준나]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和純那】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Junna Special Defense Up
    ja: 華恋と純那の特殊防御力アップ
    ko: 카렌과 준나의 특수 방어력 증가
    zh_hant: 提升華戀和純那的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3112
1100239:
  _id_: 1100239
  description:
    en: '(Passive) [Karen & Junna] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Junna Normal Defense Up
    ja: 華恋と純那の通常防御力アップ
    ko: 카렌과 준나의 일반 방어력 증가
    zh_hant: 提升華戀和純那的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3112
1100240:
  _id_: 1100240
  description:
    en: '(Passive) [Karen & Junna] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Junna Special Defense Up
    ja: 華恋と純那の特殊防御力アップ
    ko: 카렌과 준나의 특수 방어력 증가
    zh_hant: 提升華戀和純那的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3112
1100241:
  _id_: 1100241
  description:
    en: '(Passive) [Karen & Junna] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的會心率 +%opt1_value%%'
  name:
    en: Karen & Junna Dexterity Up
    ja: 華恋と純那のクリティカル率アップ
    ko: 카렌과 준나의 크리티컬 확률 증가
    zh_hant: 提升華戀和純那的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3112
1100242:
  _id_: 1100242
  description:
    en: '(Passive) [Karen & Junna] Critical Up %opt1_value%% '
    ja: '[永続]【華恋と純那】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 준나]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和純那】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Junna Critical Up
    ja: 華恋と純那のクリティカル威力アップ
    ko: 카렌과 준나의 크리티컬 위력 증가
    zh_hant: 提升華戀和純那的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3112
1100301:
  _id_: 1100301
  description:
    en: '(Passive) [Moon Front Position] Act Power Up %opt1_value% '
    ja: '[永続]【月属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [달 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的ACT力量 +%opt1_value%'
  name:
    en: Moon Front Position Act Power Up
    ja: 月属性立ち位置前のACTパワーアップ
    ko: 달 속성 앞 포지션의 ACT 파워 증가
    zh_hant: 提升月屬性站位為前的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3041
1100302:
  _id_: 1100302
  description:
    en: '(Passive) [Moon Front Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為前】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Flower Dmg Received Down
    ja: 月属性立ち位置前の花属性被ダメージダウン
    ko: 달 속성 앞 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕月屬性站位為前受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3041
1100303:
  _id_: 1100303
  description:
    en: '(Passive) [Moon Front Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為前】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Wind Dmg Received Down
    ja: 月属性立ち位置前の風属性被ダメージダウン
    ko: 달 속성 앞 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕月屬性站位為前受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3041
1100304:
  _id_: 1100304
  description:
    en: '(Passive) [Moon Front Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Snow Dmg Received Down
    ja: 月属性立ち位置前の雪属性被ダメージダウン
    ko: 달 속성 앞 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕月屬性站位為前受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3041
1100305:
  _id_: 1100305
  description:
    en: '(Passive) [Moon Front Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為前】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Moon Dmg Received Down
    ja: 月属性立ち位置前の月属性被ダメージダウン
    ko: 달 속성 앞 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕月屬性站位為前受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3041
1100306:
  _id_: 1100306
  description:
    en: '(Passive) [Moon Front Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Space Dmg Received Down
    ja: 月属性立ち位置前の宙属性被ダメージダウン
    ko: 달 속성 앞 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕月屬性站位為前受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3041
1100307:
  _id_: 1100307
  description:
    en: '(Passive) [Moon Front Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Cloud Dmg Received Down
    ja: 月属性立ち位置前の雲属性被ダメージダウン
    ko: 달 속성 앞 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕月屬性站位為前受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3041
1100308:
  _id_: 1100308
  description:
    en: '(Passive) [Moon Front Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【月屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dream Dmg Received Down
    ja: 月属性立ち位置前の夢属性被ダメージダウン
    ko: 달 속성 앞 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕月屬性站位為前受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3041
1100309:
  _id_: 1100309
  description:
    en: '(Passive) [Moon Front Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dmg to Flower Up
    ja: 月属性立ち位置前の花属性特効与ダメージアップ
    ko: 달 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為前的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3041
1100310:
  _id_: 1100310
  description:
    en: '(Passive) [Moon Front Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dmg to Wind Up
    ja: 月属性立ち位置前の風属性特効与ダメージアップ
    ko: 달 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為前的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3041
1100311:
  _id_: 1100311
  description:
    en: '(Passive) [Moon Front Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dmg to Snow Up
    ja: 月属性立ち位置前の雪属性特効与ダメージアップ
    ko: 달 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為前的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3041
1100312:
  _id_: 1100312
  description:
    en: '(Passive) [Moon Front Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dmg to Moon Up
    ja: 月属性立ち位置前の月属性特効与ダメージアップ
    ko: 달 속성 앞 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為前的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3041
1100313:
  _id_: 1100313
  description:
    en: '(Passive) [Moon Front Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dmg to Space Up
    ja: 月属性立ち位置前の宙属性特効与ダメージアップ
    ko: 달 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為前的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3041
1100314:
  _id_: 1100314
  description:
    en: '(Passive) [Moon Front Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dmg to Cloud Up
    ja: 月属性立ち位置前の雲属性特効与ダメージアップ
    ko: 달 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為前的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3041
1100315:
  _id_: 1100315
  description:
    en: '(Passive) [Moon Front Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Moon Front Position Dmg to Dream Up
    ja: 月属性立ち位置前の夢属性特効与ダメージアップ
    ko: 달 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升月屬性站位為前的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3041
1100316:
  _id_: 1100316
  description:
    en: '(Passive) [Moon Front Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [달 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的普通防禦力 +%opt1_value%'
  name:
    en: Moon Front Position Normal Defense Up
    ja: 月属性立ち位置前の通常防御力アップ
    ko: 달 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升月屬性站位為前的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3041
1100317:
  _id_: 1100317
  description:
    en: '(Passive) [Moon Front Position] Special Defense Up %opt1_value% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [달 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的特殊防禦力 +%opt1_value%'
  name:
    en: Moon Front Position Special Defense Up
    ja: 月属性立ち位置前の特殊防御力アップ
    ko: 달 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升月屬性站位為前的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3041
1100318:
  _id_: 1100318
  description:
    en: '(Passive) [Moon Front Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的普通防禦力 +%opt1_value%%'
  name:
    en: Moon Front Position Normal Defense Up
    ja: 月属性立ち位置前の通常防御力アップ
    ko: 달 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升月屬性站位為前的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3041
1100319:
  _id_: 1100319
  description:
    en: '(Passive) [Moon Front Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的特殊防禦力 +%opt1_value%%'
  name:
    en: Moon Front Position Special Defense Up
    ja: 月属性立ち位置前の特殊防御力アップ
    ko: 달 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升月屬性站位為前的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3041
1100320:
  _id_: 1100320
  description:
    en: '(Passive) [Moon Front Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的會心率 +%opt1_value%%'
  name:
    en: Moon Front Position Dexterity Up
    ja: 月属性立ち位置前のクリティカル率アップ
    ko: 달 속성 앞 포지션의 크리티컬 확률 증가
    zh_hant: 提升月屬性站位為前的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3041
1100321:
  _id_: 1100321
  description:
    en: '(Passive) [Moon Front Position] Critical Up %opt1_value%% '
    ja: '[永続]【月属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [달 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【月屬性且站位為前】的會心威力 +%opt1_value%%'
  name:
    en: Moon Front Position Critical Up
    ja: 月属性立ち位置前のクリティカル威力アップ
    ko: 달 속성 앞 포지션의 크리티컬 위력 증가
    zh_hant: 提升月屬性站位為前的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3041
1100322:
  _id_: 1100322
  description:
    en: '(Passive) [Karen & Maya] Act Power Up %opt1_value% '
    ja: '[永続]【華恋と真矢】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌과 마야]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Maya Act Power Up
    ja: 華恋と真矢のACTパワーアップ
    ko: 카렌과 마야의 ACT 파워 증가
    zh_hant: 提升華戀和真矢的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3113
1100323:
  _id_: 1100323
  description:
    en: '(Passive) [Karen & Maya] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真矢】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Flower Dmg Received Down
    ja: 華恋と真矢の花属性被ダメージダウン
    ko: 카렌과 마야가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀和真矢受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3113
1100324:
  _id_: 1100324
  description:
    en: '(Passive) [Karen & Maya] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真矢】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Wind Dmg Received Down
    ja: 華恋と真矢の風属性被ダメージダウン
    ko: 카렌과 마야가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀和真矢受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3113
1100325:
  _id_: 1100325
  description:
    en: '(Passive) [Karen & Maya] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真矢】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Snow Dmg Received Down
    ja: 華恋と真矢の雪属性被ダメージダウン
    ko: 카렌과 마야가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀和真矢受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3113
1100326:
  _id_: 1100326
  description:
    en: '(Passive) [Karen & Maya] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真矢】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Moon Dmg Received Down
    ja: 華恋と真矢の月属性被ダメージダウン
    ko: 카렌과 마야가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀和真矢受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3113
1100327:
  _id_: 1100327
  description:
    en: '(Passive) [Karen & Maya] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真矢】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Space Dmg Received Down
    ja: 華恋と真矢の宙属性被ダメージダウン
    ko: 카렌과 마야가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀和真矢受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3113
1100328:
  _id_: 1100328
  description:
    en: '(Passive) [Karen & Maya] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真矢】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Cloud Dmg Received Down
    ja: 華恋と真矢の雲属性被ダメージダウン
    ko: 카렌과 마야가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀和真矢受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3113
1100329:
  _id_: 1100329
  description:
    en: '(Passive) [Karen & Maya] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真矢】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dream Dmg Received Down
    ja: 華恋と真矢の夢属性被ダメージダウン
    ko: 카렌과 마야가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀和真矢受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3113
1100330:
  _id_: 1100330
  description:
    en: '(Passive) [Karen & Maya] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dmg to Flower Up
    ja: 華恋と真矢の花属性特効与ダメージアップ
    ko: 카렌과 마야가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真矢的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3113
1100331:
  _id_: 1100331
  description:
    en: '(Passive) [Karen & Maya] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dmg to Wind Up
    ja: 華恋と真矢の風属性特効与ダメージアップ
    ko: 카렌과 마야가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真矢的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3113
1100332:
  _id_: 1100332
  description:
    en: '(Passive) [Karen & Maya] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dmg to Snow Up
    ja: 華恋と真矢の雪属性特効与ダメージアップ
    ko: 카렌과 마야가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真矢的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3113
1100333:
  _id_: 1100333
  description:
    en: '(Passive) [Karen & Maya] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dmg to Moon Up
    ja: 華恋と真矢の月属性特効与ダメージアップ
    ko: 카렌과 마야가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真矢的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3113
1100334:
  _id_: 1100334
  description:
    en: '(Passive) [Karen & Maya] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dmg to Space Up
    ja: 華恋と真矢の宙属性特効与ダメージアップ
    ko: 카렌과 마야가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真矢的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3113
1100335:
  _id_: 1100335
  description:
    en: '(Passive) [Karen & Maya] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dmg to Cloud Up
    ja: 華恋と真矢の雲属性特効与ダメージアップ
    ko: 카렌과 마야가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真矢的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3113
1100336:
  _id_: 1100336
  description:
    en: '(Passive) [Karen & Maya] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya Dmg to Dream Up
    ja: 華恋と真矢の夢属性特効与ダメージアップ
    ko: 카렌과 마야가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真矢的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3113
1100337:
  _id_: 1100337
  description:
    en: '(Passive) [Karen & Maya] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋と真矢】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 마야]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Maya Normal Defense Up
    ja: 華恋と真矢の通常防御力アップ
    ko: 카렌과 마야의 일반 방어력 증가
    zh_hant: 提升華戀和真矢的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3113
1100338:
  _id_: 1100338
  description:
    en: '(Passive) [Karen & Maya] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋と真矢】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 마야]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Maya Special Defense Up
    ja: 華恋と真矢の特殊防御力アップ
    ko: 카렌과 마야의 특수 방어력 증가
    zh_hant: 提升華戀和真矢的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3113
1100339:
  _id_: 1100339
  description:
    en: '(Passive) [Karen & Maya] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Maya Normal Defense Up
    ja: 華恋と真矢の通常防御力アップ
    ko: 카렌과 마야의 일반 방어력 증가
    zh_hant: 提升華戀和真矢的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3113
1100340:
  _id_: 1100340
  description:
    en: '(Passive) [Karen & Maya] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Maya Special Defense Up
    ja: 華恋と真矢の特殊防御力アップ
    ko: 카렌과 마야의 특수 방어력 증가
    zh_hant: 提升華戀和真矢的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3113
1100341:
  _id_: 1100341
  description:
    en: '(Passive) [Karen & Maya] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的會心率 +%opt1_value%%'
  name:
    en: Karen & Maya Dexterity Up
    ja: 華恋と真矢のクリティカル率アップ
    ko: 카렌과 마야의 크리티컬 확률 증가
    zh_hant: 提升華戀和真矢的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3113
1100342:
  _id_: 1100342
  description:
    en: '(Passive) [Karen & Maya] Critical Up %opt1_value%% '
    ja: '[永続]【華恋と真矢】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마야]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真矢】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Maya Critical Up
    ja: 華恋と真矢のクリティカル威力アップ
    ko: 카렌과 마야의 크리티컬 위력 증가
    zh_hant: 提升華戀和真矢的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3113
1100401:
  _id_: 1100401
  description:
    en: '(Passive) [Cloud Front Position] Act Power Up %opt1_value% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [구름 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的ACT力量 +%opt1_value%'
  name:
    en: Cloud Front Position Act Power Up
    ja: 雲属性立ち位置前のACTパワーアップ
    ko: 구름 속성 앞 포지션의 ACT 파워 증가
    zh_hant: 提升雲屬性站位為前的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3091
1100402:
  _id_: 1100402
  description:
    en: '(Passive) [Cloud Front Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為前】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Flower Dmg Received Down
    ja: 雲属性立ち位置前の花属性被ダメージダウン
    ko: 구름 속성 앞 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為前受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3091
1100403:
  _id_: 1100403
  description:
    en: '(Passive) [Cloud Front Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為前】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Wind Dmg Received Down
    ja: 雲属性立ち位置前の風属性被ダメージダウン
    ko: 구름 속성 앞 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為前受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3091
1100404:
  _id_: 1100404
  description:
    en: '(Passive) [Cloud Front Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Snow Dmg Received Down
    ja: 雲属性立ち位置前の雪属性被ダメージダウン
    ko: 구름 속성 앞 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為前受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3091
1100405:
  _id_: 1100405
  description:
    en: '(Passive) [Cloud Front Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為前】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Moon Dmg Received Down
    ja: 雲属性立ち位置前の月属性被ダメージダウン
    ko: 구름 속성 앞 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為前受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3091
1100406:
  _id_: 1100406
  description:
    en: '(Passive) [Cloud Front Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Space Dmg Received Down
    ja: 雲属性立ち位置前の宙属性被ダメージダウン
    ko: 구름 속성 앞 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為前受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3091
1100407:
  _id_: 1100407
  description:
    en: '(Passive) [Cloud Front Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Cloud Dmg Received Down
    ja: 雲属性立ち位置前の雲属性被ダメージダウン
    ko: 구름 속성 앞 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為前受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3091
1100408:
  _id_: 1100408
  description:
    en: '(Passive) [Cloud Front Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雲屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dream Dmg Received Down
    ja: 雲属性立ち位置前の夢属性被ダメージダウン
    ko: 구름 속성 앞 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕雲屬性站位為前受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3091
1100409:
  _id_: 1100409
  description:
    en: '(Passive) [Cloud Front Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dmg to Flower Up
    ja: 雲属性立ち位置前の花属性特効与ダメージアップ
    ko: 구름 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為前的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3091
1100410:
  _id_: 1100410
  description:
    en: '(Passive) [Cloud Front Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dmg to Wind Up
    ja: 雲属性立ち位置前の風属性特効与ダメージアップ
    ko: 구름 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為前的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3091
1100411:
  _id_: 1100411
  description:
    en: '(Passive) [Cloud Front Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dmg to Snow Up
    ja: 雲属性立ち位置前の雪属性特効与ダメージアップ
    ko: 구름 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為前的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3091
1100412:
  _id_: 1100412
  description:
    en: '(Passive) [Cloud Front Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dmg to Moon Up
    ja: 雲属性立ち位置前の月属性特効与ダメージアップ
    ko: 구름 속성 앞 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為前的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3091
1100413:
  _id_: 1100413
  description:
    en: '(Passive) [Cloud Front Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dmg to Space Up
    ja: 雲属性立ち位置前の宙属性特効与ダメージアップ
    ko: 구름 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為前的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3091
1100414:
  _id_: 1100414
  description:
    en: '(Passive) [Cloud Front Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dmg to Cloud Up
    ja: 雲属性立ち位置前の雲属性特効与ダメージアップ
    ko: 구름 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為前的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3091
1100415:
  _id_: 1100415
  description:
    en: '(Passive) [Cloud Front Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Cloud Front Position Dmg to Dream Up
    ja: 雲属性立ち位置前の夢属性特効与ダメージアップ
    ko: 구름 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升雲屬性站位為前的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3091
1100416:
  _id_: 1100416
  description:
    en: '(Passive) [Cloud Front Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [구름 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的普通防禦力 +%opt1_value%'
  name:
    en: Cloud Front Position Normal Defense Up
    ja: 雲属性立ち位置前の通常防御力アップ
    ko: 구름 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升雲屬性站位為前的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3091
1100417:
  _id_: 1100417
  description:
    en: '(Passive) [Cloud Front Position] Special Defense Up %opt1_value% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [구름 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的特殊防禦力 +%opt1_value%'
  name:
    en: Cloud Front Position Special Defense Up
    ja: 雲属性立ち位置前の特殊防御力アップ
    ko: 구름 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升雲屬性站位為前的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3091
1100418:
  _id_: 1100418
  description:
    en: '(Passive) [Cloud Front Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的普通防禦力 +%opt1_value%%'
  name:
    en: Cloud Front Position Normal Defense Up
    ja: 雲属性立ち位置前の通常防御力アップ
    ko: 구름 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升雲屬性站位為前的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3091
1100419:
  _id_: 1100419
  description:
    en: '(Passive) [Cloud Front Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的特殊防禦力 +%opt1_value%%'
  name:
    en: Cloud Front Position Special Defense Up
    ja: 雲属性立ち位置前の特殊防御力アップ
    ko: 구름 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升雲屬性站位為前的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3091
1100420:
  _id_: 1100420
  description:
    en: '(Passive) [Cloud Front Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的會心率 +%opt1_value%%'
  name:
    en: Cloud Front Position Dexterity Up
    ja: 雲属性立ち位置前のクリティカル率アップ
    ko: 구름 속성 앞 포지션의 크리티컬 확률 증가
    zh_hant: 提升雲屬性站位為前的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3091
1100421:
  _id_: 1100421
  description:
    en: '(Passive) [Cloud Front Position] Critical Up %opt1_value%% '
    ja: '[永続]【雲属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [구름 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雲屬性且站位為前】的會心威力 +%opt1_value%%'
  name:
    en: Cloud Front Position Critical Up
    ja: 雲属性立ち位置前のクリティカル威力アップ
    ko: 구름 속성 앞 포지션의 크리티컬 위력 증가
    zh_hant: 提升雲屬性站位為前的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3091
1100422:
  _id_: 1100422
  description:
    en: '(Passive) [Karen & Mahiru] Act Power Up %opt1_value% '
    ja: '[永続]【華恋とまひる】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌과 마히루]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Mahiru Act Power Up
    ja: 華恋とまひるのACTパワーアップ
    ko: 카렌과 마히루의 ACT 파워 증가
    zh_hant: 提升華戀和真晝的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3114
1100423:
  _id_: 1100423
  description:
    en: '(Passive) [Karen & Mahiru] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真晝】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Flower Dmg Received Down
    ja: 華恋とまひるの花属性被ダメージダウン
    ko: 카렌과 마히루가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀和真晝受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3114
1100424:
  _id_: 1100424
  description:
    en: '(Passive) [Karen & Mahiru] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真晝】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Wind Dmg Received Down
    ja: 華恋とまひるの風属性被ダメージダウン
    ko: 카렌과 마히루가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀和真晝受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3114
1100425:
  _id_: 1100425
  description:
    en: '(Passive) [Karen & Mahiru] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真晝】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Snow Dmg Received Down
    ja: 華恋とまひるの雪属性被ダメージダウン
    ko: 카렌과 마히루가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀和真晝受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3114
1100426:
  _id_: 1100426
  description:
    en: '(Passive) [Karen & Mahiru] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真晝】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Moon Dmg Received Down
    ja: 華恋とまひるの月属性被ダメージダウン
    ko: 카렌과 마히루가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀和真晝受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3114
1100427:
  _id_: 1100427
  description:
    en: '(Passive) [Karen & Mahiru] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真晝】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Space Dmg Received Down
    ja: 華恋とまひるの宙属性被ダメージダウン
    ko: 카렌과 마히루가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀和真晝受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3114
1100428:
  _id_: 1100428
  description:
    en: '(Passive) [Karen & Mahiru] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真晝】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Cloud Dmg Received Down
    ja: 華恋とまひるの雲属性被ダメージダウン
    ko: 카렌과 마히루가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀和真晝受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3114
1100429:
  _id_: 1100429
  description:
    en: '(Passive) [Karen & Mahiru] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和真晝】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dream Dmg Received Down
    ja: 華恋とまひるの夢属性被ダメージダウン
    ko: 카렌과 마히루가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀和真晝受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3114
1100430:
  _id_: 1100430
  description:
    en: '(Passive) [Karen & Mahiru] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dmg to Flower Up
    ja: 華恋とまひるの花属性特効与ダメージアップ
    ko: 카렌과 마히루가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真晝的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3114
1100431:
  _id_: 1100431
  description:
    en: '(Passive) [Karen & Mahiru] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dmg to Wind Up
    ja: 華恋とまひるの風属性特効与ダメージアップ
    ko: 카렌과 마히루가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真晝的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3114
1100432:
  _id_: 1100432
  description:
    en: '(Passive) [Karen & Mahiru] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dmg to Snow Up
    ja: 華恋とまひるの雪属性特効与ダメージアップ
    ko: 카렌과 마히루가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真晝的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3114
1100433:
  _id_: 1100433
  description:
    en: '(Passive) [Karen & Mahiru] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dmg to Moon Up
    ja: 華恋とまひるの月属性特効与ダメージアップ
    ko: 카렌과 마히루가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真晝的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3114
1100434:
  _id_: 1100434
  description:
    en: '(Passive) [Karen & Mahiru] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dmg to Space Up
    ja: 華恋とまひるの宙属性特効与ダメージアップ
    ko: 카렌과 마히루가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真晝的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3114
1100435:
  _id_: 1100435
  description:
    en: '(Passive) [Karen & Mahiru] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dmg to Cloud Up
    ja: 華恋とまひるの雲属性特効与ダメージアップ
    ko: 카렌과 마히루가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真晝的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3114
1100436:
  _id_: 1100436
  description:
    en: '(Passive) [Karen & Mahiru] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dmg to Dream Up
    ja: 華恋とまひるの夢属性特効与ダメージアップ
    ko: 카렌과 마히루가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和真晝的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3114
1100437:
  _id_: 1100437
  description:
    en: '(Passive) [Karen & Mahiru] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋とまひる】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 마히루]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Mahiru Normal Defense Up
    ja: 華恋とまひるの通常防御力アップ
    ko: 카렌과 마히루의 일반 방어력 증가
    zh_hant: 提升華戀和真晝的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3114
1100438:
  _id_: 1100438
  description:
    en: '(Passive) [Karen & Mahiru] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋とまひる】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 마히루]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Mahiru Special Defense Up
    ja: 華恋とまひるの特殊防御力アップ
    ko: 카렌과 마히루의 특수 방어력 증가
    zh_hant: 提升華戀和真晝的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3114
1100439:
  _id_: 1100439
  description:
    en: '(Passive) [Karen & Mahiru] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Mahiru Normal Defense Up
    ja: 華恋とまひるの通常防御力アップ
    ko: 카렌과 마히루의 일반 방어력 증가
    zh_hant: 提升華戀和真晝的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3114
1100440:
  _id_: 1100440
  description:
    en: '(Passive) [Karen & Mahiru] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Mahiru Special Defense Up
    ja: 華恋とまひるの特殊防御力アップ
    ko: 카렌과 마히루의 특수 방어력 증가
    zh_hant: 提升華戀和真晝的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3114
1100441:
  _id_: 1100441
  description:
    en: '(Passive) [Karen & Mahiru] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的會心率 +%opt1_value%%'
  name:
    en: Karen & Mahiru Dexterity Up
    ja: 華恋とまひるのクリティカル率アップ
    ko: 카렌과 마히루의 크리티컬 확률 증가
    zh_hant: 提升華戀和真晝的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3114
1100442:
  _id_: 1100442
  description:
    en: '(Passive) [Karen & Mahiru] Critical Up %opt1_value%% '
    ja: '[永続]【華恋とまひる】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 마히루]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和真晝】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Mahiru Critical Up
    ja: 華恋とまひるのクリティカル威力アップ
    ko: 카렌과 마히루의 크리티컬 위력 증가
    zh_hant: 提升華戀和真晝的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3114
1100501:
  _id_: 1100501
  description:
    en: '(Passive) [Space Front Position] Act Power Up %opt1_value% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [우주 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的ACT力量 +%opt1_value%'
  name:
    en: Space Front Position Act Power Up
    ja: 宙属性立ち位置前のACTパワーアップ
    ko: 우주 속성 앞 포지션의 ACT 파워 증가
    zh_hant: 提升宙屬性站位為前的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3081
1100502:
  _id_: 1100502
  description:
    en: '(Passive) [Space Front Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為前】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Space Front Position Flower Dmg Received Down
    ja: 宙属性立ち位置前の花属性被ダメージダウン
    ko: 우주 속성 앞 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為前受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3081
1100503:
  _id_: 1100503
  description:
    en: '(Passive) [Space Front Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為前】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Space Front Position Wind Dmg Received Down
    ja: 宙属性立ち位置前の風属性被ダメージダウン
    ko: 우주 속성 앞 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為前受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3081
1100504:
  _id_: 1100504
  description:
    en: '(Passive) [Space Front Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Space Front Position Snow Dmg Received Down
    ja: 宙属性立ち位置前の雪属性被ダメージダウン
    ko: 우주 속성 앞 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為前受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3081
1100505:
  _id_: 1100505
  description:
    en: '(Passive) [Space Front Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為前】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Space Front Position Moon Dmg Received Down
    ja: 宙属性立ち位置前の月属性被ダメージダウン
    ko: 우주 속성 앞 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為前受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3081
1100506:
  _id_: 1100506
  description:
    en: '(Passive) [Space Front Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Space Front Position Space Dmg Received Down
    ja: 宙属性立ち位置前の宙属性被ダメージダウン
    ko: 우주 속성 앞 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為前受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3081
1100507:
  _id_: 1100507
  description:
    en: '(Passive) [Space Front Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Space Front Position Cloud Dmg Received Down
    ja: 宙属性立ち位置前の雲属性被ダメージダウン
    ko: 우주 속성 앞 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為前受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3081
1100508:
  _id_: 1100508
  description:
    en: '(Passive) [Space Front Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【宙屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dream Dmg Received Down
    ja: 宙属性立ち位置前の夢属性被ダメージダウン
    ko: 우주 속성 앞 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕宙屬性站位為前受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3081
1100509:
  _id_: 1100509
  description:
    en: '(Passive) [Space Front Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dmg to Flower Up
    ja: 宙属性立ち位置前の花属性特効与ダメージアップ
    ko: 우주 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為前的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3081
1100510:
  _id_: 1100510
  description:
    en: '(Passive) [Space Front Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dmg to Wind Up
    ja: 宙属性立ち位置前の風属性特効与ダメージアップ
    ko: 우주 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為前的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3081
1100511:
  _id_: 1100511
  description:
    en: '(Passive) [Space Front Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dmg to Snow Up
    ja: 宙属性立ち位置前の雪属性特効与ダメージアップ
    ko: 우주 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為前的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3081
1100512:
  _id_: 1100512
  description:
    en: '(Passive) [Space Front Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dmg to Moon Up
    ja: 宙属性立ち位置前の月属性特効与ダメージアップ
    ko: 우주 속성 앞 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為前的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3081
1100513:
  _id_: 1100513
  description:
    en: '(Passive) [Space Front Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dmg to Space Up
    ja: 宙属性立ち位置前の宙属性特効与ダメージアップ
    ko: 우주 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為前的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3081
1100514:
  _id_: 1100514
  description:
    en: '(Passive) [Space Front Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dmg to Cloud Up
    ja: 宙属性立ち位置前の雲属性特効与ダメージアップ
    ko: 우주 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為前的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3081
1100515:
  _id_: 1100515
  description:
    en: '(Passive) [Space Front Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Space Front Position Dmg to Dream Up
    ja: 宙属性立ち位置前の夢属性特効与ダメージアップ
    ko: 우주 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升宙屬性站位為前的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3081
1100516:
  _id_: 1100516
  description:
    en: '(Passive) [Space Front Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [우주 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的普通防禦力 +%opt1_value%'
  name:
    en: Space Front Position Normal Defense Up
    ja: 宙属性立ち位置前の通常防御力アップ
    ko: 우주 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升宙屬性站位為前的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3081
1100517:
  _id_: 1100517
  description:
    en: '(Passive) [Space Front Position] Special Defense Up %opt1_value% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [우주 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的特殊防禦力 +%opt1_value%'
  name:
    en: Space Front Position Special Defense Up
    ja: 宙属性立ち位置前の特殊防御力アップ
    ko: 우주 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升宙屬性站位為前的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3081
1100518:
  _id_: 1100518
  description:
    en: '(Passive) [Space Front Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的普通防禦力 +%opt1_value%%'
  name:
    en: Space Front Position Normal Defense Up
    ja: 宙属性立ち位置前の通常防御力アップ
    ko: 우주 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升宙屬性站位為前的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3081
1100519:
  _id_: 1100519
  description:
    en: '(Passive) [Space Front Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的特殊防禦力 +%opt1_value%%'
  name:
    en: Space Front Position Special Defense Up
    ja: 宙属性立ち位置前の特殊防御力アップ
    ko: 우주 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升宙屬性站位為前的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3081
1100520:
  _id_: 1100520
  description:
    en: '(Passive) [Space Front Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的會心率 +%opt1_value%%'
  name:
    en: Space Front Position Dexterity Up
    ja: 宙属性立ち位置前のクリティカル率アップ
    ko: 우주 속성 앞 포지션의 크리티컬 확률 증가
    zh_hant: 提升宙屬性站位為前的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3081
1100521:
  _id_: 1100521
  description:
    en: '(Passive) [Space Front Position] Critical Up %opt1_value%% '
    ja: '[永続]【宙属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [우주 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【宙屬性且站位為前】的會心威力 +%opt1_value%%'
  name:
    en: Space Front Position Critical Up
    ja: 宙属性立ち位置前のクリティカル威力アップ
    ko: 우주 속성 앞 포지션의 크리티컬 위력 증가
    zh_hant: 提升宙屬性站位為前的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3081
1100522:
  _id_: 1100522
  description:
    en: '(Passive) [Kaoruko & Futaba] Act Power Up %opt1_value% '
    ja: '[永続]【香子と双葉】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카오루코와 후타바]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的ACT力量 +%opt1_value%'
  name:
    en: Kaoruko & Futaba Act Power Up
    ja: 香子と双葉のACTパワーアップ
    ko: 카오루코와 후타바의 ACT 파워 증가
    zh_hant: 提升香子和雙葉的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3115
1100523:
  _id_: 1100523
  description:
    en: '(Passive) [Kaoruko & Futaba] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【香子和雙葉】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Flower Dmg Received Down
    ja: 香子と双葉の花属性被ダメージダウン
    ko: 카오루코와 후타바가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕香子和雙葉受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3115
1100524:
  _id_: 1100524
  description:
    en: '(Passive) [Kaoruko & Futaba] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【香子和雙葉】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Wind Dmg Received Down
    ja: 香子と双葉の風属性被ダメージダウン
    ko: 카오루코와 후타바가 받는 바람 속성 대미지 감소
    zh_hant: 減輕香子和雙葉受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3115
1100525:
  _id_: 1100525
  description:
    en: '(Passive) [Kaoruko & Futaba] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【香子和雙葉】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Snow Dmg Received Down
    ja: 香子と双葉の雪属性被ダメージダウン
    ko: 카오루코와 후타바가 받는 눈 속성 대미지 감소
    zh_hant: 減輕香子和雙葉受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3115
1100526:
  _id_: 1100526
  description:
    en: '(Passive) [Kaoruko & Futaba] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【香子和雙葉】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Moon Dmg Received Down
    ja: 香子と双葉の月属性被ダメージダウン
    ko: 카오루코와 후타바가 받는 달 속성 대미지 감소
    zh_hant: 減輕香子和雙葉受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3115
1100527:
  _id_: 1100527
  description:
    en: '(Passive) [Kaoruko & Futaba] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【香子和雙葉】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Space Dmg Received Down
    ja: 香子と双葉の宙属性被ダメージダウン
    ko: 카오루코와 후타바가 받는 우주 속성 대미지 감소
    zh_hant: 減輕香子和雙葉受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3115
1100528:
  _id_: 1100528
  description:
    en: '(Passive) [Kaoruko & Futaba] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【香子和雙葉】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Cloud Dmg Received Down
    ja: 香子と双葉の雲属性被ダメージダウン
    ko: 카오루코와 후타바가 받는 구름 속성 대미지 감소
    zh_hant: 減輕香子和雙葉受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3115
1100529:
  _id_: 1100529
  description:
    en: '(Passive) [Kaoruko & Futaba] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【香子和雙葉】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dream Dmg Received Down
    ja: 香子と双葉の夢属性被ダメージダウン
    ko: 카오루코와 후타바가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕香子和雙葉受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3115
1100530:
  _id_: 1100530
  description:
    en: '(Passive) [Kaoruko & Futaba] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dmg to Flower Up
    ja: 香子と双葉の花属性特効与ダメージアップ
    ko: 카오루코와 후타바가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升香子和雙葉的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3115
1100531:
  _id_: 1100531
  description:
    en: '(Passive) [Kaoruko & Futaba] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dmg to Wind Up
    ja: 香子と双葉の風属性特効与ダメージアップ
    ko: 카오루코와 후타바가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升香子和雙葉的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3115
1100532:
  _id_: 1100532
  description:
    en: '(Passive) [Kaoruko & Futaba] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dmg to Snow Up
    ja: 香子と双葉の雪属性特効与ダメージアップ
    ko: 카오루코와 후타바가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升香子和雙葉的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3115
1100533:
  _id_: 1100533
  description:
    en: '(Passive) [Kaoruko & Futaba] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dmg to Moon Up
    ja: 香子と双葉の月属性特効与ダメージアップ
    ko: 카오루코와 후타바가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升香子和雙葉的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3115
1100534:
  _id_: 1100534
  description:
    en: '(Passive) [Kaoruko & Futaba] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dmg to Space Up
    ja: 香子と双葉の宙属性特効与ダメージアップ
    ko: 카오루코와 후타바가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升香子和雙葉的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3115
1100535:
  _id_: 1100535
  description:
    en: '(Passive) [Kaoruko & Futaba] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dmg to Cloud Up
    ja: 香子と双葉の雲属性特効与ダメージアップ
    ko: 카오루코와 후타바가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升香子和雙葉的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3115
1100536:
  _id_: 1100536
  description:
    en: '(Passive) [Kaoruko & Futaba] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dmg to Dream Up
    ja: 香子と双葉の夢属性特効与ダメージアップ
    ko: 카오루코와 후타바가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升香子和雙葉的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3115
1100537:
  _id_: 1100537
  description:
    en: '(Passive) [Kaoruko & Futaba] Normal Defense Up %opt1_value% '
    ja: '[永続]【香子と双葉】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카오루코와 후타바]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的普通防禦力 +%opt1_value%'
  name:
    en: Kaoruko & Futaba Normal Defense Up
    ja: 香子と双葉の通常防御力アップ
    ko: 카오루코와 후타바의 일반 방어력 증가
    zh_hant: 提升香子和雙葉的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3115
1100538:
  _id_: 1100538
  description:
    en: '(Passive) [Kaoruko & Futaba] Special Defense Up %opt1_value% '
    ja: '[永続]【香子と双葉】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카오루코와 후타바]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的特殊防禦力 +%opt1_value%'
  name:
    en: Kaoruko & Futaba Special Defense Up
    ja: 香子と双葉の特殊防御力アップ
    ko: 카오루코와 후타바의 특수 방어력 증가
    zh_hant: 提升香子和雙葉的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3115
1100539:
  _id_: 1100539
  description:
    en: '(Passive) [Kaoruko & Futaba] Normal Defense Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的普通防禦力 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Normal Defense Up
    ja: 香子と双葉の通常防御力アップ
    ko: 카오루코와 후타바의 일반 방어력 증가
    zh_hant: 提升香子和雙葉的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3115
1100540:
  _id_: 1100540
  description:
    en: '(Passive) [Kaoruko & Futaba] Special Defense Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的特殊防禦力 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Special Defense Up
    ja: 香子と双葉の特殊防御力アップ
    ko: 카오루코와 후타바의 특수 방어력 증가
    zh_hant: 提升香子和雙葉的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3115
1100541:
  _id_: 1100541
  description:
    en: '(Passive) [Kaoruko & Futaba] Dexterity Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的會心率 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Dexterity Up
    ja: 香子と双葉のクリティカル率アップ
    ko: 카오루코와 후타바의 크리티컬 확률 증가
    zh_hant: 提升香子和雙葉的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3115
1100542:
  _id_: 1100542
  description:
    en: '(Passive) [Kaoruko & Futaba] Critical Up %opt1_value%% '
    ja: '[永続]【香子と双葉】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카오루코와 후타바]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【香子和雙葉】的會心威力 +%opt1_value%%'
  name:
    en: Kaoruko & Futaba Critical Up
    ja: 香子と双葉のクリティカル威力アップ
    ko: 카우로쿠와 후타바의 크리티컬 위력 증가
    zh_hant: 提升香子和雙葉的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3115
1100601:
  _id_: 1100601
  description:
    en: '(Passive) [Dream Center Position] Act Power Up %opt1_value% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [꿈 속성 중간 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的ACT力量 +%opt1_value%'
  name:
    en: Dream Center Position Act Power Up
    ja: 夢属性立ち位置中のACTパワーアップ
    ko: 꿈 속성 중간 포지션의 ACT 파워 증가
    zh_hant: 提升夢屬性站位為中的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3102
1100602:
  _id_: 1100602
  description:
    en: '(Passive) [Dream Center Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為中】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Flower Dmg Received Down
    ja: 夢属性立ち位置中の花属性被ダメージダウン
    ko: 꿈 속성 중간 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為中受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3102
1100603:
  _id_: 1100603
  description:
    en: '(Passive) [Dream Center Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為中】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Wind Dmg Received Down
    ja: 夢属性立ち位置中の風属性被ダメージダウン
    ko: 꿈 속성 중간 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為中受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3102
1100604:
  _id_: 1100604
  description:
    en: '(Passive) [Dream Center Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為中】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Snow Dmg Received Down
    ja: 夢属性立ち位置中の雪属性被ダメージダウン
    ko: 꿈 속성 중간 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為中受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3102
1100605:
  _id_: 1100605
  description:
    en: '(Passive) [Dream Center Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為中】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Moon Dmg Received Down
    ja: 夢属性立ち位置中の月属性被ダメージダウン
    ko: 꿈 속성 중간 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為中受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3102
1100606:
  _id_: 1100606
  description:
    en: '(Passive) [Dream Center Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為中】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Space Dmg Received Down
    ja: 夢属性立ち位置中の宙属性被ダメージダウン
    ko: 꿈 속성 중간 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為中受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3102
1100607:
  _id_: 1100607
  description:
    en: '(Passive) [Dream Center Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為中】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Cloud Dmg Received Down
    ja: 夢属性立ち位置中の雲属性被ダメージダウン
    ko: 꿈 속성 중간 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為中受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3102
1100608:
  _id_: 1100608
  description:
    en: '(Passive) [Dream Center Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為中】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dream Dmg Received Down
    ja: 夢属性立ち位置中の夢属性被ダメージダウン
    ko: 꿈 속성 중간 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為中受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3102
1100609:
  _id_: 1100609
  description:
    en: '(Passive) [Dream Center Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dmg to Flower Up
    ja: 夢属性立ち位置中の花属性特効与ダメージアップ
    ko: 꿈 속성 중간 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為中的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3102
1100610:
  _id_: 1100610
  description:
    en: '(Passive) [Dream Center Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dmg to Wind Up
    ja: 夢属性立ち位置中の風属性特効与ダメージアップ
    ko: 꿈 속성 중간 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為中的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3102
1100611:
  _id_: 1100611
  description:
    en: '(Passive) [Dream Center Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dmg to Snow Up
    ja: 夢属性立ち位置中の雪属性特効与ダメージアップ
    ko: 꿈 속성 중간 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為中的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3102
1100612:
  _id_: 1100612
  description:
    en: '(Passive) [Dream Center Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dmg to Moon Up
    ja: 夢属性立ち位置中の月属性特効与ダメージアップ
    ko: 꿈 속성 중간 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為中的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3102
1100613:
  _id_: 1100613
  description:
    en: '(Passive) [Dream Center Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dmg to Space Up
    ja: 夢属性立ち位置中の宙属性特効与ダメージアップ
    ko: 꿈 속성 중간 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為中的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3102
1100614:
  _id_: 1100614
  description:
    en: '(Passive) [Dream Center Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dmg to Cloud Up
    ja: 夢属性立ち位置中の雲属性特効与ダメージアップ
    ko: 꿈 속성 중간 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為中的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3102
1100615:
  _id_: 1100615
  description:
    en: '(Passive) [Dream Center Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Center Position Dmg to Dream Up
    ja: 夢属性立ち位置中の夢属性特効与ダメージアップ
    ko: 꿈 속성 중간 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為中的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3102
1100616:
  _id_: 1100616
  description:
    en: '(Passive) [Dream Center Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [꿈 속성 중간 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的普通防禦力 +%opt1_value%'
  name:
    en: Dream Center Position Normal Defense Up
    ja: 夢属性立ち位置中の通常防御力アップ
    ko: 꿈 속성 중간 포지션의 일반 방어력 증가
    zh_hant: 提升夢屬性站位為中的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3102
1100617:
  _id_: 1100617
  description:
    en: '(Passive) [Dream Center Position] Special Defense Up %opt1_value% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [꿈 속성 중간 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的特殊防禦力 +%opt1_value%'
  name:
    en: Dream Center Position Special Defense Up
    ja: 夢属性立ち位置中の特殊防御力アップ
    ko: 꿈 속성 중간 포지션의 특수 방어력 증가
    zh_hant: 提升夢屬性站位為中的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3102
1100618:
  _id_: 1100618
  description:
    en: '(Passive) [Dream Center Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的普通防禦力 +%opt1_value%%'
  name:
    en: Dream Center Position Normal Defense Up
    ja: 夢属性立ち位置中の通常防御力アップ
    ko: 꿈 속성 중간 포지션의 일반 방어력 증가
    zh_hant: 提升夢屬性站位為中的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3102
1100619:
  _id_: 1100619
  description:
    en: '(Passive) [Dream Center Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的特殊防禦力 +%opt1_value%%'
  name:
    en: Dream Center Position Special Defense Up
    ja: 夢属性立ち位置中の特殊防御力アップ
    ko: 꿈 속성 중간 포지션의 특수 방어력 증가
    zh_hant: 提升夢屬性站位為中的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3102
1100620:
  _id_: 1100620
  description:
    en: '(Passive) [Dream Center Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的會心率 +%opt1_value%%'
  name:
    en: Dream Center Position Dexterity Up
    ja: 夢属性立ち位置中のクリティカル率アップ
    ko: 꿈 속성 중간 포지션의 크리티컬 확률 증가
    zh_hant: 提升夢屬性站位為中的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3102
1100621:
  _id_: 1100621
  description:
    en: '(Passive) [Dream Center Position] Critical Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為中】的會心威力 +%opt1_value%%'
  name:
    en: Dream Center Position Critical Up
    ja: 夢属性立ち位置中のクリティカル威力アップ
    ko: 꿈 속성 중간 포지션의 크리티컬 위력 증가
    zh_hant: 提升夢屬性站位為中的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3102
1100622:
  _id_: 1100622
  description:
    en: '(Passive) [Hikari & Nana] Act Power Up %opt1_value% '
    ja: '[永続]【ひかりとなな】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [히카리와 나나]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【光和奈奈】的ACT力量 +%opt1_value%'
  name:
    en: Hikari & Nana Act Power Up
    ja: ひかりとななのACTパワーアップ
    ko: 히카리와 나나의 ACT 파워 증가
    zh_hant: 提升光和奈奈的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3116
1100623:
  _id_: 1100623
  description:
    en: '(Passive) [Hikari & Nana] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和奈奈】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Flower Dmg Received Down
    ja: ひかりとななの花属性被ダメージダウン
    ko: 히카리와 나나가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕光和奈奈受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3116
1100624:
  _id_: 1100624
  description:
    en: '(Passive) [Hikari & Nana] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和奈奈】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Wind Dmg Received Down
    ja: ひかりとななの風属性被ダメージダウン
    ko: 히카리와 나나가 받는 바람 속성 대미지 감소
    zh_hant: 減輕光和奈奈受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3116
1100625:
  _id_: 1100625
  description:
    en: '(Passive) [Hikari & Nana] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和奈奈】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Snow Dmg Received Down
    ja: ひかりとななの雪属性被ダメージダウン
    ko: 히카리와 나나가 받는 눈 속성 대미지 감소
    zh_hant: 減輕光和奈奈受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3116
1100626:
  _id_: 1100626
  description:
    en: '(Passive) [Hikari & Nana] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和奈奈】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Moon Dmg Received Down
    ja: ひかりとななの月属性被ダメージダウン
    ko: 히카리와 나나가 받는 달 속성 대미지 감소
    zh_hant: 減輕光和奈奈受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3116
1100627:
  _id_: 1100627
  description:
    en: '(Passive) [Hikari & Nana] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和奈奈】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Space Dmg Received Down
    ja: ひかりとななの宙属性被ダメージダウン
    ko: 히카리와 나나가 받는 우주 속성 대미지 감소
    zh_hant: 減輕光和奈奈受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3116
1100628:
  _id_: 1100628
  description:
    en: '(Passive) [Hikari & Nana] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和奈奈】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Cloud Dmg Received Down
    ja: ひかりとななの雲属性被ダメージダウン
    ko: 히카리와 나나가 받는 구름 속성 대미지 감소
    zh_hant: 減輕光和奈奈受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3116
1100629:
  _id_: 1100629
  description:
    en: '(Passive) [Hikari & Nana] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光和奈奈】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dream Dmg Received Down
    ja: ひかりとななの夢属性被ダメージダウン
    ko: 히카리와 나나가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕光和奈奈受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3116
1100630:
  _id_: 1100630
  description:
    en: '(Passive) [Hikari & Nana] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dmg to Flower Up
    ja: ひかりとななの花属性特効与ダメージアップ
    ko: 히카리와 나나가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升光和奈奈的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3116
1100631:
  _id_: 1100631
  description:
    en: '(Passive) [Hikari & Nana] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dmg to Wind Up
    ja: ひかりとななの風属性特効与ダメージアップ
    ko: 히카리와 나나가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升光和奈奈的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3116
1100632:
  _id_: 1100632
  description:
    en: '(Passive) [Hikari & Nana] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dmg to Snow Up
    ja: ひかりとななの雪属性特効与ダメージアップ
    ko: 히카리와 나나가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升光和奈奈的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3116
1100633:
  _id_: 1100633
  description:
    en: '(Passive) [Hikari & Nana] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dmg to Moon Up
    ja: ひかりとななの月属性特効与ダメージアップ
    ko: 히카리와 나나가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升光和奈奈的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3116
1100634:
  _id_: 1100634
  description:
    en: '(Passive) [Hikari & Nana] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dmg to Space Up
    ja: ひかりとななの宙属性特効与ダメージアップ
    ko: 히카리와 나나가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升光和奈奈的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3116
1100635:
  _id_: 1100635
  description:
    en: '(Passive) [Hikari & Nana] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dmg to Cloud Up
    ja: ひかりとななの雲属性特効与ダメージアップ
    ko: 히카리와 나나가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升光和奈奈的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3116
1100636:
  _id_: 1100636
  description:
    en: '(Passive) [Hikari & Nana] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Hikari & Nana Dmg to Dream Up
    ja: ひかりとななの夢属性特効与ダメージアップ
    ko: 히카리와 나나가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升光和奈奈的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3116
1100637:
  _id_: 1100637
  description:
    en: '(Passive) [Hikari & Nana] Normal Defense Up %opt1_value% '
    ja: '[永続]【ひかりとなな】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [히카리와 나나]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【光和奈奈】的普通防禦力 +%opt1_value%'
  name:
    en: Hikari & Nana Normal Defense Up
    ja: ひかりとななの通常防御力アップ
    ko: 히카리와 나나의 일반 방어력 증가
    zh_hant: 提升光和奈奈的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3116
1100638:
  _id_: 1100638
  description:
    en: '(Passive) [Hikari & Nana] Special Defense Up %opt1_value% '
    ja: '[永続]【ひかりとなな】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [히카리와 나나]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【光和奈奈】的特殊防禦力 +%opt1_value%'
  name:
    en: Hikari & Nana Special Defense Up
    ja: ひかりとななの特殊防御力アップ
    ko: 히카리와 나나의 특수 방어력 증가
    zh_hant: 提升光和奈奈的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3116
1100639:
  _id_: 1100639
  description:
    en: '(Passive) [Hikari & Nana] Normal Defense Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的普通防禦力 +%opt1_value%%'
  name:
    en: Hikari & Nana Normal Defense Up
    ja: ひかりとななの通常防御力アップ
    ko: 히카리와 나나의 일반 방어력 증가
    zh_hant: 提升光和奈奈的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3116
1100640:
  _id_: 1100640
  description:
    en: '(Passive) [Hikari & Nana] Special Defense Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的特殊防禦力 +%opt1_value%%'
  name:
    en: Hikari & Nana Special Defense Up
    ja: ひかりとななの特殊防御力アップ
    ko: 히카리와 나나의 특수 방어력 증가
    zh_hant: 提升光和奈奈的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3116
1100641:
  _id_: 1100641
  description:
    en: '(Passive) [Hikari & Nana] Dexterity Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的會心率 +%opt1_value%%'
  name:
    en: Hikari & Nana Dexterity Up
    ja: ひかりとななのクリティカル率アップ
    ko: 히카리와 나나의 크리티컬 확률 증가
    zh_hant: 提升光和奈奈的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3116
1100642:
  _id_: 1100642
  description:
    en: '(Passive) [Hikari & Nana] Critical Up %opt1_value%% '
    ja: '[永続]【ひかりとなな】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [히카리와 나나]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光和奈奈】的會心威力 +%opt1_value%%'
  name:
    en: Hikari & Nana Critical Up
    ja: ひかりとななのクリティカル威力アップ
    ko: 히카리와 나나의 크리티컬 위력 증가
    zh_hant: 提升光和奈奈的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3116
1100701:
  _id_: 1100701
  description:
    en: '(Passive) [Snow Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [눈 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Snow Rear Position Act Power Up
    ja: 雪属性立ち位置後のACTパワーアップ
    ko: 눈 속성 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升雪屬性站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3063
1100702:
  _id_: 1100702
  description:
    en: '(Passive) [Snow Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Flower Dmg Received Down
    ja: 雪属性立ち位置後の花属性被ダメージダウン
    ko: 눈 속성 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3063
1100703:
  _id_: 1100703
  description:
    en: '(Passive) [Snow Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Wind Dmg Received Down
    ja: 雪属性立ち位置後の風属性被ダメージダウン
    ko: 눈 속성 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3063
1100704:
  _id_: 1100704
  description:
    en: '(Passive) [Snow Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Snow Dmg Received Down
    ja: 雪属性立ち位置後の雪属性被ダメージダウン
    ko: 눈 속성 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3063
1100705:
  _id_: 1100705
  description:
    en: '(Passive) [Snow Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Moon Dmg Received Down
    ja: 雪属性立ち位置後の月属性被ダメージダウン
    ko: 눈 속성 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3063
1100706:
  _id_: 1100706
  description:
    en: '(Passive) [Snow Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Space Dmg Received Down
    ja: 雪属性立ち位置後の宙属性被ダメージダウン
    ko: 눈 속성 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3063
1100707:
  _id_: 1100707
  description:
    en: '(Passive) [Snow Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Cloud Dmg Received Down
    ja: 雪属性立ち位置後の雲属性被ダメージダウン
    ko: 눈 속성 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3063
1100708:
  _id_: 1100708
  description:
    en: '(Passive) [Snow Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雪屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dream Dmg Received Down
    ja: 雪属性立ち位置後の夢属性被ダメージダウン
    ko: 눈 속성 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕雪屬性站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3063
1100709:
  _id_: 1100709
  description:
    en: '(Passive) [Snow Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dmg to Flower Up
    ja: 雪属性立ち位置後の花属性特効与ダメージアップ
    ko: 눈 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3063
1100710:
  _id_: 1100710
  description:
    en: '(Passive) [Snow Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dmg to Wind Up
    ja: 雪属性立ち位置後の風属性特効与ダメージアップ
    ko: 눈 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3063
1100711:
  _id_: 1100711
  description:
    en: '(Passive) [Snow Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dmg to Snow Up
    ja: 雪属性立ち位置後の雪属性特効与ダメージアップ
    ko: 눈 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3063
1100712:
  _id_: 1100712
  description:
    en: '(Passive) [Snow Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dmg to Moon Up
    ja: 雪属性立ち位置後の月属性特効与ダメージアップ
    ko: 눈 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3063
1100713:
  _id_: 1100713
  description:
    en: '(Passive) [Snow Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dmg to Space Up
    ja: 雪属性立ち位置後の宙属性特効与ダメージアップ
    ko: 눈 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3063
1100714:
  _id_: 1100714
  description:
    en: '(Passive) [Snow Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dmg to Cloud Up
    ja: 雪属性立ち位置後の雲属性特効与ダメージアップ
    ko: 눈 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3063
1100715:
  _id_: 1100715
  description:
    en: '(Passive) [Snow Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Snow Rear Position Dmg to Dream Up
    ja: 雪属性立ち位置後の夢属性特効与ダメージアップ
    ko: 눈 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升雪屬性站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3063
1100716:
  _id_: 1100716
  description:
    en: '(Passive) [Snow Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [눈 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Snow Rear Position Normal Defense Up
    ja: 雪属性立ち位置後の通常防御力アップ
    ko: 눈 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升雪屬性站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3063
1100717:
  _id_: 1100717
  description:
    en: '(Passive) [Snow Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [눈 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Snow Rear Position Special Defense Up
    ja: 雪属性立ち位置後の特殊防御力アップ
    ko: 눈 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升雪屬性站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3063
1100718:
  _id_: 1100718
  description:
    en: '(Passive) [Snow Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Snow Rear Position Normal Defense Up
    ja: 雪属性立ち位置後の通常防御力アップ
    ko: 눈 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升雪屬性站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3063
1100719:
  _id_: 1100719
  description:
    en: '(Passive) [Snow Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Snow Rear Position Special Defense Up
    ja: 雪属性立ち位置後の特殊防御力アップ
    ko: 눈 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升雪屬性站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3063
1100720:
  _id_: 1100720
  description:
    en: '(Passive) [Snow Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Snow Rear Position Dexterity Up
    ja: 雪属性立ち位置後のクリティカル率アップ
    ko: 눈 속성 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升雪屬性站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3063
1100721:
  _id_: 1100721
  description:
    en: '(Passive) [Snow Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【雪属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [눈 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雪屬性且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Snow Rear Position Critical Up
    ja: 雪属性立ち位置後のクリティカル威力アップ
    ko: 눈 속성 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升雪屬性站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3063
1100722:
  _id_: 1100722
  description:
    en: '(Passive) [Karen & Nana] Act Power Up %opt1_value% '
    ja: '[永続]【華恋となな】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌과 나나]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Nana Act Power Up
    ja: 華恋とななのACTパワーアップ
    ko: 카렌과 나나의 ACT 파워 증가
    zh_hant: 提升華戀和奈奈的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3117
1100723:
  _id_: 1100723
  description:
    en: '(Passive) [Karen & Nana] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和奈奈】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Flower Dmg Received Down
    ja: 華恋とななの花属性被ダメージダウン
    ko: 카렌과 나나가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀和奈奈受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3117
1100724:
  _id_: 1100724
  description:
    en: '(Passive) [Karen & Nana] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和奈奈】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Wind Dmg Received Down
    ja: 華恋とななの風属性被ダメージダウン
    ko: 카렌과 나나가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀和奈奈受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3117
1100725:
  _id_: 1100725
  description:
    en: '(Passive) [Karen & Nana] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和奈奈】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Snow Dmg Received Down
    ja: 華恋とななの雪属性被ダメージダウン
    ko: 카렌과 나나가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀和奈奈受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3117
1100726:
  _id_: 1100726
  description:
    en: '(Passive) [Karen & Nana] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和奈奈】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Moon Dmg Received Down
    ja: 華恋とななの月属性被ダメージダウン
    ko: 카렌과 나나가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀和奈奈受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3117
1100727:
  _id_: 1100727
  description:
    en: '(Passive) [Karen & Nana] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和奈奈】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Space Dmg Received Down
    ja: 華恋とななの宙属性被ダメージダウン
    ko: 카렌과 나나가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀和奈奈受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3117
1100728:
  _id_: 1100728
  description:
    en: '(Passive) [Karen & Nana] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和奈奈】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Cloud Dmg Received Down
    ja: 華恋とななの雲属性被ダメージダウン
    ko: 카렌과 나나가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀和奈奈受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3117
1100729:
  _id_: 1100729
  description:
    en: '(Passive) [Karen & Nana] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和奈奈】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dream Dmg Received Down
    ja: 華恋とななの夢属性被ダメージダウン
    ko: 카렌과 나나가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀和奈奈受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3117
1100730:
  _id_: 1100730
  description:
    en: '(Passive) [Karen & Nana] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dmg to Flower Up
    ja: 華恋とななの花属性特効与ダメージアップ
    ko: 카렌과 나나가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和奈奈的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3117
1100731:
  _id_: 1100731
  description:
    en: '(Passive) [Karen & Nana] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dmg to Wind Up
    ja: 華恋とななの風属性特効与ダメージアップ
    ko: 카렌과 나나가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和奈奈的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3117
1100732:
  _id_: 1100732
  description:
    en: '(Passive) [Karen & Nana] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dmg to Snow Up
    ja: 華恋とななの雪属性特効与ダメージアップ
    ko: 카렌과 나나가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和奈奈的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3117
1100733:
  _id_: 1100733
  description:
    en: '(Passive) [Karen & Nana] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dmg to Moon Up
    ja: 華恋とななの月属性特効与ダメージアップ
    ko: 카렌과 나나가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和奈奈的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3117
1100734:
  _id_: 1100734
  description:
    en: '(Passive) [Karen & Nana] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dmg to Space Up
    ja: 華恋とななの宙属性特効与ダメージアップ
    ko: 카렌과 나나가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和奈奈的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3117
1100735:
  _id_: 1100735
  description:
    en: '(Passive) [Karen & Nana] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dmg to Cloud Up
    ja: 華恋とななの雲属性特効与ダメージアップ
    ko: 카렌과 나나가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和奈奈的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3117
1100736:
  _id_: 1100736
  description:
    en: '(Passive) [Karen & Nana] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Nana Dmg to Dream Up
    ja: 華恋とななの夢属性特効与ダメージアップ
    ko: 카렌과 나나가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和奈奈的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3117
1100737:
  _id_: 1100737
  description:
    en: '(Passive) [Karen & Nana] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋となな】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 나나]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Nana Normal Defense Up
    ja: 華恋とななの通常防御力アップ
    ko: 카렌과 나나의 일반 방어력 증가
    zh_hant: 提升華戀和奈奈的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3117
1100738:
  _id_: 1100738
  description:
    en: '(Passive) [Karen & Nana] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋となな】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 나나]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Nana Special Defense Up
    ja: 華恋とななの特殊防御力アップ
    ko: 카렌과 나나의 특수 방어력 증가
    zh_hant: 提升華戀和奈奈的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3117
1100739:
  _id_: 1100739
  description:
    en: '(Passive) [Karen & Nana] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Nana Normal Defense Up
    ja: 華恋とななの通常防御力アップ
    ko: 카렌과 나나의 일반 방어력 증가
    zh_hant: 提升華戀和奈奈的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3117
1100740:
  _id_: 1100740
  description:
    en: '(Passive) [Karen & Nana] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Nana Special Defense Up
    ja: 華恋とななの特殊防御力アップ
    ko: 카렌과 나나의 특수 방어력 증가
    zh_hant: 提升華戀和奈奈的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3117
1100741:
  _id_: 1100741
  description:
    en: '(Passive) [Karen & Nana] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的會心率 +%opt1_value%%'
  name:
    en: Karen & Nana Dexterity Up
    ja: 華恋とななのクリティカル率アップ
    ko: 카렌과 나나의 크리티컬 확률 증가
    zh_hant: 提升華戀和奈奈的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3117
1100742:
  _id_: 1100742
  description:
    en: '(Passive) [Karen & Nana] Critical Up %opt1_value%% '
    ja: '[永続]【華恋となな】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 나나]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和奈奈】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Nana Critical Up
    ja: 華恋とななのクリティカル威力アップ
    ko: 카렌와 나나의 크리티컬 위력 증가
    zh_hant: 提升華戀和奈奈的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3117
1100801:
  _id_: 1100801
  description:
    en: '(Passive) [Dream Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [꿈 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Dream Rear Position Act Power Up
    ja: 夢属性立ち位置後のACTパワーアップ
    ko: 꿈 속성 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升夢屬性站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3103
1100802:
  _id_: 1100802
  description:
    en: '(Passive) [Dream Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Flower Dmg Received Down
    ja: 夢属性立ち位置後の花属性被ダメージダウン
    ko: 꿈 속성 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3103
1100803:
  _id_: 1100803
  description:
    en: '(Passive) [Dream Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Wind Dmg Received Down
    ja: 夢属性立ち位置後の風属性被ダメージダウン
    ko: 꿈 속성 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3103
1100804:
  _id_: 1100804
  description:
    en: '(Passive) [Dream Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Snow Dmg Received Down
    ja: 夢属性立ち位置後の雪属性被ダメージダウン
    ko: 꿈 속성 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3103
1100805:
  _id_: 1100805
  description:
    en: '(Passive) [Dream Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Moon Dmg Received Down
    ja: 夢属性立ち位置後の月属性被ダメージダウン
    ko: 꿈 속성 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3103
1100806:
  _id_: 1100806
  description:
    en: '(Passive) [Dream Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Space Dmg Received Down
    ja: 夢属性立ち位置後の宙属性被ダメージダウン
    ko: 꿈 속성 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3103
1100807:
  _id_: 1100807
  description:
    en: '(Passive) [Dream Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Cloud Dmg Received Down
    ja: 夢属性立ち位置後の雲属性被ダメージダウン
    ko: 꿈 속성 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3103
1100808:
  _id_: 1100808
  description:
    en: '(Passive) [Dream Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【夢屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dream Dmg Received Down
    ja: 夢属性立ち位置後の夢属性被ダメージダウン
    ko: 꿈 속성 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕夢屬性站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3103
1100809:
  _id_: 1100809
  description:
    en: '(Passive) [Dream Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dmg to Flower Up
    ja: 夢属性立ち位置後の花属性特効与ダメージアップ
    ko: 꿈 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3103
1100810:
  _id_: 1100810
  description:
    en: '(Passive) [Dream Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dmg to Wind Up
    ja: 夢属性立ち位置後の風属性特効与ダメージアップ
    ko: 꿈 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3103
1100811:
  _id_: 1100811
  description:
    en: '(Passive) [Dream Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dmg to Snow Up
    ja: 夢属性立ち位置後の雪属性特効与ダメージアップ
    ko: 꿈 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3103
1100812:
  _id_: 1100812
  description:
    en: '(Passive) [Dream Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dmg to Moon Up
    ja: 夢属性立ち位置後の月属性特効与ダメージアップ
    ko: 꿈 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3103
1100813:
  _id_: 1100813
  description:
    en: '(Passive) [Dream Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dmg to Space Up
    ja: 夢属性立ち位置後の宙属性特効与ダメージアップ
    ko: 꿈 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3103
1100814:
  _id_: 1100814
  description:
    en: '(Passive) [Dream Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dmg to Cloud Up
    ja: 夢属性立ち位置後の雲属性特効与ダメージアップ
    ko: 꿈 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3103
1100815:
  _id_: 1100815
  description:
    en: '(Passive) [Dream Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Dream Rear Position Dmg to Dream Up
    ja: 夢属性立ち位置後の夢属性特効与ダメージアップ
    ko: 꿈 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升夢屬性站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3103
1100816:
  _id_: 1100816
  description:
    en: '(Passive) [Dream Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [꿈 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Dream Rear Position Normal Defense Up
    ja: 夢属性立ち位置後の通常防御力アップ
    ko: 꿈 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升夢屬性站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3103
1100817:
  _id_: 1100817
  description:
    en: '(Passive) [Dream Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [꿈 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Dream Rear Position Special Defense Up
    ja: 夢属性立ち位置後の特殊防御力アップ
    ko: 꿈 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升夢屬性站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3103
1100818:
  _id_: 1100818
  description:
    en: '(Passive) [Dream Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Dream Rear Position Normal Defense Up
    ja: 夢属性立ち位置後の通常防御力アップ
    ko: 꿈 속성 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升夢屬性站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3103
1100819:
  _id_: 1100819
  description:
    en: '(Passive) [Dream Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Dream Rear Position Special Defense Up
    ja: 夢属性立ち位置後の特殊防御力アップ
    ko: 꿈 속성 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升夢屬性站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3103
1100820:
  _id_: 1100820
  description:
    en: '(Passive) [Dream Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Dream Rear Position Dexterity Up
    ja: 夢属性立ち位置後のクリティカル率アップ
    ko: 꿈 속성 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升夢屬性站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3103
1100821:
  _id_: 1100821
  description:
    en: '(Passive) [Dream Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【夢属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [꿈 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【夢屬性且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Dream Rear Position Critical Up
    ja: 夢属性立ち位置後のクリティカル威力アップ
    ko: 꿈 속성 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升夢屬性站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3103
1100822:
  _id_: 1100822
  description:
    en: '(Passive) [Karen & Hikari] Act Power Up %opt1_value% '
    ja: '[永続]【華恋とひかり】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌과 히카리]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和光】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Hikari Act Power Up
    ja: 華恋とひかりのACTパワーアップ
    ko: 카렌과 히카리의 ACT 파워 증가
    zh_hant: 提升華戀和光的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3118
1100823:
  _id_: 1100823
  description:
    en: '(Passive) [Karen & Hikari] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和光】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Flower Dmg Received Down
    ja: 華恋とひかりの花属性被ダメージダウン
    ko: 카렌과 히카리가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀和光受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3118
1100824:
  _id_: 1100824
  description:
    en: '(Passive) [Karen & Hikari] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和光】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Wind Dmg Received Down
    ja: 華恋とひかりの風属性被ダメージダウン
    ko: 카렌과 히카리가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀和光受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3118
1100825:
  _id_: 1100825
  description:
    en: '(Passive) [Karen & Hikari] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和光】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Snow Dmg Received Down
    ja: 華恋とひかりの雪属性被ダメージダウン
    ko: 카렌과 히카리가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀和光受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3118
1100826:
  _id_: 1100826
  description:
    en: '(Passive) [Karen & Hikari] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和光】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Moon Dmg Received Down
    ja: 華恋とひかりの月属性被ダメージダウン
    ko: 카렌과 히카리가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀和光受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3118
1100827:
  _id_: 1100827
  description:
    en: '(Passive) [Karen & Hikari] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和光】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Space Dmg Received Down
    ja: 華恋とひかりの宙属性被ダメージダウン
    ko: 카렌과 히카리가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀和光受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3118
1100828:
  _id_: 1100828
  description:
    en: '(Passive) [Karen & Hikari] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和光】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Cloud Dmg Received Down
    ja: 華恋とひかりの雲属性被ダメージダウン
    ko: 카렌과 히카리가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀和光受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3118
1100829:
  _id_: 1100829
  description:
    en: '(Passive) [Karen & Hikari] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀和光】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dream Dmg Received Down
    ja: 華恋とひかりの夢属性被ダメージダウン
    ko: 카렌과 히카리가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀和光受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3118
1100830:
  _id_: 1100830
  description:
    en: '(Passive) [Karen & Hikari] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dmg to Flower Up
    ja: 華恋とひかりの花属性特効与ダメージアップ
    ko: 카렌과 히카리가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和光的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3118
1100831:
  _id_: 1100831
  description:
    en: '(Passive) [Karen & Hikari] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dmg to Wind Up
    ja: 華恋とひかりの風属性特効与ダメージアップ
    ko: 카렌과 히카리가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和光的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3118
1100832:
  _id_: 1100832
  description:
    en: '(Passive) [Karen & Hikari] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dmg to Snow Up
    ja: 華恋とひかりの雪属性特効与ダメージアップ
    ko: 카렌과 히카리가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和光的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3118
1100833:
  _id_: 1100833
  description:
    en: '(Passive) [Karen & Hikari] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dmg to Moon Up
    ja: 華恋とひかりの月属性特効与ダメージアップ
    ko: 카렌과 히카리가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和光的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3118
1100834:
  _id_: 1100834
  description:
    en: '(Passive) [Karen & Hikari] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dmg to Space Up
    ja: 華恋とひかりの宙属性特効与ダメージアップ
    ko: 카렌과 히카리가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和光的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3118
1100835:
  _id_: 1100835
  description:
    en: '(Passive) [Karen & Hikari] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dmg to Cloud Up
    ja: 華恋とひかりの雲属性特効与ダメージアップ
    ko: 카렌과 히카리가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和光的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3118
1100836:
  _id_: 1100836
  description:
    en: '(Passive) [Karen & Hikari] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari Dmg to Dream Up
    ja: 華恋とひかりの夢属性特効与ダメージアップ
    ko: 카렌과 히카리가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀和光的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3118
1100837:
  _id_: 1100837
  description:
    en: '(Passive) [Karen & Hikari] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋とひかり】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 히카리]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和光】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Hikari Normal Defense Up
    ja: 華恋とひかりの通常防御力アップ
    ko: 카렌과 히카리의 일반 방어력 증가
    zh_hant: 提升華戀和光的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3118
1100838:
  _id_: 1100838
  description:
    en: '(Passive) [Karen & Hikari] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋とひかり】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 히카리]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀和光】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Hikari Special Defense Up
    ja: 華恋とひかりの特殊防御力アップ
    ko: 카렌과 히카리의 특수 방어력 증가
    zh_hant: 提升華戀和光的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3118
1100839:
  _id_: 1100839
  description:
    en: '(Passive) [Karen & Hikari] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Hikari Normal Defense Up
    ja: 華恋とひかりの通常防御力アップ
    ko: 카렌과 히카리의 일반 방어력 증가
    zh_hant: 提升華戀和光的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3118
1100840:
  _id_: 1100840
  description:
    en: '(Passive) [Karen & Hikari] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Hikari Special Defense Up
    ja: 華恋とひかりの特殊防御力アップ
    ko: 카렌과 히카리의 특수 방어력 증가
    zh_hant: 提升華戀和光的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3118
1100841:
  _id_: 1100841
  description:
    en: '(Passive) [Karen & Hikari] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的會心率 +%opt1_value%%'
  name:
    en: Karen & Hikari Dexterity Up
    ja: 華恋とひかりのクリティカル率アップ
    ko: 카렌과 히카리의 크리티컬 확률 증가
    zh_hant: 提升華戀和光的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3118
1100842:
  _id_: 1100842
  description:
    en: '(Passive) [Karen & Hikari] Critical Up %opt1_value%% '
    ja: '[永続]【華恋とひかり】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀和光】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Hikari Critical Up
    ja: 華恋とひかりのクリティカル威力アップ
    ko: 카렌과 히카리의 크리티컬 위력 증가
    zh_hant: 提升華戀和光的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3118
2000101:
  _id_: 2000101
  description:
    en: '(Passive) [Rinmeikan Center Position] Act Power Up %opt1_value% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [린메이칸 중간 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的ACT力量 +%opt1_value%'
  name:
    en: Rinmeikan Center Position Act Power Up
    ja: 凛明館立ち位置中のACTパワーアップ
    ko: 린메이칸 중간 포지션의 ACT 파워 증가
    zh_hant: 提升凜明館站位為中的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3012
2000102:
  _id_: 2000102
  description:
    en: '(Passive) [Rinmeikan Center Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為中】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Flower Dmg Received Down
    ja: 凛明館立ち位置中の花属性被ダメージダウン
    ko: 린메이칸 중간 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕凜明館站位為中受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3012
2000103:
  _id_: 2000103
  description:
    en: '(Passive) [Rinmeikan Center Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為中】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Wind Dmg Received Down
    ja: 凛明館立ち位置中の風属性被ダメージダウン
    ko: 린메이칸 중간 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕凜明館站位為中受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3012
2000104:
  _id_: 2000104
  description:
    en: '(Passive) [Rinmeikan Center Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為中】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Snow Dmg Received Down
    ja: 凛明館立ち位置中の雪属性被ダメージダウン
    ko: 린메이칸 중간 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕凜明館站位為中受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3012
2000105:
  _id_: 2000105
  description:
    en: '(Passive) [Rinmeikan Center Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為中】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Moon Dmg Received Down
    ja: 凛明館立ち位置中の月属性被ダメージダウン
    ko: 린메이칸 중간 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕凜明館站位為中受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3012
2000106:
  _id_: 2000106
  description:
    en: '(Passive) [Rinmeikan Center Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為中】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Space Dmg Received Down
    ja: 凛明館立ち位置中の宙属性被ダメージダウン
    ko: 린메이칸 중간 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕凜明館站位為中受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3012
2000107:
  _id_: 2000107
  description:
    en: '(Passive) [Rinmeikan Center Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為中】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Cloud Dmg Received Down
    ja: 凛明館立ち位置中の雲属性被ダメージダウン
    ko: 린메이칸 중간 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕凜明館站位為中受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3012
2000108:
  _id_: 2000108
  description:
    en: '(Passive) [Rinmeikan Center Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為中】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dream Dmg Received Down
    ja: 凛明館立ち位置中の夢属性被ダメージダウン
    ko: 린메이칸 중간 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕凜明館站位為中受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3012
2000109:
  _id_: 2000109
  description:
    en: '(Passive) [Rinmeikan Center Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dmg to Flower Up
    ja: 凛明館立ち位置中の花属性特効与ダメージアップ
    ko: 린메이칸 중간 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為中的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3012
2000110:
  _id_: 2000110
  description:
    en: '(Passive) [Rinmeikan Center Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dmg to Wind Up
    ja: 凛明館立ち位置中の風属性特効与ダメージアップ
    ko: 린메이칸 중간 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為中的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3012
2000111:
  _id_: 2000111
  description:
    en: '(Passive) [Rinmeikan Center Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dmg to Snow Up
    ja: 凛明館立ち位置中の雪属性特効与ダメージアップ
    ko: 린메이칸 중간 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為中的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3012
2000112:
  _id_: 2000112
  description:
    en: '(Passive) [Rinmeikan Center Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dmg to Moon Up
    ja: 凛明館立ち位置中の月属性特効与ダメージアップ
    ko: 린메이칸 중간 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為中的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3012
2000113:
  _id_: 2000113
  description:
    en: '(Passive) [Rinmeikan Center Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dmg to Space Up
    ja: 凛明館立ち位置中の宙属性特効与ダメージアップ
    ko: 린메이칸 중간 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為中的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3012
2000114:
  _id_: 2000114
  description:
    en: '(Passive) [Rinmeikan Center Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dmg to Cloud Up
    ja: 凛明館立ち位置中の雲属性特効与ダメージアップ
    ko: 린메이칸 중간 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為中的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3012
2000115:
  _id_: 2000115
  description:
    en: '(Passive) [Rinmeikan Center Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dmg to Dream Up
    ja: 凛明館立ち位置中の夢属性特効与ダメージアップ
    ko: 린메이칸 중간 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為中的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3012
2000116:
  _id_: 2000116
  description:
    en: '(Passive) [Rinmeikan Center Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [린메이칸 중간 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的普通防禦力 +%opt1_value%'
  name:
    en: Rinmeikan Center Position Normal Defense Up
    ja: 凛明館立ち位置中の通常防御力アップ
    ko: 린메이칸 중간 포지션의 일반 방어력 증가
    zh_hant: 提升凜明館站位為中的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3012
2000117:
  _id_: 2000117
  description:
    en: '(Passive) [Rinmeikan Center Position] Special Defense Up %opt1_value% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [린메이칸 중간 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的特殊防禦力 +%opt1_value%'
  name:
    en: Rinmeikan Center Position Special Defense Up
    ja: 凛明館立ち位置中の特殊防御力アップ
    ko: 린메이칸 중간 포지션의 특수 방어력 증가
    zh_hant: 提升凜明館站位為中的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3012
2000118:
  _id_: 2000118
  description:
    en: '(Passive) [Rinmeikan Center Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的普通防禦力 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Normal Defense Up
    ja: 凛明館立ち位置中の通常防御力アップ
    ko: 린메이칸 중간 포지션의 일반 방어력 증가
    zh_hant: 提升凜明館站位為中的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3012
2000119:
  _id_: 2000119
  description:
    en: '(Passive) [Rinmeikan Center Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的特殊防禦力 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Special Defense Up
    ja: 凛明館立ち位置中の特殊防御力アップ
    ko: 린메이칸 중간 포지션의 특수 방어력 증가
    zh_hant: 提升凜明館站位為中的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3012
2000120:
  _id_: 2000120
  description:
    en: '(Passive) [Rinmeikan Center Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的會心率 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Dexterity Up
    ja: 凛明館立ち位置中のクリティカル率アップ
    ko: 린메이칸 중간 포지션의 크리티컬 확률 증가
    zh_hant: 提升凜明館站位為中的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3012
2000121:
  _id_: 2000121
  description:
    en: '(Passive) [Rinmeikan Center Position] Critical Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為中】的會心威力 +%opt1_value%%'
  name:
    en: Rinmeikan Center Position Critical Up
    ja: 凛明館立ち位置中のクリティカル威力アップ
    ko: 린메이칸 중간 포지션의 크리티컬 위력 증가
    zh_hant: 提升凜明館站位為中的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3012
2000201:
  _id_: 2000201
  description:
    en: '(Passive) [Rinmeikan Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [린메이칸 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Rinmeikan Rear Position Act Power Up
    ja: 凛明館立ち位置後のACTパワーアップ
    ko: 린메이칸 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升凜明館站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3013
2000202:
  _id_: 2000202
  description:
    en: '(Passive) [Rinmeikan Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Flower Dmg Received Down
    ja: 凛明館立ち位置後の花属性被ダメージダウン
    ko: 린메이칸 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕凜明館站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3013
2000203:
  _id_: 2000203
  description:
    en: '(Passive) [Rinmeikan Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Wind Dmg Received Down
    ja: 凛明館立ち位置後の風属性被ダメージダウン
    ko: 린메이칸 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕凜明館站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3013
2000204:
  _id_: 2000204
  description:
    en: '(Passive) [Rinmeikan Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Snow Dmg Received Down
    ja: 凛明館立ち位置後の雪属性被ダメージダウン
    ko: 린메이칸 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕凜明館站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3013
2000205:
  _id_: 2000205
  description:
    en: '(Passive) [Rinmeikan Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Moon Dmg Received Down
    ja: 凛明館立ち位置後の月属性被ダメージダウン
    ko: 린메이칸 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕凜明館站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3013
2000206:
  _id_: 2000206
  description:
    en: '(Passive) [Rinmeikan Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Space Dmg Received Down
    ja: 凛明館立ち位置後の宙属性被ダメージダウン
    ko: 린메이칸 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕凜明館站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3013
2000207:
  _id_: 2000207
  description:
    en: '(Passive) [Rinmeikan Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Cloud Dmg Received Down
    ja: 凛明館立ち位置後の雲属性被ダメージダウン
    ko: 린메이칸 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕凜明館站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3013
2000208:
  _id_: 2000208
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【凜明館且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dream Dmg Received Down
    ja: 凛明館立ち位置後の夢属性被ダメージダウン
    ko: 린메이칸 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕凜明館站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3013
2000209:
  _id_: 2000209
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dmg to Flower Up
    ja: 凛明館立ち位置後の花属性特効与ダメージアップ
    ko: 린메이칸 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3013
2000210:
  _id_: 2000210
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dmg to Wind Up
    ja: 凛明館立ち位置後の風属性特効与ダメージアップ
    ko: 린메이칸 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3013
2000211:
  _id_: 2000211
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dmg to Snow Up
    ja: 凛明館立ち位置後の雪属性特効与ダメージアップ
    ko: 린메이칸 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3013
2000212:
  _id_: 2000212
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dmg to Moon Up
    ja: 凛明館立ち位置後の月属性特効与ダメージアップ
    ko: 린메이칸 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3013
2000213:
  _id_: 2000213
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dmg to Space Up
    ja: 凛明館立ち位置後の宙属性特効与ダメージアップ
    ko: 린메이칸 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3013
2000214:
  _id_: 2000214
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dmg to Cloud Up
    ja: 凛明館立ち位置後の雲属性特効与ダメージアップ
    ko: 린메이칸 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3013
2000215:
  _id_: 2000215
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dmg to Dream Up
    ja: 凛明館立ち位置後の夢属性特効与ダメージアップ
    ko: 린메이칸 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升凜明館站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3013
2000216:
  _id_: 2000216
  description:
    en: '(Passive) [Rinmeikan Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [린메이칸 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Rinmeikan Rear Position Normal Defense Up
    ja: 凛明館立ち位置後の通常防御力アップ
    ko: 린메이칸 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升凜明館站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3013
2000217:
  _id_: 2000217
  description:
    en: '(Passive) [Rinmeikan Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [린메이칸 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Rinmeikan Rear Position Special Defense Up
    ja: 凛明館立ち位置後の特殊防御力アップ
    ko: 린메이칸 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升凜明館站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3013
2000218:
  _id_: 2000218
  description:
    en: '(Passive) [Rinmeikan Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Normal Defense Up
    ja: 凛明館立ち位置後の通常防御力アップ
    ko: 린메이칸 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升凜明館站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3013
2000219:
  _id_: 2000219
  description:
    en: '(Passive) [Rinmeikan Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Special Defense Up
    ja: 凛明館立ち位置後の特殊防御力アップ
    ko: 린메이칸 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升凜明館站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3013
2000220:
  _id_: 2000220
  description:
    en: '(Passive) [Rinmeikan Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Dexterity Up
    ja: 凛明館立ち位置後のクリティカル率アップ
    ko: 린메이칸 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升凜明館站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3013
2000221:
  _id_: 2000221
  description:
    en: '(Passive) [Rinmeikan Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【凛明館かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [린메이칸 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【凜明館且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Rinmeikan Rear Position Critical Up
    ja: 凛明館立ち位置後のクリティカル威力アップ
    ko: 린메이칸 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升凜明館站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3013
2000301:
  _id_: 2000301
  description:
    en: '(Passive) [Fumi & Rui] Act Power Up %opt1_value% '
    ja: '[永続]【文と塁】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [후미와 루이]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【文和壘】的ACT力量 +%opt1_value%'
  name:
    en: Fumi & Rui Act Power Up
    ja: 文と塁のACTパワーアップ
    ko: 후미와 루이의 ACT 파워 증가
    zh_hant: 文和壘的ACT力量提升
  skill_option1_id: 42
  skill_option1_target_id: 3120
2000302:
  _id_: 2000302
  description:
    en: '(Passive) [Fumi & Rui] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【文と塁】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【文和壘】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Flower Dmg Received Down
    ja: 文と塁の花属性被ダメージダウン
    ko: 후미와 루이가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕文和壘受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3120
2000303:
  _id_: 2000303
  description:
    en: '(Passive) [Fumi & Rui] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【文と塁】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【文和壘】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Wind Dmg Received Down
    ja: 文と塁の風属性被ダメージダウン
    ko: 후미와 루이가 받는 바람 속성 대미지 감소
    zh_hant: 減輕文和壘受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3120
2000304:
  _id_: 2000304
  description:
    en: '(Passive) [Fumi & Rui] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【文と塁】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【文和壘】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Snow Dmg Received Down
    ja: 文と塁の雪属性被ダメージダウン
    ko: 후미와 루이가 받는 눈 속성 대미지 감소
    zh_hant: 減輕文和壘受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3120
2000305:
  _id_: 2000305
  description:
    en: '(Passive) [Fumi & Rui] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【文と塁】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【文和壘】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Moon Dmg Received Down
    ja: 文と塁の月属性被ダメージダウン
    ko: 후미와 루이가 받는 달 속성 대미지 감소
    zh_hant: 減輕文和壘受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3120
2000306:
  _id_: 2000306
  description:
    en: '(Passive) [Fumi & Rui] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【文と塁】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【文和壘】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Space Dmg Received Down
    ja: 文と塁の宙属性被ダメージダウン
    ko: 후미와 루이가 받는 우주 속성 대미지 감소
    zh_hant: 減輕文和壘受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3120
2000307:
  _id_: 2000307
  description:
    en: '(Passive) [Fumi & Rui] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【文と塁】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【文和壘】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Cloud Dmg Received Down
    ja: 文と塁の雲属性被ダメージダウン
    ko: 후미와 루이가 받는 구름 속성 대미지 감소
    zh_hant: 減輕文和壘受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3120
2000308:
  _id_: 2000308
  description:
    en: '(Passive) [Fumi & Rui] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【文と塁】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【文和壘】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dream Dmg Received Down
    ja: 文と塁の夢属性被ダメージダウン
    ko: 후미와 루이가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕文和壘受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3120
2000309:
  _id_: 2000309
  description:
    en: '(Passive) [Fumi & Rui] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dmg to Flower Up
    ja: 文と塁の花属性特効与ダメージアップ
    ko: 후미와 루이가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升文和壘的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3120
2000310:
  _id_: 2000310
  description:
    en: '(Passive) [Fumi & Rui] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dmg to Wind Up
    ja: 文と塁の風属性特効与ダメージアップ
    ko: 후미와 루이가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升文和壘的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3120
2000311:
  _id_: 2000311
  description:
    en: '(Passive) [Fumi & Rui] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dmg to Snow Up
    ja: 文と塁の雪属性特効与ダメージアップ
    ko: 후미와 루이가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升文和壘的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3120
2000312:
  _id_: 2000312
  description:
    en: '(Passive) [Fumi & Rui] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dmg to Moon Up
    ja: 文と塁の月属性特効与ダメージアップ
    ko: 후미와 루이가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升文和壘的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3120
2000313:
  _id_: 2000313
  description:
    en: '(Passive) [Fumi & Rui] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dmg to Space Up
    ja: 文と塁の宙属性特効与ダメージアップ
    ko: 후미와 루이가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升文和壘的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3120
2000314:
  _id_: 2000314
  description:
    en: '(Passive) [Fumi & Rui] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dmg to Cloud Up
    ja: 文と塁の雲属性特効与ダメージアップ
    ko: 후미와 루이가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升文和壘的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3120
2000315:
  _id_: 2000315
  description:
    en: '(Passive) [Fumi & Rui] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Fumi & Rui Dmg to Dream Up
    ja: 文と塁の夢属性特効与ダメージアップ
    ko: 후미와 루이가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升文和壘的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3120
2000316:
  _id_: 2000316
  description:
    en: '(Passive) [Fumi & Rui] Normal Defense Up %opt1_value% '
    ja: '[永続]【文と塁】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [후미와 루이]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【文和壘】的普通防禦力 +%opt1_value%'
  name:
    en: Fumi & Rui Normal Defense Up
    ja: 文と塁の通常防御力アップ
    ko: 후미와 루이의 일반 방어력 증가
    zh_hant: 提升文和壘的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3120
2000317:
  _id_: 2000317
  description:
    en: '(Passive) [Fumi & Rui] Special Defense Up %opt1_value% '
    ja: '[永続]【文と塁】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [후미와 루이]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【文和壘】的特殊防禦力 +%opt1_value%'
  name:
    en: Fumi & Rui Special Defense Up
    ja: 文と塁の特殊防御力アップ
    ko: 후미와 루이의 특수 방어력 증가
    zh_hant: 提升文和壘的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3120
2000318:
  _id_: 2000318
  description:
    en: '(Passive) [Fumi & Rui] Normal Defense Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的普通防禦力 +%opt1_value%%'
  name:
    en: Fumi & Rui Normal Defense Up
    ja: 文と塁の通常防御力アップ
    ko: 후미와 루이의 일반 방어력 증가
    zh_hant: 提升文和壘的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3120
2000319:
  _id_: 2000319
  description:
    en: '(Passive) [Fumi & Rui] Special Defense Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的特殊防禦力 +%opt1_value%%'
  name:
    en: Fumi & Rui Special Defense Up
    ja: 文と塁の特殊防御力アップ
    ko: 후미와 루이의 특수 방어력 증가
    zh_hant: 提升文和壘的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3120
2000320:
  _id_: 2000320
  description:
    en: '(Passive) [Fumi & Rui] Dexterity Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的會心率 +%opt1_value%%'
  name:
    en: Fumi & Rui Dexterity Up
    ja: 文と塁のクリティカル率アップ
    ko: 후미와 루이의 크리티컬 확률 증가
    zh_hant: 提升文和壘的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3120
2000321:
  _id_: 2000321
  description:
    en: '(Passive) [Fumi & Rui] Critical Up %opt1_value%% '
    ja: '[永続]【文と塁】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [후미와 루이]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【文和壘】的會心威力 +%opt1_value%%'
  name:
    en: Fumi & Rui Critical Up
    ja: 文と塁のクリティカル威力アップ
    ko: 후미와 루이의 크리티컬 위력 증가
    zh_hant: 提升文和壘的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3120
3000101:
  _id_: 3000101
  description:
    en: '(Passive) [Frontier Center Position] Act Power Up %opt1_value% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [프론티어 중간 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的ACT力量 +%opt1_value%'
  name:
    en: Frontier Center Position Act Power Up
    ja: フロンティア立ち位置中のACTパワーアップ
    ko: 프론티어 중간 포지션의 ACT 파워 증가
    zh_hant: 提升芙羅提亞站位為中的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3022
3000102:
  _id_: 3000102
  description:
    en: '(Passive) [Frontier Center Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為中】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Flower Dmg Received Down
    ja: フロンティア立ち位置中の花属性被ダメージダウン
    ko: 프론티어 중간 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為中受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3022
3000103:
  _id_: 3000103
  description:
    en: '(Passive) [Frontier Center Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為中】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Wind Dmg Received Down
    ja: フロンティア立ち位置中の風属性被ダメージダウン
    ko: 프론티어 중간 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為中受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3022
3000104:
  _id_: 3000104
  description:
    en: '(Passive) [Frontier Center Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為中】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Snow Dmg Received Down
    ja: フロンティア立ち位置中の雪属性被ダメージダウン
    ko: 프론티어 중간 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為中受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3022
3000105:
  _id_: 3000105
  description:
    en: '(Passive) [Frontier Center Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為中】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Moon Dmg Received Down
    ja: フロンティア立ち位置中の月属性被ダメージダウン
    ko: 프론티어 중간 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為中受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3022
3000106:
  _id_: 3000106
  description:
    en: '(Passive) [Frontier Center Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為中】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Space Dmg Received Down
    ja: フロンティア立ち位置中の宙属性被ダメージダウン
    ko: 프론티어 중간 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為中受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3022
3000107:
  _id_: 3000107
  description:
    en: '(Passive) [Frontier Center Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為中】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Cloud Dmg Received Down
    ja: フロンティア立ち位置中の雲属性被ダメージダウン
    ko: 프론티어 중간 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為中受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3022
3000108:
  _id_: 3000108
  description:
    en: '(Passive) [Frontier Center Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為中】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dream Dmg Received Down
    ja: フロンティア立ち位置中の夢属性被ダメージダウン
    ko: 프론티어 중간 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為中受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3022
3000109:
  _id_: 3000109
  description:
    en: '(Passive) [Frontier Center Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dmg to Flower Up
    ja: フロンティア立ち位置中の花属性特効与ダメージアップ
    ko: 프론티어 중간 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為中的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3022
3000110:
  _id_: 3000110
  description:
    en: '(Passive) [Frontier Center Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dmg to Wind Up
    ja: フロンティア立ち位置中の風属性特効与ダメージアップ
    ko: 프론티어 중간 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為中的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3022
3000111:
  _id_: 3000111
  description:
    en: '(Passive) [Frontier Center Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dmg to Snow Up
    ja: フロンティア立ち位置中の雪属性特効与ダメージアップ
    ko: 프론티어 중간 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為中的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3022
3000112:
  _id_: 3000112
  description:
    en: '(Passive) [Frontier Center Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dmg to Moon Up
    ja: フロンティア立ち位置中の月属性特効与ダメージアップ
    ko: 프론티어 중간 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為中的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3022
3000113:
  _id_: 3000113
  description:
    en: '(Passive) [Frontier Center Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dmg to Space Up
    ja: フロンティア立ち位置中の宙属性特効与ダメージアップ
    ko: 프론티어 중간 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為中的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3022
3000114:
  _id_: 3000114
  description:
    en: '(Passive) [Frontier Center Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dmg to Cloud Up
    ja: フロンティア立ち位置中の雲属性特効与ダメージアップ
    ko: 프론티어 중간 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為中的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3022
3000115:
  _id_: 3000115
  description:
    en: '(Passive) [Frontier Center Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Center Position Dmg to Dream Up
    ja: フロンティア立ち位置中の夢属性特効与ダメージアップ
    ko: 프론티어 중간 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為中的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3022
3000116:
  _id_: 3000116
  description:
    en: '(Passive) [Frontier Center Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [프론티어 중간 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的普通防禦力 +%opt1_value%'
  name:
    en: Frontier Center Position Normal Defense Up
    ja: フロンティア立ち位置中の通常防御力アップ
    ko: 프론티어 중간 포지션의 일반 방어력 증가
    zh_hant: 提升芙羅提亞站位為中的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3022
3000117:
  _id_: 3000117
  description:
    en: '(Passive) [Frontier Center Position] Special Defense Up %opt1_value% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [프론티어 중간 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的特殊防禦力 +%opt1_value%'
  name:
    en: Frontier Center Position Special Defense Up
    ja: フロンティア立ち位置中の特殊防御力アップ
    ko: 프론티어 중간 포지션의 특수 방어력 증가
    zh_hant: 提升芙羅提亞站位為中的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3022
3000118:
  _id_: 3000118
  description:
    en: '(Passive) [Frontier Center Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的普通防禦力 +%opt1_value%%'
  name:
    en: Frontier Center Position Normal Defense Up
    ja: フロンティア立ち位置中の通常防御力アップ
    ko: 프론티어 중간 포지션의 일반 방어력 증가
    zh_hant: 提升芙羅提亞站位為中的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3022
3000119:
  _id_: 3000119
  description:
    en: '(Passive) [Frontier Center Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的特殊防禦力 +%opt1_value%%'
  name:
    en: Frontier Center Position Special Defense Up
    ja: フロンティア立ち位置中の特殊防御力アップ
    ko: 프론티어 중간 포지션의 특수 방어력 증가
    zh_hant: 提升芙羅提亞站位為中的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3022
3000120:
  _id_: 3000120
  description:
    en: '(Passive) [Frontier Center Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的會心率 +%opt1_value%%'
  name:
    en: Frontier Center Position Dexterity Up
    ja: フロンティア立ち位置中のクリティカル率アップ
    ko: 프론티어 중간 포지션의 크리티컬 확률 증가
    zh_hant: 提升芙羅提亞站位為中的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3022
3000121:
  _id_: 3000121
  description:
    en: '(Passive) [Frontier Center Position] Critical Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為中】的會心威力 +%opt1_value%%'
  name:
    en: Frontier Center Position Critical Up
    ja: フロンティア立ち位置中のクリティカル威力アップ
    ko: 프론티어 중간 포지션의 크리티컬 위력 증가
    zh_hant: 提升芙羅提亞站位為中的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3022
3000201:
  _id_: 3000201
  description:
    en: '(Passive) [Frontier Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [프론티어 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Frontier Rear Position Act Power Up
    ja: フロンティア立ち位置後のACTパワーアップ
    ko: 프론티어 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升芙羅提亞站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3023
3000202:
  _id_: 3000202
  description:
    en: '(Passive) [Frontier Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Flower Dmg Received Down
    ja: フロンティア立ち位置後の花属性被ダメージダウン
    ko: 프론티어 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3023
3000203:
  _id_: 3000203
  description:
    en: '(Passive) [Frontier Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Wind Dmg Received Down
    ja: フロンティア立ち位置後の風属性被ダメージダウン
    ko: 프론티어 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3023
3000204:
  _id_: 3000204
  description:
    en: '(Passive) [Frontier Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Snow Dmg Received Down
    ja: フロンティア立ち位置後の雪属性被ダメージダウン
    ko: 프론티어 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3023
3000205:
  _id_: 3000205
  description:
    en: '(Passive) [Frontier Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Moon Dmg Received Down
    ja: フロンティア立ち位置後の月属性被ダメージダウン
    ko: 프론티어 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3023
3000206:
  _id_: 3000206
  description:
    en: '(Passive) [Frontier Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Space Dmg Received Down
    ja: フロンティア立ち位置後の宙属性被ダメージダウン
    ko: 프론티어 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3023
3000207:
  _id_: 3000207
  description:
    en: '(Passive) [Frontier Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Cloud Dmg Received Down
    ja: フロンティア立ち位置後の雲属性被ダメージダウン
    ko: 프론티어 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3023
3000208:
  _id_: 3000208
  description:
    en: '(Passive) [Frontier Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dream Dmg Received Down
    ja: フロンティア立ち位置後の夢属性被ダメージダウン
    ko: 프론티어 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕芙羅提亞站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3023
3000209:
  _id_: 3000209
  description:
    en: '(Passive) [Frontier Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dmg to Flower Up
    ja: フロンティア立ち位置後の花属性特効与ダメージアップ
    ko: 프론티어 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3023
3000210:
  _id_: 3000210
  description:
    en: '(Passive) [Frontier Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dmg to Wind Up
    ja: フロンティア立ち位置後の風属性特効与ダメージアップ
    ko: 프론티어 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3023
3000211:
  _id_: 3000211
  description:
    en: '(Passive) [Frontier Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dmg to Snow Up
    ja: フロンティア立ち位置後の雪属性特効与ダメージアップ
    ko: 프론티어 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3023
3000212:
  _id_: 3000212
  description:
    en: '(Passive) [Frontier Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dmg to Moon Up
    ja: フロンティア立ち位置後の月属性特効与ダメージアップ
    ko: 프론티어 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3023
3000213:
  _id_: 3000213
  description:
    en: '(Passive) [Frontier Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dmg to Space Up
    ja: フロンティア立ち位置後の宙属性特効与ダメージアップ
    ko: 프론티어 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3023
3000214:
  _id_: 3000214
  description:
    en: '(Passive) [Frontier Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dmg to Cloud Up
    ja: フロンティア立ち位置後の雲属性特効与ダメージアップ
    ko: 프론티어 뒤 포지션이 우름 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3023
3000215:
  _id_: 3000215
  description:
    en: '(Passive) [Frontier Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dmg to Dream Up
    ja: フロンティア立ち位置後の夢属性特効与ダメージアップ
    ko: 프론티어 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3023
3000216:
  _id_: 3000216
  description:
    en: '(Passive) [Frontier Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [프론티어 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Frontier Rear Position Normal Defense Up
    ja: フロンティア立ち位置後の通常防御力アップ
    ko: 프론티어 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升芙羅提亞站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3023
3000217:
  _id_: 3000217
  description:
    en: '(Passive) [Frontier Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [프론티어 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Frontier Rear Position Special Defense Up
    ja: フロンティア立ち位置後の特殊防御力アップ
    ko: 프론티어 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升芙羅提亞站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3023
3000218:
  _id_: 3000218
  description:
    en: '(Passive) [Frontier Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Frontier Rear Position Normal Defense Up
    ja: フロンティア立ち位置後の通常防御力アップ
    ko: 프론티어 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升芙羅提亞站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3023
3000219:
  _id_: 3000219
  description:
    en: '(Passive) [Frontier Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Frontier Rear Position Special Defense Up
    ja: フロンティア立ち位置後の特殊防御力アップ
    ko: 프론티어 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升芙羅提亞站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3023
3000220:
  _id_: 3000220
  description:
    en: '(Passive) [Frontier Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Frontier Rear Position Dexterity Up
    ja: フロンティア立ち位置後のクリティカル率アップ
    ko: 프론티어 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升芙羅提亞站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3023
3000221:
  _id_: 3000221
  description:
    en: '(Passive) [Frontier Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【フロンティアかつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Frontier Rear Position Critical Up
    ja: フロンティア立ち位置後のクリティカル威力アップ
    ko: 프론티어 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升芙羅提亞站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3023
3000301:
  _id_: 3000301
  description:
    en: '(Passive) [Aruru & Misora] Act Power Up %opt1_value% '
    ja: '[永続]【あるると美空】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [아루루와 미소라]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的ACT力量 +%opt1_value%'
  name:
    en: Aruru & Misora Act Power Up
    ja: あるると美空のACTパワーアップ
    ko: 아루루와 미소라의 ACT 파워 증가
    zh_hant: 提升艾露露和美空的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3130
3000302:
  _id_: 3000302
  description:
    en: '(Passive) [Aruru & Misora] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【艾露露和美空】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Flower Dmg Received Down
    ja: あるると美空の花属性被ダメージダウン
    ko: 아루루와 미소라가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕艾露露和美空受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3130
3000303:
  _id_: 3000303
  description:
    en: '(Passive) [Aruru & Misora] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【艾露露和美空】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Wind Dmg Received Down
    ja: あるると美空の風属性被ダメージダウン
    ko: 아루루와 미소라가 받는 바람 속성 대미지 감소
    zh_hant: 減輕艾露露和美空受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3130
3000304:
  _id_: 3000304
  description:
    en: '(Passive) [Aruru & Misora] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【艾露露和美空】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Snow Dmg Received Down
    ja: あるると美空の雪属性被ダメージダウン
    ko: 아루루와 미소라가 받는 눈 속성 대미지 감소
    zh_hant: 減輕艾露露和美空受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3130
3000305:
  _id_: 3000305
  description:
    en: '(Passive) [Aruru & Misora] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【艾露露和美空】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Moon Dmg Received Down
    ja: あるると美空の月属性被ダメージダウン
    ko: 아루루와 미소라가 받는 달 속성 대미지 감소
    zh_hant: 減輕艾露露和美空受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3130
3000306:
  _id_: 3000306
  description:
    en: '(Passive) [Aruru & Misora] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【艾露露和美空】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Space Dmg Received Down
    ja: あるると美空の宙属性被ダメージダウン
    ko: 아루루와 미소라가 받는 우주 속성 대미지 감소
    zh_hant: 減輕艾露露和美空受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3130
3000307:
  _id_: 3000307
  description:
    en: '(Passive) [Aruru & Misora] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【艾露露和美空】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Cloud Dmg Received Down
    ja: あるると美空の雲属性被ダメージダウン
    ko: 아루루와 미소라가 받는 구름 속성 대미지 감소
    zh_hant: 減輕艾露露和美空受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3130
3000308:
  _id_: 3000308
  description:
    en: '(Passive) [Aruru & Misora] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【艾露露和美空】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dream Dmg Received Down
    ja: あるると美空の夢属性被ダメージダウン
    ko: 아루루와 미소라가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕艾露露和美空受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3130
3000309:
  _id_: 3000309
  description:
    en: '(Passive) [Aruru & Misora] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dmg to Flower Up
    ja: あるると美空の花属性特効与ダメージアップ
    ko: 아루루와 미소라가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升艾露露和美空的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3130
3000310:
  _id_: 3000310
  description:
    en: '(Passive) [Aruru & Misora] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dmg to Wind Up
    ja: あるると美空の風属性特効与ダメージアップ
    ko: 아루루와 미소라가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升艾露露和美空的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3130
3000311:
  _id_: 3000311
  description:
    en: '(Passive) [Aruru & Misora] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dmg to Snow Up
    ja: あるると美空の雪属性特効与ダメージアップ
    ko: 아루루와 미소라가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升艾露露和美空的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3130
3000312:
  _id_: 3000312
  description:
    en: '(Passive) [Aruru & Misora] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dmg to Moon Up
    ja: あるると美空の月属性特効与ダメージアップ
    ko: 아루루와 미소라가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升艾露露和美空的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3130
3000313:
  _id_: 3000313
  description:
    en: '(Passive) [Aruru & Misora] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dmg to Space Up
    ja: あるると美空の宙属性特効与ダメージアップ
    ko: 아루루와 미소라가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升艾露露和美空的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3130
3000314:
  _id_: 3000314
  description:
    en: '(Passive) [Aruru & Misora] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dmg to Cloud Up
    ja: あるると美空の雲属性特効与ダメージアップ
    ko: 아루루와 미소라가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升艾露露和美空的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3130
3000315:
  _id_: 3000315
  description:
    en: '(Passive) [Aruru & Misora] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Aruru & Misora Dmg to Dream Up
    ja: あるると美空の夢属性特効与ダメージアップ
    ko: 아루루와 미소라가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升艾露露和美空的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3130
3000316:
  _id_: 3000316
  description:
    en: '(Passive) [Aruru & Misora] Normal Defense Up %opt1_value% '
    ja: '[永続]【あるると美空】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [아루루와 미소라]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的普通防禦力 +%opt1_value%'
  name:
    en: Aruru & Misora Normal Defense Up
    ja: あるると美空の通常防御力アップ
    ko: 아루루와 미소라의 일반 방어력 증가
    zh_hant: 提升艾露露和美空的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3130
3000317:
  _id_: 3000317
  description:
    en: '(Passive) [Aruru & Misora] Special Defense Up %opt1_value% '
    ja: '[永続]【あるると美空】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [아루루와 미소라]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的特殊防禦力 +%opt1_value%'
  name:
    en: Aruru & Misora Special Defense Up
    ja: あるると美空の特殊防御力アップ
    ko: 아루루와 미소라의 특수 방어력 증가
    zh_hant: 提升艾露露和美空的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3130
3000318:
  _id_: 3000318
  description:
    en: '(Passive) [Aruru & Misora] Normal Defense Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的普通防禦力 +%opt1_value%%'
  name:
    en: Aruru & Misora Normal Defense Up
    ja: あるると美空の通常防御力アップ
    ko: 아루루와 미소라의 일반 방어력 증가
    zh_hant: 提升艾露露和美空的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3130
3000319:
  _id_: 3000319
  description:
    en: '(Passive) [Aruru & Misora] Special Defense Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的特殊防禦力 +%opt1_value%%'
  name:
    en: Aruru & Misora Special Defense Up
    ja: あるると美空の特殊防御力アップ
    ko: 아루루와 미소라의 특수 방어력 증가
    zh_hant: 提升艾露露和美空的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3130
3000320:
  _id_: 3000320
  description:
    en: '(Passive) [Aruru & Misora] Dexterity Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的會心率 +%opt1_value%%'
  name:
    en: Aruru & Misora Dexterity Up
    ja: あるると美空のクリティカル率アップ
    ko: 아루루와 미소라의 크리티컬 확률 증가
    zh_hant: 提升艾露露和美空的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3130
3000321:
  _id_: 3000321
  description:
    en: '(Passive) [Aruru & Misora] Critical Up %opt1_value%% '
    ja: '[永続]【あるると美空】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [아루루와 미소라]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【艾露露和美空】的會心威力 +%opt1_value%%'
  name:
    en: Aruru & Misora Critical Up
    ja: あるると美空のクリティカル威力アップ
    ko: 아루루와 미소라의 크리티컬 위력 증가
    zh_hant: 提升艾露露和美空的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3130
4000101:
  _id_: 4000101
  description:
    en: '(Passive) [Siegfeld Center Position] Act Power Up %opt1_value% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [시크펠트 중간 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的ACT力量 +%opt1_value%'
  name:
    en: Siegfeld Center Position Act Power Up
    ja: シークフェルト立ち位置中のACTパワーアップ
    ko: 시크펠트 중간 포지션의 ACT 파워 증가
    zh_hant: 提升席格菲特站位為中的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3032
4000102:
  _id_: 4000102
  description:
    en: '(Passive) [Siegfeld Center Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為中】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Flower Dmg Received Down
    ja: シークフェルト立ち位置中の花属性被ダメージダウン
    ko: 시크펠트 중간 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為中受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3032
4000103:
  _id_: 4000103
  description:
    en: '(Passive) [Siegfeld Center Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為中】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Wind Dmg Received Down
    ja: シークフェルト立ち位置中の風属性被ダメージダウン
    ko: 시크펠트 중간 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為中受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3032
4000104:
  _id_: 4000104
  description:
    en: '(Passive) [Siegfeld Center Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為中】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Snow Dmg Received Down
    ja: シークフェルト立ち位置中の雪属性被ダメージダウン
    ko: 시크펠트 중간 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為中受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3032
4000105:
  _id_: 4000105
  description:
    en: '(Passive) [Siegfeld Center Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為中】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Moon Dmg Received Down
    ja: シークフェルト立ち位置中の月属性被ダメージダウン
    ko: 시크펠트 중간 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為中受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3032
4000106:
  _id_: 4000106
  description:
    en: '(Passive) [Siegfeld Center Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為中】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Space Dmg Received Down
    ja: シークフェルト立ち位置中の宙属性被ダメージダウン
    ko: 시크펠트 중간 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為中受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3032
4000107:
  _id_: 4000107
  description:
    en: '(Passive) [Siegfeld Center Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為中】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Cloud Dmg Received Down
    ja: シークフェルト立ち位置中の雲属性被ダメージダウン
    ko: 시크펠트 중간 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為中受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3032
4000108:
  _id_: 4000108
  description:
    en: '(Passive) [Siegfeld Center Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為中】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dream Dmg Received Down
    ja: シークフェルト立ち位置中の夢属性被ダメージダウン
    ko: 시크펠트 중간 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為中受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3032
4000109:
  _id_: 4000109
  description:
    en: '(Passive) [Siegfeld Center Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dmg to Flower Up
    ja: シークフェルト立ち位置中の花属性特効与ダメージアップ
    ko: 시크펠트 중간 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為中的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3032
4000110:
  _id_: 4000110
  description:
    en: '(Passive) [Siegfeld Center Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dmg to Wind Up
    ja: シークフェルト立ち位置中の風属性特効与ダメージアップ
    ko: 시크펠트 중간 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為中的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3032
4000111:
  _id_: 4000111
  description:
    en: '(Passive) [Siegfeld Center Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dmg to Snow Up
    ja: シークフェルト立ち位置中の雪属性特効与ダメージアップ
    ko: 시크펠트 중간 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為中的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3032
4000112:
  _id_: 4000112
  description:
    en: '(Passive) [Siegfeld Center Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dmg to Moon Up
    ja: シークフェルト立ち位置中の月属性特効与ダメージアップ
    ko: 시크펠트 중간 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為中的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3032
4000113:
  _id_: 4000113
  description:
    en: '(Passive) [Siegfeld Center Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dmg to Space Up
    ja: シークフェルト立ち位置中の宙属性特効与ダメージアップ
    ko: 시크펠트 중간 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為中的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3032
4000114:
  _id_: 4000114
  description:
    en: '(Passive) [Siegfeld Center Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dmg to Cloud Up
    ja: シークフェルト立ち位置中の雲属性特効与ダメージアップ
    ko: 시크펠트 중간 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為中的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3032
4000115:
  _id_: 4000115
  description:
    en: '(Passive) [Siegfeld Center Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dmg to Dream Up
    ja: シークフェルト立ち位置中の夢属性特効与ダメージアップ
    ko: 시크펠트 중간 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為中的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3032
4000116:
  _id_: 4000116
  description:
    en: '(Passive) [Siegfeld Center Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 중간 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的普通防禦力 +%opt1_value%'
  name:
    en: Siegfeld Center Position Normal Defense Up
    ja: シークフェルト立ち位置中の通常防御力アップ
    ko: 시크펠트 중간 포지션의 일반 방어력 증가
    zh_hant: 提升席格菲特站位為中的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3032
4000117:
  _id_: 4000117
  description:
    en: '(Passive) [Siegfeld Center Position] Special Defense Up %opt1_value% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 중간 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的特殊防禦力 +%opt1_value%'
  name:
    en: Siegfeld Center Position Special Defense Up
    ja: シークフェルト立ち位置中の特殊防御力アップ
    ko: 시크펠트 중간 포지션의 특수 방어력 증가
    zh_hant: 提升席格菲特站位為中的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3032
4000118:
  _id_: 4000118
  description:
    en: '(Passive) [Siegfeld Center Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的普通防禦力 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Normal Defense Up
    ja: シークフェルト立ち位置中の通常防御力アップ
    ko: 시크펠트 중간 포지션의 일반 방어력 증가
    zh_hant: 提升席格菲特站位為中的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3032
4000119:
  _id_: 4000119
  description:
    en: '(Passive) [Siegfeld Center Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的特殊防禦力 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Special Defense Up
    ja: シークフェルト立ち位置中の特殊防御力アップ
    ko: 시크펠트 중간 포지션의 특수 방어력 증가
    zh_hant: 提升席格菲特站位為中的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3032
4000120:
  _id_: 4000120
  description:
    en: '(Passive) [Siegfeld Center Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的會心率 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Dexterity Up
    ja: シークフェルト立ち位置中のクリティカル率アップ
    ko: 시크펠트 중간 포지션의 크리티컬 확률 증가
    zh_hant: 提升席格菲特站位為中的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3032
4000121:
  _id_: 4000121
  description:
    en: '(Passive) [Siegfeld Center Position] Critical Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為中】的會心威力 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Critical Up
    ja: シークフェルト立ち位置中のクリティカル威力アップ
    ko: 시크펠트 중간 포지션의 크리티컬 위력 증가
    zh_hant: 提升席格菲特站位為中的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3032
4000201:
  _id_: 4000201
  description:
    en: '(Passive) [Siegfeld Rear Position] Act Power Up %opt1_value% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [시크펠트 뒤 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的ACT力量 +%opt1_value%'
  name:
    en: Siegfeld Rear Position Act Power Up
    ja: シークフェルト立ち位置後のACTパワーアップ
    ko: 시크펠트 뒤 포지션의 ACT 파워 증가
    zh_hant: 提升席格菲特站位為後的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3033
4000202:
  _id_: 4000202
  description:
    en: '(Passive) [Siegfeld Rear Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為後】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Flower Dmg Received Down
    ja: シークフェルト立ち位置後の花属性被ダメージダウン
    ko: 시크펠트 뒤 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為後受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3033
4000203:
  _id_: 4000203
  description:
    en: '(Passive) [Siegfeld Rear Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為後】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Wind Dmg Received Down
    ja: シークフェルト立ち位置後の風属性被ダメージダウン
    ko: 시크펠트 뒤 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為後受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3033
4000204:
  _id_: 4000204
  description:
    en: '(Passive) [Siegfeld Rear Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為後】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Snow Dmg Received Down
    ja: シークフェルト立ち位置後の雪属性被ダメージダウン
    ko: 시크펠트 뒤 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為後受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3033
4000205:
  _id_: 4000205
  description:
    en: '(Passive) [Siegfeld Rear Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為後】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Moon Dmg Received Down
    ja: シークフェルト立ち位置後の月属性被ダメージダウン
    ko: 시크펠트 뒤 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為後受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3033
4000206:
  _id_: 4000206
  description:
    en: '(Passive) [Siegfeld Rear Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為後】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Space Dmg Received Down
    ja: シークフェルト立ち位置後の宙属性被ダメージダウン
    ko: 시크펠트 뒤 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為後受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3033
4000207:
  _id_: 4000207
  description:
    en: '(Passive) [Siegfeld Rear Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為後】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Cloud Dmg Received Down
    ja: シークフェルト立ち位置後の雲属性被ダメージダウン
    ko: 시크펠트 뒤 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為後受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3033
4000208:
  _id_: 4000208
  description:
    en: '(Passive) [Siegfeld Rear Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特且站位為後】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dream Dmg Received Down
    ja: シークフェルト立ち位置後の夢属性被ダメージダウン
    ko: 시크펠트 뒤 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕席格菲特站位為後受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3033
4000209:
  _id_: 4000209
  description:
    en: '(Passive) [Siegfeld Rear Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dmg to Flower Up
    ja: シークフェルト立ち位置後の花属性特効与ダメージアップ
    ko: 시크펠트 뒤 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為後的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3033
4000210:
  _id_: 4000210
  description:
    en: '(Passive) [Siegfeld Rear Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dmg to Wind Up
    ja: シークフェルト立ち位置後の風属性特効与ダメージアップ
    ko: 시크펠트 뒤 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為後的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3033
4000211:
  _id_: 4000211
  description:
    en: '(Passive) [Siegfeld Rear Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dmg to Snow Up
    ja: シークフェルト立ち位置後の雪属性特効与ダメージアップ
    ko: 시크펠트 뒤 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為後的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3033
4000212:
  _id_: 4000212
  description:
    en: '(Passive) [Siegfeld Rear Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dmg to Moon Up
    ja: シークフェルト立ち位置後の月属性特効与ダメージアップ
    ko: 시크펠트 뒤 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為後的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3033
4000213:
  _id_: 4000213
  description:
    en: '(Passive) [Siegfeld Rear Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dmg to Space Up
    ja: シークフェルト立ち位置後の宙属性特効与ダメージアップ
    ko: 시크펠트 뒤 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為後的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3033
4000214:
  _id_: 4000214
  description:
    en: '(Passive) [Siegfeld Rear Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dmg to Cloud Up
    ja: シークフェルト立ち位置後の雲属性特効与ダメージアップ
    ko: 시크펠트 뒤 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為後的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3033
4000215:
  _id_: 4000215
  description:
    en: '(Passive) [Siegfeld Rear Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dmg to Dream Up
    ja: シークフェルト立ち位置後の夢属性特効与ダメージアップ
    ko: 시크펠트 뒤 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特站位為後的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3033
4000216:
  _id_: 4000216
  description:
    en: '(Passive) [Siegfeld Rear Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 뒤 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的普通防禦力 +%opt1_value%'
  name:
    en: Siegfeld Rear Position Normal Defense Up
    ja: シークフェルト立ち位置後の通常防御力アップ
    ko: 시크펠트 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升席格菲特站位為後的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3033
4000217:
  _id_: 4000217
  description:
    en: '(Passive) [Siegfeld Rear Position] Special Defense Up %opt1_value% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 뒤 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的特殊防禦力 +%opt1_value%'
  name:
    en: Siegfeld Rear Position Special Defense Up
    ja: シークフェルト立ち位置後の特殊防御力アップ
    ko: 시크펠트 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升席格菲特站位為後的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3033
4000218:
  _id_: 4000218
  description:
    en: '(Passive) [Siegfeld Rear Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的普通防禦力 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Normal Defense Up
    ja: シークフェルト立ち位置後の通常防御力アップ
    ko: 시크펠트 뒤 포지션의 일반 방어력 증가
    zh_hant: 提升席格菲特站位為後的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3033
4000219:
  _id_: 4000219
  description:
    en: '(Passive) [Siegfeld Rear Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的特殊防禦力 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Special Defense Up
    ja: シークフェルト立ち位置後の特殊防御力アップ
    ko: 시크펠트 뒤 포지션의 특수 방어력 증가
    zh_hant: 提升席格菲特站位為後的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3033
4000220:
  _id_: 4000220
  description:
    en: '(Passive) [Siegfeld Rear Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的會心率 +%opt1_value%%'
  name:
    en: Siegfeld Rear Position Dexterity Up
    ja: シークフェルト立ち位置後のクリティカル率アップ
    ko: 시크펠트 뒤 포지션의 크리티컬 확률 증가
    zh_hant: 提升席格菲特站位為後的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3033
4000221:
  _id_: 4000221
  description:
    en: '(Passive) [Siegfeld Rear Position] Critical Up %opt1_value%% '
    ja: '[永続]【シークフェルトかつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特且站位為後】的會心威力 +%opt1_value%%'
  name:
    en: Siegfeld Center Position Critical Up
    ja: シークフェルト立ち位置後のクリティカル威力アップ
    ko: 시크펠트 뒤 포지션의 크리티컬 위력 증가
    zh_hant: 提升席格菲特站位為後的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3033
4000301:
  _id_: 4000301
  description:
    en: '(Passive) [Flower Front Position] Act Power Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [꽃 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的ACT力量 +%opt1_value%'
  name:
    en: Flower Front Position Act Power Up
    ja: 花属性立ち位置前のACTパワーアップ
    ko: 꽃 속성 앞 포지션의 ACT 파워 증가
    zh_hant: 提升花屬性站位為前的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3051
4000302:
  _id_: 4000302
  description:
    en: '(Passive) [Flower Front Position] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為前】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Flower Dmg Received Down
    ja: 花属性立ち位置前の花属性被ダメージダウン
    ko: 꽃 속성 앞 포지션이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕花屬性站位為前受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3051
4000303:
  _id_: 4000303
  description:
    en: '(Passive) [Flower Front Position] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為前】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Wind Dmg Received Down
    ja: 花属性立ち位置前の風属性被ダメージダウン
    ko: 꽃 속성 앞 포지션이 받는 바람 속성 대미지 감소
    zh_hant: 減輕花屬性站位為前受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3051
4000304:
  _id_: 4000304
  description:
    en: '(Passive) [Flower Front Position] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Snow Dmg Received Down
    ja: 花属性立ち位置前の雪属性被ダメージダウン
    ko: 꽃 속성 앞 포지션이 받는 눈 속성 대미지 감소
    zh_hant: 減輕花屬性站位為前受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3051
4000305:
  _id_: 4000305
  description:
    en: '(Passive) [Flower Front Position] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為前】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Moon Dmg Received Down
    ja: 花属性立ち位置前の月属性被ダメージダウン
    ko: 꽃 속성 앞 포지션이 받는 달 속성 대미지 감소
    zh_hant: 減輕花屬性站位為前受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3051
4000306:
  _id_: 4000306
  description:
    en: '(Passive) [Flower Front Position] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Space Dmg Received Down
    ja: 花属性立ち位置前の宙属性被ダメージダウン
    ko: 꽃 속성 앞 포지션이 받는 우주 속성 대미지 감소
    zh_hant: 減輕花屬性站位為前受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3051
4000307:
  _id_: 4000307
  description:
    en: '(Passive) [Flower Front Position] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Cloud Dmg Received Down
    ja: 花属性立ち位置前の雲属性被ダメージダウン
    ko: 꽃 속성 앞 포지션이 받는 구름 속성 대미지 감소
    zh_hant: 減輕花屬性站位為前受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3051
4000308:
  _id_: 4000308
  description:
    en: '(Passive) [Flower Front Position] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【花屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dream Dmg Received Down
    ja: 花属性立ち位置前の夢属性被ダメージダウン
    ko: 꽃 속성 앞 포지션이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕花屬性站位為前受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3051
4000309:
  _id_: 4000309
  description:
    en: '(Passive) [Flower Front Position] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dmg to Flower Up
    ja: 花属性立ち位置前の花属性特効与ダメージアップ
    ko: 꽃 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為前的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3051
4000310:
  _id_: 4000310
  description:
    en: '(Passive) [Flower Front Position] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dmg to Wind Up
    ja: 花属性立ち位置前の風属性特効与ダメージアップ
    ko: 꽃 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為前的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3051
4000311:
  _id_: 4000311
  description:
    en: '(Passive) [Flower Front Position] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dmg to Snow Up
    ja: 花属性立ち位置前の雪属性特効与ダメージアップ
    ko: 꽃 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為前的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3051
4000312:
  _id_: 4000312
  description:
    en: '(Passive) [Flower Front Position] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dmg to Moon Up
    ja: 花属性立ち位置前の月属性特効与ダメージアップ
    ko: 꽃 속성 앞 포지션이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為前的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3051
4000313:
  _id_: 4000313
  description:
    en: '(Passive) [Flower Front Position] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dmg to Space Up
    ja: 花属性立ち位置前の宙属性特効与ダメージアップ
    ko: 꽃 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為前的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3051
4000314:
  _id_: 4000314
  description:
    en: '(Passive) [Flower Front Position] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dmg to Cloud Up
    ja: 花属性立ち位置前の雲属性特効与ダメージアップ
    ko: 꽃 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為前的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3051
4000315:
  _id_: 4000315
  description:
    en: '(Passive) [Flower Front Position] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Flower Front Position Dmg to Dream Up
    ja: 花属性立ち位置前の夢属性特効与ダメージアップ
    ko: 꽃 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升花屬性站位為前的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3051
4000316:
  _id_: 4000316
  description:
    en: '(Passive) [Flower Front Position] Normal Defense Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [꽃 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的普通防禦力 +%opt1_value%'
  name:
    en: Flower Front Position Normal Defense Up
    ja: 花属性立ち位置前の通常防御力アップ
    ko: 꽃 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升花屬性站位為前的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3051
4000317:
  _id_: 4000317
  description:
    en: '(Passive) [Flower Front Position] Special Defense Up %opt1_value% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [꽃 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的特殊防禦力 +%opt1_value%'
  name:
    en: Flower Front Position Special Defense Up
    ja: 花属性立ち位置前の特殊防御力アップ
    ko: 꽃 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升花屬性站位為前的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3051
4000318:
  _id_: 4000318
  description:
    en: '(Passive) [Flower Front Position] Normal Defense Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的普通防禦力 +%opt1_value%%'
  name:
    en: Flower Front Position Normal Defense Up
    ja: 花属性立ち位置前の通常防御力アップ
    ko: 꽃 속성 앞 포지션의 일반 방어력 증가
    zh_hant: 提升花屬性站位為前的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3051
4000319:
  _id_: 4000319
  description:
    en: '(Passive) [Flower Front Position] Special Defense Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的特殊防禦力 +%opt1_value%%'
  name:
    en: Flower Front Position Special Defense Up
    ja: 花属性立ち位置前の特殊防御力アップ
    ko: 꽃 속성 앞 포지션의 특수 방어력 증가
    zh_hant: 提升花屬性站位為前的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3051
4000320:
  _id_: 4000320
  description:
    en: '(Passive) [Flower Front Position] Dexterity Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的會心率 +%opt1_value%%'
  name:
    en: Flower Front Position Dexterity Up
    ja: 花属性立ち位置前のクリティカル率アップ
    ko: 꽃 속성 앞 포지션의 크리티컬 확률 증가
    zh_hant: 提升花屬性站位為前的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3051
4000321:
  _id_: 4000321
  description:
    en: '(Passive) [Flower Front Position] Critical Up %opt1_value%% '
    ja: '[永続]【花属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [꽃 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【花屬性且站位為前】的會心威力 +%opt1_value%%'
  name:
    en: Flower Front Position Critical Up
    ja: 花属性立ち位置前のクリティカル威力アップ
    ko: 꽃 속성 앞 포지션의 크리티컬 위력 증가
    zh_hant: 提升花屬性站位為前的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3051
4000322:
  _id_: 4000322
  description:
    en: '(Passive) [Akira & Shiori] Act Power Up %opt1_value% '
    ja: '[永続]【晶と栞】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [아키라와 시오리]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【晶和栞】的ACT力量 +%opt1_value%'
  name:
    en: Akira & Shiori Act Power Up
    ja: 晶と栞のACTパワーアップ
    ko: 아키라와 시오리의 ACT 파워 증가
    zh_hant: 提升晶和栞的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3119
4000323:
  _id_: 4000323
  description:
    en: '(Passive) [Akira & Shiori] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【晶和栞】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Flower Dmg Received Down
    ja: 晶と栞の花属性被ダメージダウン
    ko: 아키라와 시오리가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕晶和栞受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3119
4000324:
  _id_: 4000324
  description:
    en: '(Passive) [Akira & Shiori] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【晶和栞】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Wind Dmg Received Down
    ja: 晶と栞の風属性被ダメージダウン
    ko: 아키라와 시오리가 받는 바람 속성 대미지 감소
    zh_hant: 減輕晶和栞受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3119
4000325:
  _id_: 4000325
  description:
    en: '(Passive) [Akira & Shiori] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【晶和栞】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Snow Dmg Received Down
    ja: 晶と栞の雪属性被ダメージダウン
    ko: 아키라와 시오리가 받는 눈 속성 대미지 감소
    zh_hant: 減輕晶和栞受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3119
4000326:
  _id_: 4000326
  description:
    en: '(Passive) [Akira & Shiori] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【晶和栞】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Moon Dmg Received Down
    ja: 晶と栞の月属性被ダメージダウン
    ko: 아키라와 시오리가 받는 달 속성 대미지 감소
    zh_hant: 減輕晶和栞受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3119
4000327:
  _id_: 4000327
  description:
    en: '(Passive) [Akira & Shiori] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【晶和栞】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Space Dmg Received Down
    ja: 晶と栞の宙属性被ダメージダウン
    ko: 아키라와 시오리가 받는 우주 속성 대미지 감소
    zh_hant: 減輕晶和栞受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3119
4000328:
  _id_: 4000328
  description:
    en: '(Passive) [Akira & Shiori] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【晶和栞】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Cloud Dmg Received Down
    ja: 晶と栞の雲属性被ダメージダウン
    ko: 아키라와 시오리가 받는 구름 속성 대미지 감소
    zh_hant: 減輕晶和栞受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3119
4000329:
  _id_: 4000329
  description:
    en: '(Passive) [Akira & Shiori] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【晶和栞】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dream Dmg Received Down
    ja: 晶と栞の夢属性被ダメージダウン
    ko: 아키라와 시오리가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕晶和栞受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3119
4000330:
  _id_: 4000330
  description:
    en: '(Passive) [Akira & Shiori] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dmg to Flower Up
    ja: 晶と栞の花属性特効与ダメージアップ
    ko: 아키라와 시오리가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升晶和栞的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3119
4000331:
  _id_: 4000331
  description:
    en: '(Passive) [Akira & Shiori] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dmg to Wind Up
    ja: 晶と栞の風属性特効与ダメージアップ
    ko: 아키라와 시오리가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升晶和栞的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3119
4000332:
  _id_: 4000332
  description:
    en: '(Passive) [Akira & Shiori] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dmg to Snow Up
    ja: 晶と栞の雪属性特効与ダメージアップ
    ko: 아키라와 시오리가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升晶和栞的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3119
4000333:
  _id_: 4000333
  description:
    en: '(Passive) [Akira & Shiori] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dmg to Moon Up
    ja: 晶と栞の月属性特効与ダメージアップ
    ko: 아키라와 시오리가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升晶和栞的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3119
4000334:
  _id_: 4000334
  description:
    en: '(Passive) [Akira & Shiori] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dmg to Space Up
    ja: 晶と栞の宙属性特効与ダメージアップ
    ko: 아키라와 시오리가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升晶和栞的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3119
4000335:
  _id_: 4000335
  description:
    en: '(Passive) [Akira & Shiori] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dmg to Cloud Up
    ja: 晶と栞の雲属性特効与ダメージアップ
    ko: 아키라와 시오리가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升晶和栞的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3119
4000336:
  _id_: 4000336
  description:
    en: '(Passive) [Akira & Shiori] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Akira & Shiori Dmg to Dream Up
    ja: 晶と栞の夢属性特効与ダメージアップ
    ko: 아키라와 시오리가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升晶和栞的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3119
4000337:
  _id_: 4000337
  description:
    en: '(Passive) [Akira & Shiori] Normal Defense Up %opt1_value% '
    ja: '[永続]【晶と栞】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [아키라와 시오리]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【晶和栞】的普通防禦力 +%opt1_value%'
  name:
    en: Akira & Shiori Normal Defense Up
    ja: 晶と栞の通常防御力アップ
    ko: 아키라와 시오리의 일반 방어력 증가
    zh_hant: 提升晶和栞的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3119
4000338:
  _id_: 4000338
  description:
    en: '(Passive) [Akira & Shiori] Special Defense Up %opt1_value% '
    ja: '[永続]【晶と栞】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [아키라와 시오리]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【晶和栞】的特殊防禦力 +%opt1_value%'
  name:
    en: Akira & Shiori Special Defense Up
    ja: 晶と栞の特殊防御力アップ
    ko: 아키라와 시오리의 특수 방어력 증가
    zh_hant: 提升晶和栞的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3119
4000339:
  _id_: 4000339
  description:
    en: '(Passive) [Akira & Shiori] Normal Defense Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的普通防禦力 +%opt1_value%%'
  name:
    en: Akira & Shiori Normal Defense Up
    ja: 晶と栞の通常防御力アップ
    ko: 아키라와 시오리의 일반 방어력 증가
    zh_hant: 提升晶和栞的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3119
4000340:
  _id_: 4000340
  description:
    en: '(Passive) [Akira & Shiori] Special Defense Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的特殊防禦力 +%opt1_value%%'
  name:
    en: Akira & Shiori Special Defense Up
    ja: 晶と栞の特殊防御力アップ
    ko: 아키라와 시오리의 특수 방어력 증가
    zh_hant: 提升晶和栞的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3119
4000341:
  _id_: 4000341
  description:
    en: '(Passive) [Akira & Shiori] Dexterity Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的會心率 +%opt1_value%%'
  name:
    en: Akira & Shiori Dexterity Up
    ja: 晶と栞のクリティカル率アップ
    ko: 아키라와 시오리의 크리티컬 확률 증가
    zh_hant: 提升晶和栞的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3119
4000342:
  _id_: 4000342
  description:
    en: '(Passive) [Akira & Shiori] Critical Up %opt1_value%% '
    ja: '[永続]【晶と栞】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [아키라와 시오리]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【晶和栞】的會心威力 +%opt1_value%%'
  name:
    en: Akira & Shiori Critical Up
    ja: 晶と栞のクリティカル威力アップ
    ko: 아키라와 시오리의 크리티컬 위력 증가
    zh_hant: 提升晶和栞的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3119
4000401:
  _id_: 4000401
  description:
    en: '(Passive) [Siegfeld] Act Power Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的ACT力量 +%opt1_value%'
  name:
    en: Siegfeld Act Power Up
    ja: シークフェルト音楽学院のACTパワーアップ
    ko: 시크펠트 음악학원의 ACT 파워 증가
    zh_hant: 提升席格菲特音樂學院的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3263
4000402:
  _id_: 4000402
  description:
    en: '(Passive) [Siegfeld] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的花屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Flower Dmg Received Down
    ja: シークフェルト音楽学院の花属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3263
4000403:
  _id_: 4000403
  description:
    en: '(Passive) [Siegfeld] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的風屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Wind Dmg Received Down
    ja: シークフェルト音楽学院の風属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 바람 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3263
4000404:
  _id_: 4000404
  description:
    en: '(Passive) [Siegfeld] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的雪屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Snow Dmg Received Down
    ja: シークフェルト音楽学院の雪属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 눈 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3263
4000405:
  _id_: 4000405
  description:
    en: '(Passive) [Siegfeld] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的月屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Moon Dmg Received Down
    ja: シークフェルト音楽学院の月属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 달 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3263
4000406:
  _id_: 4000406
  description:
    en: '(Passive) [Siegfeld] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的宙屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Space Dmg Received Down
    ja: シークフェルト音楽学院の宙属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 우주 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3263
4000407:
  _id_: 4000407
  description:
    en: '(Passive) [Siegfeld] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的雲屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Cloud Dmg Received Down
    ja: シークフェルト音楽学院の雲属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 구름 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3263
4000408:
  _id_: 4000408
  description:
    en: '(Passive) [Siegfeld] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的夢屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Dream Dmg Received Down
    ja: シークフェルト音楽学院の夢属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3263
4000409:
  _id_: 4000409
  description:
    en: '(Passive) [Siegfeld] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Flower Up
    ja: シークフェルト音楽学院の花属性与ダメージアップ
    ko: 시크펠트 음악학원이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3263
4000410:
  _id_: 4000410
  description:
    en: '(Passive) [Siegfeld] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Wind Up
    ja: シークフェルト音楽学院の風属性与ダメージアップ
    ko: 시크펠트 음악학원이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3263
4000411:
  _id_: 4000411
  description:
    en: '(Passive) [Siegfeld] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Snow Up
    ja: シークフェルト音楽学院の雪属性与ダメージアップ
    ko: 시크펠트 음악학원이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3263
4000412:
  _id_: 4000412
  description:
    en: '(Passive) [Siegfeld] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Moon Up
    ja: シークフェルト音楽学院の月属性与ダメージアップ
    ko: 시크펠트 음악학원이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3263
4000413:
  _id_: 4000413
  description:
    en: '(Passive) [Siegfeld] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Space Up
    ja: シークフェルト音楽学院の宙属性与ダメージアップ
    ko: 시크펠트 음악학원이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3263
4000414:
  _id_: 4000414
  description:
    en: '(Passive) [Siegfeld] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Cloud Up
    ja: シークフェルト音楽学院の雲属性与ダメージアップ
    ko: 시크펠트 음악학원이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3263
4000415:
  _id_: 4000415
  description:
    en: '(Passive) [Siegfeld] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Dream Up
    ja: シークフェルト音楽学院の夢属性与ダメージアップ
    ko: 시크펠트 음악학원이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3263
4000416:
  _id_: 4000416
  description:
    en: '(Passive) [Siegfeld] Normal Defense Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%'
  name:
    en: Siegfeld Normal Defense Up
    ja: シークフェルト音楽学院の通常防御力アップ
    ko: 시크펠트 음악학원의 일반 방어력 증가
    zh_hant: 提升席格菲特音樂學院的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3263
4000417:
  _id_: 4000417
  description:
    en: '(Passive) [Siegfeld] Special Defense Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%'
  name:
    en: Siegfeld Special Defense Up
    ja: シークフェルト音楽学院の特殊防御力アップ
    ko: 시크펠트 음악학원의 특수 방어력 증가
    zh_hant: 提升席格菲特音樂學院的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3263
4000418:
  _id_: 4000418
  description:
    en: '(Passive) [Siegfeld] Normal Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%'
  name:
    en: Siegfeld Normal Defense Up
    ja: シークフェルト音楽学院の通常防御力アップ
    ko: 시크펠트 음악학원의 일반 방어력 증가
    zh_hant: 提升席格菲特音樂學院的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3263
4000419:
  _id_: 4000419
  description:
    en: '(Passive) [Siegfeld] Special Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%'
  name:
    en: Siegfeld Special Defense Up
    ja: シークフェルト音楽学院の特殊防御力アップ
    ko: 시크펠트 음악학원의 특수 방어력 증가
    zh_hant: 提升席格菲特音樂學院的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3263
4000420:
  _id_: 4000420
  description:
    en: '(Passive) [Siegfeld] Dexterity Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的會心率 +%opt1_value%%'
  name:
    en: Siegfeld Dexterity Up
    ja: シークフェルト音楽学院のクリティカル率アップ
    ko: 시크펠트 음악학원의 크리티컬 확률 증가
    zh_hant: 提升席格菲特音樂學院的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3263
4000421:
  _id_: 4000421
  description:
    en: '(Passive) [Siegfeld] Critical Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的會心威力 +%opt1_value%%'
  name:
    en: Siegfeld Critical Up
    ja: シークフェルト音楽学院のクリティカル威力アップ
    ko: 시크펠트 음악학원의 크리티컬 위력 증가
    zh_hant: 提升席格菲特音樂學院的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3263
4000501:
  _id_: 4000501
  description:
    en: '(Passive) [Siegfeld] Act Power Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的ACT力量 +%opt1_value%'
  name:
    en: Siegfeld Act Power Up
    ja: シークフェルト音楽学院のACTパワーアップ
    ko: 시크펠트 음악학원의 ACT 파워 증가
    zh_hant: 提升席格菲特音樂學院的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3263
4000502:
  _id_: 4000502
  description:
    en: '(Passive) [Siegfeld] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的花屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Flower Dmg Received Down
    ja: シークフェルト音楽学院の花属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3263
4000503:
  _id_: 4000503
  description:
    en: '(Passive) [Siegfeld] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的風屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Wind Dmg Received Down
    ja: シークフェルト音楽学院の風属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 바람 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3263
4000504:
  _id_: 4000504
  description:
    en: '(Passive) [Siegfeld] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的雪屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Snow Dmg Received Down
    ja: シークフェルト音楽学院の雪属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 눈 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3263
4000505:
  _id_: 4000505
  description:
    en: '(Passive) [Siegfeld] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的月屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Moon Dmg Received Down
    ja: シークフェルト音楽学院の月属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 달 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3263
4000506:
  _id_: 4000506
  description:
    en: '(Passive) [Siegfeld] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的宙屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Space Dmg Received Down
    ja: シークフェルト音楽学院の宙属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 우주 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3263
4000507:
  _id_: 4000507
  description:
    en: '(Passive) [Siegfeld] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的雲屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Cloud Dmg Received Down
    ja: シークフェルト音楽学院の雲属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 구름 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3263
4000508:
  _id_: 4000508
  description:
    en: '(Passive) [Siegfeld] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的夢屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Dream Dmg Received Down
    ja: シークフェルト音楽学院の夢属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3263
4000509:
  _id_: 4000509
  description:
    en: '(Passive) [Siegfeld] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Flower Up
    ja: シークフェルト音楽学院の花属性与ダメージアップ
    ko: 시크펠트 음악학원이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3263
4000510:
  _id_: 4000510
  description:
    en: '(Passive) [Siegfeld] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Wind Up
    ja: シークフェルト音楽学院の風属性与ダメージアップ
    ko: 시크펠트 음악학원이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3263
4000511:
  _id_: 4000511
  description:
    en: '(Passive) [Siegfeld] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Snow Up
    ja: シークフェルト音楽学院の雪属性与ダメージアップ
    ko: 시크펠트 음악학원이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3263
4000512:
  _id_: 4000512
  description:
    en: '(Passive) [Siegfeld] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Moon Up
    ja: シークフェルト音楽学院の月属性与ダメージアップ
    ko: 시크펠트 음악학원이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3263
4000513:
  _id_: 4000513
  description:
    en: '(Passive) [Siegfeld] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Space Up
    ja: シークフェルト音楽学院の宙属性与ダメージアップ
    ko: 시크펠트 음악학원이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3263
4000514:
  _id_: 4000514
  description:
    en: '(Passive) [Siegfeld] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Cloud Up
    ja: シークフェルト音楽学院の雲属性与ダメージアップ
    ko: 시크펠트 음악학원이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3263
4000515:
  _id_: 4000515
  description:
    en: '(Passive) [Siegfeld] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Dream Up
    ja: シークフェルト音楽学院の夢属性与ダメージアップ
    ko: 시크펠트 음악학원이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3263
4000516:
  _id_: 4000516
  description:
    en: '(Passive) [Siegfeld] Normal Defense Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%'
  name:
    en: Siegfeld Normal Defense Up
    ja: シークフェルト音楽学院の通常防御力アップ
    ko: 시크펠트 음악학원의 일반 방어력 증가
    zh_hant: 提升席格菲特音樂學院的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3263
4000517:
  _id_: 4000517
  description:
    en: '(Passive) [Siegfeld] Special Defense Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%'
  name:
    en: Siegfeld Special Defense Up
    ja: シークフェルト音楽学院の特殊防御力アップ
    ko: 시크펠트 음악학원의 특수 방어력 증가
    zh_hant: 提升席格菲特音樂學院的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3263
4000518:
  _id_: 4000518
  description:
    en: '(Passive) [Siegfeld] Normal Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%%'
  name:
    en: Siegfeld Normal Defense Up
    ja: シークフェルト音楽学院の通常防御力アップ
    ko: 시크펠트 음악학원의 일반 방어력 증가
    zh_hant: 提升席格菲特音樂學院的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3263
4000519:
  _id_: 4000519
  description:
    en: '(Passive) [Siegfeld] Special Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%%'
  name:
    en: Siegfeld Special Defense Up
    ja: シークフェルト音楽学院の特殊防御力アップ
    ko: 시크펠트 음악학원의 특수 방어력 증가
    zh_hant: 提升席格菲特音樂學院的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3263
4000520:
  _id_: 4000520
  description:
    en: '(Passive) [Siegfeld] Dexterity Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的會心率 +%opt1_value%%'
  name:
    en: Siegfeld Dexterity Up
    ja: シークフェルト音楽学院のクリティカル率アップ
    ko: 시크펠트 음악학원의 크리티컬 확률 증가
    zh_hant: 提升席格菲特音樂學院的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3263
4000521:
  _id_: 4000521
  description:
    en: '(Passive) [Siegfeld] Critical Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的會心威力 +%opt1_value%%'
  name:
    en: Siegfeld Critical Up
    ja: シークフェルト音楽学院のクリティカル威力アップ
    ko: 시크펠트 음악학원의 크리티컬 위력 증가
    zh_hant: 提升席格菲特音樂學院的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3263
5000101:
  _id_: 5000101
  description:
    en: '(Passive) [Karen & Hikari & Akira] Act Power Up %opt1_value% '
    ja: '[永続]【華恋とひかりと晶】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌과 히카리와 아키라]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Hikari & Akira Act Power Up
    ja: 華恋とひかりと晶のACTパワーアップ
    ko: 카렌과 히카리와 아키라의 ACT 파워 증가
    zh_hant: 提升華戀、光、晶的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3140
5000102:
  _id_: 5000102
  description:
    en: '(Passive) [Karen & Hikari & Akira] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、晶】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Flower Dmg Received Down
    ja: 華恋とひかりと晶の花属性被ダメージダウン
    ko: 카렌과 히카리와 아키라가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀、光、晶受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3140
5000103:
  _id_: 5000103
  description:
    en: '(Passive) [Karen & Hikari & Akira] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、晶】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Wind Dmg Received Down
    ja: 華恋とひかりと晶の風属性被ダメージダウン
    ko: 카렌과 히카리와 아키라가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀、光、晶受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3140
5000104:
  _id_: 5000104
  description:
    en: '(Passive) [Karen & Hikari & Akira] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、晶】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Snow Dmg Received Down
    ja: 華恋とひかりと晶の雪属性被ダメージダウン
    ko: 카렌과 히카리와 아키라가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀、光、晶受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3140
5000105:
  _id_: 5000105
  description:
    en: '(Passive) [Karen & Hikari & Akira] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、晶】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Moon Dmg Received Down
    ja: 華恋とひかりと晶の月属性被ダメージダウン
    ko: 카렌과 히카리와 아키라가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀、光、晶受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3140
5000106:
  _id_: 5000106
  description:
    en: '(Passive) [Karen & Hikari & Akira] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、晶】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Space Dmg Received Down
    ja: 華恋とひかりと晶の宙属性被ダメージダウン
    ko: 카렌과 히카리와 아키라가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀、光、晶受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3140
5000107:
  _id_: 5000107
  description:
    en: '(Passive) [Karen & Hikari & Akira] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、晶】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Cloud Dmg Received Down
    ja: 華恋とひかりと晶の雲属性被ダメージダウン
    ko: 카렌과 히카리와 아키라가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀、光、晶受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3140
5000108:
  _id_: 5000108
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、晶】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dream Dmg Received Down
    ja: 華恋とひかりと晶の夢属性被ダメージダウン
    ko: 카렌과 히카리와 아키라가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀、光、晶受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3140
5000109:
  _id_: 5000109
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dmg to Flower Up
    ja: 華恋とひかりと晶の花属性特効与ダメージアップ
    ko: 카렌과 히카리와 아키라가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、晶的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3140
5000110:
  _id_: 5000110
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dmg to Wind Up
    ja: 華恋とひかりと晶の風属性特効与ダメージアップ
    ko: 카렌과 히카리와 아키라가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、晶的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3140
5000111:
  _id_: 5000111
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dmg to Snow Up
    ja: 華恋とひかりと晶の雪属性特効与ダメージアップ
    ko: 카렌과 히카리와 아키라가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、晶的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3140
5000112:
  _id_: 5000112
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dmg to Moon Up
    ja: 華恋とひかりと晶の月属性特効与ダメージアップ
    ko: 카렌과 히카리와 아키라가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、晶的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3140
5000113:
  _id_: 5000113
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dmg to Space Up
    ja: 華恋とひかりと晶の宙属性特効与ダメージアップ
    ko: 카렌과 히카리와 아키라가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、晶的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3140
5000114:
  _id_: 5000114
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dmg to Cloud Up
    ja: 華恋とひかりと晶の雲属性特効与ダメージアップ
    ko: 카렌과 히카리와 아키라가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、晶的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3140
5000115:
  _id_: 5000115
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dmg to Dream Up
    ja: 華恋とひかりと晶の夢属性特効与ダメージアップ
    ko: 카렌과 히카리와 아키라가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、晶的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3140
5000116:
  _id_: 5000116
  description:
    en: '(Passive) [Karen & Hikari & Akira] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋とひかりと晶】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 히카리와 아키라]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Hikari & Akira Normal Defense Up
    ja: 華恋とひかりと晶の通常防御力アップ
    ko: 카렌과 히카리와 아키라의 일반 방어력 증가
    zh_hant: 提升華戀、光、晶的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3140
5000117:
  _id_: 5000117
  description:
    en: '(Passive) [Karen & Hikari & Akira] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋とひかりと晶】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌과 히카리와 아키라]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Hikari & Akira Special Defense Up
    ja: 華恋とひかりと晶の特殊防御力アップ
    ko: 카렌과 히카리와 아키라의 특수 방어력 증가
    zh_hant: 提升華戀、光、晶的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3140
5000118:
  _id_: 5000118
  description:
    en: '(Passive) [Karen & Hikari & Akira] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Normal Defense Up
    ja: 華恋とひかりと晶の通常防御力アップ
    ko: 카렌과 히카리와 아키라의 일반 방어력 증가
    zh_hant: 提升華戀、光、晶的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3140
5000119:
  _id_: 5000119
  description:
    en: '(Passive) [Karen & Hikari & Akira] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Special Defense Up
    ja: 華恋とひかりと晶の特殊防御力アップ
    ko: 카렌과 히카리와 아키라의 특수 방어력 증가
    zh_hant: 提升華戀、光、晶的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3140
5000120:
  _id_: 5000120
  description:
    en: '(Passive) [Karen & Hikari & Akira] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的會心率 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Dexterity Up
    ja: 華恋とひかりと晶のクリティカル率アップ
    ko: 카렌과 히카리와 아키라의 크리티컬 확률 증가
    zh_hant: 提升華戀、光、晶的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3140
5000121:
  _id_: 5000121
  description:
    en: '(Passive) [Karen & Hikari & Akira] Critical Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと晶】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌과 히카리와 아키라]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、晶】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Hikari & Akira Critical Up
    ja: 華恋とひかりと晶のクリティカル威力アップ
    ko: 카렌과 히카리와 아키라의 크리티컬 위력 증가
    zh_hant: 提升華戀、光、晶的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3140
5000201:
  _id_: 5000201
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Act Power Up %opt1_value% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】的ACT力量 +%opt1_value%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Act Power Up
    ja: 双葉と香子と珠緒と塁のACTパワーアップ
    ko: 후타바, 카오루코, 타마오, 루이의 ACT 파워 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3150
5000202:
  _id_: 5000202
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雙葉、香子、珠緒和壘】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Flower Dmg Received Down
    ja: 双葉と香子と珠緒と塁の花属性被ダメージダウン
    ko: 후타바, 카오루코, 타마오, 루이가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕雙葉、香子、珠緒和壘受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3150
5000203:
  _id_: 5000203
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雙葉、香子、珠緒和壘】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Wind Dmg Received Down
    ja: 双葉と香子と珠緒と塁の風属性被ダメージダウン
    ko: 후타바, 카오루코, 타마오, 루이가 받는 바람 속성 대미지 감소
    zh_hant: 減輕雙葉、香子、珠緒和壘受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3150
5000204:
  _id_: 5000204
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雙葉、香子、珠緒和壘】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Snow Dmg Received Down
    ja: 双葉と香子と珠緒と塁の雪属性被ダメージダウン
    ko: 후타바, 카오루코, 타마오, 루이가 받는 눈 속성 대미지 감소
    zh_hant: 減輕雙葉、香子、珠緒和壘受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3150
5000205:
  _id_: 5000205
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雙葉、香子、珠緒和壘】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Moon Dmg Received Down
    ja: 双葉と香子と珠緒と塁の月属性被ダメージダウン
    ko: 후타바, 카오루코, 타마오, 루이가 받는 달 속성 대미지 감소
    zh_hant: 減輕雙葉、香子、珠緒和壘受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3150
5000206:
  _id_: 5000206
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雙葉、香子、珠緒和壘】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Space Dmg Received Down
    ja: 双葉と香子と珠緒と塁の宙属性被ダメージダウン
    ko: 후타바, 카오루코, 타마오, 루이가 받는 우주 속성 대미지 감소
    zh_hant: 減輕雙葉、香子、珠緒和壘受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3150
5000207:
  _id_: 5000207
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雙葉、香子、珠緒和壘】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Cloud Dmg Received Down
    ja: 双葉と香子と珠緒と塁の雲属性被ダメージダウン
    ko: 후타바, 카오루코, 타마오, 루이가 받는 구름 속성 대미지 감소
    zh_hant: 減輕雙葉、香子、珠緒和壘受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3150
5000208:
  _id_: 5000208
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【雙葉、香子、珠緒和壘】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Dream Dmg Received Down
    ja: 双葉と香子と珠緒と塁の夢属性被ダメージダウン
    ko: 후타바, 카오루코, 타마오, 루이가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕雙葉、香子、珠緒和壘受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3150
5000209:
  _id_: 5000209
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Boost Dmg to Flower Up
    ja: 双葉と香子と珠緒と塁の花属性特効与ダメージアップ
    ko: 후타바, 카오루코, 타마오, 루이가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3150
5000210:
  _id_: 5000210
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Boost Dmg to Wind Up
    ja: 双葉と香子と珠緒と塁の風属性特効与ダメージアップ
    ko: 후타바, 카오루코, 타마오, 루이가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3150
5000211:
  _id_: 5000211
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Boost Dmg to Snow Up
    ja: 双葉と香子と珠緒と塁の雪属性特効与ダメージアップ
    ko: 후타바, 카오루코, 타마오, 루이가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3150
5000212:
  _id_: 5000212
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Boost Dmg to Moon Up
    ja: 双葉と香子と珠緒と塁の月属性特効与ダメージアップ
    ko: 후타바, 카오루코, 타마오, 루이가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3150
5000213:
  _id_: 5000213
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Boost Dmg to Space Up
    ja: 双葉と香子と珠緒と塁の宙属性特効与ダメージアップ
    ko: 후타바, 카오루코, 타마오, 루이가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3150
5000214:
  _id_: 5000214
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Boost Dmg to Cloud Up
    ja: 双葉と香子と珠緒と塁の雲属性特効与ダメージアップ
    ko: 후타바, 카오루코, 타마오, 루이가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3150
5000215:
  _id_: 5000215
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Boost Dmg to Dream Up
    ja: 双葉と香子と珠緒と塁の夢属性特効与ダメージアップ
    ko: 후타바, 카오루코, 타마오, 루이가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3150
5000216:
  _id_: 5000216
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Normal Defense Up %opt1_value% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】的普通防禦力 +%opt1_value%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Normal Defense Up
    ja: 双葉と香子と珠緒と塁の通常防御力アップ
    ko: 후타바, 카오루코, 타마오, 루이의 일반 방어력 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3150
5000217:
  _id_: 5000217
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Special Defense Up %opt1_value% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】的特殊防禦力 +%opt1_value%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Special Defense Up
    ja: 双葉と香子と珠緒と塁の特殊防御力アップ
    ko: 후타바, 카오루코, 타마오, 루이의 특수 방어력 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3150
5000218:
  _id_: 5000218
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Normal Defense Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】的普通防禦力 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Normal Defense Up
    ja: 双葉と香子と珠緒と塁の通常防御力アップ
    ko: 후타바, 카오루코, 타마오, 루이의 일반 방어력 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3150
5000219:
  _id_: 5000219
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Special Defense Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】的特殊防禦力 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Special Defense Up
    ja: 双葉と香子と珠緒と塁の特殊防御力アップ
    ko: 후타바, 카오루코, 타마오, 루이의 특수 방어력 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3150
5000220:
  _id_: 5000220
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Dexterity Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】的會心率 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Dexterity Up
    ja: 双葉と香子と珠緒と塁のクリティカル率アップ
    ko: 후타바, 카오루코, 타마오, 루이의 크리티컬 확률 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3150
5000221:
  _id_: 5000221
  description:
    en: '(Passive) [Futaba & Kaoruko & Tamao & Rui] Critical Up %opt1_value%% '
    ja: '[永続]【双葉と香子と珠緒と塁】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [후타바, 카오루코, 타마오, 루이]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【雙葉、香子、珠緒和壘】的會心威力 +%opt1_value%%'
  name:
    en: Futaba & Kaoruko & Tamao & Rui Critical Up
    ja: 双葉と香子と珠緒と塁のクリティカル威力アップ
    ko: 후타바, 카오루코, 타마오, 루이의 크리티컬 위력 증가
    zh_hant: 提升雙葉、香子、珠緒和壘的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3150
5000301:
  _id_: 5000301
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Act Power Up %opt1_value% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的ACT力量 +%opt1_value%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Act Power Up
    ja: 純那とゆゆ子とララフィンとメイファンのACTパワーアップ
    ko: '준나, 유유코, 라라핀, 메이팡의 ACT 파워 증가 '
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3160
5000302:
  _id_: 5000302
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Flower Dmg Received Down
    ja: 純那とゆゆ子とララフィンとメイファンの花属性被ダメージダウン
    ko: 준나, 유유코, 라라핀, 메이팡이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕純那、悠悠子、菈樂菲、美帆受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3160
5000303:
  _id_: 5000303
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Wind Dmg Received Down
    ja: 純那とゆゆ子とララフィンとメイファンの風属性被ダメージダウン
    ko: 준나, 유유코, 라라핀, 메이팡이 받는 바람 속성 대미지 감소
    zh_hant: 減輕純那、悠悠子、菈樂菲、美帆受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3160
5000304:
  _id_: 5000304
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Snow Dmg Received Down
    ja: 純那とゆゆ子とララフィンとメイファンの雪属性被ダメージダウン
    ko: 준나, 유유코, 라라핀, 메이팡이 받는 눈 속성 대미지 감소
    zh_hant: 減輕純那、悠悠子、菈樂菲、美帆受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3160
5000305:
  _id_: 5000305
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Moon Dmg Received Down
    ja: 純那とゆゆ子とララフィンとメイファンの月属性被ダメージダウン
    ko: 준나, 유유코, 라라핀, 메이팡이 받는 달 속성 대미지 감소
    zh_hant: 減輕純那、悠悠子、菈樂菲、美帆受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3160
5000306:
  _id_: 5000306
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Space Dmg Received Down
    ja: 純那とゆゆ子とララフィンとメイファンの宙属性被ダメージダウン
    ko: 준나, 유유코, 라라핀, 메이팡이 받는 우주 속성 대미지 감소
    zh_hant: 減輕純那、悠悠子、菈樂菲、美帆受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3160
5000307:
  _id_: 5000307
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Cloud Dmg Received Down
    ja: 純那とゆゆ子とララフィンとメイファンの雲属性被ダメージダウン
    ko: 준나, 유유코, 라라핀, 메이팡이 받는 구름 속성 대미지 감소
    zh_hant: 減輕純那、悠悠子、菈樂菲、美帆受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3160
5000308:
  _id_: 5000308
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dream Dmg Received Down
    ja: 純那とゆゆ子とララフィンとメイファンの夢属性被ダメージダウン
    ko: 준나, 유유코, 라라핀, 메이팡이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕純那、悠悠子、菈樂菲、美帆受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3160
5000309:
  _id_: 5000309
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dmg to Flower Up
    ja: 純那とゆゆ子とララフィンとメイファンの花属性与ダメージアップ
    ko: 준나, 유유코, 라라핀, 메이팡이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3160
5000310:
  _id_: 5000310
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dmg to Wind Up
    ja: 純那とゆゆ子とララフィンとメイファンの風属性与ダメージアップ
    ko: 준나, 유유코, 라라핀, 메이팡이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3160
5000311:
  _id_: 5000311
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dmg to Snow Up
    ja: 純那とゆゆ子とララフィンとメイファンの雪属性与ダメージアップ
    ko: 준나, 유유코, 라라핀, 메이팡이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3160
5000312:
  _id_: 5000312
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dmg to Moon Up
    ja: 純那とゆゆ子とララフィンとメイファンの月属性与ダメージアップ
    ko: 준나, 유유코, 라라핀, 메이팡이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3160
5000313:
  _id_: 5000313
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dmg to Space Up
    ja: 純那とゆゆ子とララフィンとメイファンの宙属性与ダメージアップ
    ko: 준나, 유유코, 라라핀, 메이팡이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3160
5000314:
  _id_: 5000314
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dmg to Cloud Up
    ja: 純那とゆゆ子とララフィンとメイファンの雲属性与ダメージアップ
    ko: 준나, 유유코, 라라핀, 메이팡이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3160
5000315:
  _id_: 5000315
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dmg to Dream Up
    ja: 純那とゆゆ子とララフィンとメイファンの夢属性与ダメージアップ
    ko: 준나, 유유코, 라라핀, 메이팡이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3160
5000316:
  _id_: 5000316
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Normal Defense Up %opt1_value% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的普通防禦力 +%opt1_value%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Normal Defense Up
    ja: 純那とゆゆ子とララフィンとメイファンの通常防御力アップ
    ko: '준나, 유유코, 라라핀, 메이팡의 일반 방어력 증가 '
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3160
5000317:
  _id_: 5000317
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Special Defense Up %opt1_value% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的特殊防禦力 +%opt1_value%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Special Defense Up
    ja: 純那とゆゆ子とララフィンとメイファンの特殊防御力アップ
    ko: '준나, 유유코, 라라핀, 메이팡의 특수 방어력 증가 '
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3160
5000318:
  _id_: 5000318
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Normal Defense Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的普通防禦力 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Normal Defense Up
    ja: 純那とゆゆ子とララフィンとメイファンの通常防御力アップ
    ko: '준나, 유유코, 라라핀, 메이팡의 일반 방어력 증가 '
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3160
5000319:
  _id_: 5000319
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Special Defense Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的特殊防禦力 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Special Defense Up
    ja: 純那とゆゆ子とララフィンとメイファンの特殊防御力アップ
    ko: '준나, 유유코, 라라핀, 메이팡의 특수 방어력 증가 '
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3160
5000320:
  _id_: 5000320
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dexterity Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的會心率 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Dexterity Up
    ja: 純那とゆゆ子とララフィンとメイファンのクリティカル率アップ
    ko: 준나, 유유코, 라라핀, 메이팡의 크리티컬 확률 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3160
5000321:
  _id_: 5000321
  description:
    en: '(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Critical Up %opt1_value%% '
    ja: '[永続]【純那とゆゆ子とララフィンとメイファン】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [준나, 유유코, 라라핀, 메이팡]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、悠悠子、菈樂菲、美帆】的會心威力 +%opt1_value%%'
  name:
    en: Junna & Yuyuko & Lalafin & Mei Fan Critical Up
    ja: 純那とゆゆ子とララフィンとメイファンのクリティカル威力アップ
    ko: 준나, 유유코, 라라핀, 메이팡의 크리티컬 위력 증가
    zh_hant: 提升純那、悠悠子、菈樂菲、美帆的會心率
  skill_option1_id: 22
  skill_option1_target_id: 3160
5000401:
  _id_: 5000401
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Act Power Up %opt1_value% '
    ja: '[永続]【クロディーヌと文と栞】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [클로딘, 후미, 시오리]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】的ACT力量 +%opt1_value%'
  name:
    en: Claudine & Fumi & Shiori Act Power Up
    ja: クロディーヌと文と栞のACTパワーアップ
    ko: 클로딘, 후미, 시오리의 ACT 파워 증가
    zh_hant: 提升克洛迪娜、文和栞的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3170
5000402:
  _id_: 5000402
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜、文和栞】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Flower Dmg Received Down
    ja: クロディーヌと文と栞の花属性被ダメージダウン
    ko: 클로딘, 후미, 시오리가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕克洛迪娜、文和栞受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3170
5000403:
  _id_: 5000403
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜、文和栞】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Wind Dmg Received Down
    ja: クロディーヌと文と栞の風属性被ダメージダウン
    ko: 클로딘, 후미, 시오리가 받는 바람 속성 대미지 감소
    zh_hant: 減輕克洛迪娜、文和栞受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3170
5000404:
  _id_: 5000404
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜、文和栞】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Snow Dmg Received Down
    ja: クロディーヌと文と栞の雪属性被ダメージダウン
    ko: 클로딘, 후미, 시오리가 받는 눈 속성 대미지 감소
    zh_hant: 減輕克洛迪娜、文和栞受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3170
5000405:
  _id_: 5000405
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜、文和栞】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Moon Dmg Received Down
    ja: クロディーヌと文と栞の月属性被ダメージダウン
    ko: 클로딘, 후미, 시오리가 받는 달 속성 대미지 감소
    zh_hant: 減輕克洛迪娜、文和栞受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3170
5000406:
  _id_: 5000406
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜、文和栞】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Space Dmg Received Down
    ja: クロディーヌと文と栞の宙属性被ダメージダウン
    ko: 클로딘, 후미, 시오리가 받는 우주 속성 대미지 감소
    zh_hant: 減輕克洛迪娜、文和栞受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3170
5000407:
  _id_: 5000407
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜、文和栞】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Cloud Dmg Received Down
    ja: クロディーヌと文と栞の雲属性被ダメージダウン
    ko: 클로딘, 후미, 시오리가 받는 구름 속성 대미지 감소
    zh_hant: 減輕克洛迪娜、文和栞受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3170
5000408:
  _id_: 5000408
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜、文和栞】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dream Dmg Received Down
    ja: クロディーヌと文と栞の夢属性被ダメージダウン
    ko: 클로딘, 후미, 시오리가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕克洛迪娜、文和栞受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3170
5000409:
  _id_: 5000409
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dmg to Flower Up
    ja: クロディーヌと文と栞の花属性与ダメージアップ
    ko: 클로딘, 후미, 시오리가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜、文和栞的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3170
5000410:
  _id_: 5000410
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dmg to Wind Up
    ja: クロディーヌと文と栞の風属性与ダメージアップ
    ko: 클로딘, 후미, 시오리가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜、文和栞的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3170
5000411:
  _id_: 5000411
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dmg to Snow Up
    ja: クロディーヌと文と栞の雪属性与ダメージアップ
    ko: 클로딘, 후미, 시오리가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜、文和栞的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3170
5000412:
  _id_: 5000412
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dmg to Moon Up
    ja: クロディーヌと文と栞の月属性与ダメージアップ
    ko: 클로딘, 후미, 시오리가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜、文和栞的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3170
5000413:
  _id_: 5000413
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dmg to Space Up
    ja: クロディーヌと文と栞の宙属性与ダメージアップ
    ko: 클로딘, 후미, 시오리가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜、文和栞的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3170
5000414:
  _id_: 5000414
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dmg to Cloud Up
    ja: クロディーヌと文と栞の雲属性与ダメージアップ
    ko: 클로딘, 후미, 시오리가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜、文和栞的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3170
5000415:
  _id_: 5000415
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dmg to Dream Up
    ja: クロディーヌと文と栞の夢属性与ダメージアップ
    ko: 클로딘, 후미, 시오리가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜、文和栞的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3170
5000416:
  _id_: 5000416
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Normal Defense Up %opt1_value% '
    ja: '[永続]【クロディーヌと文と栞】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [클로딘, 후미, 시오리]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】的普通防禦力 +%opt1_value%'
  name:
    en: Claudine & Fumi & Shiori Normal Defense Up
    ja: クロディーヌと文と栞の通常防御力アップ
    ko: 클로딘, 후미, 시오리의 일반 방어력 증가
    zh_hant: 提升克洛迪娜、文和栞的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3170
5000417:
  _id_: 5000417
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Special Defense Up %opt1_value% '
    ja: '[永続]【クロディーヌと文と栞】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [클로딘, 후미, 시오리]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】的特殊防禦力 +%opt1_value%'
  name:
    en: Claudine & Fumi & Shiori Special Defense Up
    ja: クロディーヌと文と栞の特殊防御力アップ
    ko: 클로딘, 후미, 시오리의 특수 방어력 증가
    zh_hant: 提升克洛迪娜、文和栞的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3170
5000418:
  _id_: 5000418
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Normal Defense Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】的普通防禦力 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Normal Defense Up
    ja: クロディーヌと文と栞の通常防御力アップ
    ko: 클로딘, 후미, 시오리의 일반 방어력 증가
    zh_hant: 提升克洛迪娜、文和栞的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3170
5000419:
  _id_: 5000419
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Special Defense Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】的特殊防禦力 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Special Defense Up
    ja: クロディーヌと文と栞の特殊防御力アップ
    ko: 클로딘, 후미, 시오리의 특수 방어력 증가
    zh_hant: 提升克洛迪娜、文和栞的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3170
5000420:
  _id_: 5000420
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Dexterity Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】的會心率 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Dexterity Up
    ja: クロディーヌと文と栞のクリティカル率アップ
    ko: 클로딘, 후미, 시오리의 크리티컬 확률 증가
    zh_hant: 提升克洛迪娜、文和栞的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3170
5000421:
  _id_: 5000421
  description:
    en: '(Passive) [Claudine & Fumi & Shiori] Critical Up %opt1_value%% '
    ja: '[永続]【クロディーヌと文と栞】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [클로딘, 후미, 시오리]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜、文和栞】的會心威力 +%opt1_value%%'
  name:
    en: Claudine & Fumi & Shiori Critical Up
    ja: クロディーヌと文と栞のクリティカル威力アップ
    ko: 클로딘, 후미, 시오리의 크리티컬 위력 증가
    zh_hant: 提升克洛迪娜、文和栞的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3170
5000501:
  _id_: 5000501
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Act Power
      Up %opt1_value% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 ACT 파워 %opt1_value%증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的ACT力量 +%opt1_value%'
  name:
    en: Treacherous Crete Act Power Up
    ja: 裏切りのクレタのACTパワーアップ
    ko: 배신의 크레타에 출연하는 무대소녀의 ACT 파워 증가
    zh_hant: 提升背叛的克里特的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3180
5000502:
  _id_: 5000502
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Flower Dmg
      Received Down %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Flower Dmg Received Down
    ja: 裏切りのクレタの花属性被ダメージダウン
    ko: 배신의 크레타에 출연하는 무대소녀가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕背叛的克里特受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3180
5000503:
  _id_: 5000503
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Wind Dmg
      Received Down %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Wind Dmg Received Down
    ja: 裏切りのクレタの風属性被ダメージダウン
    ko: 배신의 크레타에 출연하는 무대소녀가 받는 바람 속성 대미지 감소
    zh_hant: 減輕背叛的克里特受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3180
5000504:
  _id_: 5000504
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Snow Dmg
      Received Down %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Snow Dmg Received Down
    ja: 裏切りのクレタの雪属性被ダメージダウン
    ko: 배신의 크레타에 출연하는 무대소녀가 받는 눈 속성 대미지 감소
    zh_hant: 減輕背叛的克里特受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3180
5000505:
  _id_: 5000505
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Moon Dmg
      Received Down %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Moon Dmg Received Down
    ja: 裏切りのクレタの月属性被ダメージダウン
    ko: 배신의 크레타에 출연하는 무대소녀가 받는 달 속성 대미지 감소
    zh_hant: 減輕背叛的克里特受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3180
5000506:
  _id_: 5000506
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Space Dmg
      Received Down %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Space Dmg Received Down
    ja: 裏切りのクレタの宙属性被ダメージダウン
    ko: 배신의 크레타에 출연하는 무대소녀가 받는 우주 속성 대미지 감소
    zh_hant: 減輕背叛的克里特受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3180
5000507:
  _id_: 5000507
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Cloud Dmg
      Received Down %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Cloud Dmg Received Down
    ja: 裏切りのクレタの雲属性被ダメージダウン
    ko: 배신의 크레타에 출연하는 무대소녀가 받는 구름 속성 대미지 감소
    zh_hant: 減輕背叛的克里特受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3180
5000508:
  _id_: 5000508
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dream Dmg
      Received Down %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Dream Dmg Received Down
    ja: 裏切りのクレタの夢属性被ダメージダウン
    ko: 배신의 크레타에 출연하는 무대소녀가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕背叛的克里特受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3180
5000509:
  _id_: 5000509
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Flower
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Flower Dmg dealt Up
    ja: 裏切りのクレタの花属性与ダメージアップ
    ko: 배신의 크레타에 출연하는 무대소녀가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升背叛的克里特的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3180
5000510:
  _id_: 5000510
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Wind
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Wind Dmg dealt Up
    ja: 裏切りのクレタの風属性与ダメージアップ
    ko: 배신의 크레타에 출연하는 무대소녀가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升背叛的克里特的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3180
5000511:
  _id_: 5000511
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Snow
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Snow Dmg dealt Up
    ja: 裏切りのクレタの雪属性与ダメージアップ
    ko: 배신의 크레타에 출연하는 무대소녀가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升背叛的克里特的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3180
5000512:
  _id_: 5000512
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Moon
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Moon Dmg dealt Up
    ja: 裏切りのクレタの月属性与ダメージアップ
    ko: 배신의 크레타에 출연하는 무대소녀가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升背叛的克里特的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3180
5000513:
  _id_: 5000513
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Space
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Space Dmg dealt Up
    ja: 裏切りのクレタの宙属性与ダメージアップ
    ko: 배신의 크레타에 출연하는 무대소녀가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升背叛的克里特的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3180
5000514:
  _id_: 5000514
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Cloud
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Cloud Dmg dealt Up
    ja: 裏切りのクレタの雲属性与ダメージアップ
    ko: 배신의 크레타에 출연하는 무대소녀가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升背叛的克里特的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3180
5000515:
  _id_: 5000515
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Dream
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Treacherous Crete Dream Dmg dealt Up
    ja: 裏切りのクレタの夢属性与ダメージアップ
    ko: 배신의 크레타에 출연하는 무대소녀가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升背叛的克里特的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3180
5000516:
  _id_: 5000516
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Normal Defense
      Up %opt1_value% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 일반 방어력 %opt1_value%증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的普通防禦力 +%opt1_value%'
  name:
    en: Treacherous Crete Normal Defense Up
    ja: 裏切りのクレタの通常防御力アップ
    ko: 배신의 크레타에 출연하는 무대소녀의 일반 방어력 증가
    zh_hant: 提升背叛的克里特的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3180
5000517:
  _id_: 5000517
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Special Defense
      Up %opt1_value% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 특수 방어력 %opt1_value%증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的特殊防禦力 +%opt1_value%'
  name:
    en: Treacherous Crete Special Defense Up
    ja: 裏切りのクレタの特殊防御力アップ
    ko: 배신의 크레타에 출연하는 무대소녀의 특수 방어력 증가
    zh_hant: 提升背叛的克里特的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3180
5000518:
  _id_: 5000518
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Normal Defense
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的普通防禦力 +%opt1_value%%'
  name:
    en: Treacherous Crete Normal Defense Up
    ja: 裏切りのクレタの通常防御力アップ
    ko: 배신의 크레타에 출연하는 무대소녀의 일반 방어력 증가
    zh_hant: 提升背叛的克里特的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3180
5000519:
  _id_: 5000519
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Special Defense
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的特殊防禦力 +%opt1_value%%'
  name:
    en: Treacherous Crete Special Defense Up
    ja: 裏切りのクレタの特殊防御力アップ
    ko: 배신의 크레타에 출연하는 무대소녀의 특수 방어력 증가
    zh_hant: 提升背叛的克里特的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3180
5000520:
  _id_: 5000520
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dexterity
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的會心率 +%opt1_value%%'
  name:
    en: Treacherous Crete Dexterity Up
    ja: 裏切りのクレタのクリティカル率アップ
    ko: 배신의 크레타에 출연하는 무대소녀의 크리티컬 확률 증가
    zh_hant: 提升背叛的克里特的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3180
5000521:
  _id_: 5000521
  description:
    en: '(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Critical
      Up %opt1_value%% '
    ja: '[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的會心威力 +%opt1_value%%'
  name:
    en: Treacherous Crete Critical Up
    ja: 裏切りのクレタのクリティカル威力アップ
    ko: 배신의 크레타에 출연하는 무대소녀의 크리티컬 위력 증가
    zh_hant: 提升背叛的克里特的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3180
5000601:
  _id_: 5000601
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Act Power Up %opt1_value% '
    ja: '[永続]【まひるといちえとあるると美空】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的ACT力量 +%opt1_value%'
  name:
    en: Procyon the Bright Act Power Up
    ja: 一等星のプロキオンのACTパワーアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀의 ACT 파워 증가
    zh_hant: 提升一等星的南河三的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3190
5000602:
  _id_: 5000602
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、一愛、艾露露和美空】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Flower Dmg Received Down
    ja: 一等星のプロキオンの花属性被ダメージダウン
    ko: 1등성의 프로키온에 출연하는 무대소녀가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕一等星的南河三受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3190
5000603:
  _id_: 5000603
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、一愛、艾露露和美空】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Wind Dmg Received Down
    ja: 一等星のプロキオンの風属性被ダメージダウン
    ko: 1등성의 프로키온에 출연하는 무대소녀가 받는 바람 속성 대미지 감소
    zh_hant: 減輕一等星的南河三受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3190
5000604:
  _id_: 5000604
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、一愛、艾露露和美空】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Snow Dmg Received Down
    ja: 一等星のプロキオンの雪属性被ダメージダウン
    ko: 1등성의 프로키온에 출연하는 무대소녀가 받는 눈 속성 대미지 감소
    zh_hant: 減輕一等星的南河三受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3190
5000605:
  _id_: 5000605
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、一愛、艾露露和美空】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Moon Dmg Received Down
    ja: 一等星のプロキオンの月属性被ダメージダウン
    ko: 1등성의 프로키온에 출연하는 무대소녀가 받는 달 속성 대미지 감소
    zh_hant: 減輕一等星的南河三受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3190
5000606:
  _id_: 5000606
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、一愛、艾露露和美空】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Space Dmg Received Down
    ja: 一等星のプロキオンの宙属性被ダメージダウン
    ko: 1등성의 프로키온에 출연하는 무대소녀가 받는 우주 속성 대미지 감소
    zh_hant: 減輕一等星的南河三受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3190
5000607:
  _id_: 5000607
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、一愛、艾露露和美空】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Cloud Dmg Received Down
    ja: 一等星のプロキオンの雲属性被ダメージダウン
    ko: 1등성의 프로키온에 출연하는 무대소녀가 받는 구름 속성 대미지 감소
    zh_hant: 減輕一等星的南河三受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3190
5000608:
  _id_: 5000608
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、一愛、艾露露和美空】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dream Dmg Received Down
    ja: 一等星のプロキオンの夢属性被ダメージダウン
    ko: 1등성의 프로키온에 출연하는 무대소녀가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕一等星的南河三受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3190
5000609:
  _id_: 5000609
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dmg to Flower Up
    ja: 一等星のプロキオンの花属性与ダメージアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升一等星的南河三的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3190
5000610:
  _id_: 5000610
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dmg to Wind Up
    ja: 一等星のプロキオンの風属性与ダメージアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升一等星的南河三的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3190
5000611:
  _id_: 5000611
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dmg to Snow Up
    ja: 一等星のプロキオンの雪属性与ダメージアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升一等星的南河三的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3190
5000612:
  _id_: 5000612
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dmg to Moon Up
    ja: 一等星のプロキオンの月属性与ダメージアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升一等星的南河三的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3190
5000613:
  _id_: 5000613
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dmg to Space Up
    ja: 一等星のプロキオンの宙属性与ダメージアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升一等星的南河三的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3190
5000614:
  _id_: 5000614
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dmg to Cloud Up
    ja: 一等星のプロキオンの雲属性与ダメージアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升一等星的南河三的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3190
5000615:
  _id_: 5000615
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Procyon the Bright Dmg to Dream Up
    ja: 一等星のプロキオンの夢属性与ダメージアップ
    ko: 1등성의 프로키온에 출연하는 무대소녀가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升一等星的南河三的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3190
5000616:
  _id_: 5000616
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Normal Defense Up %opt1_value% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的普通防禦力 +%opt1_value%'
  name:
    en: Procyon the Bright Normal Defense Up
    ja: 一等星のプロキオンの通常防御力アップ
    ko: 1등성의 프로키온에 출연하는 무대소녀의 일반 방어력 증가
    zh_hant: 提升一等星的南河三的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3190
5000617:
  _id_: 5000617
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Special Defense Up %opt1_value% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的特殊防禦力 +%opt1_value%'
  name:
    en: Procyon the Bright Special Defense Up
    ja: 一等星のプロキオンの特殊防御力アップ
    ko: 1등성의 프로키온에 출연하는 무대소녀의 특수 방어력 증가
    zh_hant: 提升一等星的南河三的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3190
5000618:
  _id_: 5000618
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Normal Defense Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的普通防禦力 +%opt1_value%%'
  name:
    en: Procyon the Bright Normal Defense Up
    ja: 一等星のプロキオンの通常防御力アップ
    ko: 1등성의 프로키온에 출연하는 무대소녀의 일반 방어력 증가
    zh_hant: 提升一等星的南河三的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3190
5000619:
  _id_: 5000619
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Special Defense Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的特殊防禦力 +%opt1_value%%'
  name:
    en: Procyon the Bright Special Defense Up
    ja: 一等星のプロキオンの特殊防御力アップ
    ko: 1등성의 프로키온에 출연하는 무대소녀의 특수 방어력 증가
    zh_hant: 提升一等星的南河三的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3190
5000620:
  _id_: 5000620
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Dexterity Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的會心率 +%opt1_value%%'
  name:
    en: Procyon the Bright Dexterity Up
    ja: 一等星のプロキオンのクリティカル率アップ
    ko: 1등성의 프로키온에 출연하는 무대소녀의 크리티컬 확률 증가
    zh_hant: 提升一等星的南河三的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3190
5000621:
  _id_: 5000621
  description:
    en: '(Passive) [Mahiru & Ichie & Aruru & Misora] Critical Up %opt1_value%% '
    ja: '[永続]【まひるといちえとあるると美空】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [마히루, 이치에, 아루루, 미소라]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、一愛、艾露露和美空】的會心威力 +%opt1_value%%'
  name:
    en: Procyon the Bright Critical Up
    ja: 一等星のプロキオンのクリティカル威力アップ
    ko: 1등성의 프로키온에 출연하는 무대소녀의 크리티컬 위력 증가
    zh_hant: 提升一等星的南河三的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3190
5000701:
  _id_: 5000701
  description:
    en: '(Passive) [Seiran] Act Power Up %opt1_value% '
    ja: '[永続]【青嵐総合芸術院】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】的ACT力量+%opt1_value%'
  name:
    en: Seiran Act Power Up
    ja: 青嵐総合芸術院のACTパワーアップ
    ko: 세이란 종합 예술학원 무대소녀의 ACT 파워 증가
    zh_hant: 提升青嵐總合藝術學院之舞台少女的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3210
5000702:
  _id_: 5000702
  description:
    en: '(Passive) [Seiran] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【青嵐總合藝術學院】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Seiran Flower Dmg Received Down
    ja: 青嵐総合芸術院の花属性被ダメージダウン
    ko: 세이란 종합 예술학원 무대소녀가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕青嵐總合藝術學院受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3210
5000703:
  _id_: 5000703
  description:
    en: '(Passive) [Seiran] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【青嵐總合藝術學院】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Seiran Wind Dmg Received Down
    ja: 青嵐総合芸術院の風属性被ダメージダウン
    ko: 세이란 종합 예술학원 무대소녀가 받는 바람 속성 대미지 감소
    zh_hant: 減輕青嵐總合藝術學院受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3210
5000704:
  _id_: 5000704
  description:
    en: '(Passive) [Seiran] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【青嵐總合藝術學院】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Seiran Snow Dmg Received Down
    ja: 青嵐総合芸術院の雪属性被ダメージダウン
    ko: 세이란 종합 예술학원 무대소녀가 받는 눈 속성 대미지 감소
    zh_hant: 減輕青嵐總合藝術學院受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3210
5000705:
  _id_: 5000705
  description:
    en: '(Passive) [Seiran] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【青嵐總合藝術學院】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Seiran Moon Dmg Received Down
    ja: 青嵐総合芸術院の月属性被ダメージダウン
    ko: 세이란 종합 예술학원 무대소녀가 받는 달 속성 대미지 감소
    zh_hant: 減輕青嵐總合藝術學院受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3210
5000706:
  _id_: 5000706
  description:
    en: '(Passive) [Seiran] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【青嵐總合藝術學院】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Seiran Space Dmg Received Down
    ja: 青嵐総合芸術院の宙属性被ダメージダウン
    ko: 세이란 종합 예술학원 무대소녀가 받는 우주 속성 대미지 감소
    zh_hant: 減輕青嵐總合藝術學院受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3210
5000707:
  _id_: 5000707
  description:
    en: '(Passive) [Seiran] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【青嵐總合藝術學院】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Seiran Cloud Dmg Received Down
    ja: 青嵐総合芸術院の雲属性被ダメージダウン
    ko: 세이란 종합 예술학원 무대소녀가 받는 구름 속성 대미지 감소
    zh_hant: 減輕青嵐總合藝術學院受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3210
5000708:
  _id_: 5000708
  description:
    en: '(Passive) [Seiran] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【青嵐總合藝術學院】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Seiran Dream Dmg Received Down
    ja: 青嵐総合芸術院の夢属性被ダメージダウン
    ko: 세이란 종합 예술학원 무대소녀가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕青嵐總合藝術學院受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3210
5000709:
  _id_: 5000709
  description:
    en: '(Passive) [Seiran] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seiran Dmg to Flower Up
    ja: 青嵐総合芸術院の花属性特効与ダメージアップ
    ko: 세이란 종합 예술학원 무대소녀가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升青嵐總合藝術學院的花屬性特效造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3210
5000710:
  _id_: 5000710
  description:
    en: '(Passive) [Seiran] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seiran Dmg to Wind Up
    ja: 青嵐総合芸術院の風属性特効与ダメージアップ
    ko: 세이란 종합 예술학원 무대소녀가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升青嵐總合藝術學院的風屬性特效造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3210
5000711:
  _id_: 5000711
  description:
    en: '(Passive) [Seiran] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seiran Dmg to Snow Up
    ja: 青嵐総合芸術院の雪属性特効与ダメージアップ
    ko: 세이란 종합 예술학원 무대소녀가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升青嵐總合藝術學院的雪屬性特效造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3210
5000712:
  _id_: 5000712
  description:
    en: '(Passive) [Seiran] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seiran Dmg to Moon Up
    ja: 青嵐総合芸術院の月属性特効与ダメージアップ
    ko: 세이란 종합 예술학원 무대소녀가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升青嵐總合藝術學院的月屬性特效造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3210
5000713:
  _id_: 5000713
  description:
    en: '(Passive) [Seiran] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seiran Dmg to Space Up
    ja: 青嵐総合芸術院の宙属性特効与ダメージアップ
    ko: 세이란 종합 예술학원 무대소녀가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升青嵐總合藝術學院的宙屬性特效造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3210
5000714:
  _id_: 5000714
  description:
    en: '(Passive) [Seiran] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seiran Dmg to Cloud Up
    ja: 青嵐総合芸術院の雲属性特効与ダメージアップ
    ko: 세이란 종합 예술학원 무대소녀가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升青嵐總合藝術學院的雲屬性特效造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3210
5000715:
  _id_: 5000715
  description:
    en: '(Passive) [Seiran] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Seiran Dmg to Dream Up
    ja: 青嵐総合芸術院の夢属性特効与ダメージアップ
    ko: 세이란 종합 예술학원 무대소녀가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升青嵐總合藝術學院的夢屬性特效造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3210
5000716:
  _id_: 5000716
  description:
    en: '(Passive) [Seiran] Normal Defense Up %opt1_value% '
    ja: '[永続]【青嵐総合芸術院】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】的普通防禦力+%opt1_value%'
  name:
    en: Seiran Normal Defense Up
    ja: 青嵐総合芸術院の通常防御力アップ
    ko: 세이란 종합 예술학원 무대소녀의 일반 방어력 증가
    zh_hant: 提升青嵐總合藝術學院的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3210
5000717:
  _id_: 5000717
  description:
    en: '(Passive) [Seiran] Special Defense Up %opt1_value% '
    ja: '[永続]【青嵐総合芸術院】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】的特殊防禦力+%opt1_value%'
  name:
    en: Seiran Special Defense Up
    ja: 青嵐総合芸術院の特殊防御力アップ
    ko: 세이란 종합 예술학원 무대소녀의 특수 방어력 증가
    zh_hant: 提升青嵐總合藝術學院的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3210
5000718:
  _id_: 5000718
  description:
    en: '(Passive) [Seiran] Normal Defense Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】的普通防禦力+%opt1_value%%'
  name:
    en: Seiran Normal Defense Up
    ja: 青嵐総合芸術院の通常防御力アップ
    ko: 세이란 종합 예술학원 무대소녀의 일반 방어력 증가
    zh_hant: 提升青嵐總合藝術學院的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3210
5000719:
  _id_: 5000719
  description:
    en: '(Passive) [Seiran] Special Defense Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】的特殊防禦力+%opt1_value%%'
  name:
    en: Seiran Special Defense Up
    ja: 青嵐総合芸術院の特殊防御力アップ
    ko: 세이란 종합 예술학원 무대소녀의 특수 방어력 증가
    zh_hant: 提升青嵐總合藝術學院的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3210
5000720:
  _id_: 5000720
  description:
    en: '(Passive) [Seiran] Dexterity Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】的會心率 +%opt1_value%%'
  name:
    en: Seiran Dexterity Up
    ja: 青嵐総合芸術院のクリティカル率アップ
    ko: 세이란 종합 예술학원 무대소녀의 크리티컬 확률 증가
    zh_hant: 提升青嵐總合藝術學院的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3210
5000721:
  _id_: 5000721
  description:
    en: '(Passive) [Seiran] Critical Up %opt1_value%% '
    ja: '[永続]【青嵐総合芸術院】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [세이란 종합 예술학원 무대소녀]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【青嵐總合藝術學院】的會心威力 +%opt1_value%%'
  name:
    en: Seiran Critical Up
    ja: 青嵐総合芸術院のクリティカル威力アップ
    ko: 세이란 종합 예술학원 무대소녀의 크리티컬 위력 증가
    zh_hant: 提升青嵐總合藝術學院的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3210
5000801:
  _id_: 5000801
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Act Power Up %opt1_value% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】的ACT力量 +%opt1_value%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Act Power Up
    ja: 純那と香子と塁とゆゆ子のACTパワーアップ
    ko: 준나, 카오루코, 루이, 유유코의 ACT 파워 증가
    zh_hant: 提升純那、香子、壘和悠悠子的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3220
5000802:
  _id_: 5000802
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、香子、壘、悠悠子】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Flower Dmg Received Down
    ja: 純那と香子と塁とゆゆ子の花属性被ダメージダウン
    ko: 준나, 카오루코, 루이, 유유코가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕純那、香子、壘和悠悠子受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3220
5000803:
  _id_: 5000803
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、香子、壘、悠悠子】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Wind Dmg Received Down
    ja: 純那と香子と塁とゆゆ子の風属性被ダメージダウン
    ko: 준나, 카오루코, 루이, 유유코가 받는 바람 속성 대미지 감소
    zh_hant: 減輕純那、香子、壘和悠悠子受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3220
5000804:
  _id_: 5000804
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、香子、壘、悠悠子】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Snow Dmg Received Down
    ja: 純那と香子と塁とゆゆ子の雪属性被ダメージダウン
    ko: 준나, 카오루코, 루이, 유유코가 받는 눈 속성 대미지 감소
    zh_hant: 減輕純那、香子、壘和悠悠子受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3220
5000805:
  _id_: 5000805
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、香子、壘、悠悠子】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Moon Dmg Received Down
    ja: 純那と香子と塁とゆゆ子の月属性被ダメージダウン
    ko: 준나, 카오루코, 루이, 유유코가 받는 달 속성 대미지 감소
    zh_hant: 減輕純那、香子、壘和悠悠子受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3220
5000806:
  _id_: 5000806
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、香子、壘、悠悠子】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Space Dmg Received Down
    ja: 純那と香子と塁とゆゆ子の宙属性被ダメージダウン
    ko: 준나, 카오루코, 루이, 유유코가 받는 우주 속성 대미지 감소
    zh_hant: 減輕純那、香子、壘和悠悠子受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3220
5000807:
  _id_: 5000807
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、香子、壘、悠悠子】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Cloud Dmg Received Down
    ja: 純那と香子と塁とゆゆ子の雲属性被ダメージダウン
    ko: 준나, 카오루코, 루이, 유유코가 받는 구름 속성 대미지 감소
    zh_hant: 減輕純那、香子、壘和悠悠子受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3220
5000808:
  _id_: 5000808
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【純那、香子、壘、悠悠子】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dream Dmg Received Down
    ja: 純那と香子と塁とゆゆ子の夢属性被ダメージダウン
    ko: 준나, 카오루코, 루이, 유유코가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕純那、香子、壘和悠悠子受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3220
5000809:
  _id_: 5000809
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dmg to Flower Up
    ja: 純那と香子と塁とゆゆ子の花属性与ダメージアップ
    ko: 준나, 카오루코, 루이, 유유코가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、香子、壘和悠悠子的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3220
5000810:
  _id_: 5000810
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dmg to Wind Up
    ja: 純那と香子と塁とゆゆ子の風属性与ダメージアップ
    ko: 준나, 카오루코, 루이, 유유코가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、香子、壘和悠悠子的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3220
5000811:
  _id_: 5000811
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dmg to Snow Up
    ja: 純那と香子と塁とゆゆ子の雪属性与ダメージアップ
    ko: 준나, 카오루코, 루이, 유유코가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、香子、壘和悠悠子的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3220
5000812:
  _id_: 5000812
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dmg to Moon Up
    ja: 純那と香子と塁とゆゆ子の月属性与ダメージアップ
    ko: 준나, 카오루코, 루이, 유유코가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、香子、壘和悠悠子的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3220
5000813:
  _id_: 5000813
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dmg to Space Up
    ja: 純那と香子と塁とゆゆ子の宙属性与ダメージアップ
    ko: 준나, 카오루코, 루이, 유유코가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、香子、壘和悠悠子的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3220
5000814:
  _id_: 5000814
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dmg to Cloud Up
    ja: 純那と香子と塁とゆゆ子の雲属性与ダメージアップ
    ko: 준나, 카오루코, 루이, 유유코가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、香子、壘和悠悠子的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3220
5000815:
  _id_: 5000815
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dmg to Dream Up
    ja: 純那と香子と塁とゆゆ子の夢属性与ダメージアップ
    ko: 준나, 카오루코, 루이, 유유코가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升純那、香子、壘和悠悠子的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3220
5000816:
  _id_: 5000816
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Normal Defense Up %opt1_value% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】的普通防禦力 +%opt1_value%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Normal Defense Up
    ja: 純那と香子と塁とゆゆ子の通常防御力アップ
    ko: 준나, 카오루코, 루이, 유유코의 일반 방어력 증가
    zh_hant: 提升純那、香子、壘和悠悠子的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3220
5000817:
  _id_: 5000817
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Special Defense Up %opt1_value% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】的特殊防禦力 +%opt1_value%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Special Defense Up
    ja: 純那と香子と塁とゆゆ子の特殊防御力アップ
    ko: 준나, 카오루코, 루이, 유유코의 특수 방어력 증가
    zh_hant: 提升純那、香子、壘和悠悠子的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3220
5000818:
  _id_: 5000818
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Normal Defense Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】的普通防禦力 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Normal Defense Up
    ja: 純那と香子と塁とゆゆ子の通常防御力アップ
    ko: 준나, 카오루코, 루이, 유유코의 일반 방어력 증가
    zh_hant: 提升純那、香子、壘和悠悠子的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3220
5000819:
  _id_: 5000819
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Special Defense Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】的特殊防禦力 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Special Defense Up
    ja: 純那と香子と塁とゆゆ子の特殊防御力アップ
    ko: 준나, 카오루코, 루이, 유유코의 특수 방어력 증가
    zh_hant: 提升純那、香子、壘和悠悠子的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3220
5000820:
  _id_: 5000820
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dexterity Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】的會心率 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Dexterity Up
    ja: 純那と香子と塁とゆゆ子のクリティカル率アップ
    ko: 준나, 카오루코, 루이, 유유코의 크리티컬 확률 증가
    zh_hant: 提升純那、香子、壘和悠悠子的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3220
5000821:
  _id_: 5000821
  description:
    en: '(Passive) [Junna & Kaoruko & Rui & Yuyuko] Critical Up %opt1_value%% '
    ja: '[永続]【純那と香子と塁とゆゆ子】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [준나, 카오루코, 루이, 유유코]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【純那、香子、壘、悠悠子】的會心威力 +%opt1_value%%'
  name:
    en: Junna & Kaoruko & Rui & Yuyuko Critical Up
    ja: 純那と香子と塁とゆゆ子のクリティカル威力アップ
    ko: 준나, 카오루코, 루이, 유유코의 크리티컬 위력 증가
    zh_hant: 提升純那、香子、壘和悠悠子的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3220
5000901:
  _id_: 5000901
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Act Power Up %opt1_value% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Futaba & Michiru & Shiori Act Power Up
    ja: 華恋と双葉とミチルと栞のACTパワーアップ
    ko: 카렌, 후타바, 미치루, 시오리의 ACT 파워 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3240
5000902:
  _id_: 5000902
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、雙葉、未知留、栞】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Flower Dmg Received Down
    ja: 華恋と双葉とミチルと栞の花属性被ダメージダウン
    ko: 카렌, 후타바, 미치루, 시오리가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀、雙葉、未知留、栞受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3240
5000903:
  _id_: 5000903
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、雙葉、未知留、栞】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Wind Dmg Received Down
    ja: 華恋と双葉とミチルと栞の風属性被ダメージダウン
    ko: 카렌, 후타바, 미치루, 시오리가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀、雙葉、未知留、栞受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3240
5000904:
  _id_: 5000904
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、雙葉、未知留、栞】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Snow Dmg Received Down
    ja: 華恋と双葉とミチルと栞の雪属性被ダメージダウン
    ko: 카렌, 후타바, 미치루, 시오리가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀、雙葉、未知留、栞受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3240
5000905:
  _id_: 5000905
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、雙葉、未知留、栞】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Moon Dmg Received Down
    ja: 華恋と双葉とミチルと栞の月属性被ダメージダウン
    ko: 카렌, 후타바, 미치루, 시오리가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀、雙葉、未知留、栞受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3240
5000906:
  _id_: 5000906
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、雙葉、未知留、栞】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Space Dmg Received Down
    ja: 華恋と双葉とミチルと栞の宙属性被ダメージダウン
    ko: 카렌, 후타바, 미치루, 시오리가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀、雙葉、未知留、栞受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3240
5000907:
  _id_: 5000907
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、雙葉、未知留、栞】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Cloud Dmg Received Down
    ja: 華恋と双葉とミチルと栞の雲属性被ダメージダウン
    ko: 카렌, 후타바, 미치루, 시오리가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀、雙葉、未知留、栞受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3240
5000908:
  _id_: 5000908
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、雙葉、未知留、栞】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dream Dmg Received Down
    ja: 華恋と双葉とミチルと栞の夢属性被ダメージダウン
    ko: 카렌, 후타바, 미치루, 시오리가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀、雙葉、未知留、栞受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3240
5000909:
  _id_: 5000909
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dmg to Flower Up
    ja: 華恋と双葉とミチルと栞の花属性与ダメージアップ
    ko: 카렌, 후타바, 미치루, 시오리가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3240
5000910:
  _id_: 5000910
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dmg to Wind Up
    ja: 華恋と双葉とミチルと栞の風属性与ダメージアップ
    ko: 카렌, 후타바, 미치루, 시오리가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3240
5000911:
  _id_: 5000911
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dmg to Snow Up
    ja: 華恋と双葉とミチルと栞の雪属性与ダメージアップ
    ko: 카렌, 후타바, 미치루, 시오리가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3240
5000912:
  _id_: 5000912
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dmg to Moon Up
    ja: 華恋と双葉とミチルと栞の月属性与ダメージアップ
    ko: 카렌, 후타바, 미치루, 시오리가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3240
5000913:
  _id_: 5000913
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dmg to Space Up
    ja: 華恋と双葉とミチルと栞の宙属性与ダメージアップ
    ko: 카렌, 후타바, 미치루, 시오리가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3240
5000914:
  _id_: 5000914
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dmg to Cloud Up
    ja: 華恋と双葉とミチルと栞の雲属性与ダメージアップ
    ko: 카렌, 후타바, 미치루, 시오리가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3240
5000915:
  _id_: 5000915
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dmg to Dream Up
    ja: 華恋と双葉とミチルと栞の夢属性与ダメージアップ
    ko: 카렌, 후타바, 미치루, 시오리가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3240
5000916:
  _id_: 5000916
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Futaba & Michiru & Shiori Normal Defense Up
    ja: 華恋と双葉とミチルと栞の通常防御力アップ
    ko: 카렌, 후타바, 미치루, 시오리의 일반 방어력 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3240
5000917:
  _id_: 5000917
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Futaba & Michiru & Shiori Special Defense Up
    ja: 華恋と双葉とミチルと栞の特殊防御力アップ
    ko: 카렌, 후타바, 미치루, 시오리의 특수 방어력 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3240
5000918:
  _id_: 5000918
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Normal Defense Up
    ja: 華恋と双葉とミチルと栞の通常防御力アップ
    ko: 카렌, 후타바, 미치루, 시오리의 일반 방어력 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3240
5000919:
  _id_: 5000919
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Special Defense Up
    ja: 華恋と双葉とミチルと栞の特殊防御力アップ
    ko: 카렌, 후타바, 미치루, 시오리의 특수 방어력 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3240
5000920:
  _id_: 5000920
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的會心率 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Dexterity Up
    ja: 華恋と双葉とミチルと栞のクリティカル率アップ
    ko: 카렌, 후타바, 미치루, 시오리의 크리티컬 확률 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3240
5000921:
  _id_: 5000921
  description:
    en: '(Passive) [Karen & Futaba & Michiru & Shiori] Critical Up %opt1_value%% '
    ja: '[永続]【華恋と双葉とミチルと栞】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 후타바, 미치루, 시오리]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、雙葉、未知留、栞】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Futaba & Michiru & Shiori Critical Up
    ja: 華恋と双葉とミチルと栞のクリティカル威力アップ
    ko: 카렌, 후타바, 미치루, 시오리의 크리티컬 위력 증가
    zh_hant: 提升華戀、雙葉、未知留、栞的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3240
5001001:
  _id_: 5001001
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Act Power Up %opt1_value% '
    ja: '[永続]【まひるとななといちえと文】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的ACT力量+%opt1_value%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Act Power Up
    ja: まひるとななといちえと文のACTパワーアップ
    ko: 마히루, 나나, 이치에, 후미의 ACT 파워 증가
    zh_hant: 提升真晝、奈奈、一愛和文的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3250
5001002:
  _id_: 5001002
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、奈奈、一愛和文】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Flower Dmg Received Down
    ja: まひるとななといちえと文の花属性被ダメージダウン
    ko: 마히루, 나나, 이치에, 후미가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕真晝、奈奈、一愛和文受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3250
5001003:
  _id_: 5001003
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、奈奈、一愛和文】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Wind Dmg Received Down
    ja: まひるとななといちえと文の風属性被ダメージダウン
    ko: 마히루, 나나, 이치에, 후미가 받는 바람 속성 대미지 감소
    zh_hant: 減輕真晝、奈奈、一愛和文受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3250
5001004:
  _id_: 5001004
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、奈奈、一愛和文】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Snow Dmg Received Down
    ja: まひるとななといちえと文の雪属性被ダメージダウン
    ko: 마히루, 나나, 이치에, 후미가 받는 눈 속성 대미지 감소
    zh_hant: 減輕真晝、奈奈、一愛和文受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3250
5001005:
  _id_: 5001005
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、奈奈、一愛和文】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Moon Dmg Received Down
    ja: まひるとななといちえと文の月属性被ダメージダウン
    ko: 마히루, 나나, 이치에, 후미가 받는 달 속성 대미지 감소
    zh_hant: 減輕真晝、奈奈、一愛和文受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3250
5001006:
  _id_: 5001006
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、奈奈、一愛和文】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Space Dmg Received Down
    ja: まひるとななといちえと文の宙属性被ダメージダウン
    ko: 마히루, 나나, 이치에, 후미가 받는 우주 속성 대미지 감소
    zh_hant: 減輕真晝、奈奈、一愛和文受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3250
5001007:
  _id_: 5001007
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、奈奈、一愛和文】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Cloud Dmg Received Down
    ja: まひるとななといちえと文の雲属性被ダメージダウン
    ko: 마히루, 나나, 이치에, 후미가 받는 구름 속성 대미지 감소
    zh_hant: 減輕真晝、奈奈、一愛和文受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3250
5001008:
  _id_: 5001008
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【真晝、奈奈、一愛和文】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dream Dmg Received Down
    ja: まひるとななといちえと文の夢属性被ダメージダウン
    ko: 마히루, 나나, 이치에, 후미가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕真晝、奈奈、一愛和文受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3250
5001009:
  _id_: 5001009
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dmg to Flower Up
    ja: まひるとななといちえと文の花属性与ダメージアップ
    ko: 마히루, 나나, 이치에, 후미가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升真晝、奈奈、一愛和文的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3250
5001010:
  _id_: 5001010
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dmg to Wind Up
    ja: まひるとななといちえと文の風属性与ダメージアップ
    ko: 마히루, 나나, 이치에, 후미가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升真晝、奈奈、一愛和文的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3250
5001011:
  _id_: 5001011
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dmg to Snow Up
    ja: まひるとななといちえと文の雪属性与ダメージアップ
    ko: 마히루, 나나, 이치에, 후미가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升真晝、奈奈、一愛和文的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3250
5001012:
  _id_: 5001012
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dmg to Moon Up
    ja: まひるとななといちえと文の月属性与ダメージアップ
    ko: 마히루, 나나, 이치에, 후미가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升真晝、奈奈、一愛和文的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3250
5001013:
  _id_: 5001013
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dmg to Space Up
    ja: まひるとななといちえと文の宙属性与ダメージアップ
    ko: 마히루, 나나, 이치에, 후미가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升真晝、奈奈、一愛和文的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3250
5001014:
  _id_: 5001014
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dmg to Cloud Up
    ja: まひるとななといちえと文の雲属性与ダメージアップ
    ko: 마히루, 나나, 이치에, 후미가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升真晝、奈奈、一愛和文的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3250
5001015:
  _id_: 5001015
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dmg to Dream Up
    ja: まひるとななといちえと文の夢属性与ダメージアップ
    ko: 마히루, 나나, 이치에, 후미가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升真晝、奈奈、一愛和文的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3250
5001016:
  _id_: 5001016
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Normal Defense Up %opt1_value% '
    ja: '[永続]【まひるとななといちえと文】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的普通防禦力+%opt1_value%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Normal Defense Up
    ja: まひるとななといちえと文の通常防御力アップ
    ko: 마히루, 나나, 이치에, 후미의 일반 방어력 증가
    zh_hant: 提升真晝、奈奈、一愛和文的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3250
5001017:
  _id_: 5001017
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Special Defense Up %opt1_value% '
    ja: '[永続]【まひるとななといちえと文】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的特殊防禦力+%opt1_value%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Special Defense Up
    ja: まひるとななといちえと文の特殊防御力アップ
    ko: 마히루, 나나, 이치에, 후미의 특수 방어력 증가
    zh_hant: 提升真晝、奈奈、一愛和文的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3250
5001018:
  _id_: 5001018
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Normal Defense Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的普通防禦力 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Normal Defense Up
    ja: まひるとななといちえと文の通常防御力アップ
    ko: 마히루, 나나, 이치에, 후미의 일반 방어력 증가
    zh_hant: 提升真晝、奈奈、一愛和文的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3250
5001019:
  _id_: 5001019
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Special Defense Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的特殊防禦力+%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Special Defense Up
    ja: まひるとななといちえと文の特殊防御力アップ
    ko: 마히루, 나나, 이치에, 후미의 특수 방어력 증가
    zh_hant: 提升真晝、奈奈、一愛和文的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3250
5001020:
  _id_: 5001020
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Dexterity Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的會心率 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Dexterity Up
    ja: まひるとななといちえと文のクリティカル率アップ
    ko: 마히루, 나나, 이치에, 후미의 크리티컬 확률 증가
    zh_hant: 提升真晝、奈奈、一愛和文的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3250
5001021:
  _id_: 5001021
  description:
    en: '(Passive) [Mahiru & Nana & Ichie & Fumi] Critical Up %opt1_value%% '
    ja: '[永続]【まひるとななといちえと文】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [마히루, 나나, 이치에, 후미]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【真晝、奈奈、一愛和文】的會心威力 +%opt1_value%%'
  name:
    en: Mahiru & Nana & Ichie & Fumi Critical Up
    ja: まひるとななといちえと文のクリティカル威力アップ
    ko: 마히루, 나나, 이치에, 후미의 크리티컬 위력 증가
    zh_hant: 提升真晝、奈奈、一愛和文的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3250
5001101:
  _id_: 5001101
  description:
    en: '(Passive) [Frontier] Act Power Up %opt1_value% '
    ja: '[永続]【フロンティア芸術学校】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [프론티어 예술학교]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的ACT力量+%opt1_value%'
  name:
    en: 'Frontier Act Power Up '
    ja: フロンティア芸術学校のACTパワーアップ
    ko: 프론티어 예술학교의 ACT 파워 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3260
5001102:
  _id_: 5001102
  description:
    en: '(Passive) [Frontier] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: 'Frontier Flower Dmg Received Down '
    ja: フロンティア芸術学校の花属性被ダメージダウン
    ko: 프론티어 예술학교가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕芙羅提亞藝術學校之舞台少女受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3260
5001103:
  _id_: 5001103
  description:
    en: '(Passive) [Frontier] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: 'Frontier Wind Dmg Received Down '
    ja: フロンティア芸術学校の風属性被ダメージダウン
    ko: 프론티어 예술학교가 받는 바람 속성 대미지 감소
    zh_hant: 減輕芙羅提亞藝術學校之舞台少女受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3260
5001104:
  _id_: 5001104
  description:
    en: '(Passive) [Frontier] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: 'Frontier Snow Dmg Received Down '
    ja: フロンティア芸術学校の雪属性被ダメージダウン
    ko: 프론티어 예술학교가 받는 눈 속성 대미지 감소
    zh_hant: 減輕芙羅提亞藝術學校之舞台少女受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3260
5001105:
  _id_: 5001105
  description:
    en: '(Passive) [Frontier] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: 'Frontier Moon Dmg Received Down '
    ja: フロンティア芸術学校の月属性被ダメージダウン
    ko: 프론티어 예술학교가 받는 달 속성 대미지 감소
    zh_hant: 減輕芙羅提亞藝術學校之舞台少女受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3260
5001106:
  _id_: 5001106
  description:
    en: '(Passive) [Frontier] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: 'Frontier Space Dmg Received Down '
    ja: フロンティア芸術学校の宙属性被ダメージダウン
    ko: 프론티어 예술학교가 받는 우주 속성 대미지 감소
    zh_hant: 減輕芙羅提亞藝術學校之舞台少女受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3260
5001107:
  _id_: 5001107
  description:
    en: '(Passive) [Frontier] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: 'Frontier Cloud Dmg Received Down '
    ja: フロンティア芸術学校の雲属性被ダメージダウン
    ko: 프론티어 예술학교가 받는 구름 속성 대미지 감소
    zh_hant: 減輕芙羅提亞藝術學校之舞台少女受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3260
5001108:
  _id_: 5001108
  description:
    en: '(Passive) [Frontier] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dream Dmg Received Down '
    ja: フロンティア芸術学校の夢属性被ダメージダウン
    ko: 프론티어 예술학교가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕芙羅提亞藝術學校之舞台少女受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3260
5001109:
  _id_: 5001109
  description:
    en: '(Passive) [Frontier] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dmg to Flower Up '
    ja: フロンティア芸術学校の花属性与ダメージアップ
    ko: 프론티어 예술학교가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3260
5001110:
  _id_: 5001110
  description:
    en: '(Passive) [Frontier] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dmg to Wind Up '
    ja: フロンティア芸術学校の風属性与ダメージアップ
    ko: 프론티어 예술학교가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3260
5001111:
  _id_: 5001111
  description:
    en: '(Passive) [Frontier] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dmg to Snow Up '
    ja: フロンティア芸術学校の雪属性与ダメージアップ
    ko: 프론티어 예술학교가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3260
5001112:
  _id_: 5001112
  description:
    en: '(Passive) [Frontier] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dmg to Moon Up '
    ja: フロンティア芸術学校の月属性与ダメージアップ
    ko: 프론티어 예술학교가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3260
5001113:
  _id_: 5001113
  description:
    en: '(Passive) [Frontier] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dmg to Space Up '
    ja: フロンティア芸術学校の宙属性与ダメージアップ
    ko: 프론티어 예술학교가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3260
5001114:
  _id_: 5001114
  description:
    en: '(Passive) [Frontier] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dmg to Cloud Up '
    ja: フロンティア芸術学校の雲属性与ダメージアップ
    ko: 프론티어 예술학교가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3260
5001115:
  _id_: 5001115
  description:
    en: '(Passive) [Frontier] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: 'Frontier Dmg to Dream Up '
    ja: フロンティア芸術学校の夢属性与ダメージアップ
    ko: 프론티어 예술학교가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3260
5001116:
  _id_: 5001116
  description:
    en: '(Passive) [Frontier] Normal Defense Up %opt1_value% '
    ja: '[永続]【フロンティア芸術学校】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [프론티어 예술학교]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的普通防禦力 +%opt1_value%'
  name:
    en: 'Frontier Normal Defense Up '
    ja: フロンティア芸術学校の通常防御力アップ
    ko: 프론티어 예술학교의 일반 방어력 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3260
5001117:
  _id_: 5001117
  description:
    en: '(Passive) [Frontier] Special Defense Up %opt1_value% '
    ja: '[永続]【フロンティア芸術学校】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [프론티어 예술학교]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的特殊防禦力 +%opt1_value%'
  name:
    en: 'Frontier Special Defense Up '
    ja: フロンティア芸術学校の特殊防御力アップ
    ko: 프론티어 예술학교의 특수 방어력 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3260
5001118:
  _id_: 5001118
  description:
    en: '(Passive) [Frontier] Normal Defense Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的普通防禦力 +%opt1_value%%'
  name:
    en: 'Frontier Normal Defense Up '
    ja: フロンティア芸術学校の通常防御力アップ
    ko: 프론티어 예술학교의 일반 방어력 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3260
5001119:
  _id_: 5001119
  description:
    en: '(Passive) [Frontier] Special Defense Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的特殊防禦力 +%opt1_value%%'
  name:
    en: 'Frontier Special Defense Up '
    ja: フロンティア芸術学校の特殊防御力アップ
    ko: 프론티어 예술학교의 특수 방어력 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3260
5001120:
  _id_: 5001120
  description:
    en: '(Passive) [Frontier] Dexterity Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的會心率 +%opt1_value%%'
  name:
    en: 'Frontier Dexterity Up '
    ja: フロンティア芸術学校のクリティカル率アップ
    ko: 프론티어 예술학교의 크리티컬 확률 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3260
5001121:
  _id_: 5001121
  description:
    en: '(Passive) [Frontier] Critical Up %opt1_value%% '
    ja: '[永続]【フロンティア芸術学校】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [프론티어 예술학교]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【芙羅提亞藝術學校之舞台少女】的會心威力 +%opt1_value%%'
  name:
    en: 'Frontier Critical Up '
    ja: フロンティア芸術学校のクリティカル威力アップ
    ko: 프론티어 예술학교의 크리티컬 위력 증가
    zh_hant: 提升芙羅提亞藝術學校之舞台少女的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3260
5001201:
  _id_: 5001201
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Act Power Up %opt1_value% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的ACT力量 %opt1_value%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Act Power Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンのACTパワーアップ
    ko: '히카리, 클로딘, 타마오, 아키라, 메이팡의 ACT 파워 증가 '
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3261
5001202:
  _id_: 5001202
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Flower Dmg Received
      Down %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的花屬性傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Flower Dmg Received Down
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの花属性被ダメージダウン
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕光、克洛迪娜、珠緒、晶和美帆受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3261
5001203:
  _id_: 5001203
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Wind Dmg Received
      Down %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的風屬性傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Wind Dmg Received Down
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの風属性被ダメージダウン
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 바람 속성 대미지 감소
    zh_hant: 減輕光、克洛迪娜、珠緒、晶和美帆受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3261
5001204:
  _id_: 5001204
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Snow Dmg Received
      Down %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的雪屬性傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Snow Dmg Received Down
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの雪属性被ダメージダウン
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 눈 속성 대미지 감소
    zh_hant: 減輕光、克洛迪娜、珠緒、晶和美帆受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3261
5001205:
  _id_: 5001205
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Moon Dmg Received
      Down %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的月屬性傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Moon Dmg Received Down
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの月属性被ダメージダウン
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 달 속성 대미지 감소
    zh_hant: 減輕光、克洛迪娜、珠緒、晶和美帆受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3261
5001206:
  _id_: 5001206
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Space Dmg Received
      Down %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的宙屬性傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Space Dmg Received Down
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの宙属性被ダメージダウン
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 우주 속성 대미지 감소
    zh_hant: 減輕光、克洛迪娜、珠緒、晶和美帆受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3261
5001207:
  _id_: 5001207
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Cloud Dmg Received
      Down %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的雲屬性傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Cloud Dmg Received Down
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの雲属性被ダメージダウン
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 구름 속성 대미지 감소
    zh_hant: 減輕光、克洛迪娜、珠緒、晶和美帆受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3261
5001208:
  _id_: 5001208
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dream Dmg Received
      Down %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的夢屬性傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dream Dmg Received Down
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの夢属性被ダメージダウン
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕光、克洛迪娜、珠緒、晶和美帆受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3261
5001209:
  _id_: 5001209
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Flower Up
      %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對花屬性造成的傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Flower Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの花属性与ダメージアップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3261
5001210:
  _id_: 5001210
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對風屬性造成的傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Wind Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの風属性与ダメージアップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3261
5001211:
  _id_: 5001211
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對雪屬性造成的傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Snow Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの雪属性与ダメージアップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3261
5001212:
  _id_: 5001212
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對月屬性造成的傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Moon Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの月属性与ダメージアップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3261
5001213:
  _id_: 5001213
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對宙屬性造成的傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Space Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの宙属性与ダメージアップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3261
5001214:
  _id_: 5001214
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對雲屬性造成的傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Cloud Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの雲属性与ダメージアップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3261
5001215:
  _id_: 5001215
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對夢屬性造成的傷害 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Dream Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの夢属性与ダメージアップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3261
5001216:
  _id_: 5001216
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Normal Defense Up
      %opt1_value% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的普通防禦力 %opt1_value%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Normal Defense Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの通常防御力アップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡의 일반 방어력 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3261
5001217:
  _id_: 5001217
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Special Defense Up
      %opt1_value% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的特殊防禦力 %opt1_value%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Special Defense Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの特殊防御力アップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡의 특수 방어력 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3261
5001218:
  _id_: 5001218
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Normal Defense Up
      %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的普通防禦力 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Normal Defense Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの通常防御力アップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡의 일반 방어력 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3261
5001219:
  _id_: 5001219
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Special Defense Up
      %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的特殊防禦力 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Special Defense Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンの特殊防御力アップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡의 특수 방어력 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3261
5001220:
  _id_: 5001220
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dexterity Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的會心率 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Dexterity Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンのクリティカル率アップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡의 크리티컬 확률 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3261
5001221:
  _id_: 5001221
  description:
    en: '(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Critical Up %opt1_value%% '
    ja: '[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的會心威力 %opt1_value%%'
  name:
    en: Hikari & Claudine & Tamao & Akira & Mei Fan Critical Up
    ja: ひかりとクロディーヌと珠緒と晶とメイファンのクリティカル威力アップ
    ko: 히카리, 클로딘, 타마오, 아키라, 메이팡의 크리티컬 위력 증가
    zh_hant: 提升光、克洛迪娜、珠緒、晶和美帆的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3261
5001301:
  _id_: 5001301
  description:
    en: '(Passive) [Siegfeld] Act Power Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的ACT力量 +%opt1_value%'
  name:
    en: Siegfeld Act Power Up
    ja: シークフェルト音楽学院のACTパワーアップ
    ko: 시크펠트 음악학원의 ACT 파워 증가
    zh_hant: 提升席格菲特音樂學院的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3263
5001302:
  _id_: 5001302
  description:
    en: '(Passive) [Siegfeld] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的花屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Flower Dmg Received Down
    ja: シークフェルト音楽学院の花属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 꽃 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3263
5001303:
  _id_: 5001303
  description:
    en: '(Passive) [Siegfeld] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的風屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Wind Dmg Received Down
    ja: シークフェルト音楽学院の風属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 바람 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3263
5001304:
  _id_: 5001304
  description:
    en: '(Passive) [Siegfeld] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的雪屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Snow Dmg Received Down
    ja: シークフェルト音楽学院の雪属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 눈 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3263
5001305:
  _id_: 5001305
  description:
    en: '(Passive) [Siegfeld] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的月屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Moon Dmg Received Down
    ja: シークフェルト音楽学院の月属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 달 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3263
5001306:
  _id_: 5001306
  description:
    en: '(Passive) [Siegfeld] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的宙屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Space Dmg Received Down
    ja: シークフェルト音楽学院の宙属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 우주 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3263
5001307:
  _id_: 5001307
  description:
    en: '(Passive) [Siegfeld] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的雲屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Cloud Dmg Received Down
    ja: シークフェルト音楽学院の雲属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 구름 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3263
5001308:
  _id_: 5001308
  description:
    en: '(Passive) [Siegfeld] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【席格菲特音樂學院】受到的夢屬性傷害 %opt1_value%%'
  name:
    en: Siegfeld Dream Dmg Received Down
    ja: シークフェルト音楽学院の夢属性被ダメージダウン
    ko: 시크펠트 음악학원이 받는 꿈 속성 대미지 감소
    zh_hant: 減輕席格菲特音樂學院受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3263
5001309:
  _id_: 5001309
  description:
    en: '(Passive) [Siegfeld] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Flower Up
    ja: シークフェルト音楽学院の花属性与ダメージアップ
    ko: 시크펠트 음악학원이 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3263
5001310:
  _id_: 5001310
  description:
    en: '(Passive) [Siegfeld] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Wind Up
    ja: シークフェルト音楽学院の風属性与ダメージアップ
    ko: 시크펠트 음악학원이 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3263
5001311:
  _id_: 5001311
  description:
    en: '(Passive) [Siegfeld] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Snow Up
    ja: シークフェルト音楽学院の雪属性与ダメージアップ
    ko: 시크펠트 음악학원이 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3263
5001312:
  _id_: 5001312
  description:
    en: '(Passive) [Siegfeld] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Moon Up
    ja: シークフェルト音楽学院の月属性与ダメージアップ
    ko: 시크펠트 음악학원이 달 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3263
5001313:
  _id_: 5001313
  description:
    en: '(Passive) [Siegfeld] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Space Up
    ja: シークフェルト音楽学院の宙属性与ダメージアップ
    ko: 시크펠트 음악학원이 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3263
5001314:
  _id_: 5001314
  description:
    en: '(Passive) [Siegfeld] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Cloud Up
    ja: シークフェルト音楽学院の雲属性与ダメージアップ
    ko: 시크펠트 음악학원이 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3263
5001315:
  _id_: 5001315
  description:
    en: '(Passive) [Siegfeld] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Siegfeld Dmg to Dream Up
    ja: シークフェルト音楽学院の夢属性与ダメージアップ
    ko: 시크펠트 음악학원이 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升席格菲特音樂學院的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3263
5001316:
  _id_: 5001316
  description:
    en: '(Passive) [Siegfeld] Normal Defense Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%'
  name:
    en: Siegfeld Normal Defense Up
    ja: シークフェルト音楽学院の通常防御力アップ
    ko: 시크펠트 음악학원의 일반 방어력 증가
    zh_hant: 提升席格菲特音樂學院的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3263
5001317:
  _id_: 5001317
  description:
    en: '(Passive) [Siegfeld] Special Defense Up %opt1_value% '
    ja: '[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%'
  name:
    en: Siegfeld Special Defense Up
    ja: シークフェルト音楽学院の特殊防御力アップ
    ko: 시크펠트 음악학원의 특수 방어력 증가
    zh_hant: 提升席格菲特音樂學院的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3263
5001318:
  _id_: 5001318
  description:
    en: '(Passive) [Siegfeld] Normal Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%'
  name:
    en: Siegfeld Normal Defense Up
    ja: シークフェルト音楽学院の通常防御力アップ
    ko: 시크펠트 음악학원의 일반 방어력 증가
    zh_hant: 提升席格菲特音樂學院的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3263
5001319:
  _id_: 5001319
  description:
    en: '(Passive) [Siegfeld] Special Defense Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%'
  name:
    en: Siegfeld Special Defense Up
    ja: シークフェルト音楽学院の特殊防御力アップ
    ko: 시크펠트 음악학원의 특수 방어력 증가
    zh_hant: 提升席格菲特音樂學院的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3263
5001320:
  _id_: 5001320
  description:
    en: '(Passive) [Siegfeld] Dexterity Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的會心率 +%opt1_value%%'
  name:
    en: Siegfeld Dexterity Up
    ja: シークフェルト音楽学院のクリティカル率アップ
    ko: 시크펠트 음악학원의 크리티컬 확률 증가
    zh_hant: 提升席格菲特音樂學院的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3263
5001321:
  _id_: 5001321
  description:
    en: '(Passive) [Siegfeld] Critical Up %opt1_value%% '
    ja: '[永続]【シークフェルト音楽学院】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [시크펠트 음악학원]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【席格菲特音樂學院】的會心威力 +%opt1_value%%'
  name:
    en: Siegfeld Critical Up
    ja: シークフェルト音楽学院のクリティカル威力アップ
    ko: 시크펠트 음악학원의 크리티컬 위력 증가
    zh_hant: 提升席格菲特音樂學院的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3263
5001401:
  _id_: 5001401
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Act Power Up %opt1_value% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Act Power Up
    ja: 華恋と真矢とあるるとやちよのACTパワーアップ
    ko: 카렌, 마야, 아루루, 야치요의 ACT 파워 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 4164
5001402:
  _id_: 5001402
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、真矢、艾露露、八千代】受到的花屬性傷害 %opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Flower Dmg Received Down
    ja: 華恋と真矢とあるるとやちよの花属性被ダメージダウン
    ko: 카렌, 마야, 아루루, 야치요가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀、真矢、艾露露、八千代受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 4164
5001403:
  _id_: 5001403
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、真矢、艾露露、八千代】受到的風屬性傷害 %opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Wind Dmg Received Down
    ja: 華恋と真矢とあるるとやちよの風属性被ダメージダウン
    ko: 카렌, 마야, 아루루, 야치요가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀、真矢、艾露露、八千代受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 4164
5001404:
  _id_: 5001404
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、真矢、艾露露、八千代】受到的雪屬性傷害 %opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Snow Dmg Received Down
    ja: 華恋と真矢とあるるとやちよの雪属性被ダメージダウン
    ko: 카렌, 마야, 아루루, 야치요가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀、真矢、艾露露、八千代受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 4164
5001405:
  _id_: 5001405
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、真矢、艾露露、八千代】受到的月屬性傷害 %opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Moon Dmg Received Down
    ja: 華恋と真矢とあるるとやちよの月属性被ダメージダウン
    ko: 카렌, 마야, 아루루, 야치요가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀、真矢、艾露露、八千代受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 4164
5001406:
  _id_: 5001406
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、真矢、艾露露、八千代】受到的宙屬性傷害 %opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Space Dmg Received Down
    ja: 華恋と真矢とあるるとやちよの宙属性被ダメージダウン
    ko: 카렌, 마야, 아루루, 야치요가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀、真矢、艾露露、八千代受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 4164
5001407:
  _id_: 5001407
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、真矢、艾露露、八千代】受到的雲屬性傷害 %opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Cloud Dmg Received Down
    ja: 華恋と真矢とあるるとやちよの雲属性被ダメージダウン
    ko: 카렌, 마야, 아루루, 야치요가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀、真矢、艾露露、八千代受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 4164
5001408:
  _id_: 5001408
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、真矢、艾露露、八千代】受到的夢屬性傷害 %opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dream Dmg Received Down
    ja: 華恋と真矢とあるるとやちよの夢属性被ダメージダウン
    ko: 카렌, 마야, 아루루, 야치요가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀、真矢、艾露露、八千代受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 4164
5001409:
  _id_: 5001409
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dmg to Flower Up
    ja: 華恋と真矢とあるるとやちよの花属性与ダメージアップ
    ko: 카렌, 마야, 아루루, 야치요가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 4164
5001410:
  _id_: 5001410
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dmg to Wind Up
    ja: 華恋と真矢とあるるとやちよの風属性与ダメージアップ
    ko: 카렌, 마야, 아루루, 야치요가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 4164
5001411:
  _id_: 5001411
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dmg to Snow Up
    ja: 華恋と真矢とあるるとやちよの雪属性与ダメージアップ
    ko: 카렌, 마야, 아루루, 야치요가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 4164
5001412:
  _id_: 5001412
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dmg to Moon Up
    ja: 華恋と真矢とあるるとやちよの月属性与ダメージアップ
    ko: 카렌, 마야, 아루루, 야치요가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 4164
5001413:
  _id_: 5001413
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dmg to Space Up
    ja: 華恋と真矢とあるるとやちよの宙属性与ダメージアップ
    ko: 카렌, 마야, 아루루, 야치요가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 4164
5001414:
  _id_: 5001414
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dmg to Cloud Up
    ja: 華恋と真矢とあるるとやちよの雲属性与ダメージアップ
    ko: 카렌, 마야, 아루루, 야치요가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 4164
5001415:
  _id_: 5001415
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dmg to Dream Up
    ja: 華恋と真矢とあるるとやちよの夢属性与ダメージアップ
    ko: 카렌, 마야, 아루루, 야치요가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 4164
5001416:
  _id_: 5001416
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Normal Defense Up
    ja: 華恋と真矢とあるるとやちよの通常防御力アップ
    ko: 카렌, 마야, 아루루, 야치요의 일반 방어력 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 4164
5001417:
  _id_: 5001417
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Special Defense Up
    ja: 華恋と真矢とあるるとやちよの特殊防御力アップ
    ko: 카렌, 마야, 아루루, 야치요의 특수 방어력 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 4164
5001418:
  _id_: 5001418
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的普通防禦力 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Normal Defense Up
    ja: 華恋と真矢とあるるとやちよの通常防御力アップ
    ko: 카렌, 마야, 아루루, 야치요의 일반 방어력 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 4164
5001419:
  _id_: 5001419
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的特殊防禦力 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Special Defense Up
    ja: 華恋と真矢とあるるとやちよの特殊防御力アップ
    ko: 카렌, 마야, 아루루, 야치요의 특수 방어력 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 4164
5001420:
  _id_: 5001420
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的會心率 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Dexterity Up
    ja: 華恋と真矢とあるるとやちよのクリティカル率アップ
    ko: 카렌, 마야, 아루루, 야치요의 크리티컬 확률 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的會心率
  skill_option1_id: 20
  skill_option1_target_id: 4164
5001421:
  _id_: 5001421
  description:
    en: '(Passive) [Karen & Maya & Aruru & Yachiyo] Critical Up %opt1_value%% '
    ja: '[永続]【華恋と真矢とあるるとやちよ】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 마야, 아루루, 야치요]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、真矢、艾露露、八千代】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Maya & Aruru & Yachiyo Critical Up
    ja: 華恋と真矢とあるるとやちよのクリティカル威力アップ
    ko: 카렌, 마야, 아루루, 야치요의 크리티컬 위력 증가
    zh_hant: 提升華戀、真矢、艾露露、八千代的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 4164
9000701:
  _id_: 9000701
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Act Power Up %opt1_value% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的ACT力量 +%opt1_value%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Act Power Up
    ja: 華恋とひかりと珠緒とあるると晶のACTパワーアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라의 ACT 파워 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3200
9000702:
  _id_: 9000702
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Flower Dmg Received Down
      %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Flower Dmg Received Down
    ja: 華恋とひかりと珠緒とあるると晶の花属性被ダメージダウン
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕華戀、光、珠緒、艾露露、晶受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3200
9000703:
  _id_: 9000703
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Wind Dmg Received Down
      %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Wind Dmg Received Down
    ja: 華恋とひかりと珠緒とあるると晶の風属性被ダメージダウン
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 받는 바람 속성 대미지 감소
    zh_hant: 減輕華戀、光、珠緒、艾露露、晶受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3200
9000704:
  _id_: 9000704
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Snow Dmg Received Down
      %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Snow Dmg Received Down
    ja: 華恋とひかりと珠緒とあるると晶の雪属性被ダメージダウン
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 받는 눈 속성 대미지 감소
    zh_hant: 減輕華戀、光、珠緒、艾露露、晶受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3200
9000705:
  _id_: 9000705
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Moon Dmg Received Down
      %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Moon Dmg Received Down
    ja: 華恋とひかりと珠緒とあるると晶の月属性被ダメージダウン
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 받는 달 속성 대미지 감소
    zh_hant: 減輕華戀、光、珠緒、艾露露、晶受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3200
9000706:
  _id_: 9000706
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Space Dmg Received Down
      %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Space Dmg Received Down
    ja: 華恋とひかりと珠緒とあるると晶の宙属性被ダメージダウン
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 받는 우주 속성 대미지 감소
    zh_hant: 減輕華戀、光、珠緒、艾露露、晶受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3200
9000707:
  _id_: 9000707
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Cloud Dmg Received Down
      %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Cloud Dmg Received Down
    ja: 華恋とひかりと珠緒とあるると晶の雲属性被ダメージダウン
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 받는 구름 속성 대미지 감소
    zh_hant: 減輕華戀、光、珠緒、艾露露、晶受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3200
9000708:
  _id_: 9000708
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dream Dmg Received Down
      %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dream Dmg Received Down
    ja: 華恋とひかりと珠緒とあるると晶の夢属性被ダメージダウン
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕華戀、光、珠緒、艾露露、晶受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3200
9000709:
  _id_: 9000709
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dmg to Flower Up
    ja: 華恋とひかりと珠緒とあるると晶の花属性与ダメージアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3200
9000710:
  _id_: 9000710
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dmg to Wind Up
    ja: 華恋とひかりと珠緒とあるると晶の風属性与ダメージアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3200
9000711:
  _id_: 9000711
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dmg to Snow Up
    ja: 華恋とひかりと珠緒とあるると晶の雪属性与ダメージアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3200
9000712:
  _id_: 9000712
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dmg to Moon Up
    ja: 華恋とひかりと珠緒とあるると晶の月属性与ダメージアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3200
9000713:
  _id_: 9000713
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dmg to Space Up
    ja: 華恋とひかりと珠緒とあるると晶の宙属性与ダメージアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3200
9000714:
  _id_: 9000714
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dmg to Cloud Up
    ja: 華恋とひかりと珠緒とあるると晶の雲属性与ダメージアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3200
9000715:
  _id_: 9000715
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dmg to Dream Up
    ja: 華恋とひかりと珠緒とあるると晶の夢属性与ダメージアップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3200
9000716:
  _id_: 9000716
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Normal Defense Up %opt1_value% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的普通防禦力 +%opt1_value%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Normal Defense Up
    ja: 華恋とひかりと珠緒とあるると晶の通常防御力アップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라의 일반 방어력 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3200
9000717:
  _id_: 9000717
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Special Defense Up %opt1_value% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的特殊防禦力 +%opt1_value%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Special Defense Up
    ja: 華恋とひかりと珠緒とあるると晶の特殊防御力アップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라의 특수 방어력 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3200
9000718:
  _id_: 9000718
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Normal Defense Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的普通防禦力 +%opt1_value%％'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Normal Defense Up
    ja: 華恋とひかりと珠緒とあるると晶の通常防御力アップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라의 일반 방어력 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3200
9000719:
  _id_: 9000719
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Special Defense Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的特殊防禦力 +%opt1_value%％'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Special Defense Up
    ja: 華恋とひかりと珠緒とあるると晶の特殊防御力アップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라의 특수 방어력 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3200
9000720:
  _id_: 9000720
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dexterity Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的會心率 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Dexterity Up
    ja: 華恋とひかりと珠緒とあるると晶のクリティカル率アップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라의 크리티컬 확률 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3200
9000721:
  _id_: 9000721
  description:
    en: '(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Critical Up %opt1_value%% '
    ja: '[永続]【華恋とひかりと珠緒とあるると晶】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【華戀、光、珠緒、艾露露、晶】的會心威力 +%opt1_value%%'
  name:
    en: Karen & Hikari & Tamao & Aruru & Akira Critical Up
    ja: 華恋とひかりと珠緒とあるると晶のクリティカル威力アップ
    ko: 카렌, 히카리, 타마오, 아루루, 아키라의 크리티컬 위력 증가
    zh_hant: 提升華戀、光、珠緒、艾露露、晶的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3200
9000901:
  _id_: 9000901
  description:
    en: '(Passive) [Claudine & Maya] Act Power Up %opt1_value% '
    ja: '[永続]【クロディーヌと真矢】を対象にACTパワーアップ +%opt1_value%'
    ko: '[영구] [클로딘과 마야]의 ACT 파워 %opt1_value% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的ACT力量 +%opt1_value%'
  name:
    en: Claudine & Maya Act Power Up
    ja: クロディーヌと真矢のACTパワーアップ
    ko: 클로딘과 마야의 ACT 파워 증가
    zh_hant: 提升克洛迪娜和真矢的ACT力量
  skill_option1_id: 42
  skill_option1_target_id: 3230
9000902:
  _id_: 9000902
  description:
    en: '(Passive) [Claudine & Maya] Flower Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に花属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜和真矢】受到的花屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Flower Dmg Received Down
    ja: クロディーヌと真矢の花属性被ダメージダウン
    ko: 클로딘과 마야가 받는 꽃 속성 대미지 감소
    zh_hant: 減輕克洛迪娜和真矢受到的花屬性傷害
  skill_option1_id: 66
  skill_option1_target_id: 3230
9000903:
  _id_: 9000903
  description:
    en: '(Passive) [Claudine & Maya] Wind Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に風属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 바람 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜和真矢】受到的風屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Wind Dmg Received Down
    ja: クロディーヌと真矢の風属性被ダメージダウン
    ko: 클로딘과 마야가 받는 바람 속성 대미지 감소
    zh_hant: 減輕克洛迪娜和真矢受到的風屬性傷害
  skill_option1_id: 67
  skill_option1_target_id: 3230
9000904:
  _id_: 9000904
  description:
    en: '(Passive) [Claudine & Maya] Snow Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に雪属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 눈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜和真矢】受到的雪屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Snow Dmg Received Down
    ja: クロディーヌと真矢の雪属性被ダメージダウン
    ko: 클로딘과 마야가 받는 눈 속성 대미지 감소
    zh_hant: 減輕克洛迪娜和真矢受到的雪屬性傷害
  skill_option1_id: 68
  skill_option1_target_id: 3230
9000905:
  _id_: 9000905
  description:
    en: '(Passive) [Claudine & Maya] Moon Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に月属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 달 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜和真矢】受到的月屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Moon Dmg Received Down
    ja: クロディーヌと真矢の月属性被ダメージダウン
    ko: 클로딘과 마야가 받는 달 속성 대미지 감소
    zh_hant: 減輕克洛迪娜和真矢受到的月屬性傷害
  skill_option1_id: 69
  skill_option1_target_id: 3230
9000906:
  _id_: 9000906
  description:
    en: '(Passive) [Claudine & Maya] Space Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に宙属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 우주 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜和真矢】受到的宙屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Space Dmg Received Down
    ja: クロディーヌと真矢の宙属性被ダメージダウン
    ko: 클로딘과 마야가 받는 우주 속성 대미지 감소
    zh_hant: 減輕克洛迪娜和真矢受到的宙屬性傷害
  skill_option1_id: 70
  skill_option1_target_id: 3230
9000907:
  _id_: 9000907
  description:
    en: '(Passive) [Claudine & Maya] Cloud Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に雲属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 구름 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜和真矢】受到的雲屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Cloud Dmg Received Down
    ja: クロディーヌと真矢の雲属性被ダメージダウン
    ko: 클로딘과 마야가 받는 구름 속성 대미지 감소
    zh_hant: 減輕克洛迪娜和真矢受到的雲屬性傷害
  skill_option1_id: 71
  skill_option1_target_id: 3230
9000908:
  _id_: 9000908
  description:
    en: '(Passive) [Claudine & Maya] Dream Dmg Received Down %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に夢属性からの被ダメージダウン +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소'
    zh_hant: '[永續]減輕【克洛迪娜和真矢】受到的夢屬性傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dream Dmg Received Down
    ja: クロディーヌと真矢の夢属性被ダメージダウン
    ko: 클로딘과 마야가 받는 꿈 속성 대미지 감소
    zh_hant: 減輕克洛迪娜和真矢受到的夢屬性傷害
  skill_option1_id: 72
  skill_option1_target_id: 3230
9000909:
  _id_: 9000909
  description:
    en: '(Passive) [Claudine & Maya] Dmg to Flower Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に花属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的對花屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dmg to Flower Up
    ja: クロディーヌと真矢の花属性与ダメージアップ
    ko: 클로딘과 마야가 꽃 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜和真矢的花屬性造成的傷害
  skill_option1_id: 46
  skill_option1_target_id: 3230
9000910:
  _id_: 9000910
  description:
    en: '(Passive) [Claudine & Maya] Dmg to Wind Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に風属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的對風屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dmg to Wind Up
    ja: クロディーヌと真矢の風属性与ダメージアップ
    ko: 클로딘과 마야가 바람 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜和真矢的風屬性造成的傷害
  skill_option1_id: 47
  skill_option1_target_id: 3230
9000911:
  _id_: 9000911
  description:
    en: '(Passive) [Claudine & Maya] Dmg to Snow Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に雪属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的對雪屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dmg to Snow Up
    ja: クロディーヌと真矢の雪属性与ダメージアップ
    ko: 클로딘과 마야가 눈 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜和真矢的雪屬性造成的傷害
  skill_option1_id: 48
  skill_option1_target_id: 3230
9000912:
  _id_: 9000912
  description:
    en: '(Passive) [Claudine & Maya] Dmg to Moon Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に月属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 달 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的對月屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dmg to Moon Up
    ja: クロディーヌと真矢の月属性与ダメージアップ
    ko: 클로딘과 마야가 달 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜和真矢的月屬性造成的傷害
  skill_option1_id: 49
  skill_option1_target_id: 3230
9000913:
  _id_: 9000913
  description:
    en: '(Passive) [Claudine & Maya] Dmg to Space Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に宙属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的對宙屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dmg to Space Up
    ja: クロディーヌと真矢の宙属性与ダメージアップ
    ko: 클로딘과 마야가 우주 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜和真矢的宙屬性造成的傷害
  skill_option1_id: 50
  skill_option1_target_id: 3230
9000914:
  _id_: 9000914
  description:
    en: '(Passive) [Claudine & Maya] Dmg to Cloud Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に雲属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的對雲屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dmg to Cloud Up
    ja: クロディーヌと真矢の雲属性与ダメージアップ
    ko: 클로딘과 마야가 구름 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜和真矢的雲屬性造成的傷害
  skill_option1_id: 51
  skill_option1_target_id: 3230
9000915:
  _id_: 9000915
  description:
    en: '(Passive) [Claudine & Maya] Dmg to Dream Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に夢属性に対する与ダメージアップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的對夢屬性造成的傷害 +%opt1_value%%'
  name:
    en: Claudine & Maya Dmg to Dream Up
    ja: クロディーヌと真矢の夢属性与ダメージアップ
    ko: 클로딘과 마야가 꿈 속성에게 가하는 대미지 증가
    zh_hant: 提升克洛迪娜和真矢的夢屬性造成的傷害
  skill_option1_id: 52
  skill_option1_target_id: 3230
9000916:
  _id_: 9000916
  description:
    en: '(Passive) [Claudine & Maya] Normal Defense Up %opt1_value% '
    ja: '[永続]【クロディーヌと真矢】を対象に通常防御力アップ +%opt1_value%'
    ko: '[영구] [클로딘과 마야]의 일반 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的普通防禦力 +%opt1_value%'
  name:
    en: Claudine & Maya Normal Defense Up
    ja: クロディーヌと真矢の通常防御力アップ
    ko: 클로딘과 마야의 일반 방어력 증가
    zh_hant: 提升克洛迪娜和真矢的普通防禦力
  skill_option1_id: 37
  skill_option1_target_id: 3230
9000917:
  _id_: 9000917
  description:
    en: '(Passive) [Claudine & Maya] Special Defense Up %opt1_value% '
    ja: '[永続]【クロディーヌと真矢】を対象に特殊防御力アップ +%opt1_value%'
    ko: '[영구] [클로딘과 마야]의 특수 방어력 %opt1_value% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的特殊防禦力 +%opt1_value%'
  name:
    en: Claudine & Maya Special Defense Up
    ja: クロディーヌと真矢の特殊防御力アップ
    ko: 클로딘과 마야의 특수 방어력 증가
    zh_hant: 提升克洛迪娜和真矢的特殊防禦力
  skill_option1_id: 38
  skill_option1_target_id: 3230
9000918:
  _id_: 9000918
  description:
    en: '(Passive) [Claudine & Maya] Normal Defense Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に通常防御力アップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]의 일반 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的普通防禦力 +%opt1_value%%'
  name:
    en: Claudine & Maya Normal Defense Up
    ja: クロディーヌと真矢の通常防御力アップ
    ko: 클로딘과 마야의 일반 방어력 증가
    zh_hant: 提升克洛迪娜和真矢的普通防禦力
  skill_option1_id: 10
  skill_option1_target_id: 3230
9000919:
  _id_: 9000919
  description:
    en: '(Passive) [Claudine & Maya] Special Defense Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象に特殊防御力アップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]의 특수 방어력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的特殊防禦力 +%opt1_value%%'
  name:
    en: Claudine & Maya Special Defense Up
    ja: クロディーヌと真矢の特殊防御力アップ
    ko: 클로딘과 마야의 특수 방어력 증가
    zh_hant: 提升克洛迪娜和真矢的特殊防禦力
  skill_option1_id: 12
  skill_option1_target_id: 3230
9000920:
  _id_: 9000920
  description:
    en: '(Passive) [Claudine & Maya] Dexterity Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象にクリティカル率アップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]의 크리티컬 확률 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的會心率 +%opt1_value%%'
  name:
    en: Claudine & Maya Dexterity Up
    ja: クロディーヌと真矢のクリティカル率アップ
    ko: 클로딘과 마야의 크리티컬 확률 증가
    zh_hant: 提升克洛迪娜和真矢的會心率
  skill_option1_id: 20
  skill_option1_target_id: 3230
9000921:
  _id_: 9000921
  description:
    en: '(Passive) [Claudine & Maya] Critical Up %opt1_value%% '
    ja: '[永続]【クロディーヌと真矢】を対象にクリティカル威力アップ +%opt1_value%%'
    ko: '[영구] [클로딘과 마야]의 크리티컬 위력 %opt1_value%% 증가'
    zh_hant: '[永續]提升【克洛迪娜和真矢】的會心威力 +%opt1_value%%'
  name:
    en: Claudine & Maya Critical Up
    ja: クロディーヌと真矢のクリティカル威力アップ
    ko: 클로딘과 마야의 크리티컬 위력 증가
    zh_hant: 提升克洛迪娜和真矢的會心威力
  skill_option1_id: 22
  skill_option1_target_id: 3230

*/

inline val dataGenMusicExtraSkill get() = """{"1000101":{"description":{"en":"(Passive) [Seisho Center Position] Act Power Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [세이쇼 중간 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的ACT力量 +%opt1_value%"},"name":{"en":"Seisho Center Position Act Power Up","ja":"聖翔立ち位置中のACTパワーアップ","ko":"세이쇼 중간 포지션의 ACT 파워 증가","zh_hant":"提升聖翔站位為中的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3002,"_id_":1000101},"1000102":{"description":{"en":"(Passive) [Seisho Center Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為中】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Flower Dmg Received Down","ja":"聖翔立ち位置中の花属性被ダメージダウン","ko":"세이쇼 중간 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕聖翔站位為中受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3002,"_id_":1000102},"1000103":{"description":{"en":"(Passive) [Seisho Center Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為中】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Wind Dmg Received Down","ja":"聖翔立ち位置中の風属性被ダメージダウン","ko":"세이쇼 중간 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕聖翔站位為中受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3002,"_id_":1000103},"1000104":{"description":{"en":"(Passive) [Seisho Center Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為中】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Snow Dmg Received Down","ja":"聖翔立ち位置中の雪属性被ダメージダウン","ko":"세이쇼 중간 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕聖翔站位為中受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3002,"_id_":1000104},"1000105":{"description":{"en":"(Passive) [Seisho Center Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為中】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Moon Dmg Received Down","ja":"聖翔立ち位置中の月属性被ダメージダウン","ko":"세이쇼 중간 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕聖翔站位為中受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3002,"_id_":1000105},"1000106":{"description":{"en":"(Passive) [Seisho Center Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為中】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Space Dmg Received Down","ja":"聖翔立ち位置中の宙属性被ダメージダウン","ko":"세이쇼 중간 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕聖翔站位為中受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3002,"_id_":1000106},"1000107":{"description":{"en":"(Passive) [Seisho Center Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為中】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Cloud Dmg Received Down","ja":"聖翔立ち位置中の雲属性被ダメージダウン","ko":"세이쇼 중간 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕聖翔站位為中受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3002,"_id_":1000107},"1000108":{"description":{"en":"(Passive) [Seisho Center Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為中】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dream Dmg Received Down","ja":"聖翔立ち位置中の夢属性被ダメージダウン","ko":"세이쇼 중간 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕聖翔站位為中受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3002,"_id_":1000108},"1000109":{"description":{"en":"(Passive) [Seisho Center Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dmg to Flower Up","ja":"聖翔立ち位置中の花属性特効与ダメージアップ","ko":"세이쇼 중간 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為中的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3002,"_id_":1000109},"1000110":{"description":{"en":"(Passive) [Seisho Center Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dmg to Wind Up","ja":"聖翔立ち位置中の風属性特効与ダメージアップ","ko":"세이쇼 중간 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為中的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3002,"_id_":1000110},"1000111":{"description":{"en":"(Passive) [Seisho Center Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dmg to Snow Up","ja":"聖翔立ち位置中の雪属性特効与ダメージアップ","ko":"세이쇼 중간 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為中的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3002,"_id_":1000111},"1000112":{"description":{"en":"(Passive) [Seisho Center Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dmg to Moon Up","ja":"聖翔立ち位置中の月属性特効与ダメージアップ","ko":"세이쇼 중간 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為中的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3002,"_id_":1000112},"1000113":{"description":{"en":"(Passive) [Seisho Center Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dmg to Space Up","ja":"聖翔立ち位置中の宙属性特効与ダメージアップ","ko":"세이쇼 중간 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為中的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3002,"_id_":1000113},"1000114":{"description":{"en":"(Passive) [Seisho Center Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dmg to Cloud Up","ja":"聖翔立ち位置中の雲属性特効与ダメージアップ","ko":"세이쇼 중간 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為中的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3002,"_id_":1000114},"1000115":{"description":{"en":"(Passive) [Seisho Center Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dmg to Dream Up","ja":"聖翔立ち位置中の夢属性特効与ダメージアップ","ko":"세이쇼 중간 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為中的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3002,"_id_":1000115},"1000116":{"description":{"en":"(Passive) [Seisho Center Position] Normal Defense Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [세이쇼 중간 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的普通防禦力 +%opt1_value%"},"name":{"en":"Seisho Center Position Normal Defense Up","ja":"聖翔立ち位置中の通常防御力アップ","ko":"세이쇼 중간 포지션의 일반 방어력 증가","zh_hant":"提升聖翔站位為中的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3002,"_id_":1000116},"1000117":{"description":{"en":"(Passive) [Seisho Center Position] Special Defense Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [세이쇼 중간 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的特殊防禦力 +%opt1_value%"},"name":{"en":"Seisho Center Position Special Defense Up","ja":"聖翔立ち位置中の特殊防御力アップ","ko":"세이쇼 중간 포지션의 특수 방어력 증가","zh_hant":"提升聖翔站位為中的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3002,"_id_":1000117},"1000118":{"description":{"en":"(Passive) [Seisho Center Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的普通防禦力 +%opt1_value%%"},"name":{"en":"Seisho Center Position Normal Defense Up","ja":"聖翔立ち位置中の通常防御力アップ","ko":"세이쇼 중간 포지션의 일반 방어력 증가","zh_hant":"提升聖翔站位為中的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3002,"_id_":1000118},"1000119":{"description":{"en":"(Passive) [Seisho Center Position] Special Defense Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Seisho Center Position Special Defense Up","ja":"聖翔立ち位置中の特殊防御力アップ","ko":"세이쇼 중간 포지션의 특수 방어력 증가","zh_hant":"提升聖翔站位為中的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3002,"_id_":1000119},"1000120":{"description":{"en":"(Passive) [Seisho Center Position] Dexterity Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的會心率 +%opt1_value%%"},"name":{"en":"Seisho Center Position Dexterity Up","ja":"聖翔立ち位置中のクリティカル率アップ","ko":"세이쇼 중간 포지션의 크리티컬 확률 증가","zh_hant":"提升聖翔站位為中的會心率"},"skill_option1_id":20,"skill_option1_target_id":3002,"_id_":1000120},"1000121":{"description":{"en":"(Passive) [Seisho Center Position] Critical Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [세이쇼 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為中】的會心威力 +%opt1_value%%"},"name":{"en":"Seisho Center Position Critical Up","ja":"聖翔立ち位置中のクリティカル威力アップ","ko":"세이쇼 중간 포지션의 크리티컬 위력 증가","zh_hant":"提升聖翔站位為中的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3002,"_id_":1000121},"1000201":{"description":{"en":"(Passive) [Space Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【宙属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [우주 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Space Rear Position Act Power Up","ja":"宙属性立ち位置後のACTパワーアップ","ko":"우주 속성 뒤 포지션의 ACT 파워 증가","zh_hant":"提升宙屬性站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3083,"_id_":1000201},"1000202":{"description":{"en":"(Passive) [Space Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Flower Dmg Received Down","ja":"宙属性立ち位置後の花属性被ダメージダウン","ko":"우주 속성 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕宙屬性站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3083,"_id_":1000202},"1000203":{"description":{"en":"(Passive) [Space Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Wind Dmg Received Down","ja":"宙属性立ち位置後の風属性被ダメージダウン","ko":"우주 속성 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕宙屬性站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3083,"_id_":1000203},"1000204":{"description":{"en":"(Passive) [Space Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Snow Dmg Received Down","ja":"宙属性立ち位置後の雪属性被ダメージダウン","ko":"우주 속성 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕宙屬性站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3083,"_id_":1000204},"1000205":{"description":{"en":"(Passive) [Space Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Moon Dmg Received Down","ja":"宙属性立ち位置後の月属性被ダメージダウン","ko":"우주 속성 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕宙屬性站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3083,"_id_":1000205},"1000206":{"description":{"en":"(Passive) [Space Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Space Dmg Received Down","ja":"宙属性立ち位置後の宙属性被ダメージダウン","ko":"우주 속성 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕宙屬性站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3083,"_id_":1000206},"1000207":{"description":{"en":"(Passive) [Space Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Cloud Dmg Received Down","ja":"宙属性立ち位置後の雲属性被ダメージダウン","ko":"우주 속성 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕宙屬性站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3083,"_id_":1000207},"1000208":{"description":{"en":"(Passive) [Space Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dream Dmg Received Down","ja":"宙属性立ち位置後の夢属性被ダメージダウン","ko":"우주 속성 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕宙屬性站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3083,"_id_":1000208},"1000209":{"description":{"en":"(Passive) [Space Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dmg to Flower Up","ja":"宙属性立ち位置後の花属性特効与ダメージアップ","ko":"우주 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3083,"_id_":1000209},"1000210":{"description":{"en":"(Passive) [Space Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dmg to Wind Up","ja":"宙属性立ち位置後の風属性特効与ダメージアップ","ko":"우주 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3083,"_id_":1000210},"1000211":{"description":{"en":"(Passive) [Space Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dmg to Snow Up","ja":"宙属性立ち位置後の雪属性特効与ダメージアップ","ko":"우주 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3083,"_id_":1000211},"1000212":{"description":{"en":"(Passive) [Space Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dmg to Moon Up","ja":"宙属性立ち位置後の月属性特効与ダメージアップ","ko":"우주 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3083,"_id_":1000212},"1000213":{"description":{"en":"(Passive) [Space Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dmg to Space Up","ja":"宙属性立ち位置後の宙属性特効与ダメージアップ","ko":"우주 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3083,"_id_":1000213},"1000214":{"description":{"en":"(Passive) [Space Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dmg to Cloud Up","ja":"宙属性立ち位置後の雲属性特効与ダメージアップ","ko":"우주 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3083,"_id_":1000214},"1000215":{"description":{"en":"(Passive) [Space Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Rear Position Dmg to Dream Up","ja":"宙属性立ち位置後の夢属性特効与ダメージアップ","ko":"우주 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3083,"_id_":1000215},"1000216":{"description":{"en":"(Passive) [Space Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [우주 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Space Rear Position Normal Defense Up","ja":"宙属性立ち位置後の通常防御力アップ","ko":"우주 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升宙屬性站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3083,"_id_":1000216},"1000217":{"description":{"en":"(Passive) [Space Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [우주 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Space Rear Position Special Defense Up","ja":"宙属性立ち位置後の特殊防御力アップ","ko":"우주 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升宙屬性站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3083,"_id_":1000217},"1000218":{"description":{"en":"(Passive) [Space Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Space Rear Position Normal Defense Up","ja":"宙属性立ち位置後の通常防御力アップ","ko":"우주 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升宙屬性站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3083,"_id_":1000218},"1000219":{"description":{"en":"(Passive) [Space Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Space Rear Position Special Defense Up","ja":"宙属性立ち位置後の特殊防御力アップ","ko":"우주 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升宙屬性站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3083,"_id_":1000219},"1000220":{"description":{"en":"(Passive) [Space Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Space Rear Position Dexterity Up","ja":"宙属性立ち位置後のクリティカル率アップ","ko":"우주 속성 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升宙屬性站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3083,"_id_":1000220},"1000221":{"description":{"en":"(Passive) [Space Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [우주 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Space Rear Position Critical Up","ja":"宙属性立ち位置後のクリティカル威力アップ","ko":"우주 속성 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升宙屬性站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3083,"_id_":1000221},"1000301":{"description":{"en":"(Passive) [Flower Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [꽃 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Flower Rear Position Act Power Up","ja":"花属性立ち位置後のACTパワーアップ","ko":"꽃 속성 뒤 포지션의 ACT 파워 증가","zh_hant":"提升花屬性站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3053,"_id_":1000301},"1000302":{"description":{"en":"(Passive) [Flower Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Flower Dmg Received Down","ja":"花属性立ち位置後の花属性被ダメージダウン","ko":"꽃 속성 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕花屬性站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3053,"_id_":1000302},"1000303":{"description":{"en":"(Passive) [Flower Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Wind Dmg Received Down","ja":"花属性立ち位置後の風属性被ダメージダウン","ko":"꽃 속성 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕花屬性站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3053,"_id_":1000303},"1000304":{"description":{"en":"(Passive) [Flower Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Snow Dmg Received Down","ja":"花属性立ち位置後の雪属性被ダメージダウン","ko":"꽃 속성 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕花屬性站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3053,"_id_":1000304},"1000305":{"description":{"en":"(Passive) [Flower Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Moon Dmg Received Down","ja":"花属性立ち位置後の月属性被ダメージダウン","ko":"꽃 속성 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕花屬性站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3053,"_id_":1000305},"1000306":{"description":{"en":"(Passive) [Flower Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Space Dmg Received Down","ja":"花属性立ち位置後の宙属性被ダメージダウン","ko":"꽃 속성 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕花屬性站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3053,"_id_":1000306},"1000307":{"description":{"en":"(Passive) [Flower Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Cloud Dmg Received Down","ja":"花属性立ち位置後の雲属性被ダメージダウン","ko":"꽃 속성 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕花屬性站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3053,"_id_":1000307},"1000308":{"description":{"en":"(Passive) [Flower Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dream Dmg Received Down","ja":"花属性立ち位置後の夢属性被ダメージダウン","ko":"꽃 속성 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕花屬性站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3053,"_id_":1000308},"1000309":{"description":{"en":"(Passive) [Flower Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dmg to Flower Up","ja":"花属性立ち位置後の花属性特効与ダメージアップ","ko":"꽃 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3053,"_id_":1000309},"1000310":{"description":{"en":"(Passive) [Flower Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dmg to Wind Up","ja":"花属性立ち位置後の風属性特効与ダメージアップ","ko":"꽃 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3053,"_id_":1000310},"1000311":{"description":{"en":"(Passive) [Flower Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dmg to Snow Up","ja":"花属性立ち位置後の雪属性特効与ダメージアップ","ko":"꽃 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3053,"_id_":1000311},"1000312":{"description":{"en":"(Passive) [Flower Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dmg to Moon Up","ja":"花属性立ち位置後の月属性特効与ダメージアップ","ko":"꽃 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3053,"_id_":1000312},"1000313":{"description":{"en":"(Passive) [Flower Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dmg to Space Up","ja":"花属性立ち位置後の宙属性特効与ダメージアップ","ko":"꽃 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3053,"_id_":1000313},"1000314":{"description":{"en":"(Passive) [Flower Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dmg to Cloud Up","ja":"花属性立ち位置後の雲属性特効与ダメージアップ","ko":"꽃 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3053,"_id_":1000314},"1000315":{"description":{"en":"(Passive) [Flower Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dmg to Dream Up","ja":"花属性立ち位置後の夢属性特効与ダメージアップ","ko":"꽃 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3053,"_id_":1000315},"1000316":{"description":{"en":"(Passive) [Flower Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [꽃 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Flower Rear Position Normal Defense Up","ja":"花属性立ち位置後の通常防御力アップ","ko":"꽃 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升花屬性站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3053,"_id_":1000316},"1000317":{"description":{"en":"(Passive) [Flower Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [꽃 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Flower Rear Position Special Defense Up","ja":"花属性立ち位置後の特殊防御力アップ","ko":"꽃 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升花屬性站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3053,"_id_":1000317},"1000318":{"description":{"en":"(Passive) [Flower Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Flower Rear Position Normal Defense Up","ja":"花属性立ち位置後の通常防御力アップ","ko":"꽃 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升花屬性站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3053,"_id_":1000318},"1000319":{"description":{"en":"(Passive) [Flower Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Flower Rear Position Special Defense Up","ja":"花属性立ち位置後の特殊防御力アップ","ko":"꽃 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升花屬性站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3053,"_id_":1000319},"1000320":{"description":{"en":"(Passive) [Flower Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Flower Rear Position Dexterity Up","ja":"花属性立ち位置後のクリティカル率アップ","ko":"꽃 속성 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升花屬性站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3053,"_id_":1000320},"1000321":{"description":{"en":"(Passive) [Flower Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Flower Rear Position Critical Up","ja":"花属性立ち位置後のクリティカル威力アップ","ko":"꽃 속성 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升花屬性站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3053,"_id_":1000321},"1000401":{"description":{"en":"(Passive) [Moon Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【月属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [달 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Moon Rear Position Act Power Up","ja":"月属性立ち位置後のACTパワーアップ","ko":"달 속성 뒤 포지션의 ACT 파워 증가","zh_hant":"提升月屬性站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3043,"_id_":1000401},"1000402":{"description":{"en":"(Passive) [Moon Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Flower Dmg Received Down","ja":"月属性立ち位置後の花属性被ダメージダウン","ko":"달 속성 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕月屬性站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3043,"_id_":1000402},"1000403":{"description":{"en":"(Passive) [Moon Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Wind Dmg Received Down","ja":"月属性立ち位置後の風属性被ダメージダウン","ko":"달 속성 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕月屬性站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3043,"_id_":1000403},"1000404":{"description":{"en":"(Passive) [Moon Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Snow Dmg Received Down","ja":"月属性立ち位置後の雪属性被ダメージダウン","ko":"달 속성 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕月屬性站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3043,"_id_":1000404},"1000405":{"description":{"en":"(Passive) [Moon Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Moon Dmg Received Down","ja":"月属性立ち位置後の月属性被ダメージダウン","ko":"달 속성 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕月屬性站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3043,"_id_":1000405},"1000406":{"description":{"en":"(Passive) [Moon Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Space Dmg Received Down","ja":"月属性立ち位置後の宙属性被ダメージダウン","ko":"달 속성 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕月屬性站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3043,"_id_":1000406},"1000407":{"description":{"en":"(Passive) [Moon Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Cloud Dmg Received Down","ja":"月属性立ち位置後の雲属性被ダメージダウン","ko":"달 속성 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕月屬性站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3043,"_id_":1000407},"1000408":{"description":{"en":"(Passive) [Moon Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dream Dmg Received Down","ja":"月属性立ち位置後の夢属性被ダメージダウン","ko":"달 속성 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕月屬性站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3043,"_id_":1000408},"1000409":{"description":{"en":"(Passive) [Moon Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dmg to Flower Up","ja":"月属性立ち位置後の花属性特効与ダメージアップ","ko":"달 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3043,"_id_":1000409},"1000410":{"description":{"en":"(Passive) [Moon Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dmg to Wind Up","ja":"月属性立ち位置後の風属性特効与ダメージアップ","ko":"달 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3043,"_id_":1000410},"1000411":{"description":{"en":"(Passive) [Moon Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dmg to Snow Up","ja":"月属性立ち位置後の雪属性特効与ダメージアップ","ko":"달 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3043,"_id_":1000411},"1000412":{"description":{"en":"(Passive) [Moon Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dmg to Moon Up","ja":"月属性立ち位置後の月属性特効与ダメージアップ","ko":"달 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3043,"_id_":1000412},"1000413":{"description":{"en":"(Passive) [Moon Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dmg to Space Up","ja":"月属性立ち位置後の宙属性特効与ダメージアップ","ko":"달 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3043,"_id_":1000413},"1000414":{"description":{"en":"(Passive) [Moon Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dmg to Cloud Up","ja":"月属性立ち位置後の雲属性特効与ダメージアップ","ko":"달 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3043,"_id_":1000414},"1000415":{"description":{"en":"(Passive) [Moon Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dmg to Dream Up","ja":"月属性立ち位置後の夢属性特効与ダメージアップ","ko":"달 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3043,"_id_":1000415},"1000416":{"description":{"en":"(Passive) [Moon Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【月属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [달 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Moon Rear Position Normal Defense Up","ja":"月属性立ち位置後の通常防御力アップ","ko":"달 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升月屬性站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3043,"_id_":1000416},"1000417":{"description":{"en":"(Passive) [Moon Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【月属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [달 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Moon Rear Position Special Defense Up","ja":"月属性立ち位置後の特殊防御力アップ","ko":"달 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升月屬性站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3043,"_id_":1000417},"1000418":{"description":{"en":"(Passive) [Moon Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Moon Rear Position Normal Defense Up","ja":"月属性立ち位置後の通常防御力アップ","ko":"달 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升月屬性站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3043,"_id_":1000418},"1000419":{"description":{"en":"(Passive) [Moon Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Moon Rear Position Special Defense Up","ja":"月属性立ち位置後の特殊防御力アップ","ko":"달 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升月屬性站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3043,"_id_":1000419},"1000420":{"description":{"en":"(Passive) [Moon Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Moon Rear Position Dexterity Up","ja":"月属性立ち位置後のクリティカル率アップ","ko":"달 속성 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升月屬性站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3043,"_id_":1000420},"1000421":{"description":{"en":"(Passive) [Moon Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [달 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Moon Rear Position Critical Up","ja":"月属性立ち位置後のクリティカル威力アップ","ko":"달 속성 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升月屬性站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3043,"_id_":1000421},"1000501":{"description":{"en":"(Passive) [Wind Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【風属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [바람 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Wind Rear Position Act Power Up","ja":"風属性立ち位置後のACTパワーアップ","ko":"바람 속성 뒤 포지션의 ACT 파워 증가","zh_hant":"提升風屬性站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3073,"_id_":1000501},"1000502":{"description":{"en":"(Passive) [Wind Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Flower Dmg Received Down","ja":"風属性立ち位置後の花属性被ダメージダウン","ko":"바람 속성 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕風屬性站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3073,"_id_":1000502},"1000503":{"description":{"en":"(Passive) [Wind Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Wind Dmg Received Down","ja":"風属性立ち位置後の風属性被ダメージダウン","ko":"바람 속성 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕風屬性站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3073,"_id_":1000503},"1000504":{"description":{"en":"(Passive) [Wind Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Snow Dmg Received Down","ja":"風属性立ち位置後の雪属性被ダメージダウン","ko":"바람 속성 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕風屬性站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3073,"_id_":1000504},"1000505":{"description":{"en":"(Passive) [Wind Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Moon Dmg Received Down","ja":"風属性立ち位置後の月属性被ダメージダウン","ko":"바람 속성 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕風屬性站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3073,"_id_":1000505},"1000506":{"description":{"en":"(Passive) [Wind Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Space Dmg Received Down","ja":"風属性立ち位置後の宙属性被ダメージダウン","ko":"바람 속성 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕風屬性站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3073,"_id_":1000506},"1000507":{"description":{"en":"(Passive) [Wind Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Cloud Dmg Received Down","ja":"風属性立ち位置後の雲属性被ダメージダウン","ko":"바람 속성 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕風屬性站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3073,"_id_":1000507},"1000508":{"description":{"en":"(Passive) [Wind Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dream Dmg Received Down","ja":"風属性立ち位置後の夢属性被ダメージダウン","ko":"바람 속성 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕風屬性站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3073,"_id_":1000508},"1000509":{"description":{"en":"(Passive) [Wind Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dmg to Flower Up","ja":"風属性立ち位置後の花属性特効与ダメージアップ","ko":"바람 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3073,"_id_":1000509},"1000510":{"description":{"en":"(Passive) [Wind Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dmg to Wind Up","ja":"風属性立ち位置後の風属性特効与ダメージアップ","ko":"바람 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3073,"_id_":1000510},"1000511":{"description":{"en":"(Passive) [Wind Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dmg to Snow Up","ja":"風属性立ち位置後の雪属性特効与ダメージアップ","ko":"바람 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3073,"_id_":1000511},"1000512":{"description":{"en":"(Passive) [Wind Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dmg to Moon Up","ja":"風属性立ち位置後の月属性特効与ダメージアップ","ko":"바람 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3073,"_id_":1000512},"1000513":{"description":{"en":"(Passive) [Wind Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dmg to Space Up","ja":"風属性立ち位置後の宙属性特効与ダメージアップ","ko":"바람 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3073,"_id_":1000513},"1000514":{"description":{"en":"(Passive) [Wind Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dmg to Cloud Up","ja":"風属性立ち位置後の雲属性特効与ダメージアップ","ko":"바람 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3073,"_id_":1000514},"1000515":{"description":{"en":"(Passive) [Wind Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dmg to Dream Up","ja":"風属性立ち位置後の夢属性特効与ダメージアップ","ko":"바람 속성 뒤 포지션의 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3073,"_id_":1000515},"1000516":{"description":{"en":"(Passive) [Wind Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【風属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [바람 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Wind Rear Position Normal Defense Up","ja":"風属性立ち位置後の通常防御力アップ","ko":"바람 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升風屬性站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3073,"_id_":1000516},"1000517":{"description":{"en":"(Passive) [Wind Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【風属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [바람 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Wind Rear Position Special Defense Up","ja":"風属性立ち位置後の特殊防御力アップ","ko":"바람 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升風屬性站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3073,"_id_":1000517},"1000518":{"description":{"en":"(Passive) [Wind Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Wind Rear Position Normal Defense Up","ja":"風属性立ち位置後の通常防御力アップ","ko":"바람 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升風屬性站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3073,"_id_":1000518},"1000519":{"description":{"en":"(Passive) [Wind Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Wind Rear Position Special Defense Up","ja":"風属性立ち位置後の特殊防御力アップ","ko":"바람 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升風屬性站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3073,"_id_":1000519},"1000520":{"description":{"en":"(Passive) [Wind Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Wind Rear Position Dexterity Up","ja":"風属性立ち位置後のクリティカル率アップ","ko":"바람 속성 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升風屬性站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3073,"_id_":1000520},"1000521":{"description":{"en":"(Passive) [Wind Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [바람 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Wind Rear Position Critical Up","ja":"風属性立ち位置後のクリティカル威力アップ","ko":"바람 속성 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升風屬性站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3073,"_id_":1000521},"1000601":{"description":{"en":"(Passive) [Seisho Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [세이쇼 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Seisho Rear Position Act Power Up","ja":"聖翔立ち位置後のACTパワーアップ","ko":"세이쇼 뒤 포지션의 ACT 파워 증가","zh_hant":"提升聖翔站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3003,"_id_":1000601},"1000602":{"description":{"en":"(Passive) [Seisho Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Flower Dmg Received Down","ja":"聖翔立ち位置後の花属性被ダメージダウン","ko":"세이쇼 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕聖翔站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3003,"_id_":1000602},"1000603":{"description":{"en":"(Passive) [Seisho Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Wind Dmg Received Down","ja":"聖翔立ち位置後の風属性被ダメージダウン","ko":"세이쇼 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕聖翔站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3003,"_id_":1000603},"1000604":{"description":{"en":"(Passive) [Seisho Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Snow Dmg Received Down","ja":"聖翔立ち位置後の雪属性被ダメージダウン","ko":"세이쇼 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕聖翔站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3003,"_id_":1000604},"1000605":{"description":{"en":"(Passive) [Seisho Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Moon Dmg Received Down","ja":"聖翔立ち位置後の月属性被ダメージダウン","ko":"세이쇼 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕聖翔站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3003,"_id_":1000605},"1000606":{"description":{"en":"(Passive) [Seisho Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Space Dmg Received Down","ja":"聖翔立ち位置後の宙属性被ダメージダウン","ko":"세이쇼 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕聖翔站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3003,"_id_":1000606},"1000607":{"description":{"en":"(Passive) [Seisho Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Cloud Dmg Received Down","ja":"聖翔立ち位置後の雲属性被ダメージダウン","ko":"세이쇼 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕聖翔站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3003,"_id_":1000607},"1000608":{"description":{"en":"(Passive) [Seisho Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dream Dmg Received Down","ja":"聖翔立ち位置後の夢属性被ダメージダウン","ko":"세이쇼 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕聖翔站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3003,"_id_":1000608},"1000609":{"description":{"en":"(Passive) [Seisho Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dmg to Flower Up","ja":"聖翔立ち位置後の花属性特効与ダメージアップ","ko":"세이쇼 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3003,"_id_":1000609},"1000610":{"description":{"en":"(Passive) [Seisho Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dmg to Wind Up","ja":"聖翔立ち位置後の風属性特効与ダメージアップ","ko":"세이쇼 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3003,"_id_":1000610},"1000611":{"description":{"en":"(Passive) [Seisho Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dmg to Snow Up","ja":"聖翔立ち位置後の雪属性特効与ダメージアップ","ko":"세이쇼 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3003,"_id_":1000611},"1000612":{"description":{"en":"(Passive) [Seisho Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dmg to Moon Up","ja":"聖翔立ち位置後の月属性特効与ダメージアップ","ko":"세이쇼 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3003,"_id_":1000612},"1000613":{"description":{"en":"(Passive) [Seisho Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dmg to Space Up","ja":"聖翔立ち位置後の宙属性特効与ダメージアップ","ko":"세이쇼 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3003,"_id_":1000613},"1000614":{"description":{"en":"(Passive) [Seisho Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dmg to Cloud Up","ja":"聖翔立ち位置後の雲属性特効与ダメージアップ","ko":"세이쇼 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3003,"_id_":1000614},"1000615":{"description":{"en":"(Passive) [Seisho Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dmg to Dream Up","ja":"聖翔立ち位置後の夢属性特効与ダメージアップ","ko":"세이쇼 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3003,"_id_":1000615},"1000616":{"description":{"en":"(Passive) [Seisho Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [세이쇼 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Seisho Rear Position Normal Defense Up","ja":"聖翔立ち位置後の通常防御力アップ","ko":"세이쇼 뒤 포지션의 일반 방어력 증가","zh_hant":"提升聖翔站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3003,"_id_":1000616},"1000617":{"description":{"en":"(Passive) [Seisho Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [세이쇼 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Seisho Rear Position Special Defense Up","ja":"聖翔立ち位置後の特殊防御力アップ","ko":"세이쇼 뒤 포지션의 특수 방어력 증가","zh_hant":"提升聖翔站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3003,"_id_":1000617},"1000618":{"description":{"en":"(Passive) [Seisho Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Normal Defense Up","ja":"聖翔立ち位置後の通常防御力アップ","ko":"세이쇼 뒤 포지션의 일반 방어력 증가","zh_hant":"提升聖翔站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3003,"_id_":1000618},"1000619":{"description":{"en":"(Passive) [Seisho Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Special Defense Up","ja":"聖翔立ち位置後の特殊防御力アップ","ko":"세이쇼 뒤 포지션의 특수 방어력 증가","zh_hant":"提升聖翔站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3003,"_id_":1000619},"1000620":{"description":{"en":"(Passive) [Seisho Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Dexterity Up","ja":"聖翔立ち位置後のクリティカル率アップ","ko":"세이쇼 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升聖翔站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3003,"_id_":1000620},"1000621":{"description":{"en":"(Passive) [Seisho Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [세이쇼 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Seisho Rear Position Critical Up","ja":"聖翔立ち位置後のクリティカル威力アップ","ko":"세이쇼 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升聖翔站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3003,"_id_":1000621},"1000701":{"description":{"en":"(Passive) [Cloud Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【雲属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [구름 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Cloud Rear Position Act Power Up","ja":"雲属性立ち位置後のACTパワーアップ","ko":"구름 속성 뒤 포지션의 ACT 파워 증가","zh_hant":"提升雲屬性站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3093,"_id_":1000701},"1000702":{"description":{"en":"(Passive) [Cloud Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Flower Dmg Received Down","ja":"雲属性立ち位置後の花属性被ダメージダウン","ko":"구름 속성 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕雲屬性站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3093,"_id_":1000702},"1000703":{"description":{"en":"(Passive) [Cloud Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Wind Dmg Received Down","ja":"雲属性立ち位置後の風属性被ダメージダウン","ko":"구름 속성 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕雲屬性站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3093,"_id_":1000703},"1000704":{"description":{"en":"(Passive) [Cloud Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Snow Dmg Received Down","ja":"雲属性立ち位置後の雪属性被ダメージダウン","ko":"구름 속성 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕雲屬性站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3093,"_id_":1000704},"1000705":{"description":{"en":"(Passive) [Cloud Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Moon Dmg Received Down","ja":"雲属性立ち位置後の月属性被ダメージダウン","ko":"구름 속성 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕雲屬性站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3093,"_id_":1000705},"1000706":{"description":{"en":"(Passive) [Cloud Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Space Dmg Received Down","ja":"雲属性立ち位置後の宙属性被ダメージダウン","ko":"구름 속성 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕雲屬性站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3093,"_id_":1000706},"1000707":{"description":{"en":"(Passive) [Cloud Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Cloud Dmg Received Down","ja":"雲属性立ち位置後の雲属性被ダメージダウン","ko":"구름 속성 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕雲屬性站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3093,"_id_":1000707},"1000708":{"description":{"en":"(Passive) [Cloud Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dream Dmg Received Down","ja":"雲属性立ち位置後の夢属性被ダメージダウン","ko":"구름 속성 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕雲屬性站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3093,"_id_":1000708},"1000709":{"description":{"en":"(Passive) [Cloud Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dmg to Flower Up","ja":"雲属性立ち位置後の花属性特効与ダメージアップ","ko":"구름 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3093,"_id_":1000709},"1000710":{"description":{"en":"(Passive) [Cloud Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dmg to Wind Up","ja":"雲属性立ち位置後の風属性特効与ダメージアップ","ko":"구름 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3093,"_id_":1000710},"1000711":{"description":{"en":"(Passive) [Cloud Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dmg to Snow Up","ja":"雲属性立ち位置後の雪属性特効与ダメージアップ","ko":"구름 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3093,"_id_":1000711},"1000712":{"description":{"en":"(Passive) [Cloud Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dmg to Moon Up","ja":"雲属性立ち位置後の月属性特効与ダメージアップ","ko":"구름 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3093,"_id_":1000712},"1000713":{"description":{"en":"(Passive) [Cloud Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dmg to Space Up","ja":"雲属性立ち位置後の宙属性特効与ダメージアップ","ko":"구름 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3093,"_id_":1000713},"1000714":{"description":{"en":"(Passive) [Cloud Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dmg to Cloud Up","ja":"雲属性立ち位置後の雲属性特効与ダメージアップ","ko":"구름 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3093,"_id_":1000714},"1000715":{"description":{"en":"(Passive) [Cloud Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dmg to Dream Up","ja":"雲属性立ち位置後の夢属性特効与ダメージアップ","ko":"구름 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3093,"_id_":1000715},"1000716":{"description":{"en":"(Passive) [Cloud Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [구름 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Cloud Rear Position Normal Defense Up","ja":"雲属性立ち位置後の通常防御力アップ","ko":"구름 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升雲屬性站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3093,"_id_":1000716},"1000717":{"description":{"en":"(Passive) [Cloud Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [구름 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Cloud Rear Position Special Defense Up","ja":"雲属性立ち位置後の特殊防御力アップ","ko":"구름 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升雲屬性站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3093,"_id_":1000717},"1000718":{"description":{"en":"(Passive) [Cloud Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Normal Defense Up","ja":"雲属性立ち位置後の通常防御力アップ","ko":"구름 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升雲屬性站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3093,"_id_":1000718},"1000719":{"description":{"en":"(Passive) [Cloud Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Special Defense Up","ja":"雲属性立ち位置後の特殊防御力アップ","ko":"구름 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升雲屬性站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3093,"_id_":1000719},"1000720":{"description":{"en":"(Passive) [Cloud Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Dexterity Up","ja":"雲属性立ち位置後のクリティカル率アップ","ko":"구름 속성 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升雲屬性站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3093,"_id_":1000720},"1000721":{"description":{"en":"(Passive) [Cloud Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [구름 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Cloud Rear Position Critical Up","ja":"雲属性立ち位置後のクリティカル威力アップ","ko":"구름 속성 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升雲屬性站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3093,"_id_":1000721},"1000801":{"description":{"en":"(Passive) [Seisho Front Position] Act Power Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [세이쇼 앞 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的ACT力量 +%opt1_value%"},"name":{"en":"Seisho Front Position Act Power Up","ja":"聖翔立ち位置前のACTパワーアップ","ko":"세이쇼 앞 포지션의 ACT 파워 증가","zh_hant":"提升聖翔站位為前的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3001,"_id_":1000801},"1000802":{"description":{"en":"(Passive) [Seisho Front Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為前】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Flower Dmg Received Down","ja":"聖翔立ち位置前の花属性被ダメージダウン","ko":"세이쇼 앞 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕聖翔站位為前受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3001,"_id_":1000802},"1000803":{"description":{"en":"(Passive) [Seisho Front Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為前】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Wind Dmg Received Down","ja":"聖翔立ち位置前の風属性被ダメージダウン","ko":"세이쇼 앞 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕聖翔站位為前受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3001,"_id_":1000803},"1000804":{"description":{"en":"(Passive) [Seisho Front Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為前】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Snow Dmg Received Down","ja":"聖翔立ち位置前の雪属性被ダメージダウン","ko":"세이쇼 앞 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕聖翔站位為前受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3001,"_id_":1000804},"1000805":{"description":{"en":"(Passive) [Seisho Front Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為前】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Moon Dmg Received Down","ja":"聖翔立ち位置前の月属性被ダメージダウン","ko":"세이쇼 앞 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕聖翔站位為前受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3001,"_id_":1000805},"1000806":{"description":{"en":"(Passive) [Seisho Front Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為前】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Space Dmg Received Down","ja":"聖翔立ち位置前の宙属性被ダメージダウン","ko":"세이쇼 앞 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕聖翔站位為前受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3001,"_id_":1000806},"1000807":{"description":{"en":"(Passive) [Seisho Front Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為前】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Cloud Dmg Received Down","ja":"聖翔立ち位置前の雲属性被ダメージダウン","ko":"세이쇼 앞 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕聖翔站位為前受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3001,"_id_":1000807},"1000808":{"description":{"en":"(Passive) [Seisho Front Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【聖翔且站位為前】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dream Dmg Received Down","ja":"聖翔立ち位置前の夢属性被ダメージダウン","ko":"세이쇼 앞 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕聖翔站位為前受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3001,"_id_":1000808},"1000809":{"description":{"en":"(Passive) [Seisho Front Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dmg to Flower Up","ja":"聖翔立ち位置前の花属性特効与ダメージアップ","ko":"세이쇼 앞 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為前的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3001,"_id_":1000809},"1000810":{"description":{"en":"(Passive) [Seisho Front Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dmg to Wind Up","ja":"聖翔立ち位置前の風属性特効与ダメージアップ","ko":"세이쇼 앞 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為前的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3001,"_id_":1000810},"1000811":{"description":{"en":"(Passive) [Seisho Front Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dmg to Snow Up","ja":"聖翔立ち位置前の雪属性特効与ダメージアップ","ko":"세이쇼 앞 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為前的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3001,"_id_":1000811},"1000812":{"description":{"en":"(Passive) [Seisho Front Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dmg to Moon Up","ja":"聖翔立ち位置前の月属性特効与ダメージアップ","ko":"세이쇼 앞 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為前的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3001,"_id_":1000812},"1000813":{"description":{"en":"(Passive) [Seisho Front Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dmg to Space Up","ja":"聖翔立ち位置前の宙属性特効与ダメージアップ","ko":"세이쇼 앞 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為前的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3001,"_id_":1000813},"1000814":{"description":{"en":"(Passive) [Seisho Front Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dmg to Cloud Up","ja":"聖翔立ち位置前の雲属性特効与ダメージアップ","ko":"세이쇼 앞 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為前的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3001,"_id_":1000814},"1000815":{"description":{"en":"(Passive) [Seisho Front Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dmg to Dream Up","ja":"聖翔立ち位置前の夢属性特効与ダメージアップ","ko":"세이쇼 앞 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升聖翔站位為前的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3001,"_id_":1000815},"1000816":{"description":{"en":"(Passive) [Seisho Front Position] Normal Defense Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [세이쇼 앞 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的普通防禦力 +%opt1_value%"},"name":{"en":"Seisho Front Position Normal Defense Up","ja":"聖翔立ち位置前の通常防御力アップ","ko":"세이쇼 앞 포지션의 일반 방어력 증가","zh_hant":"提升聖翔站位為前的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3001,"_id_":1000816},"1000817":{"description":{"en":"(Passive) [Seisho Front Position] Special Defense Up %opt1_value% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [세이쇼 앞 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的特殊防禦力 +%opt1_value%"},"name":{"en":"Seisho Front Position Special Defense Up","ja":"聖翔立ち位置前の特殊防御力アップ","ko":"세이쇼 앞 포지션의 특수 방어력 증가","zh_hant":"提升聖翔站位為前的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3001,"_id_":1000817},"1000818":{"description":{"en":"(Passive) [Seisho Front Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的普通防禦力 +%opt1_value%%"},"name":{"en":"Seisho Front Position Normal Defense Up","ja":"聖翔立ち位置前の通常防御力アップ","ko":"세이쇼 앞 포지션의 일반 방어력 증가","zh_hant":"提升聖翔站位為前的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3001,"_id_":1000818},"1000819":{"description":{"en":"(Passive) [Seisho Front Position] Special Defense Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Seisho Front Position Special Defense Up","ja":"聖翔立ち位置前の特殊防御力アップ","ko":"세이쇼 앞 포지션의 특수 방어력 증가","zh_hant":"提升聖翔站位為前的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3001,"_id_":1000819},"1000820":{"description":{"en":"(Passive) [Seisho Front Position] Dexterity Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的會心率 +%opt1_value%%"},"name":{"en":"Seisho Front Position Dexterity Up","ja":"聖翔立ち位置前のクリティカル率アップ","ko":"세이쇼 앞 포지션의 크리티컬 확률 증가","zh_hant":"提升聖翔站位為前的會心率"},"skill_option1_id":20,"skill_option1_target_id":3001,"_id_":1000820},"1000821":{"description":{"en":"(Passive) [Seisho Front Position] Critical Up %opt1_value%% ","ja":"[永続]【聖翔かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [세이쇼 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【聖翔且站位為前】的會心威力 +%opt1_value%%"},"name":{"en":"Seisho Front Position Critical Up","ja":"聖翔立ち位置前のクリティカル威力アップ","ko":"세이쇼 앞 포지션의 크리티컬 위력 증가","zh_hant":"提升聖翔站位為前的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3001,"_id_":1000821},"1000901":{"description":{"en":"(Passive) [Flower Center Position] Act Power Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [꽃 속성 중간 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的ACT力量 +%opt1_value%"},"name":{"en":"Flower Center Position Act Power Up","ja":"花属性立ち位置中のACTパワーアップ","ko":"꽃 속성 중간 포지션의 ACT 파워 증가","zh_hant":"提升花屬性站位為中的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3052,"_id_":1000901},"1000902":{"description":{"en":"(Passive) [Flower Center Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為中】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Flower Dmg Received Down","ja":"花属性立ち位置中の花属性被ダメージダウン","ko":"꽃 속성 중간 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕花屬性站位為中受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3052,"_id_":1000902},"1000903":{"description":{"en":"(Passive) [Flower Center Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為中】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Wind Dmg Received Down","ja":"花属性立ち位置中の風属性被ダメージダウン","ko":"꽃 속성 중간 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕花屬性站位為中受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3052,"_id_":1000903},"1000904":{"description":{"en":"(Passive) [Flower Center Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為中】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Snow Dmg Received Down","ja":"花属性立ち位置中の雪属性被ダメージダウン","ko":"꽃 속성 중간 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕花屬性站位為中受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3052,"_id_":1000904},"1000905":{"description":{"en":"(Passive) [Flower Center Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為中】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Moon Dmg Received Down","ja":"花属性立ち位置中の月属性被ダメージダウン","ko":"꽃 속성 중간 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕花屬性站位為中受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3052,"_id_":1000905},"1000906":{"description":{"en":"(Passive) [Flower Center Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為中】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Space Dmg Received Down","ja":"花属性立ち位置中の宙属性被ダメージダウン","ko":"꽃 속성 중간 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕花屬性站位為中受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3052,"_id_":1000906},"1000907":{"description":{"en":"(Passive) [Flower Center Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為中】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Cloud Dmg Received Down","ja":"花属性立ち位置中の雲属性被ダメージダウン","ko":"꽃 속성 중간 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕花屬性站位為中受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3052,"_id_":1000907},"1000908":{"description":{"en":"(Passive) [Flower Center Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為中】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dream Dmg Received Down","ja":"花属性立ち位置中の夢属性被ダメージダウン","ko":"꽃 속성 중간 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕花屬性站位為中受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3052,"_id_":1000908},"1000909":{"description":{"en":"(Passive) [Flower Center Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dmg to Flower Up","ja":"花属性立ち位置中の花属性特効与ダメージアップ","ko":"꽃 속성 중간 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為中的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3052,"_id_":1000909},"1000910":{"description":{"en":"(Passive) [Flower Center Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dmg to Wind Up","ja":"花属性立ち位置中の風属性特効与ダメージアップ","ko":"꽃 속성 중간 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為中的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3052,"_id_":1000910},"1000911":{"description":{"en":"(Passive) [Flower Center Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dmg to Snow Up","ja":"花属性立ち位置中の雪属性特効与ダメージアップ","ko":"꽃 속성 중간 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為中的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3052,"_id_":1000911},"1000912":{"description":{"en":"(Passive) [Flower Center Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dmg to Moon Up","ja":"花属性立ち位置中の月属性特効与ダメージアップ","ko":"꽃 속성 중간 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為中的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3052,"_id_":1000912},"1000913":{"description":{"en":"(Passive) [Flower Center Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dmg to Space Up","ja":"花属性立ち位置中の宙属性特効与ダメージアップ","ko":"꽃 속성 중간 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為中的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3052,"_id_":1000913},"1000914":{"description":{"en":"(Passive) [Flower Center Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dmg to Cloud Up","ja":"花属性立ち位置中の雲属性特効与ダメージアップ","ko":"꽃 속성 중간 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為中的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3052,"_id_":1000914},"1000915":{"description":{"en":"(Passive) [Flower Center Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Center Position Dmg to Dream Up","ja":"花属性立ち位置中の夢属性特効与ダメージアップ","ko":"꽃 속성 중간 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為中的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3052,"_id_":1000915},"1000916":{"description":{"en":"(Passive) [Flower Center Position] Normal Defense Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [꽃 속성 중간 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的普通防禦力 +%opt1_value%"},"name":{"en":"Flower Center Position Normal Defense Up","ja":"花属性立ち位置中の通常防御力アップ","ko":"꽃 속성 중간 포지션의 일반 방어력 증가","zh_hant":"提升花屬性站位為中的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3052,"_id_":1000916},"1000917":{"description":{"en":"(Passive) [Flower Center Position] Special Defense Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [꽃 속성 중간 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的特殊防禦力 +%opt1_value%"},"name":{"en":"Flower Center Position Special Defense Up","ja":"花属性立ち位置中の特殊防御力アップ","ko":"꽃 속성 중간 포지션의 특수 방어력 증가","zh_hant":"提升花屬性站位為中的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3052,"_id_":1000917},"1000918":{"description":{"en":"(Passive) [Flower Center Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的普通防禦力 +%opt1_value%%"},"name":{"en":"Flower Center Position Normal Defense Up","ja":"花属性立ち位置中の通常防御力アップ","ko":"꽃 속성 중간 포지션의 일반 방어력 증가","zh_hant":"提升花屬性站位為中的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3052,"_id_":1000918},"1000919":{"description":{"en":"(Passive) [Flower Center Position] Special Defense Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Flower Center Position Special Defense Up","ja":"花属性立ち位置中の特殊防御力アップ","ko":"꽃 속성 중간 포지션의 특수 방어력 증가","zh_hant":"提升花屬性站位為中的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3052,"_id_":1000919},"1000920":{"description":{"en":"(Passive) [Flower Center Position] Dexterity Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的會心率 +%opt1_value%%"},"name":{"en":"Flower Center Position Dexterity Up","ja":"花属性立ち位置中のクリティカル率アップ","ko":"꽃 속성 중간 포지션의 크리티컬 확률 증가","zh_hant":"提升花屬性站位為中的會心率"},"skill_option1_id":20,"skill_option1_target_id":3052,"_id_":1000920},"1000921":{"description":{"en":"(Passive) [Flower Center Position] Critical Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為中】的會心威力 +%opt1_value%%"},"name":{"en":"Flower Center Position Critical Up","ja":"花属性立ち位置中のクリティカル威力アップ","ko":"꽃 속성 중간 포지션의 크리티컬 위력 증가","zh_hant":"提升花屬性站位為中的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3052,"_id_":1000921},"1100101":{"description":{"en":"(Passive) [Snow Front Position] Act Power Up %opt1_value% ","ja":"[永続]【雪属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [눈 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的ACT力量 +%opt1_value%"},"name":{"en":"Snow Front Position Act Power Up","ja":"雪属性立ち位置前のACTパワーアップ","ko":"눈 속성 앞 포지션의 ACT 파워 증가","zh_hant":"提升雪屬性站位為前的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3061,"_id_":1100101},"1100102":{"description":{"en":"(Passive) [Snow Front Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為前】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Flower Dmg Received Down","ja":"雪属性立ち位置前の花属性被ダメージダウン","ko":"눈 속성 앞 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕雪屬性站位為前受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3061,"_id_":1100102},"1100103":{"description":{"en":"(Passive) [Snow Front Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為前】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Wind Dmg Received Down","ja":"雪属性立ち位置前の風属性被ダメージダウン","ko":"눈 속성 앞 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕雪屬性站位為前受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3061,"_id_":1100103},"1100104":{"description":{"en":"(Passive) [Snow Front Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Snow Dmg Received Down","ja":"雪属性立ち位置前の雪属性被ダメージダウン","ko":"눈 속성 앞 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕雪屬性站位為前受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3061,"_id_":1100104},"1100105":{"description":{"en":"(Passive) [Snow Front Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為前】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Moon Dmg Received Down","ja":"雪属性立ち位置前の月属性被ダメージダウン","ko":"눈 속성 앞 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕雪屬性站位為前受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3061,"_id_":1100105},"1100106":{"description":{"en":"(Passive) [Snow Front Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Space Dmg Received Down","ja":"雪属性立ち位置前の宙属性被ダメージダウン","ko":"눈 속성 앞 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕雪屬性站位為前受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3061,"_id_":1100106},"1100107":{"description":{"en":"(Passive) [Snow Front Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Cloud Dmg Received Down","ja":"雪属性立ち位置前の雲属性被ダメージダウン","ko":"눈 속성 앞 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕雪屬性站位為前受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3061,"_id_":1100107},"1100108":{"description":{"en":"(Passive) [Snow Front Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dream Dmg Received Down","ja":"雪属性立ち位置前の夢属性被ダメージダウン","ko":"눈 속성 앞 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕雪屬性站位為前受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3061,"_id_":1100108},"1100109":{"description":{"en":"(Passive) [Snow Front Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dmg to Flower Up","ja":"雪属性立ち位置前の花属性特効与ダメージアップ","ko":"눈 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為前的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3061,"_id_":1100109},"1100110":{"description":{"en":"(Passive) [Snow Front Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dmg to Wind Up","ja":"雪属性立ち位置前の風属性特効与ダメージアップ","ko":"눈 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為前的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3061,"_id_":1100110},"1100111":{"description":{"en":"(Passive) [Snow Front Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dmg to Snow Up","ja":"雪属性立ち位置前の雪属性特効与ダメージアップ","ko":"눈 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為前的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3061,"_id_":1100111},"1100112":{"description":{"en":"(Passive) [Snow Front Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dmg to Moon Up","ja":"雪属性立ち位置前の月属性特効与ダメージアップ","ko":"눈 속성 앞 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為前的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3061,"_id_":1100112},"1100113":{"description":{"en":"(Passive) [Snow Front Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dmg to Space Up","ja":"雪属性立ち位置前の宙属性特効与ダメージアップ","ko":"눈 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為前的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3061,"_id_":1100113},"1100114":{"description":{"en":"(Passive) [Snow Front Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dmg to Cloud Up","ja":"雪属性立ち位置前の雲属性特効与ダメージアップ","ko":"눈 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為前的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3061,"_id_":1100114},"1100115":{"description":{"en":"(Passive) [Snow Front Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Front Position Dmg to Dream Up","ja":"雪属性立ち位置前の夢属性特効与ダメージアップ","ko":"눈 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為前的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3061,"_id_":1100115},"1100116":{"description":{"en":"(Passive) [Snow Front Position] Normal Defense Up %opt1_value% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [눈 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的普通防禦力 +%opt1_value%"},"name":{"en":"Snow Front Position Normal Defense Up","ja":"雪属性立ち位置前の通常防御力アップ","ko":"눈 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升雪屬性站位為前的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3061,"_id_":1100116},"1100117":{"description":{"en":"(Passive) [Snow Front Position] Special Defense Up %opt1_value% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [눈 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的特殊防禦力 +%opt1_value%"},"name":{"en":"Snow Front Position Special Defense Up","ja":"雪属性立ち位置前の特殊防御力アップ","ko":"눈 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升雪屬性站位為前的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3061,"_id_":1100117},"1100118":{"description":{"en":"(Passive) [Snow Front Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的普通防禦力 +%opt1_value%%"},"name":{"en":"Snow Front Position Normal Defense Up","ja":"雪属性立ち位置前の通常防御力アップ","ko":"눈 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升雪屬性站位為前的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3061,"_id_":1100118},"1100119":{"description":{"en":"(Passive) [Snow Front Position] Special Defense Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Snow Front Position Special Defense Up","ja":"雪属性立ち位置前の特殊防御力アップ","ko":"눈 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升雪屬性站位為前的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3061,"_id_":1100119},"1100120":{"description":{"en":"(Passive) [Snow Front Position] Dexterity Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的會心率 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dexterity Up","ja":"雪属性立ち位置前のクリティカル率アップ","ko":"눈 속성 앞 포지션의 크리티컬 확률 증가","zh_hant":"提升雪屬性站位為前的會心率"},"skill_option1_id":20,"skill_option1_target_id":3061,"_id_":1100120},"1100121":{"description":{"en":"(Passive) [Snow Front Position] Critical Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [눈 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為前】的會心威力 +%opt1_value%%"},"name":{"en":"Cloud Front Position Critical Up","ja":"雪属性立ち位置前のクリティカル威力アップ","ko":"눈 속성 앞 포지션의 크리티컬 위력 증가","zh_hant":"提升雪屬性站位為前的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3061,"_id_":1100121},"1100122":{"description":{"en":"(Passive) [Hikari & Junna] Act Power Up %opt1_value% ","ja":"[永続]【ひかりと純那】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [히카리와 준나]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【光和純那】的ACT力量 +%opt1_value%"},"name":{"en":"Hikari & Junna Act Power Up","ja":"ひかりと純那のACTパワーアップ","ko":"히카리와 준나의 ACT 파워 증가","zh_hant":"提升光和純那的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3111,"_id_":1100122},"1100123":{"description":{"en":"(Passive) [Hikari & Junna] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 준나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和純那】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Flower Dmg Received Down","ja":"ひかりと純那の花属性被ダメージダウン","ko":"히카리와 준나가 받는 꽃 속성 대미지 감소","zh_hant":"減輕光和純那受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3111,"_id_":1100123},"1100124":{"description":{"en":"(Passive) [Hikari & Junna] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 준나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和純那】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Wind Dmg Received Down","ja":"ひかりと純那の風属性被ダメージダウン","ko":"히카리와 준나가 받는 바람 속성 대미지 감소","zh_hant":"減輕光和純那受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3111,"_id_":1100124},"1100125":{"description":{"en":"(Passive) [Hikari & Junna] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 준나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和純那】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Snow Dmg Received Down","ja":"ひかりと純那の雪属性被ダメージダウン","ko":"히카리와 준나가 받는 눈 속성 대미지 감소","zh_hant":"減輕光和純那受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3111,"_id_":1100125},"1100126":{"description":{"en":"(Passive) [Hikari & Junna] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 준나]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和純那】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Moon Dmg Received Down","ja":"ひかりと純那の月属性被ダメージダウン","ko":"히카리와 준나가 받는 달 속성 대미지 감소","zh_hant":"減輕光和純那受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3111,"_id_":1100126},"1100127":{"description":{"en":"(Passive) [Hikari & Junna] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 준나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和純那】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Space Dmg Received Down","ja":"ひかりと純那の宙属性被ダメージダウン","ko":"히카리와 준나가 받는 우주 속성 대미지 감소","zh_hant":"減輕光和純那受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3111,"_id_":1100127},"1100128":{"description":{"en":"(Passive) [Hikari & Junna] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 준나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和純那】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Cloud Dmg Received Down","ja":"ひかりと純那の雲属性被ダメージダウン","ko":"히카리와 준나가 받는 구름 속성 대미지 감소","zh_hant":"減輕光和純那受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3111,"_id_":1100128},"1100129":{"description":{"en":"(Passive) [Hikari & Junna] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 준나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和純那】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dream Dmg Received Down","ja":"ひかりと純那の夢属性被ダメージダウン","ko":"히카리와 준나가 받는 꿈 속성 대미지 감소","zh_hant":"減輕光和純那受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3111,"_id_":1100129},"1100130":{"description":{"en":"(Passive) [Hikari & Junna] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 준나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dmg to Flower Up","ja":"ひかりと純那の花属性特効与ダメージアップ","ko":"히카리와 준나가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升光和純那的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3111,"_id_":1100130},"1100131":{"description":{"en":"(Passive) [Hikari & Junna] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 준나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dmg to Wind Up","ja":"ひかりと純那の風属性特効与ダメージアップ","ko":"히카리와 준나가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升光和純那的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3111,"_id_":1100131},"1100132":{"description":{"en":"(Passive) [Hikari & Junna] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 준나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dmg to Snow Up","ja":"ひかりと純那の雪属性特効与ダメージアップ","ko":"히카리와 준나가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升光和純那的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3111,"_id_":1100132},"1100133":{"description":{"en":"(Passive) [Hikari & Junna] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 준나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dmg to Moon Up","ja":"ひかりと純那の月属性特効与ダメージアップ","ko":"히카리와 준나가 달 속성에게 가하는 대미지 증가","zh_hant":"提升光和純那的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3111,"_id_":1100133},"1100134":{"description":{"en":"(Passive) [Hikari & Junna] Dmg to Space Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 준나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dmg to Space Up","ja":"ひかりと純那の宙属性特効与ダメージアップ","ko":"히카리와 준나가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升光和純那的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3111,"_id_":1100134},"1100135":{"description":{"en":"(Passive) [Hikari & Junna] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 준나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dmg to Cloud Up","ja":"ひかりと純那の雲属性特効与ダメージアップ","ko":"히카리와 준나가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升光和純那的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3111,"_id_":1100135},"1100136":{"description":{"en":"(Passive) [Hikari & Junna] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 준나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dmg to Dream Up","ja":"ひかりと純那の夢属性特効与ダメージアップ","ko":"히카리와 준나가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升光和純那的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3111,"_id_":1100136},"1100137":{"description":{"en":"(Passive) [Hikari & Junna] Normal Defense Up %opt1_value% ","ja":"[永続]【ひかりと純那】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [히카리와 준나]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【光和純那】的普通防禦力 +%opt1_value%"},"name":{"en":"Hikari & Junna Normal Defense Up","ja":"ひかりと純那の通常防御力アップ","ko":"히카리와 준나의 일반 방어력 증가","zh_hant":"提升光和純那的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3111,"_id_":1100137},"1100138":{"description":{"en":"(Passive) [Hikari & Junna] Special Defense Up %opt1_value% ","ja":"[永続]【ひかりと純那】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [히카리와 준나]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【光和純那】的特殊防禦力 +%opt1_value%"},"name":{"en":"Hikari & Junna Special Defense Up","ja":"ひかりと純那の特殊防御力アップ","ko":"히카리와 준나의 특수 방어력 증가","zh_hant":"提升光和純那的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3111,"_id_":1100138},"1100139":{"description":{"en":"(Passive) [Hikari & Junna] Normal Defense Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [히카리와 준나]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的普通防禦力 +%opt1_value%%"},"name":{"en":"Hikari & Junna Normal Defense Up","ja":"ひかりと純那の通常防御力アップ","ko":"히카리와 준나의 일반 방어력 증가","zh_hant":"提升光和純那的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3111,"_id_":1100139},"1100140":{"description":{"en":"(Passive) [Hikari & Junna] Special Defense Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [히카리와 준나]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Hikari & Junna Special Defense Up","ja":"ひかりと純那の特殊防御力アップ","ko":"히카리와 준나의 특수 방어력 증가","zh_hant":"提升光和純那的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3111,"_id_":1100140},"1100141":{"description":{"en":"(Passive) [Hikari & Junna] Dexterity Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [히카리와 준나]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的會心率 +%opt1_value%%"},"name":{"en":"Hikari & Junna Dexterity Up","ja":"ひかりと純那のクリティカル率アップ","ko":"히카리와 준나의 크리티컬 확률 증가","zh_hant":"提升光和純那的會心率"},"skill_option1_id":20,"skill_option1_target_id":3111,"_id_":1100141},"1100142":{"description":{"en":"(Passive) [Hikari & Junna] Critical Up %opt1_value%% ","ja":"[永続]【ひかりと純那】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [히카리와 준나]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【光和純那】的會心威力 +%opt1_value%%"},"name":{"en":"Hikari & Junna Critical Up","ja":"ひかりと純那のクリティカル威力アップ","ko":"히카리와 준나의 크리티컬 위력 증가","zh_hant":"提升光和純那的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3111,"_id_":1100142},"1100201":{"description":{"en":"(Passive) [Wind Front Position] Act Power Up %opt1_value% ","ja":"[永続]【風属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [바람 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的ACT力量 +%opt1_value%"},"name":{"en":"Wind Front Position Act Power Up","ja":"風属性立ち位置前のACTパワーアップ","ko":"바람 속성 앞 포지션의 ACT 파워 증가","zh_hant":"提升風屬性站位為前的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3071,"_id_":1100201},"1100202":{"description":{"en":"(Passive) [Wind Front Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為前】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Flower Dmg Received Down","ja":"風属性立ち位置前の花属性被ダメージダウン","ko":"바람 속성 앞 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕風屬性站位為前受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3071,"_id_":1100202},"1100203":{"description":{"en":"(Passive) [Wind Front Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為前】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Wind Dmg Received Down","ja":"風属性立ち位置前の風属性被ダメージダウン","ko":"바람 속성 앞 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕風屬性站位為前受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3071,"_id_":1100203},"1100204":{"description":{"en":"(Passive) [Wind Front Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Snow Dmg Received Down","ja":"風属性立ち位置前の雪属性被ダメージダウン","ko":"바람 속성 앞 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕風屬性站位為前受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3071,"_id_":1100204},"1100205":{"description":{"en":"(Passive) [Wind Front Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為前】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Moon Dmg Received Down","ja":"風属性立ち位置前の月属性被ダメージダウン","ko":"바람 속성 앞 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕風屬性站位為前受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3071,"_id_":1100205},"1100206":{"description":{"en":"(Passive) [Wind Front Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Space Dmg Received Down","ja":"風属性立ち位置前の宙属性被ダメージダウン","ko":"바람 속성 앞 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕風屬性站位為前受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3071,"_id_":1100206},"1100207":{"description":{"en":"(Passive) [Wind Front Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Cloud Dmg Received Down","ja":"風属性立ち位置前の雲属性被ダメージダウン","ko":"바람 속성 앞 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕風屬性站位為前受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3071,"_id_":1100207},"1100208":{"description":{"en":"(Passive) [Wind Front Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【風屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dream Dmg Received Down","ja":"風属性立ち位置前の夢属性被ダメージダウン","ko":"바람 속성 앞 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕風屬性站位為前受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3071,"_id_":1100208},"1100209":{"description":{"en":"(Passive) [Wind Front Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dmg to Flower Up","ja":"風属性立ち位置前の花属性特効与ダメージアップ","ko":"바람 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為前的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3071,"_id_":1100209},"1100210":{"description":{"en":"(Passive) [Wind Front Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dmg to Wind Up","ja":"風属性立ち位置前の風属性特効与ダメージアップ","ko":"바람 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為前的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3071,"_id_":1100210},"1100211":{"description":{"en":"(Passive) [Wind Front Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dmg to Snow Up","ja":"風属性立ち位置前の雪属性特効与ダメージアップ","ko":"바람 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為前的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3071,"_id_":1100211},"1100212":{"description":{"en":"(Passive) [Wind Front Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dmg to Moon Up","ja":"風属性立ち位置前の月属性特効与ダメージアップ","ko":"바람 속성 앞 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為前的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3071,"_id_":1100212},"1100213":{"description":{"en":"(Passive) [Wind Front Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dmg to Space Up","ja":"風属性立ち位置前の宙属性特効与ダメージアップ","ko":"바람 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為前的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3071,"_id_":1100213},"1100214":{"description":{"en":"(Passive) [Wind Front Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dmg to Cloud Up","ja":"風属性立ち位置前の雲属性特効与ダメージアップ","ko":"바람 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為前的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3071,"_id_":1100214},"1100215":{"description":{"en":"(Passive) [Wind Front Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Wind Front Position Dmg to Dream Up","ja":"風属性立ち位置前の夢属性特効与ダメージアップ","ko":"바람 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升風屬性站位為前的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3071,"_id_":1100215},"1100216":{"description":{"en":"(Passive) [Wind Front Position] Normal Defense Up %opt1_value% ","ja":"[永続]【風属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [바람 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的普通防禦力 +%opt1_value%"},"name":{"en":"Wind Front Position Normal Defense Up","ja":"風属性立ち位置前の通常防御力アップ","ko":"바람 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升風屬性站位為前的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3071,"_id_":1100216},"1100217":{"description":{"en":"(Passive) [Wind Front Position] Special Defense Up %opt1_value% ","ja":"[永続]【風属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [바람 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的特殊防禦力 +%opt1_value%"},"name":{"en":"Wind Front Position Special Defense Up","ja":"風属性立ち位置前の特殊防御力アップ","ko":"바람 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升風屬性站位為前的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3071,"_id_":1100217},"1100218":{"description":{"en":"(Passive) [Wind Front Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的普通防禦力 +%opt1_value%%"},"name":{"en":"Wind Front Position Normal Defense Up","ja":"風属性立ち位置前の通常防御力アップ","ko":"바람 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升風屬性站位為前的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3071,"_id_":1100218},"1100219":{"description":{"en":"(Passive) [Wind Front Position] Special Defense Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Wind Front Position Special Defense Up","ja":"風属性立ち位置前の特殊防御力アップ","ko":"바람 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升風屬性站位為前的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3071,"_id_":1100219},"1100220":{"description":{"en":"(Passive) [Wind Front Position] Dexterity Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的會心率 +%opt1_value%%"},"name":{"en":"Wind Front Position Dexterity Up","ja":"風属性立ち位置前のクリティカル率アップ","ko":"바람 속성 앞 포지션의 크리티컬 확률 증가","zh_hant":"提升風屬性站位為前的會心率"},"skill_option1_id":20,"skill_option1_target_id":3071,"_id_":1100220},"1100221":{"description":{"en":"(Passive) [Wind Front Position] Critical Up %opt1_value%% ","ja":"[永続]【風属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [바람 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【風屬性且站位為前】的會心威力 +%opt1_value%%"},"name":{"en":"Wind Rear Position Critical Up","ja":"風属性立ち位置前のクリティカル威力アップ","ko":"바람 속성 앞 포지션의 크리티컬 위력 증가","zh_hant":"提升風屬性站位為前的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3071,"_id_":1100221},"1100222":{"description":{"en":"(Passive) [Karen & Junna] Act Power Up %opt1_value% ","ja":"[永続]【華恋と純那】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌과 준나]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和純那】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Junna Act Power Up","ja":"華恋と純那のACTパワーアップ","ko":"카렌과 준나의 ACT 파워 증가","zh_hant":"提升華戀和純那的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3112,"_id_":1100222},"1100223":{"description":{"en":"(Passive) [Karen & Junna] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 준나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和純那】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Flower Dmg Received Down","ja":"華恋と純那の花属性被ダメージダウン","ko":"카렌과 준나가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀和純那受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3112,"_id_":1100223},"1100224":{"description":{"en":"(Passive) [Karen & Junna] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 준나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和純那】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Wind Dmg Received Down","ja":"華恋と純那の風属性被ダメージダウン","ko":"카렌과 준나가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀和純那受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3112,"_id_":1100224},"1100225":{"description":{"en":"(Passive) [Karen & Junna] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 준나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和純那】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Snow Dmg Received Down","ja":"華恋と純那の雪属性被ダメージダウン","ko":"카렌과 준나가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀和純那受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3112,"_id_":1100225},"1100226":{"description":{"en":"(Passive) [Karen & Junna] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 준나]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和純那】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Moon Dmg Received Down","ja":"華恋と純那の月属性被ダメージダウン","ko":"카렌과 준나가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀和純那受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3112,"_id_":1100226},"1100227":{"description":{"en":"(Passive) [Karen & Junna] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 준나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和純那】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Space Dmg Received Down","ja":"華恋と純那の宙属性被ダメージダウン","ko":"카렌과 준나가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀和純那受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3112,"_id_":1100227},"1100228":{"description":{"en":"(Passive) [Karen & Junna] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 준나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和純那】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Cloud Dmg Received Down","ja":"華恋と純那の雲属性被ダメージダウン","ko":"카렌과 준나가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀和純那受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3112,"_id_":1100228},"1100229":{"description":{"en":"(Passive) [Karen & Junna] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 준나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和純那】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dream Dmg Received Down","ja":"華恋と純那の夢属性被ダメージダウン","ko":"카렌과 준나가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀和純那受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3112,"_id_":1100229},"1100230":{"description":{"en":"(Passive) [Karen & Junna] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 준나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dmg to Flower Up","ja":"華恋と純那の花属性特効与ダメージアップ","ko":"카렌과 준나가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和純那的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3112,"_id_":1100230},"1100231":{"description":{"en":"(Passive) [Karen & Junna] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 준나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dmg to Wind Up","ja":"華恋と純那の風属性特効与ダメージアップ","ko":"카렌과 준나가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和純那的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3112,"_id_":1100231},"1100232":{"description":{"en":"(Passive) [Karen & Junna] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 준나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dmg to Snow Up","ja":"華恋と純那の雪属性特効与ダメージアップ","ko":"카렌과 준나가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和純那的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3112,"_id_":1100232},"1100233":{"description":{"en":"(Passive) [Karen & Junna] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 준나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dmg to Moon Up","ja":"華恋と純那の月属性特効与ダメージアップ","ko":"카렌과 준나가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和純那的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3112,"_id_":1100233},"1100234":{"description":{"en":"(Passive) [Karen & Junna] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 준나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dmg to Space Up","ja":"華恋と純那の宙属性特効与ダメージアップ","ko":"카렌과 준나가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和純那的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3112,"_id_":1100234},"1100235":{"description":{"en":"(Passive) [Karen & Junna] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 준나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dmg to Cloud Up","ja":"華恋と純那の雲属性特効与ダメージアップ","ko":"카렌과 준나가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和純那的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3112,"_id_":1100235},"1100236":{"description":{"en":"(Passive) [Karen & Junna] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 준나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Junna Dmg to Dream Up","ja":"華恋と純那の夢属性特効与ダメージアップ","ko":"카렌과 준나가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和純那的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3112,"_id_":1100236},"1100237":{"description":{"en":"(Passive) [Karen & Junna] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋と純那】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌과 준나]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和純那】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Junna Normal Defense Up","ja":"華恋と純那の通常防御力アップ","ko":"카렌과 준나의 일반 방어력 증가","zh_hant":"提升華戀和純那的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3112,"_id_":1100237},"1100238":{"description":{"en":"(Passive) [Karen & Junna] Special Defense Up %opt1_value% ","ja":"[永続]【華恋と純那】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌과 준나]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和純那】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Junna Special Defense Up","ja":"華恋と純那の特殊防御力アップ","ko":"카렌과 준나의 특수 방어력 증가","zh_hant":"提升華戀和純那的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3112,"_id_":1100238},"1100239":{"description":{"en":"(Passive) [Karen & Junna] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 준나]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Junna Normal Defense Up","ja":"華恋と純那の通常防御力アップ","ko":"카렌과 준나의 일반 방어력 증가","zh_hant":"提升華戀和純那的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3112,"_id_":1100239},"1100240":{"description":{"en":"(Passive) [Karen & Junna] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 준나]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Junna Special Defense Up","ja":"華恋と純那の特殊防御力アップ","ko":"카렌과 준나의 특수 방어력 증가","zh_hant":"提升華戀和純那的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3112,"_id_":1100240},"1100241":{"description":{"en":"(Passive) [Karen & Junna] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌과 준나]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Junna Dexterity Up","ja":"華恋と純那のクリティカル率アップ","ko":"카렌과 준나의 크리티컬 확률 증가","zh_hant":"提升華戀和純那的會心率"},"skill_option1_id":20,"skill_option1_target_id":3112,"_id_":1100241},"1100242":{"description":{"en":"(Passive) [Karen & Junna] Critical Up %opt1_value%% ","ja":"[永続]【華恋と純那】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌과 준나]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和純那】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Junna Critical Up","ja":"華恋と純那のクリティカル威力アップ","ko":"카렌과 준나의 크리티컬 위력 증가","zh_hant":"提升華戀和純那的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3112,"_id_":1100242},"1100301":{"description":{"en":"(Passive) [Moon Front Position] Act Power Up %opt1_value% ","ja":"[永続]【月属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [달 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的ACT力量 +%opt1_value%"},"name":{"en":"Moon Front Position Act Power Up","ja":"月属性立ち位置前のACTパワーアップ","ko":"달 속성 앞 포지션의 ACT 파워 증가","zh_hant":"提升月屬性站位為前的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3041,"_id_":1100301},"1100302":{"description":{"en":"(Passive) [Moon Front Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為前】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Flower Dmg Received Down","ja":"月属性立ち位置前の花属性被ダメージダウン","ko":"달 속성 앞 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕月屬性站位為前受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3041,"_id_":1100302},"1100303":{"description":{"en":"(Passive) [Moon Front Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為前】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Wind Dmg Received Down","ja":"月属性立ち位置前の風属性被ダメージダウン","ko":"달 속성 앞 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕月屬性站位為前受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3041,"_id_":1100303},"1100304":{"description":{"en":"(Passive) [Moon Front Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Snow Dmg Received Down","ja":"月属性立ち位置前の雪属性被ダメージダウン","ko":"달 속성 앞 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕月屬性站位為前受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3041,"_id_":1100304},"1100305":{"description":{"en":"(Passive) [Moon Front Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為前】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Moon Dmg Received Down","ja":"月属性立ち位置前の月属性被ダメージダウン","ko":"달 속성 앞 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕月屬性站位為前受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3041,"_id_":1100305},"1100306":{"description":{"en":"(Passive) [Moon Front Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Space Dmg Received Down","ja":"月属性立ち位置前の宙属性被ダメージダウン","ko":"달 속성 앞 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕月屬性站位為前受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3041,"_id_":1100306},"1100307":{"description":{"en":"(Passive) [Moon Front Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Cloud Dmg Received Down","ja":"月属性立ち位置前の雲属性被ダメージダウン","ko":"달 속성 앞 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕月屬性站位為前受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3041,"_id_":1100307},"1100308":{"description":{"en":"(Passive) [Moon Front Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【月屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dream Dmg Received Down","ja":"月属性立ち位置前の夢属性被ダメージダウン","ko":"달 속성 앞 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕月屬性站位為前受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3041,"_id_":1100308},"1100309":{"description":{"en":"(Passive) [Moon Front Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dmg to Flower Up","ja":"月属性立ち位置前の花属性特効与ダメージアップ","ko":"달 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為前的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3041,"_id_":1100309},"1100310":{"description":{"en":"(Passive) [Moon Front Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dmg to Wind Up","ja":"月属性立ち位置前の風属性特効与ダメージアップ","ko":"달 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為前的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3041,"_id_":1100310},"1100311":{"description":{"en":"(Passive) [Moon Front Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dmg to Snow Up","ja":"月属性立ち位置前の雪属性特効与ダメージアップ","ko":"달 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為前的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3041,"_id_":1100311},"1100312":{"description":{"en":"(Passive) [Moon Front Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dmg to Moon Up","ja":"月属性立ち位置前の月属性特効与ダメージアップ","ko":"달 속성 앞 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為前的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3041,"_id_":1100312},"1100313":{"description":{"en":"(Passive) [Moon Front Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dmg to Space Up","ja":"月属性立ち位置前の宙属性特効与ダメージアップ","ko":"달 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為前的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3041,"_id_":1100313},"1100314":{"description":{"en":"(Passive) [Moon Front Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dmg to Cloud Up","ja":"月属性立ち位置前の雲属性特効与ダメージアップ","ko":"달 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為前的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3041,"_id_":1100314},"1100315":{"description":{"en":"(Passive) [Moon Front Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Moon Front Position Dmg to Dream Up","ja":"月属性立ち位置前の夢属性特効与ダメージアップ","ko":"달 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升月屬性站位為前的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3041,"_id_":1100315},"1100316":{"description":{"en":"(Passive) [Moon Front Position] Normal Defense Up %opt1_value% ","ja":"[永続]【月属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [달 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的普通防禦力 +%opt1_value%"},"name":{"en":"Moon Front Position Normal Defense Up","ja":"月属性立ち位置前の通常防御力アップ","ko":"달 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升月屬性站位為前的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3041,"_id_":1100316},"1100317":{"description":{"en":"(Passive) [Moon Front Position] Special Defense Up %opt1_value% ","ja":"[永続]【月属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [달 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的特殊防禦力 +%opt1_value%"},"name":{"en":"Moon Front Position Special Defense Up","ja":"月属性立ち位置前の特殊防御力アップ","ko":"달 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升月屬性站位為前的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3041,"_id_":1100317},"1100318":{"description":{"en":"(Passive) [Moon Front Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的普通防禦力 +%opt1_value%%"},"name":{"en":"Moon Front Position Normal Defense Up","ja":"月属性立ち位置前の通常防御力アップ","ko":"달 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升月屬性站位為前的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3041,"_id_":1100318},"1100319":{"description":{"en":"(Passive) [Moon Front Position] Special Defense Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Moon Front Position Special Defense Up","ja":"月属性立ち位置前の特殊防御力アップ","ko":"달 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升月屬性站位為前的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3041,"_id_":1100319},"1100320":{"description":{"en":"(Passive) [Moon Front Position] Dexterity Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的會心率 +%opt1_value%%"},"name":{"en":"Moon Front Position Dexterity Up","ja":"月属性立ち位置前のクリティカル率アップ","ko":"달 속성 앞 포지션의 크리티컬 확률 증가","zh_hant":"提升月屬性站位為前的會心率"},"skill_option1_id":20,"skill_option1_target_id":3041,"_id_":1100320},"1100321":{"description":{"en":"(Passive) [Moon Front Position] Critical Up %opt1_value%% ","ja":"[永続]【月属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [달 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【月屬性且站位為前】的會心威力 +%opt1_value%%"},"name":{"en":"Moon Front Position Critical Up","ja":"月属性立ち位置前のクリティカル威力アップ","ko":"달 속성 앞 포지션의 크리티컬 위력 증가","zh_hant":"提升月屬性站位為前的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3041,"_id_":1100321},"1100322":{"description":{"en":"(Passive) [Karen & Maya] Act Power Up %opt1_value% ","ja":"[永続]【華恋と真矢】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌과 마야]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和真矢】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Maya Act Power Up","ja":"華恋と真矢のACTパワーアップ","ko":"카렌과 마야의 ACT 파워 증가","zh_hant":"提升華戀和真矢的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3113,"_id_":1100322},"1100323":{"description":{"en":"(Passive) [Karen & Maya] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마야]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真矢】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Flower Dmg Received Down","ja":"華恋と真矢の花属性被ダメージダウン","ko":"카렌과 마야가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀和真矢受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3113,"_id_":1100323},"1100324":{"description":{"en":"(Passive) [Karen & Maya] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마야]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真矢】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Wind Dmg Received Down","ja":"華恋と真矢の風属性被ダメージダウン","ko":"카렌과 마야가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀和真矢受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3113,"_id_":1100324},"1100325":{"description":{"en":"(Passive) [Karen & Maya] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마야]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真矢】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Snow Dmg Received Down","ja":"華恋と真矢の雪属性被ダメージダウン","ko":"카렌과 마야가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀和真矢受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3113,"_id_":1100325},"1100326":{"description":{"en":"(Passive) [Karen & Maya] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마야]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真矢】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Moon Dmg Received Down","ja":"華恋と真矢の月属性被ダメージダウン","ko":"카렌과 마야가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀和真矢受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3113,"_id_":1100326},"1100327":{"description":{"en":"(Passive) [Karen & Maya] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마야]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真矢】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Space Dmg Received Down","ja":"華恋と真矢の宙属性被ダメージダウン","ko":"카렌과 마야가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀和真矢受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3113,"_id_":1100327},"1100328":{"description":{"en":"(Passive) [Karen & Maya] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마야]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真矢】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Cloud Dmg Received Down","ja":"華恋と真矢の雲属性被ダメージダウン","ko":"카렌과 마야가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀和真矢受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3113,"_id_":1100328},"1100329":{"description":{"en":"(Passive) [Karen & Maya] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마야]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真矢】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dream Dmg Received Down","ja":"華恋と真矢の夢属性被ダメージダウン","ko":"카렌과 마야가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀和真矢受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3113,"_id_":1100329},"1100330":{"description":{"en":"(Passive) [Karen & Maya] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마야]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dmg to Flower Up","ja":"華恋と真矢の花属性特効与ダメージアップ","ko":"카렌과 마야가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真矢的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3113,"_id_":1100330},"1100331":{"description":{"en":"(Passive) [Karen & Maya] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마야]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dmg to Wind Up","ja":"華恋と真矢の風属性特効与ダメージアップ","ko":"카렌과 마야가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真矢的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3113,"_id_":1100331},"1100332":{"description":{"en":"(Passive) [Karen & Maya] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마야]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dmg to Snow Up","ja":"華恋と真矢の雪属性特効与ダメージアップ","ko":"카렌과 마야가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真矢的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3113,"_id_":1100332},"1100333":{"description":{"en":"(Passive) [Karen & Maya] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마야]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dmg to Moon Up","ja":"華恋と真矢の月属性特効与ダメージアップ","ko":"카렌과 마야가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真矢的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3113,"_id_":1100333},"1100334":{"description":{"en":"(Passive) [Karen & Maya] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마야]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dmg to Space Up","ja":"華恋と真矢の宙属性特効与ダメージアップ","ko":"카렌과 마야가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真矢的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3113,"_id_":1100334},"1100335":{"description":{"en":"(Passive) [Karen & Maya] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마야]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dmg to Cloud Up","ja":"華恋と真矢の雲属性特効与ダメージアップ","ko":"카렌과 마야가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真矢的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3113,"_id_":1100335},"1100336":{"description":{"en":"(Passive) [Karen & Maya] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마야]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya Dmg to Dream Up","ja":"華恋と真矢の夢属性特効与ダメージアップ","ko":"카렌과 마야가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真矢的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3113,"_id_":1100336},"1100337":{"description":{"en":"(Passive) [Karen & Maya] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋と真矢】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌과 마야]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和真矢】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Maya Normal Defense Up","ja":"華恋と真矢の通常防御力アップ","ko":"카렌과 마야의 일반 방어력 증가","zh_hant":"提升華戀和真矢的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3113,"_id_":1100337},"1100338":{"description":{"en":"(Passive) [Karen & Maya] Special Defense Up %opt1_value% ","ja":"[永続]【華恋と真矢】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌과 마야]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和真矢】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Maya Special Defense Up","ja":"華恋と真矢の特殊防御力アップ","ko":"카렌과 마야의 특수 방어력 증가","zh_hant":"提升華戀和真矢的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3113,"_id_":1100338},"1100339":{"description":{"en":"(Passive) [Karen & Maya] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 마야]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Maya Normal Defense Up","ja":"華恋と真矢の通常防御力アップ","ko":"카렌과 마야의 일반 방어력 증가","zh_hant":"提升華戀和真矢的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3113,"_id_":1100339},"1100340":{"description":{"en":"(Passive) [Karen & Maya] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 마야]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Maya Special Defense Up","ja":"華恋と真矢の特殊防御力アップ","ko":"카렌과 마야의 특수 방어력 증가","zh_hant":"提升華戀和真矢的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3113,"_id_":1100340},"1100341":{"description":{"en":"(Passive) [Karen & Maya] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌과 마야]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Maya Dexterity Up","ja":"華恋と真矢のクリティカル率アップ","ko":"카렌과 마야의 크리티컬 확률 증가","zh_hant":"提升華戀和真矢的會心率"},"skill_option1_id":20,"skill_option1_target_id":3113,"_id_":1100341},"1100342":{"description":{"en":"(Passive) [Karen & Maya] Critical Up %opt1_value%% ","ja":"[永続]【華恋と真矢】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌과 마야]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真矢】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Maya Critical Up","ja":"華恋と真矢のクリティカル威力アップ","ko":"카렌과 마야의 크리티컬 위력 증가","zh_hant":"提升華戀和真矢的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3113,"_id_":1100342},"1100401":{"description":{"en":"(Passive) [Cloud Front Position] Act Power Up %opt1_value% ","ja":"[永続]【雲属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [구름 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的ACT力量 +%opt1_value%"},"name":{"en":"Cloud Front Position Act Power Up","ja":"雲属性立ち位置前のACTパワーアップ","ko":"구름 속성 앞 포지션의 ACT 파워 증가","zh_hant":"提升雲屬性站位為前的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3091,"_id_":1100401},"1100402":{"description":{"en":"(Passive) [Cloud Front Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為前】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Flower Dmg Received Down","ja":"雲属性立ち位置前の花属性被ダメージダウン","ko":"구름 속성 앞 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕雲屬性站位為前受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3091,"_id_":1100402},"1100403":{"description":{"en":"(Passive) [Cloud Front Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為前】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Wind Dmg Received Down","ja":"雲属性立ち位置前の風属性被ダメージダウン","ko":"구름 속성 앞 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕雲屬性站位為前受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3091,"_id_":1100403},"1100404":{"description":{"en":"(Passive) [Cloud Front Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Snow Dmg Received Down","ja":"雲属性立ち位置前の雪属性被ダメージダウン","ko":"구름 속성 앞 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕雲屬性站位為前受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3091,"_id_":1100404},"1100405":{"description":{"en":"(Passive) [Cloud Front Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為前】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Moon Dmg Received Down","ja":"雲属性立ち位置前の月属性被ダメージダウン","ko":"구름 속성 앞 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕雲屬性站位為前受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3091,"_id_":1100405},"1100406":{"description":{"en":"(Passive) [Cloud Front Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Space Dmg Received Down","ja":"雲属性立ち位置前の宙属性被ダメージダウン","ko":"구름 속성 앞 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕雲屬性站位為前受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3091,"_id_":1100406},"1100407":{"description":{"en":"(Passive) [Cloud Front Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Cloud Dmg Received Down","ja":"雲属性立ち位置前の雲属性被ダメージダウン","ko":"구름 속성 앞 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕雲屬性站位為前受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3091,"_id_":1100407},"1100408":{"description":{"en":"(Passive) [Cloud Front Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雲屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dream Dmg Received Down","ja":"雲属性立ち位置前の夢属性被ダメージダウン","ko":"구름 속성 앞 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕雲屬性站位為前受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3091,"_id_":1100408},"1100409":{"description":{"en":"(Passive) [Cloud Front Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dmg to Flower Up","ja":"雲属性立ち位置前の花属性特効与ダメージアップ","ko":"구름 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為前的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3091,"_id_":1100409},"1100410":{"description":{"en":"(Passive) [Cloud Front Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dmg to Wind Up","ja":"雲属性立ち位置前の風属性特効与ダメージアップ","ko":"구름 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為前的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3091,"_id_":1100410},"1100411":{"description":{"en":"(Passive) [Cloud Front Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dmg to Snow Up","ja":"雲属性立ち位置前の雪属性特効与ダメージアップ","ko":"구름 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為前的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3091,"_id_":1100411},"1100412":{"description":{"en":"(Passive) [Cloud Front Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dmg to Moon Up","ja":"雲属性立ち位置前の月属性特効与ダメージアップ","ko":"구름 속성 앞 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為前的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3091,"_id_":1100412},"1100413":{"description":{"en":"(Passive) [Cloud Front Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dmg to Space Up","ja":"雲属性立ち位置前の宙属性特効与ダメージアップ","ko":"구름 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為前的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3091,"_id_":1100413},"1100414":{"description":{"en":"(Passive) [Cloud Front Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dmg to Cloud Up","ja":"雲属性立ち位置前の雲属性特効与ダメージアップ","ko":"구름 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為前的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3091,"_id_":1100414},"1100415":{"description":{"en":"(Passive) [Cloud Front Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dmg to Dream Up","ja":"雲属性立ち位置前の夢属性特効与ダメージアップ","ko":"구름 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升雲屬性站位為前的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3091,"_id_":1100415},"1100416":{"description":{"en":"(Passive) [Cloud Front Position] Normal Defense Up %opt1_value% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [구름 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的普通防禦力 +%opt1_value%"},"name":{"en":"Cloud Front Position Normal Defense Up","ja":"雲属性立ち位置前の通常防御力アップ","ko":"구름 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升雲屬性站位為前的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3091,"_id_":1100416},"1100417":{"description":{"en":"(Passive) [Cloud Front Position] Special Defense Up %opt1_value% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [구름 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的特殊防禦力 +%opt1_value%"},"name":{"en":"Cloud Front Position Special Defense Up","ja":"雲属性立ち位置前の特殊防御力アップ","ko":"구름 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升雲屬性站位為前的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3091,"_id_":1100417},"1100418":{"description":{"en":"(Passive) [Cloud Front Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的普通防禦力 +%opt1_value%%"},"name":{"en":"Cloud Front Position Normal Defense Up","ja":"雲属性立ち位置前の通常防御力アップ","ko":"구름 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升雲屬性站位為前的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3091,"_id_":1100418},"1100419":{"description":{"en":"(Passive) [Cloud Front Position] Special Defense Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Cloud Front Position Special Defense Up","ja":"雲属性立ち位置前の特殊防御力アップ","ko":"구름 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升雲屬性站位為前的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3091,"_id_":1100419},"1100420":{"description":{"en":"(Passive) [Cloud Front Position] Dexterity Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的會心率 +%opt1_value%%"},"name":{"en":"Cloud Front Position Dexterity Up","ja":"雲属性立ち位置前のクリティカル率アップ","ko":"구름 속성 앞 포지션의 크리티컬 확률 증가","zh_hant":"提升雲屬性站位為前的會心率"},"skill_option1_id":20,"skill_option1_target_id":3091,"_id_":1100420},"1100421":{"description":{"en":"(Passive) [Cloud Front Position] Critical Up %opt1_value%% ","ja":"[永続]【雲属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [구름 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【雲屬性且站位為前】的會心威力 +%opt1_value%%"},"name":{"en":"Cloud Front Position Critical Up","ja":"雲属性立ち位置前のクリティカル威力アップ","ko":"구름 속성 앞 포지션의 크리티컬 위력 증가","zh_hant":"提升雲屬性站位為前的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3091,"_id_":1100421},"1100422":{"description":{"en":"(Passive) [Karen & Mahiru] Act Power Up %opt1_value% ","ja":"[永続]【華恋とまひる】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌과 마히루]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和真晝】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Mahiru Act Power Up","ja":"華恋とまひるのACTパワーアップ","ko":"카렌과 마히루의 ACT 파워 증가","zh_hant":"提升華戀和真晝的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3114,"_id_":1100422},"1100423":{"description":{"en":"(Passive) [Karen & Mahiru] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真晝】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Flower Dmg Received Down","ja":"華恋とまひるの花属性被ダメージダウン","ko":"카렌과 마히루가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀和真晝受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3114,"_id_":1100423},"1100424":{"description":{"en":"(Passive) [Karen & Mahiru] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真晝】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Wind Dmg Received Down","ja":"華恋とまひるの風属性被ダメージダウン","ko":"카렌과 마히루가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀和真晝受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3114,"_id_":1100424},"1100425":{"description":{"en":"(Passive) [Karen & Mahiru] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真晝】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Snow Dmg Received Down","ja":"華恋とまひるの雪属性被ダメージダウン","ko":"카렌과 마히루가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀和真晝受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3114,"_id_":1100425},"1100426":{"description":{"en":"(Passive) [Karen & Mahiru] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真晝】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Moon Dmg Received Down","ja":"華恋とまひるの月属性被ダメージダウン","ko":"카렌과 마히루가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀和真晝受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3114,"_id_":1100426},"1100427":{"description":{"en":"(Passive) [Karen & Mahiru] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真晝】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Space Dmg Received Down","ja":"華恋とまひるの宙属性被ダメージダウン","ko":"카렌과 마히루가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀和真晝受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3114,"_id_":1100427},"1100428":{"description":{"en":"(Passive) [Karen & Mahiru] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真晝】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Cloud Dmg Received Down","ja":"華恋とまひるの雲属性被ダメージダウン","ko":"카렌과 마히루가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀和真晝受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3114,"_id_":1100428},"1100429":{"description":{"en":"(Passive) [Karen & Mahiru] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和真晝】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dream Dmg Received Down","ja":"華恋とまひるの夢属性被ダメージダウン","ko":"카렌과 마히루가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀和真晝受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3114,"_id_":1100429},"1100430":{"description":{"en":"(Passive) [Karen & Mahiru] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dmg to Flower Up","ja":"華恋とまひるの花属性特効与ダメージアップ","ko":"카렌과 마히루가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真晝的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3114,"_id_":1100430},"1100431":{"description":{"en":"(Passive) [Karen & Mahiru] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dmg to Wind Up","ja":"華恋とまひるの風属性特効与ダメージアップ","ko":"카렌과 마히루가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真晝的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3114,"_id_":1100431},"1100432":{"description":{"en":"(Passive) [Karen & Mahiru] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dmg to Snow Up","ja":"華恋とまひるの雪属性特効与ダメージアップ","ko":"카렌과 마히루가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真晝的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3114,"_id_":1100432},"1100433":{"description":{"en":"(Passive) [Karen & Mahiru] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dmg to Moon Up","ja":"華恋とまひるの月属性特効与ダメージアップ","ko":"카렌과 마히루가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真晝的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3114,"_id_":1100433},"1100434":{"description":{"en":"(Passive) [Karen & Mahiru] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dmg to Space Up","ja":"華恋とまひるの宙属性特効与ダメージアップ","ko":"카렌과 마히루가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真晝的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3114,"_id_":1100434},"1100435":{"description":{"en":"(Passive) [Karen & Mahiru] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dmg to Cloud Up","ja":"華恋とまひるの雲属性特効与ダメージアップ","ko":"카렌과 마히루가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真晝的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3114,"_id_":1100435},"1100436":{"description":{"en":"(Passive) [Karen & Mahiru] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dmg to Dream Up","ja":"華恋とまひるの夢属性特効与ダメージアップ","ko":"카렌과 마히루가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和真晝的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3114,"_id_":1100436},"1100437":{"description":{"en":"(Passive) [Karen & Mahiru] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋とまひる】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌과 마히루]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和真晝】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Mahiru Normal Defense Up","ja":"華恋とまひるの通常防御力アップ","ko":"카렌과 마히루의 일반 방어력 증가","zh_hant":"提升華戀和真晝的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3114,"_id_":1100437},"1100438":{"description":{"en":"(Passive) [Karen & Mahiru] Special Defense Up %opt1_value% ","ja":"[永続]【華恋とまひる】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌과 마히루]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和真晝】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Mahiru Special Defense Up","ja":"華恋とまひるの特殊防御力アップ","ko":"카렌과 마히루의 특수 방어력 증가","zh_hant":"提升華戀和真晝的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3114,"_id_":1100438},"1100439":{"description":{"en":"(Passive) [Karen & Mahiru] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Normal Defense Up","ja":"華恋とまひるの通常防御力アップ","ko":"카렌과 마히루의 일반 방어력 증가","zh_hant":"提升華戀和真晝的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3114,"_id_":1100439},"1100440":{"description":{"en":"(Passive) [Karen & Mahiru] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Special Defense Up","ja":"華恋とまひるの特殊防御力アップ","ko":"카렌과 마히루의 특수 방어력 증가","zh_hant":"提升華戀和真晝的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3114,"_id_":1100440},"1100441":{"description":{"en":"(Passive) [Karen & Mahiru] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Dexterity Up","ja":"華恋とまひるのクリティカル率アップ","ko":"카렌과 마히루의 크리티컬 확률 증가","zh_hant":"提升華戀和真晝的會心率"},"skill_option1_id":20,"skill_option1_target_id":3114,"_id_":1100441},"1100442":{"description":{"en":"(Passive) [Karen & Mahiru] Critical Up %opt1_value%% ","ja":"[永続]【華恋とまひる】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌과 마히루]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和真晝】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Mahiru Critical Up","ja":"華恋とまひるのクリティカル威力アップ","ko":"카렌과 마히루의 크리티컬 위력 증가","zh_hant":"提升華戀和真晝的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3114,"_id_":1100442},"1100501":{"description":{"en":"(Passive) [Space Front Position] Act Power Up %opt1_value% ","ja":"[永続]【宙属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [우주 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的ACT力量 +%opt1_value%"},"name":{"en":"Space Front Position Act Power Up","ja":"宙属性立ち位置前のACTパワーアップ","ko":"우주 속성 앞 포지션의 ACT 파워 증가","zh_hant":"提升宙屬性站位為前的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3081,"_id_":1100501},"1100502":{"description":{"en":"(Passive) [Space Front Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為前】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Flower Dmg Received Down","ja":"宙属性立ち位置前の花属性被ダメージダウン","ko":"우주 속성 앞 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕宙屬性站位為前受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3081,"_id_":1100502},"1100503":{"description":{"en":"(Passive) [Space Front Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為前】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Wind Dmg Received Down","ja":"宙属性立ち位置前の風属性被ダメージダウン","ko":"우주 속성 앞 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕宙屬性站位為前受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3081,"_id_":1100503},"1100504":{"description":{"en":"(Passive) [Space Front Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Snow Dmg Received Down","ja":"宙属性立ち位置前の雪属性被ダメージダウン","ko":"우주 속성 앞 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕宙屬性站位為前受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3081,"_id_":1100504},"1100505":{"description":{"en":"(Passive) [Space Front Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為前】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Moon Dmg Received Down","ja":"宙属性立ち位置前の月属性被ダメージダウン","ko":"우주 속성 앞 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕宙屬性站位為前受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3081,"_id_":1100505},"1100506":{"description":{"en":"(Passive) [Space Front Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Space Dmg Received Down","ja":"宙属性立ち位置前の宙属性被ダメージダウン","ko":"우주 속성 앞 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕宙屬性站位為前受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3081,"_id_":1100506},"1100507":{"description":{"en":"(Passive) [Space Front Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Cloud Dmg Received Down","ja":"宙属性立ち位置前の雲属性被ダメージダウン","ko":"우주 속성 앞 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕宙屬性站位為前受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3081,"_id_":1100507},"1100508":{"description":{"en":"(Passive) [Space Front Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【宙屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dream Dmg Received Down","ja":"宙属性立ち位置前の夢属性被ダメージダウン","ko":"우주 속성 앞 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕宙屬性站位為前受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3081,"_id_":1100508},"1100509":{"description":{"en":"(Passive) [Space Front Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dmg to Flower Up","ja":"宙属性立ち位置前の花属性特効与ダメージアップ","ko":"우주 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為前的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3081,"_id_":1100509},"1100510":{"description":{"en":"(Passive) [Space Front Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dmg to Wind Up","ja":"宙属性立ち位置前の風属性特効与ダメージアップ","ko":"우주 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為前的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3081,"_id_":1100510},"1100511":{"description":{"en":"(Passive) [Space Front Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dmg to Snow Up","ja":"宙属性立ち位置前の雪属性特効与ダメージアップ","ko":"우주 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為前的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3081,"_id_":1100511},"1100512":{"description":{"en":"(Passive) [Space Front Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dmg to Moon Up","ja":"宙属性立ち位置前の月属性特効与ダメージアップ","ko":"우주 속성 앞 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為前的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3081,"_id_":1100512},"1100513":{"description":{"en":"(Passive) [Space Front Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dmg to Space Up","ja":"宙属性立ち位置前の宙属性特効与ダメージアップ","ko":"우주 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為前的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3081,"_id_":1100513},"1100514":{"description":{"en":"(Passive) [Space Front Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dmg to Cloud Up","ja":"宙属性立ち位置前の雲属性特効与ダメージアップ","ko":"우주 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為前的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3081,"_id_":1100514},"1100515":{"description":{"en":"(Passive) [Space Front Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Space Front Position Dmg to Dream Up","ja":"宙属性立ち位置前の夢属性特効与ダメージアップ","ko":"우주 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升宙屬性站位為前的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3081,"_id_":1100515},"1100516":{"description":{"en":"(Passive) [Space Front Position] Normal Defense Up %opt1_value% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [우주 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的普通防禦力 +%opt1_value%"},"name":{"en":"Space Front Position Normal Defense Up","ja":"宙属性立ち位置前の通常防御力アップ","ko":"우주 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升宙屬性站位為前的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3081,"_id_":1100516},"1100517":{"description":{"en":"(Passive) [Space Front Position] Special Defense Up %opt1_value% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [우주 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的特殊防禦力 +%opt1_value%"},"name":{"en":"Space Front Position Special Defense Up","ja":"宙属性立ち位置前の特殊防御力アップ","ko":"우주 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升宙屬性站位為前的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3081,"_id_":1100517},"1100518":{"description":{"en":"(Passive) [Space Front Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的普通防禦力 +%opt1_value%%"},"name":{"en":"Space Front Position Normal Defense Up","ja":"宙属性立ち位置前の通常防御力アップ","ko":"우주 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升宙屬性站位為前的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3081,"_id_":1100518},"1100519":{"description":{"en":"(Passive) [Space Front Position] Special Defense Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Space Front Position Special Defense Up","ja":"宙属性立ち位置前の特殊防御力アップ","ko":"우주 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升宙屬性站位為前的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3081,"_id_":1100519},"1100520":{"description":{"en":"(Passive) [Space Front Position] Dexterity Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的會心率 +%opt1_value%%"},"name":{"en":"Space Front Position Dexterity Up","ja":"宙属性立ち位置前のクリティカル率アップ","ko":"우주 속성 앞 포지션의 크리티컬 확률 증가","zh_hant":"提升宙屬性站位為前的會心率"},"skill_option1_id":20,"skill_option1_target_id":3081,"_id_":1100520},"1100521":{"description":{"en":"(Passive) [Space Front Position] Critical Up %opt1_value%% ","ja":"[永続]【宙属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [우주 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【宙屬性且站位為前】的會心威力 +%opt1_value%%"},"name":{"en":"Space Front Position Critical Up","ja":"宙属性立ち位置前のクリティカル威力アップ","ko":"우주 속성 앞 포지션의 크리티컬 위력 증가","zh_hant":"提升宙屬性站位為前的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3081,"_id_":1100521},"1100522":{"description":{"en":"(Passive) [Kaoruko & Futaba] Act Power Up %opt1_value% ","ja":"[永続]【香子と双葉】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카오루코와 후타바]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【香子和雙葉】的ACT力量 +%opt1_value%"},"name":{"en":"Kaoruko & Futaba Act Power Up","ja":"香子と双葉のACTパワーアップ","ko":"카오루코와 후타바의 ACT 파워 증가","zh_hant":"提升香子和雙葉的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3115,"_id_":1100522},"1100523":{"description":{"en":"(Passive) [Kaoruko & Futaba] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【香子和雙葉】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Flower Dmg Received Down","ja":"香子と双葉の花属性被ダメージダウン","ko":"카오루코와 후타바가 받는 꽃 속성 대미지 감소","zh_hant":"減輕香子和雙葉受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3115,"_id_":1100523},"1100524":{"description":{"en":"(Passive) [Kaoruko & Futaba] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【香子和雙葉】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Wind Dmg Received Down","ja":"香子と双葉の風属性被ダメージダウン","ko":"카오루코와 후타바가 받는 바람 속성 대미지 감소","zh_hant":"減輕香子和雙葉受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3115,"_id_":1100524},"1100525":{"description":{"en":"(Passive) [Kaoruko & Futaba] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【香子和雙葉】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Snow Dmg Received Down","ja":"香子と双葉の雪属性被ダメージダウン","ko":"카오루코와 후타바가 받는 눈 속성 대미지 감소","zh_hant":"減輕香子和雙葉受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3115,"_id_":1100525},"1100526":{"description":{"en":"(Passive) [Kaoruko & Futaba] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【香子和雙葉】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Moon Dmg Received Down","ja":"香子と双葉の月属性被ダメージダウン","ko":"카오루코와 후타바가 받는 달 속성 대미지 감소","zh_hant":"減輕香子和雙葉受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3115,"_id_":1100526},"1100527":{"description":{"en":"(Passive) [Kaoruko & Futaba] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【香子和雙葉】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Space Dmg Received Down","ja":"香子と双葉の宙属性被ダメージダウン","ko":"카오루코와 후타바가 받는 우주 속성 대미지 감소","zh_hant":"減輕香子和雙葉受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3115,"_id_":1100527},"1100528":{"description":{"en":"(Passive) [Kaoruko & Futaba] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【香子和雙葉】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Cloud Dmg Received Down","ja":"香子と双葉の雲属性被ダメージダウン","ko":"카오루코와 후타바가 받는 구름 속성 대미지 감소","zh_hant":"減輕香子和雙葉受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3115,"_id_":1100528},"1100529":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【香子和雙葉】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dream Dmg Received Down","ja":"香子と双葉の夢属性被ダメージダウン","ko":"카오루코와 후타바가 받는 꿈 속성 대미지 감소","zh_hant":"減輕香子和雙葉受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3115,"_id_":1100529},"1100530":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dmg to Flower Up","ja":"香子と双葉の花属性特効与ダメージアップ","ko":"카오루코와 후타바가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升香子和雙葉的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3115,"_id_":1100530},"1100531":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dmg to Wind Up","ja":"香子と双葉の風属性特効与ダメージアップ","ko":"카오루코와 후타바가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升香子和雙葉的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3115,"_id_":1100531},"1100532":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dmg to Snow Up","ja":"香子と双葉の雪属性特効与ダメージアップ","ko":"카오루코와 후타바가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升香子和雙葉的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3115,"_id_":1100532},"1100533":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dmg to Moon Up","ja":"香子と双葉の月属性特効与ダメージアップ","ko":"카오루코와 후타바가 달 속성에게 가하는 대미지 증가","zh_hant":"提升香子和雙葉的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3115,"_id_":1100533},"1100534":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dmg to Space Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dmg to Space Up","ja":"香子と双葉の宙属性特効与ダメージアップ","ko":"카오루코와 후타바가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升香子和雙葉的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3115,"_id_":1100534},"1100535":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dmg to Cloud Up","ja":"香子と双葉の雲属性特効与ダメージアップ","ko":"카오루코와 후타바가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升香子和雙葉的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3115,"_id_":1100535},"1100536":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dmg to Dream Up","ja":"香子と双葉の夢属性特効与ダメージアップ","ko":"카오루코와 후타바가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升香子和雙葉的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3115,"_id_":1100536},"1100537":{"description":{"en":"(Passive) [Kaoruko & Futaba] Normal Defense Up %opt1_value% ","ja":"[永続]【香子と双葉】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카오루코와 후타바]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【香子和雙葉】的普通防禦力 +%opt1_value%"},"name":{"en":"Kaoruko & Futaba Normal Defense Up","ja":"香子と双葉の通常防御力アップ","ko":"카오루코와 후타바의 일반 방어력 증가","zh_hant":"提升香子和雙葉的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3115,"_id_":1100537},"1100538":{"description":{"en":"(Passive) [Kaoruko & Futaba] Special Defense Up %opt1_value% ","ja":"[永続]【香子と双葉】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카오루코와 후타바]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【香子和雙葉】的特殊防禦力 +%opt1_value%"},"name":{"en":"Kaoruko & Futaba Special Defense Up","ja":"香子と双葉の特殊防御力アップ","ko":"카오루코와 후타바의 특수 방어력 증가","zh_hant":"提升香子和雙葉的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3115,"_id_":1100538},"1100539":{"description":{"en":"(Passive) [Kaoruko & Futaba] Normal Defense Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的普通防禦力 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Normal Defense Up","ja":"香子と双葉の通常防御力アップ","ko":"카오루코와 후타바의 일반 방어력 증가","zh_hant":"提升香子和雙葉的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3115,"_id_":1100539},"1100540":{"description":{"en":"(Passive) [Kaoruko & Futaba] Special Defense Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Special Defense Up","ja":"香子と双葉の特殊防御力アップ","ko":"카오루코와 후타바의 특수 방어력 증가","zh_hant":"提升香子和雙葉的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3115,"_id_":1100540},"1100541":{"description":{"en":"(Passive) [Kaoruko & Futaba] Dexterity Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的會心率 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Dexterity Up","ja":"香子と双葉のクリティカル率アップ","ko":"카오루코와 후타바의 크리티컬 확률 증가","zh_hant":"提升香子和雙葉的會心率"},"skill_option1_id":20,"skill_option1_target_id":3115,"_id_":1100541},"1100542":{"description":{"en":"(Passive) [Kaoruko & Futaba] Critical Up %opt1_value%% ","ja":"[永続]【香子と双葉】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카오루코와 후타바]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【香子和雙葉】的會心威力 +%opt1_value%%"},"name":{"en":"Kaoruko & Futaba Critical Up","ja":"香子と双葉のクリティカル威力アップ","ko":"카우로쿠와 후타바의 크리티컬 위력 증가","zh_hant":"提升香子和雙葉的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3115,"_id_":1100542},"1100601":{"description":{"en":"(Passive) [Dream Center Position] Act Power Up %opt1_value% ","ja":"[永続]【夢属性かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [꿈 속성 중간 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的ACT力量 +%opt1_value%"},"name":{"en":"Dream Center Position Act Power Up","ja":"夢属性立ち位置中のACTパワーアップ","ko":"꿈 속성 중간 포지션의 ACT 파워 증가","zh_hant":"提升夢屬性站位為中的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3102,"_id_":1100601},"1100602":{"description":{"en":"(Passive) [Dream Center Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為中】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Flower Dmg Received Down","ja":"夢属性立ち位置中の花属性被ダメージダウン","ko":"꿈 속성 중간 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕夢屬性站位為中受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3102,"_id_":1100602},"1100603":{"description":{"en":"(Passive) [Dream Center Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為中】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Wind Dmg Received Down","ja":"夢属性立ち位置中の風属性被ダメージダウン","ko":"꿈 속성 중간 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕夢屬性站位為中受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3102,"_id_":1100603},"1100604":{"description":{"en":"(Passive) [Dream Center Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為中】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Snow Dmg Received Down","ja":"夢属性立ち位置中の雪属性被ダメージダウン","ko":"꿈 속성 중간 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕夢屬性站位為中受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3102,"_id_":1100604},"1100605":{"description":{"en":"(Passive) [Dream Center Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為中】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Moon Dmg Received Down","ja":"夢属性立ち位置中の月属性被ダメージダウン","ko":"꿈 속성 중간 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕夢屬性站位為中受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3102,"_id_":1100605},"1100606":{"description":{"en":"(Passive) [Dream Center Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為中】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Space Dmg Received Down","ja":"夢属性立ち位置中の宙属性被ダメージダウン","ko":"꿈 속성 중간 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕夢屬性站位為中受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3102,"_id_":1100606},"1100607":{"description":{"en":"(Passive) [Dream Center Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為中】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Cloud Dmg Received Down","ja":"夢属性立ち位置中の雲属性被ダメージダウン","ko":"꿈 속성 중간 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕夢屬性站位為中受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3102,"_id_":1100607},"1100608":{"description":{"en":"(Passive) [Dream Center Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為中】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dream Dmg Received Down","ja":"夢属性立ち位置中の夢属性被ダメージダウン","ko":"꿈 속성 중간 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕夢屬性站位為中受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3102,"_id_":1100608},"1100609":{"description":{"en":"(Passive) [Dream Center Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dmg to Flower Up","ja":"夢属性立ち位置中の花属性特効与ダメージアップ","ko":"꿈 속성 중간 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為中的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3102,"_id_":1100609},"1100610":{"description":{"en":"(Passive) [Dream Center Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dmg to Wind Up","ja":"夢属性立ち位置中の風属性特効与ダメージアップ","ko":"꿈 속성 중간 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為中的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3102,"_id_":1100610},"1100611":{"description":{"en":"(Passive) [Dream Center Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dmg to Snow Up","ja":"夢属性立ち位置中の雪属性特効与ダメージアップ","ko":"꿈 속성 중간 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為中的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3102,"_id_":1100611},"1100612":{"description":{"en":"(Passive) [Dream Center Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dmg to Moon Up","ja":"夢属性立ち位置中の月属性特効与ダメージアップ","ko":"꿈 속성 중간 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為中的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3102,"_id_":1100612},"1100613":{"description":{"en":"(Passive) [Dream Center Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dmg to Space Up","ja":"夢属性立ち位置中の宙属性特効与ダメージアップ","ko":"꿈 속성 중간 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為中的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3102,"_id_":1100613},"1100614":{"description":{"en":"(Passive) [Dream Center Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dmg to Cloud Up","ja":"夢属性立ち位置中の雲属性特効与ダメージアップ","ko":"꿈 속성 중간 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為中的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3102,"_id_":1100614},"1100615":{"description":{"en":"(Passive) [Dream Center Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Center Position Dmg to Dream Up","ja":"夢属性立ち位置中の夢属性特効与ダメージアップ","ko":"꿈 속성 중간 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為中的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3102,"_id_":1100615},"1100616":{"description":{"en":"(Passive) [Dream Center Position] Normal Defense Up %opt1_value% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [꿈 속성 중간 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的普通防禦力 +%opt1_value%"},"name":{"en":"Dream Center Position Normal Defense Up","ja":"夢属性立ち位置中の通常防御力アップ","ko":"꿈 속성 중간 포지션의 일반 방어력 증가","zh_hant":"提升夢屬性站位為中的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3102,"_id_":1100616},"1100617":{"description":{"en":"(Passive) [Dream Center Position] Special Defense Up %opt1_value% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [꿈 속성 중간 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的特殊防禦力 +%opt1_value%"},"name":{"en":"Dream Center Position Special Defense Up","ja":"夢属性立ち位置中の特殊防御力アップ","ko":"꿈 속성 중간 포지션의 특수 방어력 증가","zh_hant":"提升夢屬性站位為中的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3102,"_id_":1100617},"1100618":{"description":{"en":"(Passive) [Dream Center Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的普通防禦力 +%opt1_value%%"},"name":{"en":"Dream Center Position Normal Defense Up","ja":"夢属性立ち位置中の通常防御力アップ","ko":"꿈 속성 중간 포지션의 일반 방어력 증가","zh_hant":"提升夢屬性站位為中的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3102,"_id_":1100618},"1100619":{"description":{"en":"(Passive) [Dream Center Position] Special Defense Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Dream Center Position Special Defense Up","ja":"夢属性立ち位置中の特殊防御力アップ","ko":"꿈 속성 중간 포지션의 특수 방어력 증가","zh_hant":"提升夢屬性站位為中的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3102,"_id_":1100619},"1100620":{"description":{"en":"(Passive) [Dream Center Position] Dexterity Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的會心率 +%opt1_value%%"},"name":{"en":"Dream Center Position Dexterity Up","ja":"夢属性立ち位置中のクリティカル率アップ","ko":"꿈 속성 중간 포지션의 크리티컬 확률 증가","zh_hant":"提升夢屬性站位為中的會心率"},"skill_option1_id":20,"skill_option1_target_id":3102,"_id_":1100620},"1100621":{"description":{"en":"(Passive) [Dream Center Position] Critical Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [꿈 속성 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為中】的會心威力 +%opt1_value%%"},"name":{"en":"Dream Center Position Critical Up","ja":"夢属性立ち位置中のクリティカル威力アップ","ko":"꿈 속성 중간 포지션의 크리티컬 위력 증가","zh_hant":"提升夢屬性站位為中的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3102,"_id_":1100621},"1100622":{"description":{"en":"(Passive) [Hikari & Nana] Act Power Up %opt1_value% ","ja":"[永続]【ひかりとなな】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [히카리와 나나]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【光和奈奈】的ACT力量 +%opt1_value%"},"name":{"en":"Hikari & Nana Act Power Up","ja":"ひかりとななのACTパワーアップ","ko":"히카리와 나나의 ACT 파워 증가","zh_hant":"提升光和奈奈的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3116,"_id_":1100622},"1100623":{"description":{"en":"(Passive) [Hikari & Nana] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 나나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和奈奈】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Flower Dmg Received Down","ja":"ひかりとななの花属性被ダメージダウン","ko":"히카리와 나나가 받는 꽃 속성 대미지 감소","zh_hant":"減輕光和奈奈受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3116,"_id_":1100623},"1100624":{"description":{"en":"(Passive) [Hikari & Nana] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 나나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和奈奈】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Wind Dmg Received Down","ja":"ひかりとななの風属性被ダメージダウン","ko":"히카리와 나나가 받는 바람 속성 대미지 감소","zh_hant":"減輕光和奈奈受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3116,"_id_":1100624},"1100625":{"description":{"en":"(Passive) [Hikari & Nana] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 나나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和奈奈】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Snow Dmg Received Down","ja":"ひかりとななの雪属性被ダメージダウン","ko":"히카리와 나나가 받는 눈 속성 대미지 감소","zh_hant":"減輕光和奈奈受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3116,"_id_":1100625},"1100626":{"description":{"en":"(Passive) [Hikari & Nana] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 나나]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和奈奈】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Moon Dmg Received Down","ja":"ひかりとななの月属性被ダメージダウン","ko":"히카리와 나나가 받는 달 속성 대미지 감소","zh_hant":"減輕光和奈奈受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3116,"_id_":1100626},"1100627":{"description":{"en":"(Passive) [Hikari & Nana] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 나나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和奈奈】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Space Dmg Received Down","ja":"ひかりとななの宙属性被ダメージダウン","ko":"히카리와 나나가 받는 우주 속성 대미지 감소","zh_hant":"減輕光和奈奈受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3116,"_id_":1100627},"1100628":{"description":{"en":"(Passive) [Hikari & Nana] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 나나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和奈奈】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Cloud Dmg Received Down","ja":"ひかりとななの雲属性被ダメージダウン","ko":"히카리와 나나가 받는 구름 속성 대미지 감소","zh_hant":"減輕光和奈奈受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3116,"_id_":1100628},"1100629":{"description":{"en":"(Passive) [Hikari & Nana] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리와 나나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光和奈奈】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dream Dmg Received Down","ja":"ひかりとななの夢属性被ダメージダウン","ko":"히카리와 나나가 받는 꿈 속성 대미지 감소","zh_hant":"減輕光和奈奈受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3116,"_id_":1100629},"1100630":{"description":{"en":"(Passive) [Hikari & Nana] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 나나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dmg to Flower Up","ja":"ひかりとななの花属性特効与ダメージアップ","ko":"히카리와 나나가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升光和奈奈的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3116,"_id_":1100630},"1100631":{"description":{"en":"(Passive) [Hikari & Nana] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 나나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dmg to Wind Up","ja":"ひかりとななの風属性特効与ダメージアップ","ko":"히카리와 나나가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升光和奈奈的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3116,"_id_":1100631},"1100632":{"description":{"en":"(Passive) [Hikari & Nana] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 나나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dmg to Snow Up","ja":"ひかりとななの雪属性特効与ダメージアップ","ko":"히카리와 나나가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升光和奈奈的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3116,"_id_":1100632},"1100633":{"description":{"en":"(Passive) [Hikari & Nana] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 나나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dmg to Moon Up","ja":"ひかりとななの月属性特効与ダメージアップ","ko":"히카리와 나나가 달 속성에게 가하는 대미지 증가","zh_hant":"提升光和奈奈的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3116,"_id_":1100633},"1100634":{"description":{"en":"(Passive) [Hikari & Nana] Dmg to Space Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 나나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dmg to Space Up","ja":"ひかりとななの宙属性特効与ダメージアップ","ko":"히카리와 나나가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升光和奈奈的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3116,"_id_":1100634},"1100635":{"description":{"en":"(Passive) [Hikari & Nana] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 나나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dmg to Cloud Up","ja":"ひかりとななの雲属性特効与ダメージアップ","ko":"히카리와 나나가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升光和奈奈的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3116,"_id_":1100635},"1100636":{"description":{"en":"(Passive) [Hikari & Nana] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리와 나나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dmg to Dream Up","ja":"ひかりとななの夢属性特効与ダメージアップ","ko":"히카리와 나나가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升光和奈奈的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3116,"_id_":1100636},"1100637":{"description":{"en":"(Passive) [Hikari & Nana] Normal Defense Up %opt1_value% ","ja":"[永続]【ひかりとなな】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [히카리와 나나]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【光和奈奈】的普通防禦力 +%opt1_value%"},"name":{"en":"Hikari & Nana Normal Defense Up","ja":"ひかりとななの通常防御力アップ","ko":"히카리와 나나의 일반 방어력 증가","zh_hant":"提升光和奈奈的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3116,"_id_":1100637},"1100638":{"description":{"en":"(Passive) [Hikari & Nana] Special Defense Up %opt1_value% ","ja":"[永続]【ひかりとなな】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [히카리와 나나]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【光和奈奈】的特殊防禦力 +%opt1_value%"},"name":{"en":"Hikari & Nana Special Defense Up","ja":"ひかりとななの特殊防御力アップ","ko":"히카리와 나나의 특수 방어력 증가","zh_hant":"提升光和奈奈的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3116,"_id_":1100638},"1100639":{"description":{"en":"(Passive) [Hikari & Nana] Normal Defense Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [히카리와 나나]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的普通防禦力 +%opt1_value%%"},"name":{"en":"Hikari & Nana Normal Defense Up","ja":"ひかりとななの通常防御力アップ","ko":"히카리와 나나의 일반 방어력 증가","zh_hant":"提升光和奈奈的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3116,"_id_":1100639},"1100640":{"description":{"en":"(Passive) [Hikari & Nana] Special Defense Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [히카리와 나나]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Hikari & Nana Special Defense Up","ja":"ひかりとななの特殊防御力アップ","ko":"히카리와 나나의 특수 방어력 증가","zh_hant":"提升光和奈奈的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3116,"_id_":1100640},"1100641":{"description":{"en":"(Passive) [Hikari & Nana] Dexterity Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [히카리와 나나]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的會心率 +%opt1_value%%"},"name":{"en":"Hikari & Nana Dexterity Up","ja":"ひかりとななのクリティカル率アップ","ko":"히카리와 나나의 크리티컬 확률 증가","zh_hant":"提升光和奈奈的會心率"},"skill_option1_id":20,"skill_option1_target_id":3116,"_id_":1100641},"1100642":{"description":{"en":"(Passive) [Hikari & Nana] Critical Up %opt1_value%% ","ja":"[永続]【ひかりとなな】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [히카리와 나나]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【光和奈奈】的會心威力 +%opt1_value%%"},"name":{"en":"Hikari & Nana Critical Up","ja":"ひかりとななのクリティカル威力アップ","ko":"히카리와 나나의 크리티컬 위력 증가","zh_hant":"提升光和奈奈的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3116,"_id_":1100642},"1100701":{"description":{"en":"(Passive) [Snow Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【雪属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [눈 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Snow Rear Position Act Power Up","ja":"雪属性立ち位置後のACTパワーアップ","ko":"눈 속성 뒤 포지션의 ACT 파워 증가","zh_hant":"提升雪屬性站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3063,"_id_":1100701},"1100702":{"description":{"en":"(Passive) [Snow Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Flower Dmg Received Down","ja":"雪属性立ち位置後の花属性被ダメージダウン","ko":"눈 속성 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕雪屬性站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3063,"_id_":1100702},"1100703":{"description":{"en":"(Passive) [Snow Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Wind Dmg Received Down","ja":"雪属性立ち位置後の風属性被ダメージダウン","ko":"눈 속성 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕雪屬性站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3063,"_id_":1100703},"1100704":{"description":{"en":"(Passive) [Snow Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Snow Dmg Received Down","ja":"雪属性立ち位置後の雪属性被ダメージダウン","ko":"눈 속성 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕雪屬性站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3063,"_id_":1100704},"1100705":{"description":{"en":"(Passive) [Snow Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Moon Dmg Received Down","ja":"雪属性立ち位置後の月属性被ダメージダウン","ko":"눈 속성 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕雪屬性站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3063,"_id_":1100705},"1100706":{"description":{"en":"(Passive) [Snow Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Space Dmg Received Down","ja":"雪属性立ち位置後の宙属性被ダメージダウン","ko":"눈 속성 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕雪屬性站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3063,"_id_":1100706},"1100707":{"description":{"en":"(Passive) [Snow Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Cloud Dmg Received Down","ja":"雪属性立ち位置後の雲属性被ダメージダウン","ko":"눈 속성 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕雪屬性站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3063,"_id_":1100707},"1100708":{"description":{"en":"(Passive) [Snow Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雪屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dream Dmg Received Down","ja":"雪属性立ち位置後の夢属性被ダメージダウン","ko":"눈 속성 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕雪屬性站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3063,"_id_":1100708},"1100709":{"description":{"en":"(Passive) [Snow Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dmg to Flower Up","ja":"雪属性立ち位置後の花属性特効与ダメージアップ","ko":"눈 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3063,"_id_":1100709},"1100710":{"description":{"en":"(Passive) [Snow Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dmg to Wind Up","ja":"雪属性立ち位置後の風属性特効与ダメージアップ","ko":"눈 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3063,"_id_":1100710},"1100711":{"description":{"en":"(Passive) [Snow Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dmg to Snow Up","ja":"雪属性立ち位置後の雪属性特効与ダメージアップ","ko":"눈 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3063,"_id_":1100711},"1100712":{"description":{"en":"(Passive) [Snow Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dmg to Moon Up","ja":"雪属性立ち位置後の月属性特効与ダメージアップ","ko":"눈 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3063,"_id_":1100712},"1100713":{"description":{"en":"(Passive) [Snow Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dmg to Space Up","ja":"雪属性立ち位置後の宙属性特効与ダメージアップ","ko":"눈 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3063,"_id_":1100713},"1100714":{"description":{"en":"(Passive) [Snow Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dmg to Cloud Up","ja":"雪属性立ち位置後の雲属性特効与ダメージアップ","ko":"눈 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3063,"_id_":1100714},"1100715":{"description":{"en":"(Passive) [Snow Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dmg to Dream Up","ja":"雪属性立ち位置後の夢属性特効与ダメージアップ","ko":"눈 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升雪屬性站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3063,"_id_":1100715},"1100716":{"description":{"en":"(Passive) [Snow Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [눈 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Snow Rear Position Normal Defense Up","ja":"雪属性立ち位置後の通常防御力アップ","ko":"눈 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升雪屬性站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3063,"_id_":1100716},"1100717":{"description":{"en":"(Passive) [Snow Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [눈 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Snow Rear Position Special Defense Up","ja":"雪属性立ち位置後の特殊防御力アップ","ko":"눈 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升雪屬性站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3063,"_id_":1100717},"1100718":{"description":{"en":"(Passive) [Snow Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Snow Rear Position Normal Defense Up","ja":"雪属性立ち位置後の通常防御力アップ","ko":"눈 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升雪屬性站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3063,"_id_":1100718},"1100719":{"description":{"en":"(Passive) [Snow Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Snow Rear Position Special Defense Up","ja":"雪属性立ち位置後の特殊防御力アップ","ko":"눈 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升雪屬性站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3063,"_id_":1100719},"1100720":{"description":{"en":"(Passive) [Snow Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Snow Rear Position Dexterity Up","ja":"雪属性立ち位置後のクリティカル率アップ","ko":"눈 속성 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升雪屬性站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3063,"_id_":1100720},"1100721":{"description":{"en":"(Passive) [Snow Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【雪属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [눈 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【雪屬性且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Snow Rear Position Critical Up","ja":"雪属性立ち位置後のクリティカル威力アップ","ko":"눈 속성 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升雪屬性站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3063,"_id_":1100721},"1100722":{"description":{"en":"(Passive) [Karen & Nana] Act Power Up %opt1_value% ","ja":"[永続]【華恋となな】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌과 나나]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和奈奈】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Nana Act Power Up","ja":"華恋とななのACTパワーアップ","ko":"카렌과 나나의 ACT 파워 증가","zh_hant":"提升華戀和奈奈的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3117,"_id_":1100722},"1100723":{"description":{"en":"(Passive) [Karen & Nana] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋となな】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 나나]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和奈奈】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Flower Dmg Received Down","ja":"華恋とななの花属性被ダメージダウン","ko":"카렌과 나나가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀和奈奈受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3117,"_id_":1100723},"1100724":{"description":{"en":"(Passive) [Karen & Nana] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋となな】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 나나]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和奈奈】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Wind Dmg Received Down","ja":"華恋とななの風属性被ダメージダウン","ko":"카렌과 나나가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀和奈奈受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3117,"_id_":1100724},"1100725":{"description":{"en":"(Passive) [Karen & Nana] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋となな】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 나나]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和奈奈】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Snow Dmg Received Down","ja":"華恋とななの雪属性被ダメージダウン","ko":"카렌과 나나가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀和奈奈受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3117,"_id_":1100725},"1100726":{"description":{"en":"(Passive) [Karen & Nana] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋となな】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 나나]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和奈奈】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Moon Dmg Received Down","ja":"華恋とななの月属性被ダメージダウン","ko":"카렌과 나나가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀和奈奈受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3117,"_id_":1100726},"1100727":{"description":{"en":"(Passive) [Karen & Nana] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋となな】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 나나]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和奈奈】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Space Dmg Received Down","ja":"華恋とななの宙属性被ダメージダウン","ko":"카렌과 나나가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀和奈奈受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3117,"_id_":1100727},"1100728":{"description":{"en":"(Passive) [Karen & Nana] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋となな】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 나나]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和奈奈】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Cloud Dmg Received Down","ja":"華恋とななの雲属性被ダメージダウン","ko":"카렌과 나나가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀和奈奈受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3117,"_id_":1100728},"1100729":{"description":{"en":"(Passive) [Karen & Nana] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋となな】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 나나]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和奈奈】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dream Dmg Received Down","ja":"華恋とななの夢属性被ダメージダウン","ko":"카렌과 나나가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀和奈奈受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3117,"_id_":1100729},"1100730":{"description":{"en":"(Passive) [Karen & Nana] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 나나]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dmg to Flower Up","ja":"華恋とななの花属性特効与ダメージアップ","ko":"카렌과 나나가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和奈奈的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3117,"_id_":1100730},"1100731":{"description":{"en":"(Passive) [Karen & Nana] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 나나]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dmg to Wind Up","ja":"華恋とななの風属性特効与ダメージアップ","ko":"카렌과 나나가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和奈奈的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3117,"_id_":1100731},"1100732":{"description":{"en":"(Passive) [Karen & Nana] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 나나]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dmg to Snow Up","ja":"華恋とななの雪属性特効与ダメージアップ","ko":"카렌과 나나가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和奈奈的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3117,"_id_":1100732},"1100733":{"description":{"en":"(Passive) [Karen & Nana] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 나나]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dmg to Moon Up","ja":"華恋とななの月属性特効与ダメージアップ","ko":"카렌과 나나가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和奈奈的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3117,"_id_":1100733},"1100734":{"description":{"en":"(Passive) [Karen & Nana] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 나나]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dmg to Space Up","ja":"華恋とななの宙属性特効与ダメージアップ","ko":"카렌과 나나가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和奈奈的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3117,"_id_":1100734},"1100735":{"description":{"en":"(Passive) [Karen & Nana] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 나나]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dmg to Cloud Up","ja":"華恋とななの雲属性特効与ダメージアップ","ko":"카렌과 나나가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和奈奈的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3117,"_id_":1100735},"1100736":{"description":{"en":"(Passive) [Karen & Nana] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 나나]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Nana Dmg to Dream Up","ja":"華恋とななの夢属性特効与ダメージアップ","ko":"카렌과 나나가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和奈奈的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3117,"_id_":1100736},"1100737":{"description":{"en":"(Passive) [Karen & Nana] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋となな】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌과 나나]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和奈奈】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Nana Normal Defense Up","ja":"華恋とななの通常防御力アップ","ko":"카렌과 나나의 일반 방어력 증가","zh_hant":"提升華戀和奈奈的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3117,"_id_":1100737},"1100738":{"description":{"en":"(Passive) [Karen & Nana] Special Defense Up %opt1_value% ","ja":"[永続]【華恋となな】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌과 나나]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和奈奈】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Nana Special Defense Up","ja":"華恋とななの特殊防御力アップ","ko":"카렌과 나나의 특수 방어력 증가","zh_hant":"提升華戀和奈奈的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3117,"_id_":1100738},"1100739":{"description":{"en":"(Passive) [Karen & Nana] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 나나]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Nana Normal Defense Up","ja":"華恋とななの通常防御力アップ","ko":"카렌과 나나의 일반 방어력 증가","zh_hant":"提升華戀和奈奈的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3117,"_id_":1100739},"1100740":{"description":{"en":"(Passive) [Karen & Nana] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 나나]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Nana Special Defense Up","ja":"華恋とななの特殊防御力アップ","ko":"카렌과 나나의 특수 방어력 증가","zh_hant":"提升華戀和奈奈的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3117,"_id_":1100740},"1100741":{"description":{"en":"(Passive) [Karen & Nana] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌과 나나]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Nana Dexterity Up","ja":"華恋とななのクリティカル率アップ","ko":"카렌과 나나의 크리티컬 확률 증가","zh_hant":"提升華戀和奈奈的會心率"},"skill_option1_id":20,"skill_option1_target_id":3117,"_id_":1100741},"1100742":{"description":{"en":"(Passive) [Karen & Nana] Critical Up %opt1_value%% ","ja":"[永続]【華恋となな】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌과 나나]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和奈奈】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Nana Critical Up","ja":"華恋とななのクリティカル威力アップ","ko":"카렌와 나나의 크리티컬 위력 증가","zh_hant":"提升華戀和奈奈的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3117,"_id_":1100742},"1100801":{"description":{"en":"(Passive) [Dream Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【夢属性かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [꿈 속성 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Dream Rear Position Act Power Up","ja":"夢属性立ち位置後のACTパワーアップ","ko":"꿈 속성 뒤 포지션의 ACT 파워 증가","zh_hant":"提升夢屬性站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3103,"_id_":1100801},"1100802":{"description":{"en":"(Passive) [Dream Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Flower Dmg Received Down","ja":"夢属性立ち位置後の花属性被ダメージダウン","ko":"꿈 속성 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕夢屬性站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3103,"_id_":1100802},"1100803":{"description":{"en":"(Passive) [Dream Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Wind Dmg Received Down","ja":"夢属性立ち位置後の風属性被ダメージダウン","ko":"꿈 속성 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕夢屬性站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3103,"_id_":1100803},"1100804":{"description":{"en":"(Passive) [Dream Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Snow Dmg Received Down","ja":"夢属性立ち位置後の雪属性被ダメージダウン","ko":"꿈 속성 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕夢屬性站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3103,"_id_":1100804},"1100805":{"description":{"en":"(Passive) [Dream Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Moon Dmg Received Down","ja":"夢属性立ち位置後の月属性被ダメージダウン","ko":"꿈 속성 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕夢屬性站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3103,"_id_":1100805},"1100806":{"description":{"en":"(Passive) [Dream Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Space Dmg Received Down","ja":"夢属性立ち位置後の宙属性被ダメージダウン","ko":"꿈 속성 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕夢屬性站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3103,"_id_":1100806},"1100807":{"description":{"en":"(Passive) [Dream Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Cloud Dmg Received Down","ja":"夢属性立ち位置後の雲属性被ダメージダウン","ko":"꿈 속성 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕夢屬性站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3103,"_id_":1100807},"1100808":{"description":{"en":"(Passive) [Dream Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【夢屬性且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dream Dmg Received Down","ja":"夢属性立ち位置後の夢属性被ダメージダウン","ko":"꿈 속성 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕夢屬性站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3103,"_id_":1100808},"1100809":{"description":{"en":"(Passive) [Dream Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dmg to Flower Up","ja":"夢属性立ち位置後の花属性特効与ダメージアップ","ko":"꿈 속성 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3103,"_id_":1100809},"1100810":{"description":{"en":"(Passive) [Dream Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dmg to Wind Up","ja":"夢属性立ち位置後の風属性特効与ダメージアップ","ko":"꿈 속성 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3103,"_id_":1100810},"1100811":{"description":{"en":"(Passive) [Dream Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dmg to Snow Up","ja":"夢属性立ち位置後の雪属性特効与ダメージアップ","ko":"꿈 속성 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3103,"_id_":1100811},"1100812":{"description":{"en":"(Passive) [Dream Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dmg to Moon Up","ja":"夢属性立ち位置後の月属性特効与ダメージアップ","ko":"꿈 속성 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3103,"_id_":1100812},"1100813":{"description":{"en":"(Passive) [Dream Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dmg to Space Up","ja":"夢属性立ち位置後の宙属性特効与ダメージアップ","ko":"꿈 속성 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3103,"_id_":1100813},"1100814":{"description":{"en":"(Passive) [Dream Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dmg to Cloud Up","ja":"夢属性立ち位置後の雲属性特効与ダメージアップ","ko":"꿈 속성 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3103,"_id_":1100814},"1100815":{"description":{"en":"(Passive) [Dream Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dmg to Dream Up","ja":"夢属性立ち位置後の夢属性特効与ダメージアップ","ko":"꿈 속성 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升夢屬性站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3103,"_id_":1100815},"1100816":{"description":{"en":"(Passive) [Dream Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [꿈 속성 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Dream Rear Position Normal Defense Up","ja":"夢属性立ち位置後の通常防御力アップ","ko":"꿈 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升夢屬性站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3103,"_id_":1100816},"1100817":{"description":{"en":"(Passive) [Dream Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [꿈 속성 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Dream Rear Position Special Defense Up","ja":"夢属性立ち位置後の特殊防御力アップ","ko":"꿈 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升夢屬性站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3103,"_id_":1100817},"1100818":{"description":{"en":"(Passive) [Dream Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Dream Rear Position Normal Defense Up","ja":"夢属性立ち位置後の通常防御力アップ","ko":"꿈 속성 뒤 포지션의 일반 방어력 증가","zh_hant":"提升夢屬性站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3103,"_id_":1100818},"1100819":{"description":{"en":"(Passive) [Dream Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Dream Rear Position Special Defense Up","ja":"夢属性立ち位置後の特殊防御力アップ","ko":"꿈 속성 뒤 포지션의 특수 방어력 증가","zh_hant":"提升夢屬性站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3103,"_id_":1100819},"1100820":{"description":{"en":"(Passive) [Dream Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Dream Rear Position Dexterity Up","ja":"夢属性立ち位置後のクリティカル率アップ","ko":"꿈 속성 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升夢屬性站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3103,"_id_":1100820},"1100821":{"description":{"en":"(Passive) [Dream Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【夢属性かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [꿈 속성 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【夢屬性且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Dream Rear Position Critical Up","ja":"夢属性立ち位置後のクリティカル威力アップ","ko":"꿈 속성 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升夢屬性站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3103,"_id_":1100821},"1100822":{"description":{"en":"(Passive) [Karen & Hikari] Act Power Up %opt1_value% ","ja":"[永続]【華恋とひかり】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌과 히카리]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和光】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Hikari Act Power Up","ja":"華恋とひかりのACTパワーアップ","ko":"카렌과 히카리의 ACT 파워 증가","zh_hant":"提升華戀和光的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3118,"_id_":1100822},"1100823":{"description":{"en":"(Passive) [Karen & Hikari] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和光】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Flower Dmg Received Down","ja":"華恋とひかりの花属性被ダメージダウン","ko":"카렌과 히카리가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀和光受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3118,"_id_":1100823},"1100824":{"description":{"en":"(Passive) [Karen & Hikari] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和光】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Wind Dmg Received Down","ja":"華恋とひかりの風属性被ダメージダウン","ko":"카렌과 히카리가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀和光受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3118,"_id_":1100824},"1100825":{"description":{"en":"(Passive) [Karen & Hikari] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和光】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Snow Dmg Received Down","ja":"華恋とひかりの雪属性被ダメージダウン","ko":"카렌과 히카리가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀和光受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3118,"_id_":1100825},"1100826":{"description":{"en":"(Passive) [Karen & Hikari] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和光】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Moon Dmg Received Down","ja":"華恋とひかりの月属性被ダメージダウン","ko":"카렌과 히카리가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀和光受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3118,"_id_":1100826},"1100827":{"description":{"en":"(Passive) [Karen & Hikari] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和光】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Space Dmg Received Down","ja":"華恋とひかりの宙属性被ダメージダウン","ko":"카렌과 히카리가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀和光受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3118,"_id_":1100827},"1100828":{"description":{"en":"(Passive) [Karen & Hikari] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和光】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Cloud Dmg Received Down","ja":"華恋とひかりの雲属性被ダメージダウン","ko":"카렌과 히카리가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀和光受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3118,"_id_":1100828},"1100829":{"description":{"en":"(Passive) [Karen & Hikari] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀和光】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dream Dmg Received Down","ja":"華恋とひかりの夢属性被ダメージダウン","ko":"카렌과 히카리가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀和光受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3118,"_id_":1100829},"1100830":{"description":{"en":"(Passive) [Karen & Hikari] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dmg to Flower Up","ja":"華恋とひかりの花属性特効与ダメージアップ","ko":"카렌과 히카리가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和光的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3118,"_id_":1100830},"1100831":{"description":{"en":"(Passive) [Karen & Hikari] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dmg to Wind Up","ja":"華恋とひかりの風属性特効与ダメージアップ","ko":"카렌과 히카리가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和光的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3118,"_id_":1100831},"1100832":{"description":{"en":"(Passive) [Karen & Hikari] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dmg to Snow Up","ja":"華恋とひかりの雪属性特効与ダメージアップ","ko":"카렌과 히카리가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和光的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3118,"_id_":1100832},"1100833":{"description":{"en":"(Passive) [Karen & Hikari] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dmg to Moon Up","ja":"華恋とひかりの月属性特効与ダメージアップ","ko":"카렌과 히카리가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和光的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3118,"_id_":1100833},"1100834":{"description":{"en":"(Passive) [Karen & Hikari] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dmg to Space Up","ja":"華恋とひかりの宙属性特効与ダメージアップ","ko":"카렌과 히카리가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和光的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3118,"_id_":1100834},"1100835":{"description":{"en":"(Passive) [Karen & Hikari] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dmg to Cloud Up","ja":"華恋とひかりの雲属性特効与ダメージアップ","ko":"카렌과 히카리가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和光的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3118,"_id_":1100835},"1100836":{"description":{"en":"(Passive) [Karen & Hikari] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dmg to Dream Up","ja":"華恋とひかりの夢属性特効与ダメージアップ","ko":"카렌과 히카리가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀和光的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3118,"_id_":1100836},"1100837":{"description":{"en":"(Passive) [Karen & Hikari] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋とひかり】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌과 히카리]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和光】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Hikari Normal Defense Up","ja":"華恋とひかりの通常防御力アップ","ko":"카렌과 히카리의 일반 방어력 증가","zh_hant":"提升華戀和光的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3118,"_id_":1100837},"1100838":{"description":{"en":"(Passive) [Karen & Hikari] Special Defense Up %opt1_value% ","ja":"[永続]【華恋とひかり】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌과 히카리]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀和光】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Hikari Special Defense Up","ja":"華恋とひかりの特殊防御力アップ","ko":"카렌과 히카리의 특수 방어력 증가","zh_hant":"提升華戀和光的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3118,"_id_":1100838},"1100839":{"description":{"en":"(Passive) [Karen & Hikari] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Hikari Normal Defense Up","ja":"華恋とひかりの通常防御力アップ","ko":"카렌과 히카리의 일반 방어력 증가","zh_hant":"提升華戀和光的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3118,"_id_":1100839},"1100840":{"description":{"en":"(Passive) [Karen & Hikari] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Hikari Special Defense Up","ja":"華恋とひかりの特殊防御力アップ","ko":"카렌과 히카리의 특수 방어력 증가","zh_hant":"提升華戀和光的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3118,"_id_":1100840},"1100841":{"description":{"en":"(Passive) [Karen & Hikari] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Hikari Dexterity Up","ja":"華恋とひかりのクリティカル率アップ","ko":"카렌과 히카리의 크리티컬 확률 증가","zh_hant":"提升華戀和光的會心率"},"skill_option1_id":20,"skill_option1_target_id":3118,"_id_":1100841},"1100842":{"description":{"en":"(Passive) [Karen & Hikari] Critical Up %opt1_value%% ","ja":"[永続]【華恋とひかり】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀和光】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Hikari Critical Up","ja":"華恋とひかりのクリティカル威力アップ","ko":"카렌과 히카리의 크리티컬 위력 증가","zh_hant":"提升華戀和光的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3118,"_id_":1100842},"2000101":{"description":{"en":"(Passive) [Rinmeikan Center Position] Act Power Up %opt1_value% ","ja":"[永続]【凛明館かつ立ち位置中】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [린메이칸 중간 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的ACT力量 +%opt1_value%"},"name":{"en":"Rinmeikan Center Position Act Power Up","ja":"凛明館立ち位置中のACTパワーアップ","ko":"린메이칸 중간 포지션의 ACT 파워 증가","zh_hant":"提升凜明館站位為中的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3012,"_id_":2000101},"2000102":{"description":{"en":"(Passive) [Rinmeikan Center Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為中】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Flower Dmg Received Down","ja":"凛明館立ち位置中の花属性被ダメージダウン","ko":"린메이칸 중간 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕凜明館站位為中受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3012,"_id_":2000102},"2000103":{"description":{"en":"(Passive) [Rinmeikan Center Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為中】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Wind Dmg Received Down","ja":"凛明館立ち位置中の風属性被ダメージダウン","ko":"린메이칸 중간 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕凜明館站位為中受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3012,"_id_":2000103},"2000104":{"description":{"en":"(Passive) [Rinmeikan Center Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為中】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Snow Dmg Received Down","ja":"凛明館立ち位置中の雪属性被ダメージダウン","ko":"린메이칸 중간 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕凜明館站位為中受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3012,"_id_":2000104},"2000105":{"description":{"en":"(Passive) [Rinmeikan Center Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為中】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Moon Dmg Received Down","ja":"凛明館立ち位置中の月属性被ダメージダウン","ko":"린메이칸 중간 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕凜明館站位為中受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3012,"_id_":2000105},"2000106":{"description":{"en":"(Passive) [Rinmeikan Center Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為中】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Space Dmg Received Down","ja":"凛明館立ち位置中の宙属性被ダメージダウン","ko":"린메이칸 중간 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕凜明館站位為中受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3012,"_id_":2000106},"2000107":{"description":{"en":"(Passive) [Rinmeikan Center Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為中】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Cloud Dmg Received Down","ja":"凛明館立ち位置中の雲属性被ダメージダウン","ko":"린메이칸 중간 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕凜明館站位為中受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3012,"_id_":2000107},"2000108":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為中】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dream Dmg Received Down","ja":"凛明館立ち位置中の夢属性被ダメージダウン","ko":"린메이칸 중간 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕凜明館站位為中受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3012,"_id_":2000108},"2000109":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dmg to Flower Up","ja":"凛明館立ち位置中の花属性特効与ダメージアップ","ko":"린메이칸 중간 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為中的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3012,"_id_":2000109},"2000110":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dmg to Wind Up","ja":"凛明館立ち位置中の風属性特効与ダメージアップ","ko":"린메이칸 중간 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為中的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3012,"_id_":2000110},"2000111":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dmg to Snow Up","ja":"凛明館立ち位置中の雪属性特効与ダメージアップ","ko":"린메이칸 중간 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為中的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3012,"_id_":2000111},"2000112":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dmg to Moon Up","ja":"凛明館立ち位置中の月属性特効与ダメージアップ","ko":"린메이칸 중간 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為中的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3012,"_id_":2000112},"2000113":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dmg to Space Up","ja":"凛明館立ち位置中の宙属性特効与ダメージアップ","ko":"린메이칸 중간 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為中的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3012,"_id_":2000113},"2000114":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dmg to Cloud Up","ja":"凛明館立ち位置中の雲属性特効与ダメージアップ","ko":"린메이칸 중간 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為中的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3012,"_id_":2000114},"2000115":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dmg to Dream Up","ja":"凛明館立ち位置中の夢属性特効与ダメージアップ","ko":"린메이칸 중간 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為中的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3012,"_id_":2000115},"2000116":{"description":{"en":"(Passive) [Rinmeikan Center Position] Normal Defense Up %opt1_value% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [린메이칸 중간 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的普通防禦力 +%opt1_value%"},"name":{"en":"Rinmeikan Center Position Normal Defense Up","ja":"凛明館立ち位置中の通常防御力アップ","ko":"린메이칸 중간 포지션의 일반 방어력 증가","zh_hant":"提升凜明館站位為中的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3012,"_id_":2000116},"2000117":{"description":{"en":"(Passive) [Rinmeikan Center Position] Special Defense Up %opt1_value% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [린메이칸 중간 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的特殊防禦力 +%opt1_value%"},"name":{"en":"Rinmeikan Center Position Special Defense Up","ja":"凛明館立ち位置中の特殊防御力アップ","ko":"린메이칸 중간 포지션의 특수 방어력 증가","zh_hant":"提升凜明館站位為中的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3012,"_id_":2000117},"2000118":{"description":{"en":"(Passive) [Rinmeikan Center Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的普通防禦力 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Normal Defense Up","ja":"凛明館立ち位置中の通常防御力アップ","ko":"린메이칸 중간 포지션의 일반 방어력 증가","zh_hant":"提升凜明館站位為中的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3012,"_id_":2000118},"2000119":{"description":{"en":"(Passive) [Rinmeikan Center Position] Special Defense Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Special Defense Up","ja":"凛明館立ち位置中の特殊防御力アップ","ko":"린메이칸 중간 포지션의 특수 방어력 증가","zh_hant":"提升凜明館站位為中的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3012,"_id_":2000119},"2000120":{"description":{"en":"(Passive) [Rinmeikan Center Position] Dexterity Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的會心率 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Dexterity Up","ja":"凛明館立ち位置中のクリティカル率アップ","ko":"린메이칸 중간 포지션의 크리티컬 확률 증가","zh_hant":"提升凜明館站位為中的會心率"},"skill_option1_id":20,"skill_option1_target_id":3012,"_id_":2000120},"2000121":{"description":{"en":"(Passive) [Rinmeikan Center Position] Critical Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [린메이칸 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為中】的會心威力 +%opt1_value%%"},"name":{"en":"Rinmeikan Center Position Critical Up","ja":"凛明館立ち位置中のクリティカル威力アップ","ko":"린메이칸 중간 포지션의 크리티컬 위력 증가","zh_hant":"提升凜明館站位為中的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3012,"_id_":2000121},"2000201":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【凛明館かつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [린메이칸 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Rinmeikan Rear Position Act Power Up","ja":"凛明館立ち位置後のACTパワーアップ","ko":"린메이칸 뒤 포지션의 ACT 파워 증가","zh_hant":"提升凜明館站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3013,"_id_":2000201},"2000202":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Flower Dmg Received Down","ja":"凛明館立ち位置後の花属性被ダメージダウン","ko":"린메이칸 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕凜明館站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3013,"_id_":2000202},"2000203":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Wind Dmg Received Down","ja":"凛明館立ち位置後の風属性被ダメージダウン","ko":"린메이칸 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕凜明館站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3013,"_id_":2000203},"2000204":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Snow Dmg Received Down","ja":"凛明館立ち位置後の雪属性被ダメージダウン","ko":"린메이칸 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕凜明館站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3013,"_id_":2000204},"2000205":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Moon Dmg Received Down","ja":"凛明館立ち位置後の月属性被ダメージダウン","ko":"린메이칸 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕凜明館站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3013,"_id_":2000205},"2000206":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Space Dmg Received Down","ja":"凛明館立ち位置後の宙属性被ダメージダウン","ko":"린메이칸 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕凜明館站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3013,"_id_":2000206},"2000207":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Cloud Dmg Received Down","ja":"凛明館立ち位置後の雲属性被ダメージダウン","ko":"린메이칸 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕凜明館站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3013,"_id_":2000207},"2000208":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【凜明館且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dream Dmg Received Down","ja":"凛明館立ち位置後の夢属性被ダメージダウン","ko":"린메이칸 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕凜明館站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3013,"_id_":2000208},"2000209":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dmg to Flower Up","ja":"凛明館立ち位置後の花属性特効与ダメージアップ","ko":"린메이칸 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3013,"_id_":2000209},"2000210":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dmg to Wind Up","ja":"凛明館立ち位置後の風属性特効与ダメージアップ","ko":"린메이칸 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3013,"_id_":2000210},"2000211":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dmg to Snow Up","ja":"凛明館立ち位置後の雪属性特効与ダメージアップ","ko":"린메이칸 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3013,"_id_":2000211},"2000212":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dmg to Moon Up","ja":"凛明館立ち位置後の月属性特効与ダメージアップ","ko":"린메이칸 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3013,"_id_":2000212},"2000213":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dmg to Space Up","ja":"凛明館立ち位置後の宙属性特効与ダメージアップ","ko":"린메이칸 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3013,"_id_":2000213},"2000214":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dmg to Cloud Up","ja":"凛明館立ち位置後の雲属性特効与ダメージアップ","ko":"린메이칸 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3013,"_id_":2000214},"2000215":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dmg to Dream Up","ja":"凛明館立ち位置後の夢属性特効与ダメージアップ","ko":"린메이칸 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升凜明館站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3013,"_id_":2000215},"2000216":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [린메이칸 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Rinmeikan Rear Position Normal Defense Up","ja":"凛明館立ち位置後の通常防御力アップ","ko":"린메이칸 뒤 포지션의 일반 방어력 증가","zh_hant":"提升凜明館站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3013,"_id_":2000216},"2000217":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [린메이칸 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Rinmeikan Rear Position Special Defense Up","ja":"凛明館立ち位置後の特殊防御力アップ","ko":"린메이칸 뒤 포지션의 특수 방어력 증가","zh_hant":"提升凜明館站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3013,"_id_":2000217},"2000218":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Normal Defense Up","ja":"凛明館立ち位置後の通常防御力アップ","ko":"린메이칸 뒤 포지션의 일반 방어력 증가","zh_hant":"提升凜明館站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3013,"_id_":2000218},"2000219":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Special Defense Up","ja":"凛明館立ち位置後の特殊防御力アップ","ko":"린메이칸 뒤 포지션의 특수 방어력 증가","zh_hant":"提升凜明館站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3013,"_id_":2000219},"2000220":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Dexterity Up","ja":"凛明館立ち位置後のクリティカル率アップ","ko":"린메이칸 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升凜明館站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3013,"_id_":2000220},"2000221":{"description":{"en":"(Passive) [Rinmeikan Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【凛明館かつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [린메이칸 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【凜明館且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Rinmeikan Rear Position Critical Up","ja":"凛明館立ち位置後のクリティカル威力アップ","ko":"린메이칸 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升凜明館站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3013,"_id_":2000221},"2000301":{"description":{"en":"(Passive) [Fumi & Rui] Act Power Up %opt1_value% ","ja":"[永続]【文と塁】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [후미와 루이]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【文和壘】的ACT力量 +%opt1_value%"},"name":{"en":"Fumi & Rui Act Power Up","ja":"文と塁のACTパワーアップ","ko":"후미와 루이의 ACT 파워 증가","zh_hant":"文和壘的ACT力量提升"},"skill_option1_id":42,"skill_option1_target_id":3120,"_id_":2000301},"2000302":{"description":{"en":"(Passive) [Fumi & Rui] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【文と塁】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후미와 루이]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【文和壘】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Flower Dmg Received Down","ja":"文と塁の花属性被ダメージダウン","ko":"후미와 루이가 받는 꽃 속성 대미지 감소","zh_hant":"減輕文和壘受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3120,"_id_":2000302},"2000303":{"description":{"en":"(Passive) [Fumi & Rui] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【文と塁】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후미와 루이]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【文和壘】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Wind Dmg Received Down","ja":"文と塁の風属性被ダメージダウン","ko":"후미와 루이가 받는 바람 속성 대미지 감소","zh_hant":"減輕文和壘受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3120,"_id_":2000303},"2000304":{"description":{"en":"(Passive) [Fumi & Rui] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【文と塁】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후미와 루이]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【文和壘】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Snow Dmg Received Down","ja":"文と塁の雪属性被ダメージダウン","ko":"후미와 루이가 받는 눈 속성 대미지 감소","zh_hant":"減輕文和壘受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3120,"_id_":2000304},"2000305":{"description":{"en":"(Passive) [Fumi & Rui] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【文と塁】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후미와 루이]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【文和壘】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Moon Dmg Received Down","ja":"文と塁の月属性被ダメージダウン","ko":"후미와 루이가 받는 달 속성 대미지 감소","zh_hant":"減輕文和壘受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3120,"_id_":2000305},"2000306":{"description":{"en":"(Passive) [Fumi & Rui] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【文と塁】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후미와 루이]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【文和壘】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Space Dmg Received Down","ja":"文と塁の宙属性被ダメージダウン","ko":"후미와 루이가 받는 우주 속성 대미지 감소","zh_hant":"減輕文和壘受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3120,"_id_":2000306},"2000307":{"description":{"en":"(Passive) [Fumi & Rui] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【文と塁】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후미와 루이]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【文和壘】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Cloud Dmg Received Down","ja":"文と塁の雲属性被ダメージダウン","ko":"후미와 루이가 받는 구름 속성 대미지 감소","zh_hant":"減輕文和壘受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3120,"_id_":2000307},"2000308":{"description":{"en":"(Passive) [Fumi & Rui] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【文と塁】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후미와 루이]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【文和壘】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dream Dmg Received Down","ja":"文と塁の夢属性被ダメージダウン","ko":"후미와 루이가 받는 꿈 속성 대미지 감소","zh_hant":"減輕文和壘受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3120,"_id_":2000308},"2000309":{"description":{"en":"(Passive) [Fumi & Rui] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후미와 루이]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dmg to Flower Up","ja":"文と塁の花属性特効与ダメージアップ","ko":"후미와 루이가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升文和壘的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3120,"_id_":2000309},"2000310":{"description":{"en":"(Passive) [Fumi & Rui] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후미와 루이]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dmg to Wind Up","ja":"文と塁の風属性特効与ダメージアップ","ko":"후미와 루이가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升文和壘的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3120,"_id_":2000310},"2000311":{"description":{"en":"(Passive) [Fumi & Rui] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후미와 루이]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dmg to Snow Up","ja":"文と塁の雪属性特効与ダメージアップ","ko":"후미와 루이가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升文和壘的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3120,"_id_":2000311},"2000312":{"description":{"en":"(Passive) [Fumi & Rui] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후미와 루이]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dmg to Moon Up","ja":"文と塁の月属性特効与ダメージアップ","ko":"후미와 루이가 달 속성에게 가하는 대미지 증가","zh_hant":"提升文和壘的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3120,"_id_":2000312},"2000313":{"description":{"en":"(Passive) [Fumi & Rui] Dmg to Space Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후미와 루이]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dmg to Space Up","ja":"文と塁の宙属性特効与ダメージアップ","ko":"후미와 루이가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升文和壘的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3120,"_id_":2000313},"2000314":{"description":{"en":"(Passive) [Fumi & Rui] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후미와 루이]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dmg to Cloud Up","ja":"文と塁の雲属性特効与ダメージアップ","ko":"후미와 루이가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升文和壘的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3120,"_id_":2000314},"2000315":{"description":{"en":"(Passive) [Fumi & Rui] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후미와 루이]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dmg to Dream Up","ja":"文と塁の夢属性特効与ダメージアップ","ko":"후미와 루이가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升文和壘的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3120,"_id_":2000315},"2000316":{"description":{"en":"(Passive) [Fumi & Rui] Normal Defense Up %opt1_value% ","ja":"[永続]【文と塁】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [후미와 루이]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【文和壘】的普通防禦力 +%opt1_value%"},"name":{"en":"Fumi & Rui Normal Defense Up","ja":"文と塁の通常防御力アップ","ko":"후미와 루이의 일반 방어력 증가","zh_hant":"提升文和壘的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3120,"_id_":2000316},"2000317":{"description":{"en":"(Passive) [Fumi & Rui] Special Defense Up %opt1_value% ","ja":"[永続]【文と塁】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [후미와 루이]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【文和壘】的特殊防禦力 +%opt1_value%"},"name":{"en":"Fumi & Rui Special Defense Up","ja":"文と塁の特殊防御力アップ","ko":"후미와 루이의 특수 방어력 증가","zh_hant":"提升文和壘的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3120,"_id_":2000317},"2000318":{"description":{"en":"(Passive) [Fumi & Rui] Normal Defense Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [후미와 루이]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的普通防禦力 +%opt1_value%%"},"name":{"en":"Fumi & Rui Normal Defense Up","ja":"文と塁の通常防御力アップ","ko":"후미와 루이의 일반 방어력 증가","zh_hant":"提升文和壘的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3120,"_id_":2000318},"2000319":{"description":{"en":"(Passive) [Fumi & Rui] Special Defense Up %opt1_value%% ","ja":"[永続]【文と塁】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [후미와 루이]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Fumi & Rui Special Defense Up","ja":"文と塁の特殊防御力アップ","ko":"후미와 루이의 특수 방어력 증가","zh_hant":"提升文和壘的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3120,"_id_":2000319},"2000320":{"description":{"en":"(Passive) [Fumi & Rui] Dexterity Up %opt1_value%% ","ja":"[永続]【文と塁】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [후미와 루이]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的會心率 +%opt1_value%%"},"name":{"en":"Fumi & Rui Dexterity Up","ja":"文と塁のクリティカル率アップ","ko":"후미와 루이의 크리티컬 확률 증가","zh_hant":"提升文和壘的會心率"},"skill_option1_id":20,"skill_option1_target_id":3120,"_id_":2000320},"2000321":{"description":{"en":"(Passive) [Fumi & Rui] Critical Up %opt1_value%% ","ja":"[永続]【文と塁】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [후미와 루이]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【文和壘】的會心威力 +%opt1_value%%"},"name":{"en":"Fumi & Rui Critical Up","ja":"文と塁のクリティカル威力アップ","ko":"후미와 루이의 크리티컬 위력 증가","zh_hant":"提升文和壘的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3120,"_id_":2000321},"3000101":{"description":{"en":"(Passive) [Frontier Center Position] Act Power Up %opt1_value% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [프론티어 중간 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的ACT力量 +%opt1_value%"},"name":{"en":"Frontier Center Position Act Power Up","ja":"フロンティア立ち位置中のACTパワーアップ","ko":"프론티어 중간 포지션의 ACT 파워 증가","zh_hant":"提升芙羅提亞站位為中的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3022,"_id_":3000101},"3000102":{"description":{"en":"(Passive) [Frontier Center Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為中】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Flower Dmg Received Down","ja":"フロンティア立ち位置中の花属性被ダメージダウン","ko":"프론티어 중간 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為中受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3022,"_id_":3000102},"3000103":{"description":{"en":"(Passive) [Frontier Center Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為中】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Wind Dmg Received Down","ja":"フロンティア立ち位置中の風属性被ダメージダウン","ko":"프론티어 중간 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為中受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3022,"_id_":3000103},"3000104":{"description":{"en":"(Passive) [Frontier Center Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為中】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Snow Dmg Received Down","ja":"フロンティア立ち位置中の雪属性被ダメージダウン","ko":"프론티어 중간 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為中受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3022,"_id_":3000104},"3000105":{"description":{"en":"(Passive) [Frontier Center Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為中】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Moon Dmg Received Down","ja":"フロンティア立ち位置中の月属性被ダメージダウン","ko":"프론티어 중간 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為中受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3022,"_id_":3000105},"3000106":{"description":{"en":"(Passive) [Frontier Center Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為中】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Space Dmg Received Down","ja":"フロンティア立ち位置中の宙属性被ダメージダウン","ko":"프론티어 중간 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為中受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3022,"_id_":3000106},"3000107":{"description":{"en":"(Passive) [Frontier Center Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為中】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Cloud Dmg Received Down","ja":"フロンティア立ち位置中の雲属性被ダメージダウン","ko":"프론티어 중간 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為中受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3022,"_id_":3000107},"3000108":{"description":{"en":"(Passive) [Frontier Center Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為中】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dream Dmg Received Down","ja":"フロンティア立ち位置中の夢属性被ダメージダウン","ko":"프론티어 중간 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為中受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3022,"_id_":3000108},"3000109":{"description":{"en":"(Passive) [Frontier Center Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dmg to Flower Up","ja":"フロンティア立ち位置中の花属性特効与ダメージアップ","ko":"프론티어 중간 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為中的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3022,"_id_":3000109},"3000110":{"description":{"en":"(Passive) [Frontier Center Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dmg to Wind Up","ja":"フロンティア立ち位置中の風属性特効与ダメージアップ","ko":"프론티어 중간 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為中的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3022,"_id_":3000110},"3000111":{"description":{"en":"(Passive) [Frontier Center Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dmg to Snow Up","ja":"フロンティア立ち位置中の雪属性特効与ダメージアップ","ko":"프론티어 중간 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為中的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3022,"_id_":3000111},"3000112":{"description":{"en":"(Passive) [Frontier Center Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dmg to Moon Up","ja":"フロンティア立ち位置中の月属性特効与ダメージアップ","ko":"프론티어 중간 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為中的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3022,"_id_":3000112},"3000113":{"description":{"en":"(Passive) [Frontier Center Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dmg to Space Up","ja":"フロンティア立ち位置中の宙属性特効与ダメージアップ","ko":"프론티어 중간 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為中的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3022,"_id_":3000113},"3000114":{"description":{"en":"(Passive) [Frontier Center Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dmg to Cloud Up","ja":"フロンティア立ち位置中の雲属性特効与ダメージアップ","ko":"프론티어 중간 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為中的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3022,"_id_":3000114},"3000115":{"description":{"en":"(Passive) [Frontier Center Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dmg to Dream Up","ja":"フロンティア立ち位置中の夢属性特効与ダメージアップ","ko":"프론티어 중간 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為中的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3022,"_id_":3000115},"3000116":{"description":{"en":"(Passive) [Frontier Center Position] Normal Defense Up %opt1_value% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [프론티어 중간 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的普通防禦力 +%opt1_value%"},"name":{"en":"Frontier Center Position Normal Defense Up","ja":"フロンティア立ち位置中の通常防御力アップ","ko":"프론티어 중간 포지션의 일반 방어력 증가","zh_hant":"提升芙羅提亞站位為中的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3022,"_id_":3000116},"3000117":{"description":{"en":"(Passive) [Frontier Center Position] Special Defense Up %opt1_value% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [프론티어 중간 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的特殊防禦力 +%opt1_value%"},"name":{"en":"Frontier Center Position Special Defense Up","ja":"フロンティア立ち位置中の特殊防御力アップ","ko":"프론티어 중간 포지션의 특수 방어력 증가","zh_hant":"提升芙羅提亞站位為中的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3022,"_id_":3000117},"3000118":{"description":{"en":"(Passive) [Frontier Center Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的普通防禦力 +%opt1_value%%"},"name":{"en":"Frontier Center Position Normal Defense Up","ja":"フロンティア立ち位置中の通常防御力アップ","ko":"프론티어 중간 포지션의 일반 방어력 증가","zh_hant":"提升芙羅提亞站位為中的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3022,"_id_":3000118},"3000119":{"description":{"en":"(Passive) [Frontier Center Position] Special Defense Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Frontier Center Position Special Defense Up","ja":"フロンティア立ち位置中の特殊防御力アップ","ko":"프론티어 중간 포지션의 특수 방어력 증가","zh_hant":"提升芙羅提亞站位為中的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3022,"_id_":3000119},"3000120":{"description":{"en":"(Passive) [Frontier Center Position] Dexterity Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的會心率 +%opt1_value%%"},"name":{"en":"Frontier Center Position Dexterity Up","ja":"フロンティア立ち位置中のクリティカル率アップ","ko":"프론티어 중간 포지션의 크리티컬 확률 증가","zh_hant":"提升芙羅提亞站位為中的會心率"},"skill_option1_id":20,"skill_option1_target_id":3022,"_id_":3000120},"3000121":{"description":{"en":"(Passive) [Frontier Center Position] Critical Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [프론티어 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為中】的會心威力 +%opt1_value%%"},"name":{"en":"Frontier Center Position Critical Up","ja":"フロンティア立ち位置中のクリティカル威力アップ","ko":"프론티어 중간 포지션의 크리티컬 위력 증가","zh_hant":"提升芙羅提亞站位為中的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3022,"_id_":3000121},"3000201":{"description":{"en":"(Passive) [Frontier Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [프론티어 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Frontier Rear Position Act Power Up","ja":"フロンティア立ち位置後のACTパワーアップ","ko":"프론티어 뒤 포지션의 ACT 파워 증가","zh_hant":"提升芙羅提亞站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3023,"_id_":3000201},"3000202":{"description":{"en":"(Passive) [Frontier Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Flower Dmg Received Down","ja":"フロンティア立ち位置後の花属性被ダメージダウン","ko":"프론티어 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3023,"_id_":3000202},"3000203":{"description":{"en":"(Passive) [Frontier Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Wind Dmg Received Down","ja":"フロンティア立ち位置後の風属性被ダメージダウン","ko":"프론티어 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3023,"_id_":3000203},"3000204":{"description":{"en":"(Passive) [Frontier Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Snow Dmg Received Down","ja":"フロンティア立ち位置後の雪属性被ダメージダウン","ko":"프론티어 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3023,"_id_":3000204},"3000205":{"description":{"en":"(Passive) [Frontier Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Moon Dmg Received Down","ja":"フロンティア立ち位置後の月属性被ダメージダウン","ko":"프론티어 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3023,"_id_":3000205},"3000206":{"description":{"en":"(Passive) [Frontier Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Space Dmg Received Down","ja":"フロンティア立ち位置後の宙属性被ダメージダウン","ko":"프론티어 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3023,"_id_":3000206},"3000207":{"description":{"en":"(Passive) [Frontier Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Cloud Dmg Received Down","ja":"フロンティア立ち位置後の雲属性被ダメージダウン","ko":"프론티어 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3023,"_id_":3000207},"3000208":{"description":{"en":"(Passive) [Frontier Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dream Dmg Received Down","ja":"フロンティア立ち位置後の夢属性被ダメージダウン","ko":"프론티어 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕芙羅提亞站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3023,"_id_":3000208},"3000209":{"description":{"en":"(Passive) [Frontier Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dmg to Flower Up","ja":"フロンティア立ち位置後の花属性特効与ダメージアップ","ko":"프론티어 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3023,"_id_":3000209},"3000210":{"description":{"en":"(Passive) [Frontier Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dmg to Wind Up","ja":"フロンティア立ち位置後の風属性特効与ダメージアップ","ko":"프론티어 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3023,"_id_":3000210},"3000211":{"description":{"en":"(Passive) [Frontier Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dmg to Snow Up","ja":"フロンティア立ち位置後の雪属性特効与ダメージアップ","ko":"프론티어 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3023,"_id_":3000211},"3000212":{"description":{"en":"(Passive) [Frontier Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dmg to Moon Up","ja":"フロンティア立ち位置後の月属性特効与ダメージアップ","ko":"프론티어 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3023,"_id_":3000212},"3000213":{"description":{"en":"(Passive) [Frontier Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dmg to Space Up","ja":"フロンティア立ち位置後の宙属性特効与ダメージアップ","ko":"프론티어 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3023,"_id_":3000213},"3000214":{"description":{"en":"(Passive) [Frontier Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dmg to Cloud Up","ja":"フロンティア立ち位置後の雲属性特効与ダメージアップ","ko":"프론티어 뒤 포지션이 우름 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3023,"_id_":3000214},"3000215":{"description":{"en":"(Passive) [Frontier Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dmg to Dream Up","ja":"フロンティア立ち位置後の夢属性特効与ダメージアップ","ko":"프론티어 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3023,"_id_":3000215},"3000216":{"description":{"en":"(Passive) [Frontier Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [프론티어 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Frontier Rear Position Normal Defense Up","ja":"フロンティア立ち位置後の通常防御力アップ","ko":"프론티어 뒤 포지션의 일반 방어력 증가","zh_hant":"提升芙羅提亞站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3023,"_id_":3000216},"3000217":{"description":{"en":"(Passive) [Frontier Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [프론티어 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Frontier Rear Position Special Defense Up","ja":"フロンティア立ち位置後の特殊防御力アップ","ko":"프론티어 뒤 포지션의 특수 방어력 증가","zh_hant":"提升芙羅提亞站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3023,"_id_":3000217},"3000218":{"description":{"en":"(Passive) [Frontier Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Normal Defense Up","ja":"フロンティア立ち位置後の通常防御力アップ","ko":"프론티어 뒤 포지션의 일반 방어력 증가","zh_hant":"提升芙羅提亞站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3023,"_id_":3000218},"3000219":{"description":{"en":"(Passive) [Frontier Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Special Defense Up","ja":"フロンティア立ち位置後の特殊防御力アップ","ko":"프론티어 뒤 포지션의 특수 방어력 증가","zh_hant":"提升芙羅提亞站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3023,"_id_":3000219},"3000220":{"description":{"en":"(Passive) [Frontier Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Dexterity Up","ja":"フロンティア立ち位置後のクリティカル率アップ","ko":"프론티어 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升芙羅提亞站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3023,"_id_":3000220},"3000221":{"description":{"en":"(Passive) [Frontier Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【フロンティアかつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [프론티어 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Frontier Rear Position Critical Up","ja":"フロンティア立ち位置後のクリティカル威力アップ","ko":"프론티어 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升芙羅提亞站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3023,"_id_":3000221},"3000301":{"description":{"en":"(Passive) [Aruru & Misora] Act Power Up %opt1_value% ","ja":"[永続]【あるると美空】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [아루루와 미소라]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【艾露露和美空】的ACT力量 +%opt1_value%"},"name":{"en":"Aruru & Misora Act Power Up","ja":"あるると美空のACTパワーアップ","ko":"아루루와 미소라의 ACT 파워 증가","zh_hant":"提升艾露露和美空的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3130,"_id_":3000301},"3000302":{"description":{"en":"(Passive) [Aruru & Misora] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【あるると美空】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【艾露露和美空】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Flower Dmg Received Down","ja":"あるると美空の花属性被ダメージダウン","ko":"아루루와 미소라가 받는 꽃 속성 대미지 감소","zh_hant":"減輕艾露露和美空受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3130,"_id_":3000302},"3000303":{"description":{"en":"(Passive) [Aruru & Misora] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【あるると美空】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【艾露露和美空】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Wind Dmg Received Down","ja":"あるると美空の風属性被ダメージダウン","ko":"아루루와 미소라가 받는 바람 속성 대미지 감소","zh_hant":"減輕艾露露和美空受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3130,"_id_":3000303},"3000304":{"description":{"en":"(Passive) [Aruru & Misora] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【あるると美空】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【艾露露和美空】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Snow Dmg Received Down","ja":"あるると美空の雪属性被ダメージダウン","ko":"아루루와 미소라가 받는 눈 속성 대미지 감소","zh_hant":"減輕艾露露和美空受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3130,"_id_":3000304},"3000305":{"description":{"en":"(Passive) [Aruru & Misora] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【あるると美空】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【艾露露和美空】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Moon Dmg Received Down","ja":"あるると美空の月属性被ダメージダウン","ko":"아루루와 미소라가 받는 달 속성 대미지 감소","zh_hant":"減輕艾露露和美空受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3130,"_id_":3000305},"3000306":{"description":{"en":"(Passive) [Aruru & Misora] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【あるると美空】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【艾露露和美空】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Space Dmg Received Down","ja":"あるると美空の宙属性被ダメージダウン","ko":"아루루와 미소라가 받는 우주 속성 대미지 감소","zh_hant":"減輕艾露露和美空受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3130,"_id_":3000306},"3000307":{"description":{"en":"(Passive) [Aruru & Misora] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【あるると美空】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【艾露露和美空】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Cloud Dmg Received Down","ja":"あるると美空の雲属性被ダメージダウン","ko":"아루루와 미소라가 받는 구름 속성 대미지 감소","zh_hant":"減輕艾露露和美空受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3130,"_id_":3000307},"3000308":{"description":{"en":"(Passive) [Aruru & Misora] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【あるると美空】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【艾露露和美空】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dream Dmg Received Down","ja":"あるると美空の夢属性被ダメージダウン","ko":"아루루와 미소라가 받는 꿈 속성 대미지 감소","zh_hant":"減輕艾露露和美空受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3130,"_id_":3000308},"3000309":{"description":{"en":"(Passive) [Aruru & Misora] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dmg to Flower Up","ja":"あるると美空の花属性特効与ダメージアップ","ko":"아루루와 미소라가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升艾露露和美空的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3130,"_id_":3000309},"3000310":{"description":{"en":"(Passive) [Aruru & Misora] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dmg to Wind Up","ja":"あるると美空の風属性特効与ダメージアップ","ko":"아루루와 미소라가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升艾露露和美空的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3130,"_id_":3000310},"3000311":{"description":{"en":"(Passive) [Aruru & Misora] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dmg to Snow Up","ja":"あるると美空の雪属性特効与ダメージアップ","ko":"아루루와 미소라가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升艾露露和美空的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3130,"_id_":3000311},"3000312":{"description":{"en":"(Passive) [Aruru & Misora] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dmg to Moon Up","ja":"あるると美空の月属性特効与ダメージアップ","ko":"아루루와 미소라가 달 속성에게 가하는 대미지 증가","zh_hant":"提升艾露露和美空的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3130,"_id_":3000312},"3000313":{"description":{"en":"(Passive) [Aruru & Misora] Dmg to Space Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dmg to Space Up","ja":"あるると美空の宙属性特効与ダメージアップ","ko":"아루루와 미소라가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升艾露露和美空的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3130,"_id_":3000313},"3000314":{"description":{"en":"(Passive) [Aruru & Misora] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dmg to Cloud Up","ja":"あるると美空の雲属性特効与ダメージアップ","ko":"아루루와 미소라가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升艾露露和美空的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3130,"_id_":3000314},"3000315":{"description":{"en":"(Passive) [Aruru & Misora] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dmg to Dream Up","ja":"あるると美空の夢属性特効与ダメージアップ","ko":"아루루와 미소라가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升艾露露和美空的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3130,"_id_":3000315},"3000316":{"description":{"en":"(Passive) [Aruru & Misora] Normal Defense Up %opt1_value% ","ja":"[永続]【あるると美空】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [아루루와 미소라]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【艾露露和美空】的普通防禦力 +%opt1_value%"},"name":{"en":"Aruru & Misora Normal Defense Up","ja":"あるると美空の通常防御力アップ","ko":"아루루와 미소라의 일반 방어력 증가","zh_hant":"提升艾露露和美空的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3130,"_id_":3000316},"3000317":{"description":{"en":"(Passive) [Aruru & Misora] Special Defense Up %opt1_value% ","ja":"[永続]【あるると美空】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [아루루와 미소라]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【艾露露和美空】的特殊防禦力 +%opt1_value%"},"name":{"en":"Aruru & Misora Special Defense Up","ja":"あるると美空の特殊防御力アップ","ko":"아루루와 미소라의 특수 방어력 증가","zh_hant":"提升艾露露和美空的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3130,"_id_":3000317},"3000318":{"description":{"en":"(Passive) [Aruru & Misora] Normal Defense Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的普通防禦力 +%opt1_value%%"},"name":{"en":"Aruru & Misora Normal Defense Up","ja":"あるると美空の通常防御力アップ","ko":"아루루와 미소라의 일반 방어력 증가","zh_hant":"提升艾露露和美空的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3130,"_id_":3000318},"3000319":{"description":{"en":"(Passive) [Aruru & Misora] Special Defense Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Aruru & Misora Special Defense Up","ja":"あるると美空の特殊防御力アップ","ko":"아루루와 미소라의 특수 방어력 증가","zh_hant":"提升艾露露和美空的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3130,"_id_":3000319},"3000320":{"description":{"en":"(Passive) [Aruru & Misora] Dexterity Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的會心率 +%opt1_value%%"},"name":{"en":"Aruru & Misora Dexterity Up","ja":"あるると美空のクリティカル率アップ","ko":"아루루와 미소라의 크리티컬 확률 증가","zh_hant":"提升艾露露和美空的會心率"},"skill_option1_id":20,"skill_option1_target_id":3130,"_id_":3000320},"3000321":{"description":{"en":"(Passive) [Aruru & Misora] Critical Up %opt1_value%% ","ja":"[永続]【あるると美空】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [아루루와 미소라]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【艾露露和美空】的會心威力 +%opt1_value%%"},"name":{"en":"Aruru & Misora Critical Up","ja":"あるると美空のクリティカル威力アップ","ko":"아루루와 미소라의 크리티컬 위력 증가","zh_hant":"提升艾露露和美空的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3130,"_id_":3000321},"4000101":{"description":{"en":"(Passive) [Siegfeld Center Position] Act Power Up %opt1_value% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [시크펠트 중간 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的ACT力量 +%opt1_value%"},"name":{"en":"Siegfeld Center Position Act Power Up","ja":"シークフェルト立ち位置中のACTパワーアップ","ko":"시크펠트 중간 포지션의 ACT 파워 증가","zh_hant":"提升席格菲特站位為中的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3032,"_id_":4000101},"4000102":{"description":{"en":"(Passive) [Siegfeld Center Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為中】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Flower Dmg Received Down","ja":"シークフェルト立ち位置中の花属性被ダメージダウン","ko":"시크펠트 중간 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕席格菲特站位為中受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3032,"_id_":4000102},"4000103":{"description":{"en":"(Passive) [Siegfeld Center Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為中】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Wind Dmg Received Down","ja":"シークフェルト立ち位置中の風属性被ダメージダウン","ko":"시크펠트 중간 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕席格菲特站位為中受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3032,"_id_":4000103},"4000104":{"description":{"en":"(Passive) [Siegfeld Center Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為中】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Snow Dmg Received Down","ja":"シークフェルト立ち位置中の雪属性被ダメージダウン","ko":"시크펠트 중간 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕席格菲特站位為中受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3032,"_id_":4000104},"4000105":{"description":{"en":"(Passive) [Siegfeld Center Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為中】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Moon Dmg Received Down","ja":"シークフェルト立ち位置中の月属性被ダメージダウン","ko":"시크펠트 중간 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕席格菲特站位為中受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3032,"_id_":4000105},"4000106":{"description":{"en":"(Passive) [Siegfeld Center Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為中】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Space Dmg Received Down","ja":"シークフェルト立ち位置中の宙属性被ダメージダウン","ko":"시크펠트 중간 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕席格菲特站位為中受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3032,"_id_":4000106},"4000107":{"description":{"en":"(Passive) [Siegfeld Center Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為中】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Cloud Dmg Received Down","ja":"シークフェルト立ち位置中の雲属性被ダメージダウン","ko":"시크펠트 중간 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕席格菲特站位為中受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3032,"_id_":4000107},"4000108":{"description":{"en":"(Passive) [Siegfeld Center Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為中】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dream Dmg Received Down","ja":"シークフェルト立ち位置中の夢属性被ダメージダウン","ko":"시크펠트 중간 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕席格菲特站位為中受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3032,"_id_":4000108},"4000109":{"description":{"en":"(Passive) [Siegfeld Center Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dmg to Flower Up","ja":"シークフェルト立ち位置中の花属性特効与ダメージアップ","ko":"시크펠트 중간 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為中的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3032,"_id_":4000109},"4000110":{"description":{"en":"(Passive) [Siegfeld Center Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dmg to Wind Up","ja":"シークフェルト立ち位置中の風属性特効与ダメージアップ","ko":"시크펠트 중간 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為中的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3032,"_id_":4000110},"4000111":{"description":{"en":"(Passive) [Siegfeld Center Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dmg to Snow Up","ja":"シークフェルト立ち位置中の雪属性特効与ダメージアップ","ko":"시크펠트 중간 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為中的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3032,"_id_":4000111},"4000112":{"description":{"en":"(Passive) [Siegfeld Center Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dmg to Moon Up","ja":"シークフェルト立ち位置中の月属性特効与ダメージアップ","ko":"시크펠트 중간 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為中的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3032,"_id_":4000112},"4000113":{"description":{"en":"(Passive) [Siegfeld Center Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dmg to Space Up","ja":"シークフェルト立ち位置中の宙属性特効与ダメージアップ","ko":"시크펠트 중간 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為中的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3032,"_id_":4000113},"4000114":{"description":{"en":"(Passive) [Siegfeld Center Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dmg to Cloud Up","ja":"シークフェルト立ち位置中の雲属性特効与ダメージアップ","ko":"시크펠트 중간 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為中的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3032,"_id_":4000114},"4000115":{"description":{"en":"(Passive) [Siegfeld Center Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dmg to Dream Up","ja":"シークフェルト立ち位置中の夢属性特効与ダメージアップ","ko":"시크펠트 중간 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為中的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3032,"_id_":4000115},"4000116":{"description":{"en":"(Passive) [Siegfeld Center Position] Normal Defense Up %opt1_value% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 중간 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的普通防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Center Position Normal Defense Up","ja":"シークフェルト立ち位置中の通常防御力アップ","ko":"시크펠트 중간 포지션의 일반 방어력 증가","zh_hant":"提升席格菲特站位為中的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3032,"_id_":4000116},"4000117":{"description":{"en":"(Passive) [Siegfeld Center Position] Special Defense Up %opt1_value% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 중간 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的特殊防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Center Position Special Defense Up","ja":"シークフェルト立ち位置中の特殊防御力アップ","ko":"시크펠트 중간 포지션의 특수 방어력 증가","zh_hant":"提升席格菲特站位為中的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3032,"_id_":4000117},"4000118":{"description":{"en":"(Passive) [Siegfeld Center Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的普通防禦力 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Normal Defense Up","ja":"シークフェルト立ち位置中の通常防御力アップ","ko":"시크펠트 중간 포지션의 일반 방어력 증가","zh_hant":"提升席格菲特站位為中的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3032,"_id_":4000118},"4000119":{"description":{"en":"(Passive) [Siegfeld Center Position] Special Defense Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Special Defense Up","ja":"シークフェルト立ち位置中の特殊防御力アップ","ko":"시크펠트 중간 포지션의 특수 방어력 증가","zh_hant":"提升席格菲特站位為中的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3032,"_id_":4000119},"4000120":{"description":{"en":"(Passive) [Siegfeld Center Position] Dexterity Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的會心率 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Dexterity Up","ja":"シークフェルト立ち位置中のクリティカル率アップ","ko":"시크펠트 중간 포지션의 크리티컬 확률 증가","zh_hant":"提升席格菲特站位為中的會心率"},"skill_option1_id":20,"skill_option1_target_id":3032,"_id_":4000120},"4000121":{"description":{"en":"(Passive) [Siegfeld Center Position] Critical Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置中】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [시크펠트 중간 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為中】的會心威力 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Critical Up","ja":"シークフェルト立ち位置中のクリティカル威力アップ","ko":"시크펠트 중간 포지션의 크리티컬 위력 증가","zh_hant":"提升席格菲特站位為中的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3032,"_id_":4000121},"4000201":{"description":{"en":"(Passive) [Siegfeld Rear Position] Act Power Up %opt1_value% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [시크펠트 뒤 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的ACT力量 +%opt1_value%"},"name":{"en":"Siegfeld Rear Position Act Power Up","ja":"シークフェルト立ち位置後のACTパワーアップ","ko":"시크펠트 뒤 포지션의 ACT 파워 증가","zh_hant":"提升席格菲特站位為後的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3033,"_id_":4000201},"4000202":{"description":{"en":"(Passive) [Siegfeld Rear Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為後】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Flower Dmg Received Down","ja":"シークフェルト立ち位置後の花属性被ダメージダウン","ko":"시크펠트 뒤 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕席格菲特站位為後受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3033,"_id_":4000202},"4000203":{"description":{"en":"(Passive) [Siegfeld Rear Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為後】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Wind Dmg Received Down","ja":"シークフェルト立ち位置後の風属性被ダメージダウン","ko":"시크펠트 뒤 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕席格菲特站位為後受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3033,"_id_":4000203},"4000204":{"description":{"en":"(Passive) [Siegfeld Rear Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為後】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Snow Dmg Received Down","ja":"シークフェルト立ち位置後の雪属性被ダメージダウン","ko":"시크펠트 뒤 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕席格菲特站位為後受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3033,"_id_":4000204},"4000205":{"description":{"en":"(Passive) [Siegfeld Rear Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為後】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Moon Dmg Received Down","ja":"シークフェルト立ち位置後の月属性被ダメージダウン","ko":"시크펠트 뒤 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕席格菲特站位為後受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3033,"_id_":4000205},"4000206":{"description":{"en":"(Passive) [Siegfeld Rear Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為後】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Space Dmg Received Down","ja":"シークフェルト立ち位置後の宙属性被ダメージダウン","ko":"시크펠트 뒤 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕席格菲特站位為後受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3033,"_id_":4000206},"4000207":{"description":{"en":"(Passive) [Siegfeld Rear Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為後】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Cloud Dmg Received Down","ja":"シークフェルト立ち位置後の雲属性被ダメージダウン","ko":"시크펠트 뒤 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕席格菲特站位為後受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3033,"_id_":4000207},"4000208":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特且站位為後】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dream Dmg Received Down","ja":"シークフェルト立ち位置後の夢属性被ダメージダウン","ko":"시크펠트 뒤 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕席格菲特站位為後受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3033,"_id_":4000208},"4000209":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dmg to Flower Up","ja":"シークフェルト立ち位置後の花属性特効与ダメージアップ","ko":"시크펠트 뒤 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為後的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3033,"_id_":4000209},"4000210":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dmg to Wind Up","ja":"シークフェルト立ち位置後の風属性特効与ダメージアップ","ko":"시크펠트 뒤 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為後的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3033,"_id_":4000210},"4000211":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dmg to Snow Up","ja":"シークフェルト立ち位置後の雪属性特効与ダメージアップ","ko":"시크펠트 뒤 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為後的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3033,"_id_":4000211},"4000212":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dmg to Moon Up","ja":"シークフェルト立ち位置後の月属性特効与ダメージアップ","ko":"시크펠트 뒤 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為後的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3033,"_id_":4000212},"4000213":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dmg to Space Up","ja":"シークフェルト立ち位置後の宙属性特効与ダメージアップ","ko":"시크펠트 뒤 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為後的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3033,"_id_":4000213},"4000214":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dmg to Cloud Up","ja":"シークフェルト立ち位置後の雲属性特効与ダメージアップ","ko":"시크펠트 뒤 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為後的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3033,"_id_":4000214},"4000215":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dmg to Dream Up","ja":"シークフェルト立ち位置後の夢属性特効与ダメージアップ","ko":"시크펠트 뒤 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特站位為後的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3033,"_id_":4000215},"4000216":{"description":{"en":"(Passive) [Siegfeld Rear Position] Normal Defense Up %opt1_value% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 뒤 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的普通防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Rear Position Normal Defense Up","ja":"シークフェルト立ち位置後の通常防御力アップ","ko":"시크펠트 뒤 포지션의 일반 방어력 증가","zh_hant":"提升席格菲特站位為後的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3033,"_id_":4000216},"4000217":{"description":{"en":"(Passive) [Siegfeld Rear Position] Special Defense Up %opt1_value% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 뒤 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的特殊防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Rear Position Special Defense Up","ja":"シークフェルト立ち位置後の特殊防御力アップ","ko":"시크펠트 뒤 포지션의 특수 방어력 증가","zh_hant":"提升席格菲特站位為後的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3033,"_id_":4000217},"4000218":{"description":{"en":"(Passive) [Siegfeld Rear Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的普通防禦力 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Normal Defense Up","ja":"シークフェルト立ち位置後の通常防御力アップ","ko":"시크펠트 뒤 포지션의 일반 방어력 증가","zh_hant":"提升席格菲特站位為後的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3033,"_id_":4000218},"4000219":{"description":{"en":"(Passive) [Siegfeld Rear Position] Special Defense Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Special Defense Up","ja":"シークフェルト立ち位置後の特殊防御力アップ","ko":"시크펠트 뒤 포지션의 특수 방어력 증가","zh_hant":"提升席格菲特站位為後的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3033,"_id_":4000219},"4000220":{"description":{"en":"(Passive) [Siegfeld Rear Position] Dexterity Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的會心率 +%opt1_value%%"},"name":{"en":"Siegfeld Rear Position Dexterity Up","ja":"シークフェルト立ち位置後のクリティカル率アップ","ko":"시크펠트 뒤 포지션의 크리티컬 확률 증가","zh_hant":"提升席格菲特站位為後的會心率"},"skill_option1_id":20,"skill_option1_target_id":3033,"_id_":4000220},"4000221":{"description":{"en":"(Passive) [Siegfeld Rear Position] Critical Up %opt1_value%% ","ja":"[永続]【シークフェルトかつ立ち位置後】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [시크펠트 뒤 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特且站位為後】的會心威力 +%opt1_value%%"},"name":{"en":"Siegfeld Center Position Critical Up","ja":"シークフェルト立ち位置後のクリティカル威力アップ","ko":"시크펠트 뒤 포지션의 크리티컬 위력 증가","zh_hant":"提升席格菲特站位為後的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3033,"_id_":4000221},"4000301":{"description":{"en":"(Passive) [Flower Front Position] Act Power Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置前】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [꽃 속성 앞 포지션]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的ACT力量 +%opt1_value%"},"name":{"en":"Flower Front Position Act Power Up","ja":"花属性立ち位置前のACTパワーアップ","ko":"꽃 속성 앞 포지션의 ACT 파워 증가","zh_hant":"提升花屬性站位為前的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3051,"_id_":4000301},"4000302":{"description":{"en":"(Passive) [Flower Front Position] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為前】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Flower Dmg Received Down","ja":"花属性立ち位置前の花属性被ダメージダウン","ko":"꽃 속성 앞 포지션이 받는 꽃 속성 대미지 감소","zh_hant":"減輕花屬性站位為前受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3051,"_id_":4000302},"4000303":{"description":{"en":"(Passive) [Flower Front Position] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為前】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Wind Dmg Received Down","ja":"花属性立ち位置前の風属性被ダメージダウン","ko":"꽃 속성 앞 포지션이 받는 바람 속성 대미지 감소","zh_hant":"減輕花屬性站位為前受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3051,"_id_":4000303},"4000304":{"description":{"en":"(Passive) [Flower Front Position] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為前】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Snow Dmg Received Down","ja":"花属性立ち位置前の雪属性被ダメージダウン","ko":"꽃 속성 앞 포지션이 받는 눈 속성 대미지 감소","zh_hant":"減輕花屬性站位為前受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3051,"_id_":4000304},"4000305":{"description":{"en":"(Passive) [Flower Front Position] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為前】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Moon Dmg Received Down","ja":"花属性立ち位置前の月属性被ダメージダウン","ko":"꽃 속성 앞 포지션이 받는 달 속성 대미지 감소","zh_hant":"減輕花屬性站位為前受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3051,"_id_":4000305},"4000306":{"description":{"en":"(Passive) [Flower Front Position] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為前】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Space Dmg Received Down","ja":"花属性立ち位置前の宙属性被ダメージダウン","ko":"꽃 속성 앞 포지션이 받는 우주 속성 대미지 감소","zh_hant":"減輕花屬性站位為前受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3051,"_id_":4000306},"4000307":{"description":{"en":"(Passive) [Flower Front Position] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為前】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Cloud Dmg Received Down","ja":"花属性立ち位置前の雲属性被ダメージダウン","ko":"꽃 속성 앞 포지션이 받는 구름 속성 대미지 감소","zh_hant":"減輕花屬性站位為前受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3051,"_id_":4000307},"4000308":{"description":{"en":"(Passive) [Flower Front Position] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【花屬性且站位為前】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dream Dmg Received Down","ja":"花属性立ち位置前の夢属性被ダメージダウン","ko":"꽃 속성 앞 포지션이 받는 꿈 속성 대미지 감소","zh_hant":"減輕花屬性站位為前受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3051,"_id_":4000308},"4000309":{"description":{"en":"(Passive) [Flower Front Position] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dmg to Flower Up","ja":"花属性立ち位置前の花属性特効与ダメージアップ","ko":"꽃 속성 앞 포지션이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為前的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3051,"_id_":4000309},"4000310":{"description":{"en":"(Passive) [Flower Front Position] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dmg to Wind Up","ja":"花属性立ち位置前の風属性特効与ダメージアップ","ko":"꽃 속성 앞 포지션이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為前的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3051,"_id_":4000310},"4000311":{"description":{"en":"(Passive) [Flower Front Position] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dmg to Snow Up","ja":"花属性立ち位置前の雪属性特効与ダメージアップ","ko":"꽃 속성 앞 포지션이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為前的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3051,"_id_":4000311},"4000312":{"description":{"en":"(Passive) [Flower Front Position] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dmg to Moon Up","ja":"花属性立ち位置前の月属性特効与ダメージアップ","ko":"꽃 속성 앞 포지션이 달 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為前的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3051,"_id_":4000312},"4000313":{"description":{"en":"(Passive) [Flower Front Position] Dmg to Space Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dmg to Space Up","ja":"花属性立ち位置前の宙属性特効与ダメージアップ","ko":"꽃 속성 앞 포지션이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為前的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3051,"_id_":4000313},"4000314":{"description":{"en":"(Passive) [Flower Front Position] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dmg to Cloud Up","ja":"花属性立ち位置前の雲属性特効与ダメージアップ","ko":"꽃 속성 앞 포지션이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為前的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3051,"_id_":4000314},"4000315":{"description":{"en":"(Passive) [Flower Front Position] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Flower Front Position Dmg to Dream Up","ja":"花属性立ち位置前の夢属性特効与ダメージアップ","ko":"꽃 속성 앞 포지션이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升花屬性站位為前的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3051,"_id_":4000315},"4000316":{"description":{"en":"(Passive) [Flower Front Position] Normal Defense Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [꽃 속성 앞 포지션]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的普通防禦力 +%opt1_value%"},"name":{"en":"Flower Front Position Normal Defense Up","ja":"花属性立ち位置前の通常防御力アップ","ko":"꽃 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升花屬性站位為前的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3051,"_id_":4000316},"4000317":{"description":{"en":"(Passive) [Flower Front Position] Special Defense Up %opt1_value% ","ja":"[永続]【花属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [꽃 속성 앞 포지션]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的特殊防禦力 +%opt1_value%"},"name":{"en":"Flower Front Position Special Defense Up","ja":"花属性立ち位置前の特殊防御力アップ","ko":"꽃 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升花屬性站位為前的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3051,"_id_":4000317},"4000318":{"description":{"en":"(Passive) [Flower Front Position] Normal Defense Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的普通防禦力 +%opt1_value%%"},"name":{"en":"Flower Front Position Normal Defense Up","ja":"花属性立ち位置前の通常防御力アップ","ko":"꽃 속성 앞 포지션의 일반 방어력 증가","zh_hant":"提升花屬性站位為前的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3051,"_id_":4000318},"4000319":{"description":{"en":"(Passive) [Flower Front Position] Special Defense Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Flower Front Position Special Defense Up","ja":"花属性立ち位置前の特殊防御力アップ","ko":"꽃 속성 앞 포지션의 특수 방어력 증가","zh_hant":"提升花屬性站位為前的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3051,"_id_":4000319},"4000320":{"description":{"en":"(Passive) [Flower Front Position] Dexterity Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的會心率 +%opt1_value%%"},"name":{"en":"Flower Front Position Dexterity Up","ja":"花属性立ち位置前のクリティカル率アップ","ko":"꽃 속성 앞 포지션의 크리티컬 확률 증가","zh_hant":"提升花屬性站位為前的會心率"},"skill_option1_id":20,"skill_option1_target_id":3051,"_id_":4000320},"4000321":{"description":{"en":"(Passive) [Flower Front Position] Critical Up %opt1_value%% ","ja":"[永続]【花属性かつ立ち位置前】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [꽃 속성 앞 포지션]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【花屬性且站位為前】的會心威力 +%opt1_value%%"},"name":{"en":"Flower Front Position Critical Up","ja":"花属性立ち位置前のクリティカル威力アップ","ko":"꽃 속성 앞 포지션의 크리티컬 위력 증가","zh_hant":"提升花屬性站位為前的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3051,"_id_":4000321},"4000322":{"description":{"en":"(Passive) [Akira & Shiori] Act Power Up %opt1_value% ","ja":"[永続]【晶と栞】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [아키라와 시오리]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【晶和栞】的ACT力量 +%opt1_value%"},"name":{"en":"Akira & Shiori Act Power Up","ja":"晶と栞のACTパワーアップ","ko":"아키라와 시오리의 ACT 파워 증가","zh_hant":"提升晶和栞的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3119,"_id_":4000322},"4000323":{"description":{"en":"(Passive) [Akira & Shiori] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【晶と栞】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【晶和栞】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Flower Dmg Received Down","ja":"晶と栞の花属性被ダメージダウン","ko":"아키라와 시오리가 받는 꽃 속성 대미지 감소","zh_hant":"減輕晶和栞受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3119,"_id_":4000323},"4000324":{"description":{"en":"(Passive) [Akira & Shiori] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【晶と栞】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【晶和栞】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Wind Dmg Received Down","ja":"晶と栞の風属性被ダメージダウン","ko":"아키라와 시오리가 받는 바람 속성 대미지 감소","zh_hant":"減輕晶和栞受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3119,"_id_":4000324},"4000325":{"description":{"en":"(Passive) [Akira & Shiori] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【晶と栞】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【晶和栞】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Snow Dmg Received Down","ja":"晶と栞の雪属性被ダメージダウン","ko":"아키라와 시오리가 받는 눈 속성 대미지 감소","zh_hant":"減輕晶和栞受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3119,"_id_":4000325},"4000326":{"description":{"en":"(Passive) [Akira & Shiori] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【晶と栞】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【晶和栞】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Moon Dmg Received Down","ja":"晶と栞の月属性被ダメージダウン","ko":"아키라와 시오리가 받는 달 속성 대미지 감소","zh_hant":"減輕晶和栞受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3119,"_id_":4000326},"4000327":{"description":{"en":"(Passive) [Akira & Shiori] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【晶と栞】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【晶和栞】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Space Dmg Received Down","ja":"晶と栞の宙属性被ダメージダウン","ko":"아키라와 시오리가 받는 우주 속성 대미지 감소","zh_hant":"減輕晶和栞受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3119,"_id_":4000327},"4000328":{"description":{"en":"(Passive) [Akira & Shiori] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【晶と栞】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【晶和栞】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Cloud Dmg Received Down","ja":"晶と栞の雲属性被ダメージダウン","ko":"아키라와 시오리가 받는 구름 속성 대미지 감소","zh_hant":"減輕晶和栞受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3119,"_id_":4000328},"4000329":{"description":{"en":"(Passive) [Akira & Shiori] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【晶と栞】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【晶和栞】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dream Dmg Received Down","ja":"晶と栞の夢属性被ダメージダウン","ko":"아키라와 시오리가 받는 꿈 속성 대미지 감소","zh_hant":"減輕晶和栞受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3119,"_id_":4000329},"4000330":{"description":{"en":"(Passive) [Akira & Shiori] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dmg to Flower Up","ja":"晶と栞の花属性特効与ダメージアップ","ko":"아키라와 시오리가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升晶和栞的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3119,"_id_":4000330},"4000331":{"description":{"en":"(Passive) [Akira & Shiori] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dmg to Wind Up","ja":"晶と栞の風属性特効与ダメージアップ","ko":"아키라와 시오리가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升晶和栞的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3119,"_id_":4000331},"4000332":{"description":{"en":"(Passive) [Akira & Shiori] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dmg to Snow Up","ja":"晶と栞の雪属性特効与ダメージアップ","ko":"아키라와 시오리가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升晶和栞的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3119,"_id_":4000332},"4000333":{"description":{"en":"(Passive) [Akira & Shiori] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dmg to Moon Up","ja":"晶と栞の月属性特効与ダメージアップ","ko":"아키라와 시오리가 달 속성에게 가하는 대미지 증가","zh_hant":"提升晶和栞的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3119,"_id_":4000333},"4000334":{"description":{"en":"(Passive) [Akira & Shiori] Dmg to Space Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dmg to Space Up","ja":"晶と栞の宙属性特効与ダメージアップ","ko":"아키라와 시오리가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升晶和栞的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3119,"_id_":4000334},"4000335":{"description":{"en":"(Passive) [Akira & Shiori] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dmg to Cloud Up","ja":"晶と栞の雲属性特効与ダメージアップ","ko":"아키라와 시오리가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升晶和栞的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3119,"_id_":4000335},"4000336":{"description":{"en":"(Passive) [Akira & Shiori] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dmg to Dream Up","ja":"晶と栞の夢属性特効与ダメージアップ","ko":"아키라와 시오리가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升晶和栞的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3119,"_id_":4000336},"4000337":{"description":{"en":"(Passive) [Akira & Shiori] Normal Defense Up %opt1_value% ","ja":"[永続]【晶と栞】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [아키라와 시오리]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【晶和栞】的普通防禦力 +%opt1_value%"},"name":{"en":"Akira & Shiori Normal Defense Up","ja":"晶と栞の通常防御力アップ","ko":"아키라와 시오리의 일반 방어력 증가","zh_hant":"提升晶和栞的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3119,"_id_":4000337},"4000338":{"description":{"en":"(Passive) [Akira & Shiori] Special Defense Up %opt1_value% ","ja":"[永続]【晶と栞】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [아키라와 시오리]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【晶和栞】的特殊防禦力 +%opt1_value%"},"name":{"en":"Akira & Shiori Special Defense Up","ja":"晶と栞の特殊防御力アップ","ko":"아키라와 시오리의 특수 방어력 증가","zh_hant":"提升晶和栞的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3119,"_id_":4000338},"4000339":{"description":{"en":"(Passive) [Akira & Shiori] Normal Defense Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的普通防禦力 +%opt1_value%%"},"name":{"en":"Akira & Shiori Normal Defense Up","ja":"晶と栞の通常防御力アップ","ko":"아키라와 시오리의 일반 방어력 증가","zh_hant":"提升晶和栞的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3119,"_id_":4000339},"4000340":{"description":{"en":"(Passive) [Akira & Shiori] Special Defense Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Akira & Shiori Special Defense Up","ja":"晶と栞の特殊防御力アップ","ko":"아키라와 시오리의 특수 방어력 증가","zh_hant":"提升晶和栞的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3119,"_id_":4000340},"4000341":{"description":{"en":"(Passive) [Akira & Shiori] Dexterity Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的會心率 +%opt1_value%%"},"name":{"en":"Akira & Shiori Dexterity Up","ja":"晶と栞のクリティカル率アップ","ko":"아키라와 시오리의 크리티컬 확률 증가","zh_hant":"提升晶和栞的會心率"},"skill_option1_id":20,"skill_option1_target_id":3119,"_id_":4000341},"4000342":{"description":{"en":"(Passive) [Akira & Shiori] Critical Up %opt1_value%% ","ja":"[永続]【晶と栞】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [아키라와 시오리]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【晶和栞】的會心威力 +%opt1_value%%"},"name":{"en":"Akira & Shiori Critical Up","ja":"晶と栞のクリティカル威力アップ","ko":"아키라와 시오리의 크리티컬 위력 증가","zh_hant":"提升晶和栞的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3119,"_id_":4000342},"4000401":{"description":{"en":"(Passive) [Siegfeld] Act Power Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的ACT力量 +%opt1_value%"},"name":{"en":"Siegfeld Act Power Up","ja":"シークフェルト音楽学院のACTパワーアップ","ko":"시크펠트 음악학원의 ACT 파워 증가","zh_hant":"提升席格菲特音樂學院的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3263,"_id_":4000401},"4000402":{"description":{"en":"(Passive) [Siegfeld] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的花屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Flower Dmg Received Down","ja":"シークフェルト音楽学院の花属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 꽃 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3263,"_id_":4000402},"4000403":{"description":{"en":"(Passive) [Siegfeld] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的風屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Wind Dmg Received Down","ja":"シークフェルト音楽学院の風属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 바람 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3263,"_id_":4000403},"4000404":{"description":{"en":"(Passive) [Siegfeld] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的雪屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Snow Dmg Received Down","ja":"シークフェルト音楽学院の雪属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 눈 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3263,"_id_":4000404},"4000405":{"description":{"en":"(Passive) [Siegfeld] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的月屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Moon Dmg Received Down","ja":"シークフェルト音楽学院の月属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 달 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3263,"_id_":4000405},"4000406":{"description":{"en":"(Passive) [Siegfeld] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的宙屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Space Dmg Received Down","ja":"シークフェルト音楽学院の宙属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 우주 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3263,"_id_":4000406},"4000407":{"description":{"en":"(Passive) [Siegfeld] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的雲屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Cloud Dmg Received Down","ja":"シークフェルト音楽学院の雲属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 구름 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3263,"_id_":4000407},"4000408":{"description":{"en":"(Passive) [Siegfeld] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的夢屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Dream Dmg Received Down","ja":"シークフェルト音楽学院の夢属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 꿈 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3263,"_id_":4000408},"4000409":{"description":{"en":"(Passive) [Siegfeld] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Flower Up","ja":"シークフェルト音楽学院の花属性与ダメージアップ","ko":"시크펠트 음악학원이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3263,"_id_":4000409},"4000410":{"description":{"en":"(Passive) [Siegfeld] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Wind Up","ja":"シークフェルト音楽学院の風属性与ダメージアップ","ko":"시크펠트 음악학원이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3263,"_id_":4000410},"4000411":{"description":{"en":"(Passive) [Siegfeld] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Snow Up","ja":"シークフェルト音楽学院の雪属性与ダメージアップ","ko":"시크펠트 음악학원이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3263,"_id_":4000411},"4000412":{"description":{"en":"(Passive) [Siegfeld] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Moon Up","ja":"シークフェルト音楽学院の月属性与ダメージアップ","ko":"시크펠트 음악학원이 달 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3263,"_id_":4000412},"4000413":{"description":{"en":"(Passive) [Siegfeld] Dmg to Space Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Space Up","ja":"シークフェルト音楽学院の宙属性与ダメージアップ","ko":"시크펠트 음악학원이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3263,"_id_":4000413},"4000414":{"description":{"en":"(Passive) [Siegfeld] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Cloud Up","ja":"シークフェルト音楽学院の雲属性与ダメージアップ","ko":"시크펠트 음악학원이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3263,"_id_":4000414},"4000415":{"description":{"en":"(Passive) [Siegfeld] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Dream Up","ja":"シークフェルト音楽学院の夢属性与ダメージアップ","ko":"시크펠트 음악학원이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3263,"_id_":4000415},"4000416":{"description":{"en":"(Passive) [Siegfeld] Normal Defense Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Normal Defense Up","ja":"シークフェルト音楽学院の通常防御力アップ","ko":"시크펠트 음악학원의 일반 방어력 증가","zh_hant":"提升席格菲特音樂學院的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3263,"_id_":4000416},"4000417":{"description":{"en":"(Passive) [Siegfeld] Special Defense Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Special Defense Up","ja":"シークフェルト音楽学院の特殊防御力アップ","ko":"시크펠트 음악학원의 특수 방어력 증가","zh_hant":"提升席格菲特音樂學院的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3263,"_id_":4000417},"4000418":{"description":{"en":"(Passive) [Siegfeld] Normal Defense Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Normal Defense Up","ja":"シークフェルト音楽学院の通常防御力アップ","ko":"시크펠트 음악학원의 일반 방어력 증가","zh_hant":"提升席格菲特音樂學院的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3263,"_id_":4000418},"4000419":{"description":{"en":"(Passive) [Siegfeld] Special Defense Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Special Defense Up","ja":"シークフェルト音楽学院の特殊防御力アップ","ko":"시크펠트 음악학원의 특수 방어력 증가","zh_hant":"提升席格菲特音樂學院的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3263,"_id_":4000419},"4000420":{"description":{"en":"(Passive) [Siegfeld] Dexterity Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的會心率 +%opt1_value%%"},"name":{"en":"Siegfeld Dexterity Up","ja":"シークフェルト音楽学院のクリティカル率アップ","ko":"시크펠트 음악학원의 크리티컬 확률 증가","zh_hant":"提升席格菲特音樂學院的會心率"},"skill_option1_id":20,"skill_option1_target_id":3263,"_id_":4000420},"4000421":{"description":{"en":"(Passive) [Siegfeld] Critical Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的會心威力 +%opt1_value%%"},"name":{"en":"Siegfeld Critical Up","ja":"シークフェルト音楽学院のクリティカル威力アップ","ko":"시크펠트 음악학원의 크리티컬 위력 증가","zh_hant":"提升席格菲特音樂學院的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3263,"_id_":4000421},"4000501":{"description":{"en":"(Passive) [Siegfeld] Act Power Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的ACT力量 +%opt1_value%"},"name":{"en":"Siegfeld Act Power Up","ja":"シークフェルト音楽学院のACTパワーアップ","ko":"시크펠트 음악학원의 ACT 파워 증가","zh_hant":"提升席格菲特音樂學院的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3263,"_id_":4000501},"4000502":{"description":{"en":"(Passive) [Siegfeld] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的花屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Flower Dmg Received Down","ja":"シークフェルト音楽学院の花属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 꽃 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3263,"_id_":4000502},"4000503":{"description":{"en":"(Passive) [Siegfeld] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的風屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Wind Dmg Received Down","ja":"シークフェルト音楽学院の風属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 바람 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3263,"_id_":4000503},"4000504":{"description":{"en":"(Passive) [Siegfeld] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的雪屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Snow Dmg Received Down","ja":"シークフェルト音楽学院の雪属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 눈 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3263,"_id_":4000504},"4000505":{"description":{"en":"(Passive) [Siegfeld] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的月屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Moon Dmg Received Down","ja":"シークフェルト音楽学院の月属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 달 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3263,"_id_":4000505},"4000506":{"description":{"en":"(Passive) [Siegfeld] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的宙屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Space Dmg Received Down","ja":"シークフェルト音楽学院の宙属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 우주 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3263,"_id_":4000506},"4000507":{"description":{"en":"(Passive) [Siegfeld] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的雲屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Cloud Dmg Received Down","ja":"シークフェルト音楽学院の雲属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 구름 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3263,"_id_":4000507},"4000508":{"description":{"en":"(Passive) [Siegfeld] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的夢屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Dream Dmg Received Down","ja":"シークフェルト音楽学院の夢属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 꿈 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3263,"_id_":4000508},"4000509":{"description":{"en":"(Passive) [Siegfeld] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Flower Up","ja":"シークフェルト音楽学院の花属性与ダメージアップ","ko":"시크펠트 음악학원이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3263,"_id_":4000509},"4000510":{"description":{"en":"(Passive) [Siegfeld] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Wind Up","ja":"シークフェルト音楽学院の風属性与ダメージアップ","ko":"시크펠트 음악학원이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3263,"_id_":4000510},"4000511":{"description":{"en":"(Passive) [Siegfeld] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Snow Up","ja":"シークフェルト音楽学院の雪属性与ダメージアップ","ko":"시크펠트 음악학원이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3263,"_id_":4000511},"4000512":{"description":{"en":"(Passive) [Siegfeld] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Moon Up","ja":"シークフェルト音楽学院の月属性与ダメージアップ","ko":"시크펠트 음악학원이 달 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3263,"_id_":4000512},"4000513":{"description":{"en":"(Passive) [Siegfeld] Dmg to Space Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Space Up","ja":"シークフェルト音楽学院の宙属性与ダメージアップ","ko":"시크펠트 음악학원이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3263,"_id_":4000513},"4000514":{"description":{"en":"(Passive) [Siegfeld] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Cloud Up","ja":"シークフェルト音楽学院の雲属性与ダメージアップ","ko":"시크펠트 음악학원이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3263,"_id_":4000514},"4000515":{"description":{"en":"(Passive) [Siegfeld] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Dream Up","ja":"シークフェルト音楽学院の夢属性与ダメージアップ","ko":"시크펠트 음악학원이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3263,"_id_":4000515},"4000516":{"description":{"en":"(Passive) [Siegfeld] Normal Defense Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Normal Defense Up","ja":"シークフェルト音楽学院の通常防御力アップ","ko":"시크펠트 음악학원의 일반 방어력 증가","zh_hant":"提升席格菲特音樂學院的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3263,"_id_":4000516},"4000517":{"description":{"en":"(Passive) [Siegfeld] Special Defense Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Special Defense Up","ja":"シークフェルト音楽学院の特殊防御力アップ","ko":"시크펠트 음악학원의 특수 방어력 증가","zh_hant":"提升席格菲特音樂學院的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3263,"_id_":4000517},"4000518":{"description":{"en":"(Passive) [Siegfeld] Normal Defense Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%%"},"name":{"en":"Siegfeld Normal Defense Up","ja":"シークフェルト音楽学院の通常防御力アップ","ko":"시크펠트 음악학원의 일반 방어력 증가","zh_hant":"提升席格菲特音樂學院的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3263,"_id_":4000518},"4000519":{"description":{"en":"(Passive) [Siegfeld] Special Defense Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Siegfeld Special Defense Up","ja":"シークフェルト音楽学院の特殊防御力アップ","ko":"시크펠트 음악학원의 특수 방어력 증가","zh_hant":"提升席格菲特音樂學院的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3263,"_id_":4000519},"4000520":{"description":{"en":"(Passive) [Siegfeld] Dexterity Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的會心率 +%opt1_value%%"},"name":{"en":"Siegfeld Dexterity Up","ja":"シークフェルト音楽学院のクリティカル率アップ","ko":"시크펠트 음악학원의 크리티컬 확률 증가","zh_hant":"提升席格菲特音樂學院的會心率"},"skill_option1_id":20,"skill_option1_target_id":3263,"_id_":4000520},"4000521":{"description":{"en":"(Passive) [Siegfeld] Critical Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的會心威力 +%opt1_value%%"},"name":{"en":"Siegfeld Critical Up","ja":"シークフェルト音楽学院のクリティカル威力アップ","ko":"시크펠트 음악학원의 크리티컬 위력 증가","zh_hant":"提升席格菲特音樂學院的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3263,"_id_":4000521},"5000101":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Act Power Up %opt1_value% ","ja":"[永続]【華恋とひかりと晶】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌과 히카리와 아키라]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、光、晶】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Hikari & Akira Act Power Up","ja":"華恋とひかりと晶のACTパワーアップ","ko":"카렌과 히카리와 아키라의 ACT 파워 증가","zh_hant":"提升華戀、光、晶的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3140,"_id_":5000101},"5000102":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、晶】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Flower Dmg Received Down","ja":"華恋とひかりと晶の花属性被ダメージダウン","ko":"카렌과 히카리와 아키라가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀、光、晶受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3140,"_id_":5000102},"5000103":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、晶】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Wind Dmg Received Down","ja":"華恋とひかりと晶の風属性被ダメージダウン","ko":"카렌과 히카리와 아키라가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀、光、晶受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3140,"_id_":5000103},"5000104":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、晶】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Snow Dmg Received Down","ja":"華恋とひかりと晶の雪属性被ダメージダウン","ko":"카렌과 히카리와 아키라가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀、光、晶受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3140,"_id_":5000104},"5000105":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、晶】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Moon Dmg Received Down","ja":"華恋とひかりと晶の月属性被ダメージダウン","ko":"카렌과 히카리와 아키라가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀、光、晶受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3140,"_id_":5000105},"5000106":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、晶】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Space Dmg Received Down","ja":"華恋とひかりと晶の宙属性被ダメージダウン","ko":"카렌과 히카리와 아키라가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀、光、晶受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3140,"_id_":5000106},"5000107":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、晶】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Cloud Dmg Received Down","ja":"華恋とひかりと晶の雲属性被ダメージダウン","ko":"카렌과 히카리와 아키라가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀、光、晶受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3140,"_id_":5000107},"5000108":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、晶】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dream Dmg Received Down","ja":"華恋とひかりと晶の夢属性被ダメージダウン","ko":"카렌과 히카리와 아키라가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀、光、晶受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3140,"_id_":5000108},"5000109":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dmg to Flower Up","ja":"華恋とひかりと晶の花属性特効与ダメージアップ","ko":"카렌과 히카리와 아키라가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、晶的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3140,"_id_":5000109},"5000110":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dmg to Wind Up","ja":"華恋とひかりと晶の風属性特効与ダメージアップ","ko":"카렌과 히카리와 아키라가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、晶的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3140,"_id_":5000110},"5000111":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dmg to Snow Up","ja":"華恋とひかりと晶の雪属性特効与ダメージアップ","ko":"카렌과 히카리와 아키라가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、晶的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3140,"_id_":5000111},"5000112":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dmg to Moon Up","ja":"華恋とひかりと晶の月属性特効与ダメージアップ","ko":"카렌과 히카리와 아키라가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、晶的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3140,"_id_":5000112},"5000113":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dmg to Space Up","ja":"華恋とひかりと晶の宙属性特効与ダメージアップ","ko":"카렌과 히카리와 아키라가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、晶的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3140,"_id_":5000113},"5000114":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dmg to Cloud Up","ja":"華恋とひかりと晶の雲属性特効与ダメージアップ","ko":"카렌과 히카리와 아키라가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、晶的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3140,"_id_":5000114},"5000115":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dmg to Dream Up","ja":"華恋とひかりと晶の夢属性特効与ダメージアップ","ko":"카렌과 히카리와 아키라가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、晶的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3140,"_id_":5000115},"5000116":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋とひかりと晶】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌과 히카리와 아키라]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、光、晶】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Hikari & Akira Normal Defense Up","ja":"華恋とひかりと晶の通常防御力アップ","ko":"카렌과 히카리와 아키라의 일반 방어력 증가","zh_hant":"提升華戀、光、晶的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3140,"_id_":5000116},"5000117":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Special Defense Up %opt1_value% ","ja":"[永続]【華恋とひかりと晶】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌과 히카리와 아키라]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、光、晶】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Hikari & Akira Special Defense Up","ja":"華恋とひかりと晶の特殊防御力アップ","ko":"카렌과 히카리와 아키라의 특수 방어력 증가","zh_hant":"提升華戀、光、晶的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3140,"_id_":5000117},"5000118":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Normal Defense Up","ja":"華恋とひかりと晶の通常防御力アップ","ko":"카렌과 히카리와 아키라의 일반 방어력 증가","zh_hant":"提升華戀、光、晶的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3140,"_id_":5000118},"5000119":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Special Defense Up","ja":"華恋とひかりと晶の特殊防御力アップ","ko":"카렌과 히카리와 아키라의 특수 방어력 증가","zh_hant":"提升華戀、光、晶的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3140,"_id_":5000119},"5000120":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Dexterity Up","ja":"華恋とひかりと晶のクリティカル率アップ","ko":"카렌과 히카리와 아키라의 크리티컬 확률 증가","zh_hant":"提升華戀、光、晶的會心率"},"skill_option1_id":20,"skill_option1_target_id":3140,"_id_":5000120},"5000121":{"description":{"en":"(Passive) [Karen & Hikari & Akira] Critical Up %opt1_value%% ","ja":"[永続]【華恋とひかりと晶】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌과 히카리와 아키라]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、晶】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Akira Critical Up","ja":"華恋とひかりと晶のクリティカル威力アップ","ko":"카렌과 히카리와 아키라의 크리티컬 위력 증가","zh_hant":"提升華戀、光、晶的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3140,"_id_":5000121},"5000201":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Act Power Up %opt1_value% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】的ACT力量 +%opt1_value%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Act Power Up","ja":"双葉と香子と珠緒と塁のACTパワーアップ","ko":"후타바, 카오루코, 타마오, 루이의 ACT 파워 증가","zh_hant":"提升雙葉、香子、珠緒和壘的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3150,"_id_":5000201},"5000202":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雙葉、香子、珠緒和壘】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Flower Dmg Received Down","ja":"双葉と香子と珠緒と塁の花属性被ダメージダウン","ko":"후타바, 카오루코, 타마오, 루이가 받는 꽃 속성 대미지 감소","zh_hant":"減輕雙葉、香子、珠緒和壘受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3150,"_id_":5000202},"5000203":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雙葉、香子、珠緒和壘】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Wind Dmg Received Down","ja":"双葉と香子と珠緒と塁の風属性被ダメージダウン","ko":"후타바, 카오루코, 타마오, 루이가 받는 바람 속성 대미지 감소","zh_hant":"減輕雙葉、香子、珠緒和壘受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3150,"_id_":5000203},"5000204":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雙葉、香子、珠緒和壘】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Snow Dmg Received Down","ja":"双葉と香子と珠緒と塁の雪属性被ダメージダウン","ko":"후타바, 카오루코, 타마오, 루이가 받는 눈 속성 대미지 감소","zh_hant":"減輕雙葉、香子、珠緒和壘受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3150,"_id_":5000204},"5000205":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雙葉、香子、珠緒和壘】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Moon Dmg Received Down","ja":"双葉と香子と珠緒と塁の月属性被ダメージダウン","ko":"후타바, 카오루코, 타마오, 루이가 받는 달 속성 대미지 감소","zh_hant":"減輕雙葉、香子、珠緒和壘受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3150,"_id_":5000205},"5000206":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雙葉、香子、珠緒和壘】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Space Dmg Received Down","ja":"双葉と香子と珠緒と塁の宙属性被ダメージダウン","ko":"후타바, 카오루코, 타마오, 루이가 받는 우주 속성 대미지 감소","zh_hant":"減輕雙葉、香子、珠緒和壘受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3150,"_id_":5000206},"5000207":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雙葉、香子、珠緒和壘】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Cloud Dmg Received Down","ja":"双葉と香子と珠緒と塁の雲属性被ダメージダウン","ko":"후타바, 카오루코, 타마오, 루이가 받는 구름 속성 대미지 감소","zh_hant":"減輕雙葉、香子、珠緒和壘受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3150,"_id_":5000207},"5000208":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【雙葉、香子、珠緒和壘】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Dream Dmg Received Down","ja":"双葉と香子と珠緒と塁の夢属性被ダメージダウン","ko":"후타바, 카오루코, 타마오, 루이가 받는 꿈 속성 대미지 감소","zh_hant":"減輕雙葉、香子、珠緒和壘受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3150,"_id_":5000208},"5000209":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Boost Dmg to Flower Up","ja":"双葉と香子と珠緒と塁の花属性特効与ダメージアップ","ko":"후타바, 카오루코, 타마오, 루이가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升雙葉、香子、珠緒和壘的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3150,"_id_":5000209},"5000210":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Boost Dmg to Wind Up","ja":"双葉と香子と珠緒と塁の風属性特効与ダメージアップ","ko":"후타바, 카오루코, 타마오, 루이가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升雙葉、香子、珠緒和壘的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3150,"_id_":5000210},"5000211":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Boost Dmg to Snow Up","ja":"双葉と香子と珠緒と塁の雪属性特効与ダメージアップ","ko":"후타바, 카오루코, 타마오, 루이가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升雙葉、香子、珠緒和壘的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3150,"_id_":5000211},"5000212":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Boost Dmg to Moon Up","ja":"双葉と香子と珠緒と塁の月属性特効与ダメージアップ","ko":"후타바, 카오루코, 타마오, 루이가 달 속성에게 가하는 대미지 증가","zh_hant":"提升雙葉、香子、珠緒和壘的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3150,"_id_":5000212},"5000213":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Space Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Boost Dmg to Space Up","ja":"双葉と香子と珠緒と塁の宙属性特効与ダメージアップ","ko":"후타바, 카오루코, 타마오, 루이가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升雙葉、香子、珠緒和壘的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3150,"_id_":5000213},"5000214":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Boost Dmg to Cloud Up","ja":"双葉と香子と珠緒と塁の雲属性特効与ダメージアップ","ko":"후타바, 카오루코, 타마오, 루이가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升雙葉、香子、珠緒和壘的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3150,"_id_":5000214},"5000215":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Boost Dmg to Dream Up","ja":"双葉と香子と珠緒と塁の夢属性特効与ダメージアップ","ko":"후타바, 카오루코, 타마오, 루이가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升雙葉、香子、珠緒和壘的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3150,"_id_":5000215},"5000216":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Normal Defense Up %opt1_value% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】的普通防禦力 +%opt1_value%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Normal Defense Up","ja":"双葉と香子と珠緒と塁の通常防御力アップ","ko":"후타바, 카오루코, 타마오, 루이의 일반 방어력 증가","zh_hant":"提升雙葉、香子、珠緒和壘的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3150,"_id_":5000216},"5000217":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Special Defense Up %opt1_value% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】的特殊防禦力 +%opt1_value%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Special Defense Up","ja":"双葉と香子と珠緒と塁の特殊防御力アップ","ko":"후타바, 카오루코, 타마오, 루이의 특수 방어력 증가","zh_hant":"提升雙葉、香子、珠緒和壘的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3150,"_id_":5000217},"5000218":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Normal Defense Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】的普通防禦力 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Normal Defense Up","ja":"双葉と香子と珠緒と塁の通常防御力アップ","ko":"후타바, 카오루코, 타마오, 루이의 일반 방어력 증가","zh_hant":"提升雙葉、香子、珠緒和壘的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3150,"_id_":5000218},"5000219":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Special Defense Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Special Defense Up","ja":"双葉と香子と珠緒と塁の特殊防御力アップ","ko":"후타바, 카오루코, 타마오, 루이의 특수 방어력 증가","zh_hant":"提升雙葉、香子、珠緒和壘的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3150,"_id_":5000219},"5000220":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Dexterity Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】的會心率 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Dexterity Up","ja":"双葉と香子と珠緒と塁のクリティカル率アップ","ko":"후타바, 카오루코, 타마오, 루이의 크리티컬 확률 증가","zh_hant":"提升雙葉、香子、珠緒和壘的會心率"},"skill_option1_id":20,"skill_option1_target_id":3150,"_id_":5000220},"5000221":{"description":{"en":"(Passive) [Futaba & Kaoruko & Tamao & Rui] Critical Up %opt1_value%% ","ja":"[永続]【双葉と香子と珠緒と塁】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [후타바, 카오루코, 타마오, 루이]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【雙葉、香子、珠緒和壘】的會心威力 +%opt1_value%%"},"name":{"en":"Futaba & Kaoruko & Tamao & Rui Critical Up","ja":"双葉と香子と珠緒と塁のクリティカル威力アップ","ko":"후타바, 카오루코, 타마오, 루이의 크리티컬 위력 증가","zh_hant":"提升雙葉、香子、珠緒和壘的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3150,"_id_":5000221},"5000301":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Act Power Up %opt1_value% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的ACT力量 +%opt1_value%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Act Power Up","ja":"純那とゆゆ子とララフィンとメイファンのACTパワーアップ","ko":"준나, 유유코, 라라핀, 메이팡의 ACT 파워 증가 ","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3160,"_id_":5000301},"5000302":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Flower Dmg Received Down","ja":"純那とゆゆ子とララフィンとメイファンの花属性被ダメージダウン","ko":"준나, 유유코, 라라핀, 메이팡이 받는 꽃 속성 대미지 감소","zh_hant":"減輕純那、悠悠子、菈樂菲、美帆受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3160,"_id_":5000302},"5000303":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Wind Dmg Received Down","ja":"純那とゆゆ子とララフィンとメイファンの風属性被ダメージダウン","ko":"준나, 유유코, 라라핀, 메이팡이 받는 바람 속성 대미지 감소","zh_hant":"減輕純那、悠悠子、菈樂菲、美帆受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3160,"_id_":5000303},"5000304":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Snow Dmg Received Down","ja":"純那とゆゆ子とララフィンとメイファンの雪属性被ダメージダウン","ko":"준나, 유유코, 라라핀, 메이팡이 받는 눈 속성 대미지 감소","zh_hant":"減輕純那、悠悠子、菈樂菲、美帆受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3160,"_id_":5000304},"5000305":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Moon Dmg Received Down","ja":"純那とゆゆ子とララフィンとメイファンの月属性被ダメージダウン","ko":"준나, 유유코, 라라핀, 메이팡이 받는 달 속성 대미지 감소","zh_hant":"減輕純那、悠悠子、菈樂菲、美帆受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3160,"_id_":5000305},"5000306":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Space Dmg Received Down","ja":"純那とゆゆ子とララフィンとメイファンの宙属性被ダメージダウン","ko":"준나, 유유코, 라라핀, 메이팡이 받는 우주 속성 대미지 감소","zh_hant":"減輕純那、悠悠子、菈樂菲、美帆受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3160,"_id_":5000306},"5000307":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Cloud Dmg Received Down","ja":"純那とゆゆ子とララフィンとメイファンの雲属性被ダメージダウン","ko":"준나, 유유코, 라라핀, 메이팡이 받는 구름 속성 대미지 감소","zh_hant":"減輕純那、悠悠子、菈樂菲、美帆受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3160,"_id_":5000307},"5000308":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、悠悠子、菈樂菲、美帆】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dream Dmg Received Down","ja":"純那とゆゆ子とララフィンとメイファンの夢属性被ダメージダウン","ko":"준나, 유유코, 라라핀, 메이팡이 받는 꿈 속성 대미지 감소","zh_hant":"減輕純那、悠悠子、菈樂菲、美帆受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3160,"_id_":5000308},"5000309":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dmg to Flower Up","ja":"純那とゆゆ子とララフィンとメイファンの花属性与ダメージアップ","ko":"준나, 유유코, 라라핀, 메이팡이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3160,"_id_":5000309},"5000310":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dmg to Wind Up","ja":"純那とゆゆ子とララフィンとメイファンの風属性与ダメージアップ","ko":"준나, 유유코, 라라핀, 메이팡이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3160,"_id_":5000310},"5000311":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dmg to Snow Up","ja":"純那とゆゆ子とララフィンとメイファンの雪属性与ダメージアップ","ko":"준나, 유유코, 라라핀, 메이팡이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3160,"_id_":5000311},"5000312":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dmg to Moon Up","ja":"純那とゆゆ子とララフィンとメイファンの月属性与ダメージアップ","ko":"준나, 유유코, 라라핀, 메이팡이 달 속성에게 가하는 대미지 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3160,"_id_":5000312},"5000313":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Space Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dmg to Space Up","ja":"純那とゆゆ子とララフィンとメイファンの宙属性与ダメージアップ","ko":"준나, 유유코, 라라핀, 메이팡이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3160,"_id_":5000313},"5000314":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dmg to Cloud Up","ja":"純那とゆゆ子とララフィンとメイファンの雲属性与ダメージアップ","ko":"준나, 유유코, 라라핀, 메이팡이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3160,"_id_":5000314},"5000315":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dmg to Dream Up","ja":"純那とゆゆ子とララフィンとメイファンの夢属性与ダメージアップ","ko":"준나, 유유코, 라라핀, 메이팡이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3160,"_id_":5000315},"5000316":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Normal Defense Up %opt1_value% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的普通防禦力 +%opt1_value%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Normal Defense Up","ja":"純那とゆゆ子とララフィンとメイファンの通常防御力アップ","ko":"준나, 유유코, 라라핀, 메이팡의 일반 방어력 증가 ","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3160,"_id_":5000316},"5000317":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Special Defense Up %opt1_value% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的特殊防禦力 +%opt1_value%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Special Defense Up","ja":"純那とゆゆ子とララフィンとメイファンの特殊防御力アップ","ko":"준나, 유유코, 라라핀, 메이팡의 특수 방어력 증가 ","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3160,"_id_":5000317},"5000318":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Normal Defense Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的普通防禦力 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Normal Defense Up","ja":"純那とゆゆ子とララフィンとメイファンの通常防御力アップ","ko":"준나, 유유코, 라라핀, 메이팡의 일반 방어력 증가 ","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3160,"_id_":5000318},"5000319":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Special Defense Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Special Defense Up","ja":"純那とゆゆ子とララフィンとメイファンの特殊防御力アップ","ko":"준나, 유유코, 라라핀, 메이팡의 특수 방어력 증가 ","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3160,"_id_":5000319},"5000320":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Dexterity Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的會心率 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Dexterity Up","ja":"純那とゆゆ子とララフィンとメイファンのクリティカル率アップ","ko":"준나, 유유코, 라라핀, 메이팡의 크리티컬 확률 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的會心率"},"skill_option1_id":20,"skill_option1_target_id":3160,"_id_":5000320},"5000321":{"description":{"en":"(Passive) [Junna & Yuyuko & Lalafin & Mei Fan] Critical Up %opt1_value%% ","ja":"[永続]【純那とゆゆ子とララフィンとメイファン】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [준나, 유유코, 라라핀, 메이팡]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、悠悠子、菈樂菲、美帆】的會心威力 +%opt1_value%%"},"name":{"en":"Junna & Yuyuko & Lalafin & Mei Fan Critical Up","ja":"純那とゆゆ子とララフィンとメイファンのクリティカル威力アップ","ko":"준나, 유유코, 라라핀, 메이팡의 크리티컬 위력 증가","zh_hant":"提升純那、悠悠子、菈樂菲、美帆的會心率"},"skill_option1_id":22,"skill_option1_target_id":3160,"_id_":5000321},"5000401":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Act Power Up %opt1_value% ","ja":"[永続]【クロディーヌと文と栞】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [클로딘, 후미, 시오리]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】的ACT力量 +%opt1_value%"},"name":{"en":"Claudine & Fumi & Shiori Act Power Up","ja":"クロディーヌと文と栞のACTパワーアップ","ko":"클로딘, 후미, 시오리의 ACT 파워 증가","zh_hant":"提升克洛迪娜、文和栞的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3170,"_id_":5000401},"5000402":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜、文和栞】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Flower Dmg Received Down","ja":"クロディーヌと文と栞の花属性被ダメージダウン","ko":"클로딘, 후미, 시오리가 받는 꽃 속성 대미지 감소","zh_hant":"減輕克洛迪娜、文和栞受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3170,"_id_":5000402},"5000403":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜、文和栞】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Wind Dmg Received Down","ja":"クロディーヌと文と栞の風属性被ダメージダウン","ko":"클로딘, 후미, 시오리가 받는 바람 속성 대미지 감소","zh_hant":"減輕克洛迪娜、文和栞受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3170,"_id_":5000403},"5000404":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜、文和栞】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Snow Dmg Received Down","ja":"クロディーヌと文と栞の雪属性被ダメージダウン","ko":"클로딘, 후미, 시오리가 받는 눈 속성 대미지 감소","zh_hant":"減輕克洛迪娜、文和栞受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3170,"_id_":5000404},"5000405":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜、文和栞】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Moon Dmg Received Down","ja":"クロディーヌと文と栞の月属性被ダメージダウン","ko":"클로딘, 후미, 시오리가 받는 달 속성 대미지 감소","zh_hant":"減輕克洛迪娜、文和栞受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3170,"_id_":5000405},"5000406":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜、文和栞】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Space Dmg Received Down","ja":"クロディーヌと文と栞の宙属性被ダメージダウン","ko":"클로딘, 후미, 시오리가 받는 우주 속성 대미지 감소","zh_hant":"減輕克洛迪娜、文和栞受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3170,"_id_":5000406},"5000407":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜、文和栞】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Cloud Dmg Received Down","ja":"クロディーヌと文と栞の雲属性被ダメージダウン","ko":"클로딘, 후미, 시오리가 받는 구름 속성 대미지 감소","zh_hant":"減輕克洛迪娜、文和栞受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3170,"_id_":5000407},"5000408":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜、文和栞】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dream Dmg Received Down","ja":"クロディーヌと文と栞の夢属性被ダメージダウン","ko":"클로딘, 후미, 시오리가 받는 꿈 속성 대미지 감소","zh_hant":"減輕克洛迪娜、文和栞受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3170,"_id_":5000408},"5000409":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dmg to Flower Up","ja":"クロディーヌと文と栞の花属性与ダメージアップ","ko":"클로딘, 후미, 시오리가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜、文和栞的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3170,"_id_":5000409},"5000410":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dmg to Wind Up","ja":"クロディーヌと文と栞の風属性与ダメージアップ","ko":"클로딘, 후미, 시오리가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜、文和栞的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3170,"_id_":5000410},"5000411":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dmg to Snow Up","ja":"クロディーヌと文と栞の雪属性与ダメージアップ","ko":"클로딘, 후미, 시오리가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜、文和栞的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3170,"_id_":5000411},"5000412":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dmg to Moon Up","ja":"クロディーヌと文と栞の月属性与ダメージアップ","ko":"클로딘, 후미, 시오리가 달 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜、文和栞的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3170,"_id_":5000412},"5000413":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dmg to Space Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dmg to Space Up","ja":"クロディーヌと文と栞の宙属性与ダメージアップ","ko":"클로딘, 후미, 시오리가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜、文和栞的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3170,"_id_":5000413},"5000414":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dmg to Cloud Up","ja":"クロディーヌと文と栞の雲属性与ダメージアップ","ko":"클로딘, 후미, 시오리가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜、文和栞的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3170,"_id_":5000414},"5000415":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dmg to Dream Up","ja":"クロディーヌと文と栞の夢属性与ダメージアップ","ko":"클로딘, 후미, 시오리가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜、文和栞的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3170,"_id_":5000415},"5000416":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Normal Defense Up %opt1_value% ","ja":"[永続]【クロディーヌと文と栞】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [클로딘, 후미, 시오리]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】的普通防禦力 +%opt1_value%"},"name":{"en":"Claudine & Fumi & Shiori Normal Defense Up","ja":"クロディーヌと文と栞の通常防御力アップ","ko":"클로딘, 후미, 시오리의 일반 방어력 증가","zh_hant":"提升克洛迪娜、文和栞的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3170,"_id_":5000416},"5000417":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Special Defense Up %opt1_value% ","ja":"[永続]【クロディーヌと文と栞】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [클로딘, 후미, 시오리]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】的特殊防禦力 +%opt1_value%"},"name":{"en":"Claudine & Fumi & Shiori Special Defense Up","ja":"クロディーヌと文と栞の特殊防御力アップ","ko":"클로딘, 후미, 시오리의 특수 방어력 증가","zh_hant":"提升克洛迪娜、文和栞的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3170,"_id_":5000417},"5000418":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Normal Defense Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】的普通防禦力 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Normal Defense Up","ja":"クロディーヌと文と栞の通常防御力アップ","ko":"클로딘, 후미, 시오리의 일반 방어력 증가","zh_hant":"提升克洛迪娜、文和栞的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3170,"_id_":5000418},"5000419":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Special Defense Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Special Defense Up","ja":"クロディーヌと文と栞の特殊防御力アップ","ko":"클로딘, 후미, 시오리의 특수 방어력 증가","zh_hant":"提升克洛迪娜、文和栞的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3170,"_id_":5000419},"5000420":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Dexterity Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】的會心率 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Dexterity Up","ja":"クロディーヌと文と栞のクリティカル率アップ","ko":"클로딘, 후미, 시오리의 크리티컬 확률 증가","zh_hant":"提升克洛迪娜、文和栞的會心率"},"skill_option1_id":20,"skill_option1_target_id":3170,"_id_":5000420},"5000421":{"description":{"en":"(Passive) [Claudine & Fumi & Shiori] Critical Up %opt1_value%% ","ja":"[永続]【クロディーヌと文と栞】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [클로딘, 후미, 시오리]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜、文和栞】的會心威力 +%opt1_value%%"},"name":{"en":"Claudine & Fumi & Shiori Critical Up","ja":"クロディーヌと文と栞のクリティカル威力アップ","ko":"클로딘, 후미, 시오리의 크리티컬 위력 증가","zh_hant":"提升克洛迪娜、文和栞的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3170,"_id_":5000421},"5000501":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Act Power Up %opt1_value% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象にACTパワーアップ +%opt1_value%","ko":"[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 ACT 파워 %opt1_value%증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的ACT力量 +%opt1_value%"},"name":{"en":"Treacherous Crete Act Power Up","ja":"裏切りのクレタのACTパワーアップ","ko":"배신의 크레타에 출연하는 무대소녀의 ACT 파워 증가","zh_hant":"提升背叛的克里特的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3180,"_id_":5000501},"5000502":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Flower Dmg Received Down","ja":"裏切りのクレタの花属性被ダメージダウン","ko":"배신의 크레타에 출연하는 무대소녀가 받는 꽃 속성 대미지 감소","zh_hant":"減輕背叛的克里特受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3180,"_id_":5000502},"5000503":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Wind Dmg Received Down","ja":"裏切りのクレタの風属性被ダメージダウン","ko":"배신의 크레타에 출연하는 무대소녀가 받는 바람 속성 대미지 감소","zh_hant":"減輕背叛的克里特受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3180,"_id_":5000503},"5000504":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Snow Dmg Received Down","ja":"裏切りのクレタの雪属性被ダメージダウン","ko":"배신의 크레타에 출연하는 무대소녀가 받는 눈 속성 대미지 감소","zh_hant":"減輕背叛的克里特受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3180,"_id_":5000504},"5000505":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Moon Dmg Received Down","ja":"裏切りのクレタの月属性被ダメージダウン","ko":"배신의 크레타에 출연하는 무대소녀가 받는 달 속성 대미지 감소","zh_hant":"減輕背叛的克里特受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3180,"_id_":5000505},"5000506":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Space Dmg Received Down","ja":"裏切りのクレタの宙属性被ダメージダウン","ko":"배신의 크레타에 출연하는 무대소녀가 받는 우주 속성 대미지 감소","zh_hant":"減輕背叛的克里特受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3180,"_id_":5000506},"5000507":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Cloud Dmg Received Down","ja":"裏切りのクレタの雲属性被ダメージダウン","ko":"배신의 크레타에 출연하는 무대소녀가 받는 구름 속성 대미지 감소","zh_hant":"減輕背叛的克里特受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3180,"_id_":5000507},"5000508":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真矢・奈奈・司・靜羽・未知留・八千代】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Dream Dmg Received Down","ja":"裏切りのクレタの夢属性被ダメージダウン","ko":"배신의 크레타에 출연하는 무대소녀가 받는 꿈 속성 대미지 감소","zh_hant":"減輕背叛的克里特受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3180,"_id_":5000508},"5000509":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Flower Dmg dealt Up","ja":"裏切りのクレタの花属性与ダメージアップ","ko":"배신의 크레타에 출연하는 무대소녀가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升背叛的克里特的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3180,"_id_":5000509},"5000510":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Wind Dmg dealt Up","ja":"裏切りのクレタの風属性与ダメージアップ","ko":"배신의 크레타에 출연하는 무대소녀가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升背叛的克里特的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3180,"_id_":5000510},"5000511":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Snow Dmg dealt Up","ja":"裏切りのクレタの雪属性与ダメージアップ","ko":"배신의 크레타에 출연하는 무대소녀가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升背叛的克里特的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3180,"_id_":5000511},"5000512":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Moon Dmg dealt Up","ja":"裏切りのクレタの月属性与ダメージアップ","ko":"배신의 크레타에 출연하는 무대소녀가 달 속성에게 가하는 대미지 증가","zh_hant":"提升背叛的克里特的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3180,"_id_":5000512},"5000513":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Space Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Space Dmg dealt Up","ja":"裏切りのクレタの宙属性与ダメージアップ","ko":"배신의 크레타에 출연하는 무대소녀가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升背叛的克里特的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3180,"_id_":5000513},"5000514":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Cloud Dmg dealt Up","ja":"裏切りのクレタの雲属性与ダメージアップ","ko":"배신의 크레타에 출연하는 무대소녀가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升背叛的克里特的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3180,"_id_":5000514},"5000515":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마야, 나나, 츠카사, 시즈하, 미치루, 야치요]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Treacherous Crete Dream Dmg dealt Up","ja":"裏切りのクレタの夢属性与ダメージアップ","ko":"배신의 크레타에 출연하는 무대소녀가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升背叛的克里特的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3180,"_id_":5000515},"5000516":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Normal Defense Up %opt1_value% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に通常防御力アップ +%opt1_value%","ko":"[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 일반 방어력 %opt1_value%증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的普通防禦力 +%opt1_value%"},"name":{"en":"Treacherous Crete Normal Defense Up","ja":"裏切りのクレタの通常防御力アップ","ko":"배신의 크레타에 출연하는 무대소녀의 일반 방어력 증가","zh_hant":"提升背叛的克里特的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3180,"_id_":5000516},"5000517":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Special Defense Up %opt1_value% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 특수 방어력 %opt1_value%증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的特殊防禦力 +%opt1_value%"},"name":{"en":"Treacherous Crete Special Defense Up","ja":"裏切りのクレタの特殊防御力アップ","ko":"배신의 크레타에 출연하는 무대소녀의 특수 방어력 증가","zh_hant":"提升背叛的克里特的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3180,"_id_":5000517},"5000518":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Normal Defense Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的普通防禦力 +%opt1_value%%"},"name":{"en":"Treacherous Crete Normal Defense Up","ja":"裏切りのクレタの通常防御力アップ","ko":"배신의 크레타에 출연하는 무대소녀의 일반 방어력 증가","zh_hant":"提升背叛的克里特的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3180,"_id_":5000518},"5000519":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Special Defense Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Treacherous Crete Special Defense Up","ja":"裏切りのクレタの特殊防御力アップ","ko":"배신의 크레타에 출연하는 무대소녀의 특수 방어력 증가","zh_hant":"提升背叛的克里特的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3180,"_id_":5000519},"5000520":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Dexterity Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的會心率 +%opt1_value%%"},"name":{"en":"Treacherous Crete Dexterity Up","ja":"裏切りのクレタのクリティカル率アップ","ko":"배신의 크레타에 출연하는 무대소녀의 크리티컬 확률 증가","zh_hant":"提升背叛的克里特的會心率"},"skill_option1_id":20,"skill_option1_target_id":3180,"_id_":5000520},"5000521":{"description":{"en":"(Passive) [Maya & Nana & Tsukasa & Shizuha & Michiru & Yachiyo] Critical Up %opt1_value%% ","ja":"[永続]【真矢・なな・つかさ・静羽・ミチル・やちよ】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구][마야, 나나, 츠카사, 시즈하, 미치루, 야치요]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【真矢・奈奈・司・靜羽・未知留・八千代】的會心威力 +%opt1_value%%"},"name":{"en":"Treacherous Crete Critical Up","ja":"裏切りのクレタのクリティカル威力アップ","ko":"배신의 크레타에 출연하는 무대소녀의 크리티컬 위력 증가","zh_hant":"提升背叛的克里特的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3180,"_id_":5000521},"5000601":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Act Power Up %opt1_value% ","ja":"[永続]【まひるといちえとあるると美空】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的ACT力量 +%opt1_value%"},"name":{"en":"Procyon the Bright Act Power Up","ja":"一等星のプロキオンのACTパワーアップ","ko":"1등성의 프로키온에 출연하는 무대소녀의 ACT 파워 증가","zh_hant":"提升一等星的南河三的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3190,"_id_":5000601},"5000602":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、一愛、艾露露和美空】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Flower Dmg Received Down","ja":"一等星のプロキオンの花属性被ダメージダウン","ko":"1등성의 프로키온에 출연하는 무대소녀가 받는 꽃 속성 대미지 감소","zh_hant":"減輕一等星的南河三受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3190,"_id_":5000602},"5000603":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、一愛、艾露露和美空】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Wind Dmg Received Down","ja":"一等星のプロキオンの風属性被ダメージダウン","ko":"1등성의 프로키온에 출연하는 무대소녀가 받는 바람 속성 대미지 감소","zh_hant":"減輕一等星的南河三受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3190,"_id_":5000603},"5000604":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、一愛、艾露露和美空】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Snow Dmg Received Down","ja":"一等星のプロキオンの雪属性被ダメージダウン","ko":"1등성의 프로키온에 출연하는 무대소녀가 받는 눈 속성 대미지 감소","zh_hant":"減輕一等星的南河三受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3190,"_id_":5000604},"5000605":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、一愛、艾露露和美空】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Moon Dmg Received Down","ja":"一等星のプロキオンの月属性被ダメージダウン","ko":"1등성의 프로키온에 출연하는 무대소녀가 받는 달 속성 대미지 감소","zh_hant":"減輕一等星的南河三受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3190,"_id_":5000605},"5000606":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、一愛、艾露露和美空】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Space Dmg Received Down","ja":"一等星のプロキオンの宙属性被ダメージダウン","ko":"1등성의 프로키온에 출연하는 무대소녀가 받는 우주 속성 대미지 감소","zh_hant":"減輕一等星的南河三受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3190,"_id_":5000606},"5000607":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、一愛、艾露露和美空】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Cloud Dmg Received Down","ja":"一等星のプロキオンの雲属性被ダメージダウン","ko":"1등성의 프로키온에 출연하는 무대소녀가 받는 구름 속성 대미지 감소","zh_hant":"減輕一等星的南河三受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3190,"_id_":5000607},"5000608":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、一愛、艾露露和美空】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dream Dmg Received Down","ja":"一等星のプロキオンの夢属性被ダメージダウン","ko":"1등성의 프로키온에 출연하는 무대소녀가 받는 꿈 속성 대미지 감소","zh_hant":"減輕一等星的南河三受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3190,"_id_":5000608},"5000609":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dmg to Flower Up","ja":"一等星のプロキオンの花属性与ダメージアップ","ko":"1등성의 프로키온에 출연하는 무대소녀가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升一等星的南河三的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3190,"_id_":5000609},"5000610":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dmg to Wind Up","ja":"一等星のプロキオンの風属性与ダメージアップ","ko":"1등성의 프로키온에 출연하는 무대소녀가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升一等星的南河三的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3190,"_id_":5000610},"5000611":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dmg to Snow Up","ja":"一等星のプロキオンの雪属性与ダメージアップ","ko":"1등성의 프로키온에 출연하는 무대소녀가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升一等星的南河三的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3190,"_id_":5000611},"5000612":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dmg to Moon Up","ja":"一等星のプロキオンの月属性与ダメージアップ","ko":"1등성의 프로키온에 출연하는 무대소녀가 달 속성에게 가하는 대미지 증가","zh_hant":"提升一等星的南河三的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3190,"_id_":5000612},"5000613":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Space Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dmg to Space Up","ja":"一等星のプロキオンの宙属性与ダメージアップ","ko":"1등성의 프로키온에 출연하는 무대소녀가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升一等星的南河三的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3190,"_id_":5000613},"5000614":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dmg to Cloud Up","ja":"一等星のプロキオンの雲属性与ダメージアップ","ko":"1등성의 프로키온에 출연하는 무대소녀가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升一等星的南河三的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3190,"_id_":5000614},"5000615":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dmg to Dream Up","ja":"一等星のプロキオンの夢属性与ダメージアップ","ko":"1등성의 프로키온에 출연하는 무대소녀가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升一等星的南河三的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3190,"_id_":5000615},"5000616":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Normal Defense Up %opt1_value% ","ja":"[永続]【まひるといちえとあるると美空】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的普通防禦力 +%opt1_value%"},"name":{"en":"Procyon the Bright Normal Defense Up","ja":"一等星のプロキオンの通常防御力アップ","ko":"1등성의 프로키온에 출연하는 무대소녀의 일반 방어력 증가","zh_hant":"提升一等星的南河三的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3190,"_id_":5000616},"5000617":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Special Defense Up %opt1_value% ","ja":"[永続]【まひるといちえとあるると美空】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的特殊防禦力 +%opt1_value%"},"name":{"en":"Procyon the Bright Special Defense Up","ja":"一等星のプロキオンの特殊防御力アップ","ko":"1등성의 프로키온에 출연하는 무대소녀의 특수 방어력 증가","zh_hant":"提升一等星的南河三的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3190,"_id_":5000617},"5000618":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Normal Defense Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的普通防禦力 +%opt1_value%%"},"name":{"en":"Procyon the Bright Normal Defense Up","ja":"一等星のプロキオンの通常防御力アップ","ko":"1등성의 프로키온에 출연하는 무대소녀의 일반 방어력 증가","zh_hant":"提升一等星的南河三的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3190,"_id_":5000618},"5000619":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Special Defense Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Procyon the Bright Special Defense Up","ja":"一等星のプロキオンの特殊防御力アップ","ko":"1등성의 프로키온에 출연하는 무대소녀의 특수 방어력 증가","zh_hant":"提升一等星的南河三的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3190,"_id_":5000619},"5000620":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Dexterity Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的會心率 +%opt1_value%%"},"name":{"en":"Procyon the Bright Dexterity Up","ja":"一等星のプロキオンのクリティカル率アップ","ko":"1등성의 프로키온에 출연하는 무대소녀의 크리티컬 확률 증가","zh_hant":"提升一等星的南河三的會心率"},"skill_option1_id":20,"skill_option1_target_id":3190,"_id_":5000620},"5000621":{"description":{"en":"(Passive) [Mahiru & Ichie & Aruru & Misora] Critical Up %opt1_value%% ","ja":"[永続]【まひるといちえとあるると美空】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [마히루, 이치에, 아루루, 미소라]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、一愛、艾露露和美空】的會心威力 +%opt1_value%%"},"name":{"en":"Procyon the Bright Critical Up","ja":"一等星のプロキオンのクリティカル威力アップ","ko":"1등성의 프로키온에 출연하는 무대소녀의 크리티컬 위력 증가","zh_hant":"提升一等星的南河三的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3190,"_id_":5000621},"5000701":{"description":{"en":"(Passive) [Seiran] Act Power Up %opt1_value% ","ja":"[永続]【青嵐総合芸術院】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [세이란 종합 예술학원 무대소녀]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】的ACT力量+%opt1_value%"},"name":{"en":"Seiran Act Power Up","ja":"青嵐総合芸術院のACTパワーアップ","ko":"세이란 종합 예술학원 무대소녀의 ACT 파워 증가","zh_hant":"提升青嵐總合藝術學院之舞台少女的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3210,"_id_":5000701},"5000702":{"description":{"en":"(Passive) [Seiran] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【青嵐總合藝術學院】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Seiran Flower Dmg Received Down","ja":"青嵐総合芸術院の花属性被ダメージダウン","ko":"세이란 종합 예술학원 무대소녀가 받는 꽃 속성 대미지 감소","zh_hant":"減輕青嵐總合藝術學院受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3210,"_id_":5000702},"5000703":{"description":{"en":"(Passive) [Seiran] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【青嵐總合藝術學院】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Seiran Wind Dmg Received Down","ja":"青嵐総合芸術院の風属性被ダメージダウン","ko":"세이란 종합 예술학원 무대소녀가 받는 바람 속성 대미지 감소","zh_hant":"減輕青嵐總合藝術學院受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3210,"_id_":5000703},"5000704":{"description":{"en":"(Passive) [Seiran] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【青嵐總合藝術學院】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Seiran Snow Dmg Received Down","ja":"青嵐総合芸術院の雪属性被ダメージダウン","ko":"세이란 종합 예술학원 무대소녀가 받는 눈 속성 대미지 감소","zh_hant":"減輕青嵐總合藝術學院受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3210,"_id_":5000704},"5000705":{"description":{"en":"(Passive) [Seiran] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【青嵐總合藝術學院】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Seiran Moon Dmg Received Down","ja":"青嵐総合芸術院の月属性被ダメージダウン","ko":"세이란 종합 예술학원 무대소녀가 받는 달 속성 대미지 감소","zh_hant":"減輕青嵐總合藝術學院受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3210,"_id_":5000705},"5000706":{"description":{"en":"(Passive) [Seiran] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【青嵐總合藝術學院】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Seiran Space Dmg Received Down","ja":"青嵐総合芸術院の宙属性被ダメージダウン","ko":"세이란 종합 예술학원 무대소녀가 받는 우주 속성 대미지 감소","zh_hant":"減輕青嵐總合藝術學院受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3210,"_id_":5000706},"5000707":{"description":{"en":"(Passive) [Seiran] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【青嵐總合藝術學院】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Seiran Cloud Dmg Received Down","ja":"青嵐総合芸術院の雲属性被ダメージダウン","ko":"세이란 종합 예술학원 무대소녀가 받는 구름 속성 대미지 감소","zh_hant":"減輕青嵐總合藝術學院受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3210,"_id_":5000707},"5000708":{"description":{"en":"(Passive) [Seiran] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【青嵐總合藝術學院】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Seiran Dream Dmg Received Down","ja":"青嵐総合芸術院の夢属性被ダメージダウン","ko":"세이란 종합 예술학원 무대소녀가 받는 꿈 속성 대미지 감소","zh_hant":"減輕青嵐總合藝術學院受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3210,"_id_":5000708},"5000709":{"description":{"en":"(Passive) [Seiran] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seiran Dmg to Flower Up","ja":"青嵐総合芸術院の花属性特効与ダメージアップ","ko":"세이란 종합 예술학원 무대소녀가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升青嵐總合藝術學院的花屬性特效造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3210,"_id_":5000709},"5000710":{"description":{"en":"(Passive) [Seiran] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seiran Dmg to Wind Up","ja":"青嵐総合芸術院の風属性特効与ダメージアップ","ko":"세이란 종합 예술학원 무대소녀가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升青嵐總合藝術學院的風屬性特效造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3210,"_id_":5000710},"5000711":{"description":{"en":"(Passive) [Seiran] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seiran Dmg to Snow Up","ja":"青嵐総合芸術院の雪属性特効与ダメージアップ","ko":"세이란 종합 예술학원 무대소녀가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升青嵐總合藝術學院的雪屬性特效造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3210,"_id_":5000711},"5000712":{"description":{"en":"(Passive) [Seiran] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seiran Dmg to Moon Up","ja":"青嵐総合芸術院の月属性特効与ダメージアップ","ko":"세이란 종합 예술학원 무대소녀가 달 속성에게 가하는 대미지 증가","zh_hant":"提升青嵐總合藝術學院的月屬性特效造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3210,"_id_":5000712},"5000713":{"description":{"en":"(Passive) [Seiran] Dmg to Space Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seiran Dmg to Space Up","ja":"青嵐総合芸術院の宙属性特効与ダメージアップ","ko":"세이란 종합 예술학원 무대소녀가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升青嵐總合藝術學院的宙屬性特效造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3210,"_id_":5000713},"5000714":{"description":{"en":"(Passive) [Seiran] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seiran Dmg to Cloud Up","ja":"青嵐総合芸術院の雲属性特効与ダメージアップ","ko":"세이란 종합 예술학원 무대소녀가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升青嵐總合藝術學院的雲屬性特效造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3210,"_id_":5000714},"5000715":{"description":{"en":"(Passive) [Seiran] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Seiran Dmg to Dream Up","ja":"青嵐総合芸術院の夢属性特効与ダメージアップ","ko":"세이란 종합 예술학원 무대소녀가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升青嵐總合藝術學院的夢屬性特效造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3210,"_id_":5000715},"5000716":{"description":{"en":"(Passive) [Seiran] Normal Defense Up %opt1_value% ","ja":"[永続]【青嵐総合芸術院】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [세이란 종합 예술학원 무대소녀]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】的普通防禦力+%opt1_value%"},"name":{"en":"Seiran Normal Defense Up","ja":"青嵐総合芸術院の通常防御力アップ","ko":"세이란 종합 예술학원 무대소녀의 일반 방어력 증가","zh_hant":"提升青嵐總合藝術學院的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3210,"_id_":5000716},"5000717":{"description":{"en":"(Passive) [Seiran] Special Defense Up %opt1_value% ","ja":"[永続]【青嵐総合芸術院】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [세이란 종합 예술학원 무대소녀]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】的特殊防禦力+%opt1_value%"},"name":{"en":"Seiran Special Defense Up","ja":"青嵐総合芸術院の特殊防御力アップ","ko":"세이란 종합 예술학원 무대소녀의 특수 방어력 증가","zh_hant":"提升青嵐總合藝術學院的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3210,"_id_":5000717},"5000718":{"description":{"en":"(Passive) [Seiran] Normal Defense Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】的普通防禦力+%opt1_value%%"},"name":{"en":"Seiran Normal Defense Up","ja":"青嵐総合芸術院の通常防御力アップ","ko":"세이란 종합 예술학원 무대소녀의 일반 방어력 증가","zh_hant":"提升青嵐總合藝術學院的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3210,"_id_":5000718},"5000719":{"description":{"en":"(Passive) [Seiran] Special Defense Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】的特殊防禦力+%opt1_value%%"},"name":{"en":"Seiran Special Defense Up","ja":"青嵐総合芸術院の特殊防御力アップ","ko":"세이란 종합 예술학원 무대소녀의 특수 방어력 증가","zh_hant":"提升青嵐總合藝術學院的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3210,"_id_":5000719},"5000720":{"description":{"en":"(Passive) [Seiran] Dexterity Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】的會心率 +%opt1_value%%"},"name":{"en":"Seiran Dexterity Up","ja":"青嵐総合芸術院のクリティカル率アップ","ko":"세이란 종합 예술학원 무대소녀의 크리티컬 확률 증가","zh_hant":"提升青嵐總合藝術學院的會心率"},"skill_option1_id":20,"skill_option1_target_id":3210,"_id_":5000720},"5000721":{"description":{"en":"(Passive) [Seiran] Critical Up %opt1_value%% ","ja":"[永続]【青嵐総合芸術院】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [세이란 종합 예술학원 무대소녀]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【青嵐總合藝術學院】的會心威力 +%opt1_value%%"},"name":{"en":"Seiran Critical Up","ja":"青嵐総合芸術院のクリティカル威力アップ","ko":"세이란 종합 예술학원 무대소녀의 크리티컬 위력 증가","zh_hant":"提升青嵐總合藝術學院的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3210,"_id_":5000721},"5000801":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Act Power Up %opt1_value% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [준나, 카오루코, 루이, 유유코]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】的ACT力量 +%opt1_value%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Act Power Up","ja":"純那と香子と塁とゆゆ子のACTパワーアップ","ko":"준나, 카오루코, 루이, 유유코의 ACT 파워 증가","zh_hant":"提升純那、香子、壘和悠悠子的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3220,"_id_":5000801},"5000802":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、香子、壘、悠悠子】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Flower Dmg Received Down","ja":"純那と香子と塁とゆゆ子の花属性被ダメージダウン","ko":"준나, 카오루코, 루이, 유유코가 받는 꽃 속성 대미지 감소","zh_hant":"減輕純那、香子、壘和悠悠子受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3220,"_id_":5000802},"5000803":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、香子、壘、悠悠子】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Wind Dmg Received Down","ja":"純那と香子と塁とゆゆ子の風属性被ダメージダウン","ko":"준나, 카오루코, 루이, 유유코가 받는 바람 속성 대미지 감소","zh_hant":"減輕純那、香子、壘和悠悠子受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3220,"_id_":5000803},"5000804":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、香子、壘、悠悠子】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Snow Dmg Received Down","ja":"純那と香子と塁とゆゆ子の雪属性被ダメージダウン","ko":"준나, 카오루코, 루이, 유유코가 받는 눈 속성 대미지 감소","zh_hant":"減輕純那、香子、壘和悠悠子受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3220,"_id_":5000804},"5000805":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、香子、壘、悠悠子】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Moon Dmg Received Down","ja":"純那と香子と塁とゆゆ子の月属性被ダメージダウン","ko":"준나, 카오루코, 루이, 유유코가 받는 달 속성 대미지 감소","zh_hant":"減輕純那、香子、壘和悠悠子受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3220,"_id_":5000805},"5000806":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、香子、壘、悠悠子】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Space Dmg Received Down","ja":"純那と香子と塁とゆゆ子の宙属性被ダメージダウン","ko":"준나, 카오루코, 루이, 유유코가 받는 우주 속성 대미지 감소","zh_hant":"減輕純那、香子、壘和悠悠子受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3220,"_id_":5000806},"5000807":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、香子、壘、悠悠子】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Cloud Dmg Received Down","ja":"純那と香子と塁とゆゆ子の雲属性被ダメージダウン","ko":"준나, 카오루코, 루이, 유유코가 받는 구름 속성 대미지 감소","zh_hant":"減輕純那、香子、壘和悠悠子受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3220,"_id_":5000807},"5000808":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【純那、香子、壘、悠悠子】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dream Dmg Received Down","ja":"純那と香子と塁とゆゆ子の夢属性被ダメージダウン","ko":"준나, 카오루코, 루이, 유유코가 받는 꿈 속성 대미지 감소","zh_hant":"減輕純那、香子、壘和悠悠子受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3220,"_id_":5000808},"5000809":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dmg to Flower Up","ja":"純那と香子と塁とゆゆ子の花属性与ダメージアップ","ko":"준나, 카오루코, 루이, 유유코가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升純那、香子、壘和悠悠子的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3220,"_id_":5000809},"5000810":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dmg to Wind Up","ja":"純那と香子と塁とゆゆ子の風属性与ダメージアップ","ko":"준나, 카오루코, 루이, 유유코가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升純那、香子、壘和悠悠子的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3220,"_id_":5000810},"5000811":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dmg to Snow Up","ja":"純那と香子と塁とゆゆ子の雪属性与ダメージアップ","ko":"준나, 카오루코, 루이, 유유코가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升純那、香子、壘和悠悠子的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3220,"_id_":5000811},"5000812":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dmg to Moon Up","ja":"純那と香子と塁とゆゆ子の月属性与ダメージアップ","ko":"준나, 카오루코, 루이, 유유코가 달 속성에게 가하는 대미지 증가","zh_hant":"提升純那、香子、壘和悠悠子的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3220,"_id_":5000812},"5000813":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Space Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dmg to Space Up","ja":"純那と香子と塁とゆゆ子の宙属性与ダメージアップ","ko":"준나, 카오루코, 루이, 유유코가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升純那、香子、壘和悠悠子的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3220,"_id_":5000813},"5000814":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dmg to Cloud Up","ja":"純那と香子と塁とゆゆ子の雲属性与ダメージアップ","ko":"준나, 카오루코, 루이, 유유코가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升純那、香子、壘和悠悠子的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3220,"_id_":5000814},"5000815":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dmg to Dream Up","ja":"純那と香子と塁とゆゆ子の夢属性与ダメージアップ","ko":"준나, 카오루코, 루이, 유유코가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升純那、香子、壘和悠悠子的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3220,"_id_":5000815},"5000816":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Normal Defense Up %opt1_value% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [준나, 카오루코, 루이, 유유코]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】的普通防禦力 +%opt1_value%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Normal Defense Up","ja":"純那と香子と塁とゆゆ子の通常防御力アップ","ko":"준나, 카오루코, 루이, 유유코의 일반 방어력 증가","zh_hant":"提升純那、香子、壘和悠悠子的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3220,"_id_":5000816},"5000817":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Special Defense Up %opt1_value% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [준나, 카오루코, 루이, 유유코]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】的特殊防禦力 +%opt1_value%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Special Defense Up","ja":"純那と香子と塁とゆゆ子の特殊防御力アップ","ko":"준나, 카오루코, 루이, 유유코의 특수 방어력 증가","zh_hant":"提升純那、香子、壘和悠悠子的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3220,"_id_":5000817},"5000818":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Normal Defense Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】的普通防禦力 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Normal Defense Up","ja":"純那と香子と塁とゆゆ子の通常防御力アップ","ko":"준나, 카오루코, 루이, 유유코의 일반 방어력 증가","zh_hant":"提升純那、香子、壘和悠悠子的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3220,"_id_":5000818},"5000819":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Special Defense Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Special Defense Up","ja":"純那と香子と塁とゆゆ子の特殊防御力アップ","ko":"준나, 카오루코, 루이, 유유코의 특수 방어력 증가","zh_hant":"提升純那、香子、壘和悠悠子的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3220,"_id_":5000819},"5000820":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Dexterity Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】的會心率 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Dexterity Up","ja":"純那と香子と塁とゆゆ子のクリティカル率アップ","ko":"준나, 카오루코, 루이, 유유코의 크리티컬 확률 증가","zh_hant":"提升純那、香子、壘和悠悠子的會心率"},"skill_option1_id":20,"skill_option1_target_id":3220,"_id_":5000820},"5000821":{"description":{"en":"(Passive) [Junna & Kaoruko & Rui & Yuyuko] Critical Up %opt1_value%% ","ja":"[永続]【純那と香子と塁とゆゆ子】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [준나, 카오루코, 루이, 유유코]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【純那、香子、壘、悠悠子】的會心威力 +%opt1_value%%"},"name":{"en":"Junna & Kaoruko & Rui & Yuyuko Critical Up","ja":"純那と香子と塁とゆゆ子のクリティカル威力アップ","ko":"준나, 카오루코, 루이, 유유코의 크리티컬 위력 증가","zh_hant":"提升純那、香子、壘和悠悠子的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3220,"_id_":5000821},"5000901":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Act Power Up %opt1_value% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Act Power Up","ja":"華恋と双葉とミチルと栞のACTパワーアップ","ko":"카렌, 후타바, 미치루, 시오리의 ACT 파워 증가","zh_hant":"提升華戀、雙葉、未知留、栞的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3240,"_id_":5000901},"5000902":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、雙葉、未知留、栞】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Flower Dmg Received Down","ja":"華恋と双葉とミチルと栞の花属性被ダメージダウン","ko":"카렌, 후타바, 미치루, 시오리가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀、雙葉、未知留、栞受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3240,"_id_":5000902},"5000903":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、雙葉、未知留、栞】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Wind Dmg Received Down","ja":"華恋と双葉とミチルと栞の風属性被ダメージダウン","ko":"카렌, 후타바, 미치루, 시오리가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀、雙葉、未知留、栞受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3240,"_id_":5000903},"5000904":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、雙葉、未知留、栞】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Snow Dmg Received Down","ja":"華恋と双葉とミチルと栞の雪属性被ダメージダウン","ko":"카렌, 후타바, 미치루, 시오리가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀、雙葉、未知留、栞受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3240,"_id_":5000904},"5000905":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、雙葉、未知留、栞】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Moon Dmg Received Down","ja":"華恋と双葉とミチルと栞の月属性被ダメージダウン","ko":"카렌, 후타바, 미치루, 시오리가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀、雙葉、未知留、栞受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3240,"_id_":5000905},"5000906":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、雙葉、未知留、栞】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Space Dmg Received Down","ja":"華恋と双葉とミチルと栞の宙属性被ダメージダウン","ko":"카렌, 후타바, 미치루, 시오리가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀、雙葉、未知留、栞受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3240,"_id_":5000906},"5000907":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、雙葉、未知留、栞】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Cloud Dmg Received Down","ja":"華恋と双葉とミチルと栞の雲属性被ダメージダウン","ko":"카렌, 후타바, 미치루, 시오리가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀、雙葉、未知留、栞受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3240,"_id_":5000907},"5000908":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、雙葉、未知留、栞】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dream Dmg Received Down","ja":"華恋と双葉とミチルと栞の夢属性被ダメージダウン","ko":"카렌, 후타바, 미치루, 시오리가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀、雙葉、未知留、栞受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3240,"_id_":5000908},"5000909":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dmg to Flower Up","ja":"華恋と双葉とミチルと栞の花属性与ダメージアップ","ko":"카렌, 후타바, 미치루, 시오리가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、雙葉、未知留、栞的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3240,"_id_":5000909},"5000910":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dmg to Wind Up","ja":"華恋と双葉とミチルと栞の風属性与ダメージアップ","ko":"카렌, 후타바, 미치루, 시오리가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、雙葉、未知留、栞的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3240,"_id_":5000910},"5000911":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dmg to Snow Up","ja":"華恋と双葉とミチルと栞の雪属性与ダメージアップ","ko":"카렌, 후타바, 미치루, 시오리가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、雙葉、未知留、栞的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3240,"_id_":5000911},"5000912":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dmg to Moon Up","ja":"華恋と双葉とミチルと栞の月属性与ダメージアップ","ko":"카렌, 후타바, 미치루, 시오리가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、雙葉、未知留、栞的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3240,"_id_":5000912},"5000913":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dmg to Space Up","ja":"華恋と双葉とミチルと栞の宙属性与ダメージアップ","ko":"카렌, 후타바, 미치루, 시오리가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、雙葉、未知留、栞的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3240,"_id_":5000913},"5000914":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dmg to Cloud Up","ja":"華恋と双葉とミチルと栞の雲属性与ダメージアップ","ko":"카렌, 후타바, 미치루, 시오리가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、雙葉、未知留、栞的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3240,"_id_":5000914},"5000915":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dmg to Dream Up","ja":"華恋と双葉とミチルと栞の夢属性与ダメージアップ","ko":"카렌, 후타바, 미치루, 시오리가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、雙葉、未知留、栞的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3240,"_id_":5000915},"5000916":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Normal Defense Up","ja":"華恋と双葉とミチルと栞の通常防御力アップ","ko":"카렌, 후타바, 미치루, 시오리의 일반 방어력 증가","zh_hant":"提升華戀、雙葉、未知留、栞的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3240,"_id_":5000916},"5000917":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Special Defense Up %opt1_value% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Special Defense Up","ja":"華恋と双葉とミチルと栞の特殊防御力アップ","ko":"카렌, 후타바, 미치루, 시오리의 특수 방어력 증가","zh_hant":"提升華戀、雙葉、未知留、栞的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3240,"_id_":5000917},"5000918":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Normal Defense Up","ja":"華恋と双葉とミチルと栞の通常防御力アップ","ko":"카렌, 후타바, 미치루, 시오리의 일반 방어력 증가","zh_hant":"提升華戀、雙葉、未知留、栞的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3240,"_id_":5000918},"5000919":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Special Defense Up","ja":"華恋と双葉とミチルと栞の特殊防御力アップ","ko":"카렌, 후타바, 미치루, 시오리의 특수 방어력 증가","zh_hant":"提升華戀、雙葉、未知留、栞的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3240,"_id_":5000919},"5000920":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Dexterity Up","ja":"華恋と双葉とミチルと栞のクリティカル率アップ","ko":"카렌, 후타바, 미치루, 시오리의 크리티컬 확률 증가","zh_hant":"提升華戀、雙葉、未知留、栞的會心率"},"skill_option1_id":20,"skill_option1_target_id":3240,"_id_":5000920},"5000921":{"description":{"en":"(Passive) [Karen & Futaba & Michiru & Shiori] Critical Up %opt1_value%% ","ja":"[永続]【華恋と双葉とミチルと栞】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌, 후타바, 미치루, 시오리]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、雙葉、未知留、栞】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Futaba & Michiru & Shiori Critical Up","ja":"華恋と双葉とミチルと栞のクリティカル威力アップ","ko":"카렌, 후타바, 미치루, 시오리의 크리티컬 위력 증가","zh_hant":"提升華戀、雙葉、未知留、栞的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3240,"_id_":5000921},"5001001":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Act Power Up %opt1_value% ","ja":"[永続]【まひるとななといちえと文】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [마히루, 나나, 이치에, 후미]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的ACT力量+%opt1_value%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Act Power Up","ja":"まひるとななといちえと文のACTパワーアップ","ko":"마히루, 나나, 이치에, 후미의 ACT 파워 증가","zh_hant":"提升真晝、奈奈、一愛和文的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3250,"_id_":5001001},"5001002":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、奈奈、一愛和文】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Flower Dmg Received Down","ja":"まひるとななといちえと文の花属性被ダメージダウン","ko":"마히루, 나나, 이치에, 후미가 받는 꽃 속성 대미지 감소","zh_hant":"減輕真晝、奈奈、一愛和文受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3250,"_id_":5001002},"5001003":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、奈奈、一愛和文】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Wind Dmg Received Down","ja":"まひるとななといちえと文の風属性被ダメージダウン","ko":"마히루, 나나, 이치에, 후미가 받는 바람 속성 대미지 감소","zh_hant":"減輕真晝、奈奈、一愛和文受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3250,"_id_":5001003},"5001004":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、奈奈、一愛和文】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Snow Dmg Received Down","ja":"まひるとななといちえと文の雪属性被ダメージダウン","ko":"마히루, 나나, 이치에, 후미가 받는 눈 속성 대미지 감소","zh_hant":"減輕真晝、奈奈、一愛和文受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3250,"_id_":5001004},"5001005":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、奈奈、一愛和文】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Moon Dmg Received Down","ja":"まひるとななといちえと文の月属性被ダメージダウン","ko":"마히루, 나나, 이치에, 후미가 받는 달 속성 대미지 감소","zh_hant":"減輕真晝、奈奈、一愛和文受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3250,"_id_":5001005},"5001006":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、奈奈、一愛和文】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Space Dmg Received Down","ja":"まひるとななといちえと文の宙属性被ダメージダウン","ko":"마히루, 나나, 이치에, 후미가 받는 우주 속성 대미지 감소","zh_hant":"減輕真晝、奈奈、一愛和文受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3250,"_id_":5001006},"5001007":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、奈奈、一愛和文】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Cloud Dmg Received Down","ja":"まひるとななといちえと文の雲属性被ダメージダウン","ko":"마히루, 나나, 이치에, 후미가 받는 구름 속성 대미지 감소","zh_hant":"減輕真晝、奈奈、一愛和文受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3250,"_id_":5001007},"5001008":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【真晝、奈奈、一愛和文】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dream Dmg Received Down","ja":"まひるとななといちえと文の夢属性被ダメージダウン","ko":"마히루, 나나, 이치에, 후미가 받는 꿈 속성 대미지 감소","zh_hant":"減輕真晝、奈奈、一愛和文受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3250,"_id_":5001008},"5001009":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dmg to Flower Up","ja":"まひるとななといちえと文の花属性与ダメージアップ","ko":"마히루, 나나, 이치에, 후미가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升真晝、奈奈、一愛和文的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3250,"_id_":5001009},"5001010":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dmg to Wind Up","ja":"まひるとななといちえと文の風属性与ダメージアップ","ko":"마히루, 나나, 이치에, 후미가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升真晝、奈奈、一愛和文的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3250,"_id_":5001010},"5001011":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dmg to Snow Up","ja":"まひるとななといちえと文の雪属性与ダメージアップ","ko":"마히루, 나나, 이치에, 후미가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升真晝、奈奈、一愛和文的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3250,"_id_":5001011},"5001012":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dmg to Moon Up","ja":"まひるとななといちえと文の月属性与ダメージアップ","ko":"마히루, 나나, 이치에, 후미가 달 속성에게 가하는 대미지 증가","zh_hant":"提升真晝、奈奈、一愛和文的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3250,"_id_":5001012},"5001013":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Space Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dmg to Space Up","ja":"まひるとななといちえと文の宙属性与ダメージアップ","ko":"마히루, 나나, 이치에, 후미가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升真晝、奈奈、一愛和文的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3250,"_id_":5001013},"5001014":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dmg to Cloud Up","ja":"まひるとななといちえと文の雲属性与ダメージアップ","ko":"마히루, 나나, 이치에, 후미가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升真晝、奈奈、一愛和文的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3250,"_id_":5001014},"5001015":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dmg to Dream Up","ja":"まひるとななといちえと文の夢属性与ダメージアップ","ko":"마히루, 나나, 이치에, 후미가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升真晝、奈奈、一愛和文的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3250,"_id_":5001015},"5001016":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Normal Defense Up %opt1_value% ","ja":"[永続]【まひるとななといちえと文】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [마히루, 나나, 이치에, 후미]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的普通防禦力+%opt1_value%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Normal Defense Up","ja":"まひるとななといちえと文の通常防御力アップ","ko":"마히루, 나나, 이치에, 후미의 일반 방어력 증가","zh_hant":"提升真晝、奈奈、一愛和文的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3250,"_id_":5001016},"5001017":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Special Defense Up %opt1_value% ","ja":"[永続]【まひるとななといちえと文】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [마히루, 나나, 이치에, 후미]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的特殊防禦力+%opt1_value%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Special Defense Up","ja":"まひるとななといちえと文の特殊防御力アップ","ko":"마히루, 나나, 이치에, 후미의 특수 방어력 증가","zh_hant":"提升真晝、奈奈、一愛和文的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3250,"_id_":5001017},"5001018":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Normal Defense Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的普通防禦力 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Normal Defense Up","ja":"まひるとななといちえと文の通常防御力アップ","ko":"마히루, 나나, 이치에, 후미의 일반 방어력 증가","zh_hant":"提升真晝、奈奈、一愛和文的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3250,"_id_":5001018},"5001019":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Special Defense Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的特殊防禦力+%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Special Defense Up","ja":"まひるとななといちえと文の特殊防御力アップ","ko":"마히루, 나나, 이치에, 후미의 특수 방어력 증가","zh_hant":"提升真晝、奈奈、一愛和文的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3250,"_id_":5001019},"5001020":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Dexterity Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的會心率 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Dexterity Up","ja":"まひるとななといちえと文のクリティカル率アップ","ko":"마히루, 나나, 이치에, 후미의 크리티컬 확률 증가","zh_hant":"提升真晝、奈奈、一愛和文的會心率"},"skill_option1_id":20,"skill_option1_target_id":3250,"_id_":5001020},"5001021":{"description":{"en":"(Passive) [Mahiru & Nana & Ichie & Fumi] Critical Up %opt1_value%% ","ja":"[永続]【まひるとななといちえと文】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [마히루, 나나, 이치에, 후미]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【真晝、奈奈、一愛和文】的會心威力 +%opt1_value%%"},"name":{"en":"Mahiru & Nana & Ichie & Fumi Critical Up","ja":"まひるとななといちえと文のクリティカル威力アップ","ko":"마히루, 나나, 이치에, 후미의 크리티컬 위력 증가","zh_hant":"提升真晝、奈奈、一愛和文的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3250,"_id_":5001021},"5001101":{"description":{"en":"(Passive) [Frontier] Act Power Up %opt1_value% ","ja":"[永続]【フロンティア芸術学校】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [프론티어 예술학교]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的ACT力量+%opt1_value%"},"name":{"en":"Frontier Act Power Up ","ja":"フロンティア芸術学校のACTパワーアップ","ko":"프론티어 예술학교의 ACT 파워 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3260,"_id_":5001101},"5001102":{"description":{"en":"(Passive) [Frontier] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Flower Dmg Received Down ","ja":"フロンティア芸術学校の花属性被ダメージダウン","ko":"프론티어 예술학교가 받는 꽃 속성 대미지 감소","zh_hant":"減輕芙羅提亞藝術學校之舞台少女受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3260,"_id_":5001102},"5001103":{"description":{"en":"(Passive) [Frontier] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Wind Dmg Received Down ","ja":"フロンティア芸術学校の風属性被ダメージダウン","ko":"프론티어 예술학교가 받는 바람 속성 대미지 감소","zh_hant":"減輕芙羅提亞藝術學校之舞台少女受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3260,"_id_":5001103},"5001104":{"description":{"en":"(Passive) [Frontier] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Snow Dmg Received Down ","ja":"フロンティア芸術学校の雪属性被ダメージダウン","ko":"프론티어 예술학교가 받는 눈 속성 대미지 감소","zh_hant":"減輕芙羅提亞藝術學校之舞台少女受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3260,"_id_":5001104},"5001105":{"description":{"en":"(Passive) [Frontier] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Moon Dmg Received Down ","ja":"フロンティア芸術学校の月属性被ダメージダウン","ko":"프론티어 예술학교가 받는 달 속성 대미지 감소","zh_hant":"減輕芙羅提亞藝術學校之舞台少女受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3260,"_id_":5001105},"5001106":{"description":{"en":"(Passive) [Frontier] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Space Dmg Received Down ","ja":"フロンティア芸術学校の宙属性被ダメージダウン","ko":"프론티어 예술학교가 받는 우주 속성 대미지 감소","zh_hant":"減輕芙羅提亞藝術學校之舞台少女受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3260,"_id_":5001106},"5001107":{"description":{"en":"(Passive) [Frontier] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Cloud Dmg Received Down ","ja":"フロンティア芸術学校の雲属性被ダメージダウン","ko":"프론티어 예술학교가 받는 구름 속성 대미지 감소","zh_hant":"減輕芙羅提亞藝術學校之舞台少女受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3260,"_id_":5001107},"5001108":{"description":{"en":"(Passive) [Frontier] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【芙羅提亞藝術學校之舞台少女】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Frontier Dream Dmg Received Down ","ja":"フロンティア芸術学校の夢属性被ダメージダウン","ko":"프론티어 예술학교가 받는 꿈 속성 대미지 감소","zh_hant":"減輕芙羅提亞藝術學校之舞台少女受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3260,"_id_":5001108},"5001109":{"description":{"en":"(Passive) [Frontier] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Dmg to Flower Up ","ja":"フロンティア芸術学校の花属性与ダメージアップ","ko":"프론티어 예술학교가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3260,"_id_":5001109},"5001110":{"description":{"en":"(Passive) [Frontier] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Dmg to Wind Up ","ja":"フロンティア芸術学校の風属性与ダメージアップ","ko":"프론티어 예술학교가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3260,"_id_":5001110},"5001111":{"description":{"en":"(Passive) [Frontier] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Dmg to Snow Up ","ja":"フロンティア芸術学校の雪属性与ダメージアップ","ko":"프론티어 예술학교가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3260,"_id_":5001111},"5001112":{"description":{"en":"(Passive) [Frontier] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Dmg to Moon Up ","ja":"フロンティア芸術学校の月属性与ダメージアップ","ko":"프론티어 예술학교가 달 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3260,"_id_":5001112},"5001113":{"description":{"en":"(Passive) [Frontier] Dmg to Space Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Dmg to Space Up ","ja":"フロンティア芸術学校の宙属性与ダメージアップ","ko":"프론티어 예술학교가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3260,"_id_":5001113},"5001114":{"description":{"en":"(Passive) [Frontier] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Dmg to Cloud Up ","ja":"フロンティア芸術学校の雲属性与ダメージアップ","ko":"프론티어 예술학교가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3260,"_id_":5001114},"5001115":{"description":{"en":"(Passive) [Frontier] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Frontier Dmg to Dream Up ","ja":"フロンティア芸術学校の夢属性与ダメージアップ","ko":"프론티어 예술학교가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3260,"_id_":5001115},"5001116":{"description":{"en":"(Passive) [Frontier] Normal Defense Up %opt1_value% ","ja":"[永続]【フロンティア芸術学校】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [프론티어 예술학교]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的普通防禦力 +%opt1_value%"},"name":{"en":"Frontier Normal Defense Up ","ja":"フロンティア芸術学校の通常防御力アップ","ko":"프론티어 예술학교의 일반 방어력 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3260,"_id_":5001116},"5001117":{"description":{"en":"(Passive) [Frontier] Special Defense Up %opt1_value% ","ja":"[永続]【フロンティア芸術学校】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [프론티어 예술학교]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的特殊防禦力 +%opt1_value%"},"name":{"en":"Frontier Special Defense Up ","ja":"フロンティア芸術学校の特殊防御力アップ","ko":"프론티어 예술학교의 특수 방어력 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3260,"_id_":5001117},"5001118":{"description":{"en":"(Passive) [Frontier] Normal Defense Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的普通防禦力 +%opt1_value%%"},"name":{"en":"Frontier Normal Defense Up ","ja":"フロンティア芸術学校の通常防御力アップ","ko":"프론티어 예술학교의 일반 방어력 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3260,"_id_":5001118},"5001119":{"description":{"en":"(Passive) [Frontier] Special Defense Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Frontier Special Defense Up ","ja":"フロンティア芸術学校の特殊防御力アップ","ko":"프론티어 예술학교의 특수 방어력 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3260,"_id_":5001119},"5001120":{"description":{"en":"(Passive) [Frontier] Dexterity Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的會心率 +%opt1_value%%"},"name":{"en":"Frontier Dexterity Up ","ja":"フロンティア芸術学校のクリティカル率アップ","ko":"프론티어 예술학교의 크리티컬 확률 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的會心率"},"skill_option1_id":20,"skill_option1_target_id":3260,"_id_":5001120},"5001121":{"description":{"en":"(Passive) [Frontier] Critical Up %opt1_value%% ","ja":"[永続]【フロンティア芸術学校】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [프론티어 예술학교]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【芙羅提亞藝術學校之舞台少女】的會心威力 +%opt1_value%%"},"name":{"en":"Frontier Critical Up ","ja":"フロンティア芸術学校のクリティカル威力アップ","ko":"프론티어 예술학교의 크리티컬 위력 증가","zh_hant":"提升芙羅提亞藝術學校之舞台少女的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3260,"_id_":5001121},"5001201":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Act Power Up %opt1_value% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的ACT力量 %opt1_value%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Act Power Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンのACTパワーアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡의 ACT 파워 증가 ","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3261,"_id_":5001201},"5001202":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的花屬性傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Flower Dmg Received Down","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの花属性被ダメージダウン","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 꽃 속성 대미지 감소","zh_hant":"減輕光、克洛迪娜、珠緒、晶和美帆受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3261,"_id_":5001202},"5001203":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的風屬性傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Wind Dmg Received Down","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの風属性被ダメージダウン","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 바람 속성 대미지 감소","zh_hant":"減輕光、克洛迪娜、珠緒、晶和美帆受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3261,"_id_":5001203},"5001204":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的雪屬性傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Snow Dmg Received Down","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの雪属性被ダメージダウン","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 눈 속성 대미지 감소","zh_hant":"減輕光、克洛迪娜、珠緒、晶和美帆受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3261,"_id_":5001204},"5001205":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的月屬性傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Moon Dmg Received Down","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの月属性被ダメージダウン","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 달 속성 대미지 감소","zh_hant":"減輕光、克洛迪娜、珠緒、晶和美帆受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3261,"_id_":5001205},"5001206":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的宙屬性傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Space Dmg Received Down","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの宙属性被ダメージダウン","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 우주 속성 대미지 감소","zh_hant":"減輕光、克洛迪娜、珠緒、晶和美帆受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3261,"_id_":5001206},"5001207":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的雲屬性傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Cloud Dmg Received Down","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの雲属性被ダメージダウン","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 구름 속성 대미지 감소","zh_hant":"減輕光、克洛迪娜、珠緒、晶和美帆受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3261,"_id_":5001207},"5001208":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【光、克洛迪娜、珠緒、晶和美帆】受到的夢屬性傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dream Dmg Received Down","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの夢属性被ダメージダウン","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 받는 꿈 속성 대미지 감소","zh_hant":"減輕光、克洛迪娜、珠緒、晶和美帆受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3261,"_id_":5001208},"5001209":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對花屬性造成的傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Flower Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの花属性与ダメージアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3261,"_id_":5001209},"5001210":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對風屬性造成的傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Wind Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの風属性与ダメージアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3261,"_id_":5001210},"5001211":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對雪屬性造成的傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Snow Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの雪属性与ダメージアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3261,"_id_":5001211},"5001212":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對月屬性造成的傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Moon Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの月属性与ダメージアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 달 속성에게 가하는 대미지 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3261,"_id_":5001212},"5001213":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Space Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對宙屬性造成的傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Space Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの宙属性与ダメージアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3261,"_id_":5001213},"5001214":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對雲屬性造成的傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Cloud Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの雲属性与ダメージアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3261,"_id_":5001214},"5001215":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】對夢屬性造成的傷害 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dmg to Dream Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの夢属性与ダメージアップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3261,"_id_":5001215},"5001216":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Normal Defense Up %opt1_value% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的普通防禦力 %opt1_value%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Normal Defense Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの通常防御力アップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡의 일반 방어력 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3261,"_id_":5001216},"5001217":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Special Defense Up %opt1_value% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的特殊防禦力 %opt1_value%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Special Defense Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの特殊防御力アップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡의 특수 방어력 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3261,"_id_":5001217},"5001218":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Normal Defense Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的普通防禦力 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Normal Defense Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの通常防御力アップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡의 일반 방어력 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3261,"_id_":5001218},"5001219":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Special Defense Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的特殊防禦力 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Special Defense Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンの特殊防御力アップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡의 특수 방어력 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3261,"_id_":5001219},"5001220":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Dexterity Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的會心率 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Dexterity Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンのクリティカル率アップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡의 크리티컬 확률 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的會心率"},"skill_option1_id":20,"skill_option1_target_id":3261,"_id_":5001220},"5001221":{"description":{"en":"(Passive) [Hikari & Claudine & Tamao & Akira & Mei Fan] Critical Up %opt1_value%% ","ja":"[永続]【ひかりとクロディーヌと珠緒と晶とメイファン】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [히카리, 클로딘, 타마오, 아키라, 메이팡]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【光、克洛迪娜、珠緒、晶和美帆】的會心威力 %opt1_value%%"},"name":{"en":"Hikari & Claudine & Tamao & Akira & Mei Fan Critical Up","ja":"ひかりとクロディーヌと珠緒と晶とメイファンのクリティカル威力アップ","ko":"히카리, 클로딘, 타마오, 아키라, 메이팡의 크리티컬 위력 증가","zh_hant":"提升光、克洛迪娜、珠緒、晶和美帆的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3261,"_id_":5001221},"5001301":{"description":{"en":"(Passive) [Siegfeld] Act Power Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的ACT力量 +%opt1_value%"},"name":{"en":"Siegfeld Act Power Up","ja":"シークフェルト音楽学院のACTパワーアップ","ko":"시크펠트 음악학원의 ACT 파워 증가","zh_hant":"提升席格菲特音樂學院的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3263,"_id_":5001301},"5001302":{"description":{"en":"(Passive) [Siegfeld] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的花屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Flower Dmg Received Down","ja":"シークフェルト音楽学院の花属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 꽃 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3263,"_id_":5001302},"5001303":{"description":{"en":"(Passive) [Siegfeld] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的風屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Wind Dmg Received Down","ja":"シークフェルト音楽学院の風属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 바람 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3263,"_id_":5001303},"5001304":{"description":{"en":"(Passive) [Siegfeld] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的雪屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Snow Dmg Received Down","ja":"シークフェルト音楽学院の雪属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 눈 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3263,"_id_":5001304},"5001305":{"description":{"en":"(Passive) [Siegfeld] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的月屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Moon Dmg Received Down","ja":"シークフェルト音楽学院の月属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 달 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3263,"_id_":5001305},"5001306":{"description":{"en":"(Passive) [Siegfeld] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的宙屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Space Dmg Received Down","ja":"シークフェルト音楽学院の宙属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 우주 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3263,"_id_":5001306},"5001307":{"description":{"en":"(Passive) [Siegfeld] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的雲屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Cloud Dmg Received Down","ja":"シークフェルト音楽学院の雲属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 구름 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3263,"_id_":5001307},"5001308":{"description":{"en":"(Passive) [Siegfeld] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【席格菲特音樂學院】受到的夢屬性傷害 %opt1_value%%"},"name":{"en":"Siegfeld Dream Dmg Received Down","ja":"シークフェルト音楽学院の夢属性被ダメージダウン","ko":"시크펠트 음악학원이 받는 꿈 속성 대미지 감소","zh_hant":"減輕席格菲特音樂學院受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3263,"_id_":5001308},"5001309":{"description":{"en":"(Passive) [Siegfeld] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Flower Up","ja":"シークフェルト音楽学院の花属性与ダメージアップ","ko":"시크펠트 음악학원이 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3263,"_id_":5001309},"5001310":{"description":{"en":"(Passive) [Siegfeld] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Wind Up","ja":"シークフェルト音楽学院の風属性与ダメージアップ","ko":"시크펠트 음악학원이 바람 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3263,"_id_":5001310},"5001311":{"description":{"en":"(Passive) [Siegfeld] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Snow Up","ja":"シークフェルト音楽学院の雪属性与ダメージアップ","ko":"시크펠트 음악학원이 눈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3263,"_id_":5001311},"5001312":{"description":{"en":"(Passive) [Siegfeld] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Moon Up","ja":"シークフェルト音楽学院の月属性与ダメージアップ","ko":"시크펠트 음악학원이 달 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3263,"_id_":5001312},"5001313":{"description":{"en":"(Passive) [Siegfeld] Dmg to Space Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Space Up","ja":"シークフェルト音楽学院の宙属性与ダメージアップ","ko":"시크펠트 음악학원이 우주 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3263,"_id_":5001313},"5001314":{"description":{"en":"(Passive) [Siegfeld] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Cloud Up","ja":"シークフェルト音楽学院の雲属性与ダメージアップ","ko":"시크펠트 음악학원이 구름 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3263,"_id_":5001314},"5001315":{"description":{"en":"(Passive) [Siegfeld] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]이 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Siegfeld Dmg to Dream Up","ja":"シークフェルト音楽学院の夢属性与ダメージアップ","ko":"시크펠트 음악학원이 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升席格菲特音樂學院的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3263,"_id_":5001315},"5001316":{"description":{"en":"(Passive) [Siegfeld] Normal Defense Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Normal Defense Up","ja":"シークフェルト音楽学院の通常防御力アップ","ko":"시크펠트 음악학원의 일반 방어력 증가","zh_hant":"提升席格菲特音樂學院的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3263,"_id_":5001316},"5001317":{"description":{"en":"(Passive) [Siegfeld] Special Defense Up %opt1_value% ","ja":"[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Special Defense Up","ja":"シークフェルト音楽学院の特殊防御力アップ","ko":"시크펠트 음악학원의 특수 방어력 증가","zh_hant":"提升席格菲特音樂學院的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3263,"_id_":5001317},"5001318":{"description":{"en":"(Passive) [Siegfeld] Normal Defense Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的普通防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Normal Defense Up","ja":"シークフェルト音楽学院の通常防御力アップ","ko":"시크펠트 음악학원의 일반 방어력 증가","zh_hant":"提升席格菲特音樂學院的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3263,"_id_":5001318},"5001319":{"description":{"en":"(Passive) [Siegfeld] Special Defense Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的特殊防禦力 +%opt1_value%"},"name":{"en":"Siegfeld Special Defense Up","ja":"シークフェルト音楽学院の特殊防御力アップ","ko":"시크펠트 음악학원의 특수 방어력 증가","zh_hant":"提升席格菲特音樂學院的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3263,"_id_":5001319},"5001320":{"description":{"en":"(Passive) [Siegfeld] Dexterity Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的會心率 +%opt1_value%%"},"name":{"en":"Siegfeld Dexterity Up","ja":"シークフェルト音楽学院のクリティカル率アップ","ko":"시크펠트 음악학원의 크리티컬 확률 증가","zh_hant":"提升席格菲特音樂學院的會心率"},"skill_option1_id":20,"skill_option1_target_id":3263,"_id_":5001320},"5001321":{"description":{"en":"(Passive) [Siegfeld] Critical Up %opt1_value%% ","ja":"[永続]【シークフェルト音楽学院】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [시크펠트 음악학원]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【席格菲特音樂學院】的會心威力 +%opt1_value%%"},"name":{"en":"Siegfeld Critical Up","ja":"シークフェルト音楽学院のクリティカル威力アップ","ko":"시크펠트 음악학원의 크리티컬 위력 증가","zh_hant":"提升席格菲特音樂學院的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3263,"_id_":5001321},"5001401":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Act Power Up %opt1_value% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌, 마야, 아루루, 야치요]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Act Power Up","ja":"華恋と真矢とあるるとやちよのACTパワーアップ","ko":"카렌, 마야, 아루루, 야치요의 ACT 파워 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":4164,"_id_":5001401},"5001402":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、真矢、艾露露、八千代】受到的花屬性傷害 %opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Flower Dmg Received Down","ja":"華恋と真矢とあるるとやちよの花属性被ダメージダウン","ko":"카렌, 마야, 아루루, 야치요가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀、真矢、艾露露、八千代受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":4164,"_id_":5001402},"5001403":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、真矢、艾露露、八千代】受到的風屬性傷害 %opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Wind Dmg Received Down","ja":"華恋と真矢とあるるとやちよの風属性被ダメージダウン","ko":"카렌, 마야, 아루루, 야치요가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀、真矢、艾露露、八千代受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":4164,"_id_":5001403},"5001404":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、真矢、艾露露、八千代】受到的雪屬性傷害 %opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Snow Dmg Received Down","ja":"華恋と真矢とあるるとやちよの雪属性被ダメージダウン","ko":"카렌, 마야, 아루루, 야치요가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀、真矢、艾露露、八千代受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":4164,"_id_":5001404},"5001405":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、真矢、艾露露、八千代】受到的月屬性傷害 %opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Moon Dmg Received Down","ja":"華恋と真矢とあるるとやちよの月属性被ダメージダウン","ko":"카렌, 마야, 아루루, 야치요가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀、真矢、艾露露、八千代受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":4164,"_id_":5001405},"5001406":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、真矢、艾露露、八千代】受到的宙屬性傷害 %opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Space Dmg Received Down","ja":"華恋と真矢とあるるとやちよの宙属性被ダメージダウン","ko":"카렌, 마야, 아루루, 야치요가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀、真矢、艾露露、八千代受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":4164,"_id_":5001406},"5001407":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、真矢、艾露露、八千代】受到的雲屬性傷害 %opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Cloud Dmg Received Down","ja":"華恋と真矢とあるるとやちよの雲属性被ダメージダウン","ko":"카렌, 마야, 아루루, 야치요가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀、真矢、艾露露、八千代受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":4164,"_id_":5001407},"5001408":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、真矢、艾露露、八千代】受到的夢屬性傷害 %opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dream Dmg Received Down","ja":"華恋と真矢とあるるとやちよの夢属性被ダメージダウン","ko":"카렌, 마야, 아루루, 야치요가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀、真矢、艾露露、八千代受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":4164,"_id_":5001408},"5001409":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dmg to Flower Up","ja":"華恋と真矢とあるるとやちよの花属性与ダメージアップ","ko":"카렌, 마야, 아루루, 야치요가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":4164,"_id_":5001409},"5001410":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dmg to Wind Up","ja":"華恋と真矢とあるるとやちよの風属性与ダメージアップ","ko":"카렌, 마야, 아루루, 야치요가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":4164,"_id_":5001410},"5001411":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dmg to Snow Up","ja":"華恋と真矢とあるるとやちよの雪属性与ダメージアップ","ko":"카렌, 마야, 아루루, 야치요가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":4164,"_id_":5001411},"5001412":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dmg to Moon Up","ja":"華恋と真矢とあるるとやちよの月属性与ダメージアップ","ko":"카렌, 마야, 아루루, 야치요가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":4164,"_id_":5001412},"5001413":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dmg to Space Up","ja":"華恋と真矢とあるるとやちよの宙属性与ダメージアップ","ko":"카렌, 마야, 아루루, 야치요가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":4164,"_id_":5001413},"5001414":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dmg to Cloud Up","ja":"華恋と真矢とあるるとやちよの雲属性与ダメージアップ","ko":"카렌, 마야, 아루루, 야치요가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":4164,"_id_":5001414},"5001415":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dmg to Dream Up","ja":"華恋と真矢とあるるとやちよの夢属性与ダメージアップ","ko":"카렌, 마야, 아루루, 야치요가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":4164,"_id_":5001415},"5001416":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌, 마야, 아루루, 야치요]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Normal Defense Up","ja":"華恋と真矢とあるるとやちよの通常防御力アップ","ko":"카렌, 마야, 아루루, 야치요의 일반 방어력 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":4164,"_id_":5001416},"5001417":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Special Defense Up %opt1_value% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌, 마야, 아루루, 야치요]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Special Defense Up","ja":"華恋と真矢とあるるとやちよの特殊防御力アップ","ko":"카렌, 마야, 아루루, 야치요의 특수 방어력 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":4164,"_id_":5001417},"5001418":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的普通防禦力 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Normal Defense Up","ja":"華恋と真矢とあるるとやちよの通常防御力アップ","ko":"카렌, 마야, 아루루, 야치요의 일반 방어력 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":4164,"_id_":5001418},"5001419":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Special Defense Up","ja":"華恋と真矢とあるるとやちよの特殊防御力アップ","ko":"카렌, 마야, 아루루, 야치요의 특수 방어력 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":4164,"_id_":5001419},"5001420":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Dexterity Up","ja":"華恋と真矢とあるるとやちよのクリティカル率アップ","ko":"카렌, 마야, 아루루, 야치요의 크리티컬 확률 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的會心率"},"skill_option1_id":20,"skill_option1_target_id":4164,"_id_":5001420},"5001421":{"description":{"en":"(Passive) [Karen & Maya & Aruru & Yachiyo] Critical Up %opt1_value%% ","ja":"[永続]【華恋と真矢とあるるとやちよ】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌, 마야, 아루루, 야치요]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、真矢、艾露露、八千代】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Maya & Aruru & Yachiyo Critical Up","ja":"華恋と真矢とあるるとやちよのクリティカル威力アップ","ko":"카렌, 마야, 아루루, 야치요의 크리티컬 위력 증가","zh_hant":"提升華戀、真矢、艾露露、八千代的會心威力"},"skill_option1_id":22,"skill_option1_target_id":4164,"_id_":5001421},"9000701":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Act Power Up %opt1_value% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的ACT力量 +%opt1_value%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Act Power Up","ja":"華恋とひかりと珠緒とあるると晶のACTパワーアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라의 ACT 파워 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3200,"_id_":9000701},"9000702":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Flower Dmg Received Down","ja":"華恋とひかりと珠緒とあるると晶の花属性被ダメージダウン","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 받는 꽃 속성 대미지 감소","zh_hant":"減輕華戀、光、珠緒、艾露露、晶受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3200,"_id_":9000702},"9000703":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Wind Dmg Received Down","ja":"華恋とひかりと珠緒とあるると晶の風属性被ダメージダウン","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 받는 바람 속성 대미지 감소","zh_hant":"減輕華戀、光、珠緒、艾露露、晶受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3200,"_id_":9000703},"9000704":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Snow Dmg Received Down","ja":"華恋とひかりと珠緒とあるると晶の雪属性被ダメージダウン","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 받는 눈 속성 대미지 감소","zh_hant":"減輕華戀、光、珠緒、艾露露、晶受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3200,"_id_":9000704},"9000705":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Moon Dmg Received Down","ja":"華恋とひかりと珠緒とあるると晶の月属性被ダメージダウン","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 받는 달 속성 대미지 감소","zh_hant":"減輕華戀、光、珠緒、艾露露、晶受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3200,"_id_":9000705},"9000706":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Space Dmg Received Down","ja":"華恋とひかりと珠緒とあるると晶の宙属性被ダメージダウン","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 받는 우주 속성 대미지 감소","zh_hant":"減輕華戀、光、珠緒、艾露露、晶受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3200,"_id_":9000706},"9000707":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Cloud Dmg Received Down","ja":"華恋とひかりと珠緒とあるると晶の雲属性被ダメージダウン","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 받는 구름 속성 대미지 감소","zh_hant":"減輕華戀、光、珠緒、艾露露、晶受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3200,"_id_":9000707},"9000708":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【華戀、光、珠緒、艾露露、晶】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dream Dmg Received Down","ja":"華恋とひかりと珠緒とあるると晶の夢属性被ダメージダウン","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 받는 꿈 속성 대미지 감소","zh_hant":"減輕華戀、光、珠緒、艾露露、晶受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3200,"_id_":9000708},"9000709":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dmg to Flower Up","ja":"華恋とひかりと珠緒とあるると晶の花属性与ダメージアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3200,"_id_":9000709},"9000710":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dmg to Wind Up","ja":"華恋とひかりと珠緒とあるると晶の風属性与ダメージアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3200,"_id_":9000710},"9000711":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dmg to Snow Up","ja":"華恋とひかりと珠緒とあるると晶の雪属性与ダメージアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3200,"_id_":9000711},"9000712":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dmg to Moon Up","ja":"華恋とひかりと珠緒とあるると晶の月属性与ダメージアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 달 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3200,"_id_":9000712},"9000713":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Space Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dmg to Space Up","ja":"華恋とひかりと珠緒とあるると晶の宙属性与ダメージアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3200,"_id_":9000713},"9000714":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dmg to Cloud Up","ja":"華恋とひかりと珠緒とあるると晶の雲属性与ダメージアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3200,"_id_":9000714},"9000715":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dmg to Dream Up","ja":"華恋とひかりと珠緒とあるると晶の夢属性与ダメージアップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3200,"_id_":9000715},"9000716":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Normal Defense Up %opt1_value% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的普通防禦力 +%opt1_value%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Normal Defense Up","ja":"華恋とひかりと珠緒とあるると晶の通常防御力アップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라의 일반 방어력 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3200,"_id_":9000716},"9000717":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Special Defense Up %opt1_value% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的特殊防禦力 +%opt1_value%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Special Defense Up","ja":"華恋とひかりと珠緒とあるると晶の特殊防御力アップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라의 특수 방어력 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3200,"_id_":9000717},"9000718":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Normal Defense Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的普通防禦力 +%opt1_value%％"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Normal Defense Up","ja":"華恋とひかりと珠緒とあるると晶の通常防御力アップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라의 일반 방어력 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3200,"_id_":9000718},"9000719":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Special Defense Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的特殊防禦力 +%opt1_value%％"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Special Defense Up","ja":"華恋とひかりと珠緒とあるると晶の特殊防御力アップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라의 특수 방어력 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3200,"_id_":9000719},"9000720":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Dexterity Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的會心率 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Dexterity Up","ja":"華恋とひかりと珠緒とあるると晶のクリティカル率アップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라의 크리티컬 확률 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的會心率"},"skill_option1_id":20,"skill_option1_target_id":3200,"_id_":9000720},"9000721":{"description":{"en":"(Passive) [Karen & Hikari & Tamao & Aruru & Akira] Critical Up %opt1_value%% ","ja":"[永続]【華恋とひかりと珠緒とあるると晶】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [카렌, 히카리, 타마오, 아루루, 아키라]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【華戀、光、珠緒、艾露露、晶】的會心威力 +%opt1_value%%"},"name":{"en":"Karen & Hikari & Tamao & Aruru & Akira Critical Up","ja":"華恋とひかりと珠緒とあるると晶のクリティカル威力アップ","ko":"카렌, 히카리, 타마오, 아루루, 아키라의 크리티컬 위력 증가","zh_hant":"提升華戀、光、珠緒、艾露露、晶的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3200,"_id_":9000721},"9000901":{"description":{"en":"(Passive) [Claudine & Maya] Act Power Up %opt1_value% ","ja":"[永続]【クロディーヌと真矢】を対象にACTパワーアップ +%opt1_value%","ko":"[영구] [클로딘과 마야]의 ACT 파워 %opt1_value% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的ACT力量 +%opt1_value%"},"name":{"en":"Claudine & Maya Act Power Up","ja":"クロディーヌと真矢のACTパワーアップ","ko":"클로딘과 마야의 ACT 파워 증가","zh_hant":"提升克洛迪娜和真矢的ACT力量"},"skill_option1_id":42,"skill_option1_target_id":3230,"_id_":9000901},"9000902":{"description":{"en":"(Passive) [Claudine & Maya] Flower Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に花属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 꽃 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜和真矢】受到的花屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Flower Dmg Received Down","ja":"クロディーヌと真矢の花属性被ダメージダウン","ko":"클로딘과 마야가 받는 꽃 속성 대미지 감소","zh_hant":"減輕克洛迪娜和真矢受到的花屬性傷害"},"skill_option1_id":66,"skill_option1_target_id":3230,"_id_":9000902},"9000903":{"description":{"en":"(Passive) [Claudine & Maya] Wind Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に風属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 바람 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜和真矢】受到的風屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Wind Dmg Received Down","ja":"クロディーヌと真矢の風属性被ダメージダウン","ko":"클로딘과 마야가 받는 바람 속성 대미지 감소","zh_hant":"減輕克洛迪娜和真矢受到的風屬性傷害"},"skill_option1_id":67,"skill_option1_target_id":3230,"_id_":9000903},"9000904":{"description":{"en":"(Passive) [Claudine & Maya] Snow Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に雪属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 눈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜和真矢】受到的雪屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Snow Dmg Received Down","ja":"クロディーヌと真矢の雪属性被ダメージダウン","ko":"클로딘과 마야가 받는 눈 속성 대미지 감소","zh_hant":"減輕克洛迪娜和真矢受到的雪屬性傷害"},"skill_option1_id":68,"skill_option1_target_id":3230,"_id_":9000904},"9000905":{"description":{"en":"(Passive) [Claudine & Maya] Moon Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に月属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 달 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜和真矢】受到的月屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Moon Dmg Received Down","ja":"クロディーヌと真矢の月属性被ダメージダウン","ko":"클로딘과 마야가 받는 달 속성 대미지 감소","zh_hant":"減輕克洛迪娜和真矢受到的月屬性傷害"},"skill_option1_id":69,"skill_option1_target_id":3230,"_id_":9000905},"9000906":{"description":{"en":"(Passive) [Claudine & Maya] Space Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に宙属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 우주 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜和真矢】受到的宙屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Space Dmg Received Down","ja":"クロディーヌと真矢の宙属性被ダメージダウン","ko":"클로딘과 마야가 받는 우주 속성 대미지 감소","zh_hant":"減輕克洛迪娜和真矢受到的宙屬性傷害"},"skill_option1_id":70,"skill_option1_target_id":3230,"_id_":9000906},"9000907":{"description":{"en":"(Passive) [Claudine & Maya] Cloud Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に雲属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 구름 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜和真矢】受到的雲屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Cloud Dmg Received Down","ja":"クロディーヌと真矢の雲属性被ダメージダウン","ko":"클로딘과 마야가 받는 구름 속성 대미지 감소","zh_hant":"減輕克洛迪娜和真矢受到的雲屬性傷害"},"skill_option1_id":71,"skill_option1_target_id":3230,"_id_":9000907},"9000908":{"description":{"en":"(Passive) [Claudine & Maya] Dream Dmg Received Down %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に夢属性からの被ダメージダウン +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 꿈 속성에게 받는 대미지 %opt1_value%% 감소","zh_hant":"[永續]減輕【克洛迪娜和真矢】受到的夢屬性傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dream Dmg Received Down","ja":"クロディーヌと真矢の夢属性被ダメージダウン","ko":"클로딘과 마야가 받는 꿈 속성 대미지 감소","zh_hant":"減輕克洛迪娜和真矢受到的夢屬性傷害"},"skill_option1_id":72,"skill_option1_target_id":3230,"_id_":9000908},"9000909":{"description":{"en":"(Passive) [Claudine & Maya] Dmg to Flower Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に花属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 꽃 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的對花屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dmg to Flower Up","ja":"クロディーヌと真矢の花属性与ダメージアップ","ko":"클로딘과 마야가 꽃 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜和真矢的花屬性造成的傷害"},"skill_option1_id":46,"skill_option1_target_id":3230,"_id_":9000909},"9000910":{"description":{"en":"(Passive) [Claudine & Maya] Dmg to Wind Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に風属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 바람 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的對風屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dmg to Wind Up","ja":"クロディーヌと真矢の風属性与ダメージアップ","ko":"클로딘과 마야가 바람 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜和真矢的風屬性造成的傷害"},"skill_option1_id":47,"skill_option1_target_id":3230,"_id_":9000910},"9000911":{"description":{"en":"(Passive) [Claudine & Maya] Dmg to Snow Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に雪属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 눈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的對雪屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dmg to Snow Up","ja":"クロディーヌと真矢の雪属性与ダメージアップ","ko":"클로딘과 마야가 눈 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜和真矢的雪屬性造成的傷害"},"skill_option1_id":48,"skill_option1_target_id":3230,"_id_":9000911},"9000912":{"description":{"en":"(Passive) [Claudine & Maya] Dmg to Moon Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に月属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 달 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的對月屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dmg to Moon Up","ja":"クロディーヌと真矢の月属性与ダメージアップ","ko":"클로딘과 마야가 달 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜和真矢的月屬性造成的傷害"},"skill_option1_id":49,"skill_option1_target_id":3230,"_id_":9000912},"9000913":{"description":{"en":"(Passive) [Claudine & Maya] Dmg to Space Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に宙属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 우주 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的對宙屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dmg to Space Up","ja":"クロディーヌと真矢の宙属性与ダメージアップ","ko":"클로딘과 마야가 우주 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜和真矢的宙屬性造成的傷害"},"skill_option1_id":50,"skill_option1_target_id":3230,"_id_":9000913},"9000914":{"description":{"en":"(Passive) [Claudine & Maya] Dmg to Cloud Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に雲属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 구름 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的對雲屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dmg to Cloud Up","ja":"クロディーヌと真矢の雲属性与ダメージアップ","ko":"클로딘과 마야가 구름 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜和真矢的雲屬性造成的傷害"},"skill_option1_id":51,"skill_option1_target_id":3230,"_id_":9000914},"9000915":{"description":{"en":"(Passive) [Claudine & Maya] Dmg to Dream Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に夢属性に対する与ダメージアップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]가 꿈 속성에게 가하는 대미지 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的對夢屬性造成的傷害 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dmg to Dream Up","ja":"クロディーヌと真矢の夢属性与ダメージアップ","ko":"클로딘과 마야가 꿈 속성에게 가하는 대미지 증가","zh_hant":"提升克洛迪娜和真矢的夢屬性造成的傷害"},"skill_option1_id":52,"skill_option1_target_id":3230,"_id_":9000915},"9000916":{"description":{"en":"(Passive) [Claudine & Maya] Normal Defense Up %opt1_value% ","ja":"[永続]【クロディーヌと真矢】を対象に通常防御力アップ +%opt1_value%","ko":"[영구] [클로딘과 마야]의 일반 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的普通防禦力 +%opt1_value%"},"name":{"en":"Claudine & Maya Normal Defense Up","ja":"クロディーヌと真矢の通常防御力アップ","ko":"클로딘과 마야의 일반 방어력 증가","zh_hant":"提升克洛迪娜和真矢的普通防禦力"},"skill_option1_id":37,"skill_option1_target_id":3230,"_id_":9000916},"9000917":{"description":{"en":"(Passive) [Claudine & Maya] Special Defense Up %opt1_value% ","ja":"[永続]【クロディーヌと真矢】を対象に特殊防御力アップ +%opt1_value%","ko":"[영구] [클로딘과 마야]의 특수 방어력 %opt1_value% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的特殊防禦力 +%opt1_value%"},"name":{"en":"Claudine & Maya Special Defense Up","ja":"クロディーヌと真矢の特殊防御力アップ","ko":"클로딘과 마야의 특수 방어력 증가","zh_hant":"提升克洛迪娜和真矢的特殊防禦力"},"skill_option1_id":38,"skill_option1_target_id":3230,"_id_":9000917},"9000918":{"description":{"en":"(Passive) [Claudine & Maya] Normal Defense Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に通常防御力アップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]의 일반 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的普通防禦力 +%opt1_value%%"},"name":{"en":"Claudine & Maya Normal Defense Up","ja":"クロディーヌと真矢の通常防御力アップ","ko":"클로딘과 마야의 일반 방어력 증가","zh_hant":"提升克洛迪娜和真矢的普通防禦力"},"skill_option1_id":10,"skill_option1_target_id":3230,"_id_":9000918},"9000919":{"description":{"en":"(Passive) [Claudine & Maya] Special Defense Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象に特殊防御力アップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]의 특수 방어력 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的特殊防禦力 +%opt1_value%%"},"name":{"en":"Claudine & Maya Special Defense Up","ja":"クロディーヌと真矢の特殊防御力アップ","ko":"클로딘과 마야의 특수 방어력 증가","zh_hant":"提升克洛迪娜和真矢的特殊防禦力"},"skill_option1_id":12,"skill_option1_target_id":3230,"_id_":9000919},"9000920":{"description":{"en":"(Passive) [Claudine & Maya] Dexterity Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象にクリティカル率アップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]의 크리티컬 확률 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的會心率 +%opt1_value%%"},"name":{"en":"Claudine & Maya Dexterity Up","ja":"クロディーヌと真矢のクリティカル率アップ","ko":"클로딘과 마야의 크리티컬 확률 증가","zh_hant":"提升克洛迪娜和真矢的會心率"},"skill_option1_id":20,"skill_option1_target_id":3230,"_id_":9000920},"9000921":{"description":{"en":"(Passive) [Claudine & Maya] Critical Up %opt1_value%% ","ja":"[永続]【クロディーヌと真矢】を対象にクリティカル威力アップ +%opt1_value%%","ko":"[영구] [클로딘과 마야]의 크리티컬 위력 %opt1_value%% 증가","zh_hant":"[永續]提升【克洛迪娜和真矢】的會心威力 +%opt1_value%%"},"name":{"en":"Claudine & Maya Critical Up","ja":"クロディーヌと真矢のクリティカル威力アップ","ko":"클로딘과 마야의 크리티컬 위력 증가","zh_hant":"提升克洛迪娜和真矢的會心威力"},"skill_option1_id":22,"skill_option1_target_id":3230,"_id_":9000921}}"""
